// English translations — complete dictionary, 1:1 structure with cs.js.
// Financial terminology follows industry usage (sum insured, premium, annuity,
// creditworthiness, mutual fund…). Czech-specific names, brands and legal terms
// (BJ, DPS, DIP, ČNB, ARES, RPSN, IČO, Leadovač) are kept and explained inline.
const en = {
  /* Zájemci, prohlídky a předání financím
     (pages/RealityZajemciPage.js + pages/ProhlidkaPrihlaskaPage.js).
     Klíče `ver*` mluví na ZÁJEMCE — bez odborných slov, krátké věty.
     Zbytek mluví na makléře. Znění samotných souhlasů tu NENÍ: chodí ze
     serveru (backend/lib/reality_souhlas.py), protože se ukládá jeho otisk
     a ten musí sedět s tím, co člověk doopravdy viděl. */
  realZaj: {
    nadpis: "Enquirers and viewings",
    nacitam: "Loading…",
    chyba: "That did not work. Please try again.",
    terminy: "Viewing dates",
    terminyPopis: "Announce one date and send the link. People sign up themselves.",
    vypsatTermin: "Announce a date",
    termin: "Date and time",
    delka: "Minutes",
    kapacita: "How many people",
    ulozit: "Save",
    zadneTerminy: "You have not announced any date yet.",
    volno: "{n} of {z} places free",
    neplatny: "Link no longer valid",
    vDiari: "In the diary",
    kopirovat: "Copy link",
    zkopirovano: "Copied",
    zneplatnit: "Invalidate",
    zajemci: "Enquirers",
    pridatZajemce: "Add an enquirer",
    rozesilka: "{n} of {z} enquirers may receive further offers.",
    jmeno: "Name",
    telefon: "Phone",
    email: "E-mail",
    rucneBezSouhlasu: "An enquirer you typed in has no consent — only they can give it, on the sign-up form.",
    nikdoTu: "Nobody here yet.",
    bezJmena: "No name",
    stav: "Step",
    financovani: "Financing",
    okamzik: "When to hand over",
    predatPoradci: "Hand over to advisor",
    predanoPoradci: "Handed over",
    bezSouhlasuNejde: "Not without their consent. Send them the sign-up link so they can ask for it themselves.",
    odvolat: "Withdraw consent",
    smazatPotvrzeni: "Delete the enquirer and their data? Hand-overs stay, but without personal data.",
    souhlasPoradci: "Consented to advisor",
    souhlasAno: "Consented to offers",
    souhlasNe: "No consent",
    souhlasNezeptano: "Never asked",
    souhlasOdvolan: "Consent withdrawn",
    souhlasImport: "From the old database",
    predani: "Hand-over to finance",
    zadnePredavky: "You have not handed anyone over yet.",
    odmenaNenastavena: "Share not set",
    odmenaVysvetleni: "Until someone picks what the share is calculated from, no amount is computed.",
    zpetNaNemovitost: "Back to the property",
    smlouvaZalozit: "Reservation agreement",
    smlouvaOtevrit: "Open reservation agreement",
    smlouvaPodepsana: "Reservation agreement signed",
    fin: {
      neptal_jsem_se: "Did not ask",
      hotovost: "Cash",
      hypoteka: "Mortgage",
      nevim: "Does not know",
    },
    predavkaStav: {
      navrzena: "Waiting for the advisor",
      odeslana: "Sent",
      prijata: "Advisor took it",
      odmitnuta: "Advisor declined",
      propadla: "Expired",
    },
    verNadpis: "Viewing sign-up",
    verNacitam: "Loading…",
    verNeplatnyNadpis: "This link is not valid",
    verNeplatny: "The date has passed or the link expired. Please contact the agent.",
    verJazyk: "Language",
    verJmeno: "Full name",
    verTelefon: "Phone",
    verEmail: "E-mail",
    verPlno: "This viewing is full. Please contact the agent.",
    verOdeslat: "Sign up for the viewing",
    verOdesilam: "Sending…",
    verPovinne: "Without the first tick we cannot save your sign-up.",
    verChybiKontakt: "Please leave a phone number or an e-mail so we can reach you.",
    verChyba: "Sending failed. Please try again.",
    verHotovo: "You are signed up.",
    verHotovoPoradce: "A mortgage specialist will contact you as well.",
  },
  /* Kalkulačka na veřejné stránce nemovitosti
     (components/nemovitost/KalkulackaNemovitosti.js). Mluví na KLIENTA,
     ne na poradce — krátké věty, žádný odborný slovník. */
  nemKalk: {
    otazka: "Are you buying it to live in, or as an investment?",
    proSebe: "To live in",
    jakoInvestici: "As an investment",
    vlastni: "Own funds",
    sazba: "Interest rate",
    splatnost: "Term",
    najem: "Expected monthly rent",
    splatkaPopis: "monthly payment",
    vetaSplatka: "With {podil} of your own money you need {vlastni} and the payment will be {splatka} a month.",
    hruby: "Gross yield",
    cisty: "Net yield",
    cashflow: "Monthly cash flow",
    vetaMinus: "The rent will not cover the payment and the costs — you top up {castka} every month.",
    vetaPlus: "After the payment and the costs, {castka} of the rent is left every month.",
    vetaNajem: "Enter the expected rent — the yield cannot be worked out without it.",
    predpoklady: "Calculated with running costs of {naklady} a month, {mesicu} of 12 months let and rental income tax of 15 % on 70 % of the income.",
    orientacni: "An indicative calculation, not an offer or a guarantee. The actual rate is set by the bank based on your creditworthiness.",
    zaM2: "{cena} per m²",
    rokOne: "{n} year",
    rokFew: "{n} years",
    rokMany: "{n} years",
  },
  /* Realitni zakazky (/zakazky). Klice musi byt ve VSECH peti slovnicich —
     t() na chybejicim klici tise vrati klic a na obrazovce sviti `zakazky.nazev`.
     Hlida to frontend/src/__tests__/klicVeSlovniku.test.js. */
  poptavka: {
    prohlidka: 'Viewing',
    dorazil: 'attended',
    nedorazil: 'did not attend',
    teplotaVlazno: 'Stuck for a while — call the buyer',
    teplotaHorko: 'Stuck too long — the buyer has gone quiet',
    stitek: 'Buying request',
    zpetNaPipeline: 'Back to the property pipeline',
    otevritObchod: 'Case history',
    otevritKlienta: 'Client folder',
    followUp: 'Follow-up',
    nenalezena: 'This request does not exist or is not yours.',
    faze0: 'Enquired',
    faze1: 'Viewing booked',
    faze2: 'Attended viewing',
    faze3: 'Serious interest',
    faze4: 'Reservation',
    faze5: 'Purchase contract',
    faze6: 'Handover',
    ukol0: 'Call them and find out what they want and how they will pay.',
    ukol1: 'Confirm the time and send the address.',
    ukol2: 'Ask about financing and follow up within three days.',
    ukol3: 'Before the reservation, make sure someone handles the financing.',
    ukol4: 'Draw up the reservation contract for the chosen property.',
    ukol5: 'Send the paperwork to the lawyer and watch the deadlines.',
    ukol6: 'Hand over the keys and close the case.',
    akce0: 'Offer a property',
    akce1: 'Confirm the viewing time',
    akce2: 'Record how they will pay',
    akce3: 'Arrange the mortgage',
    akce4: 'Draw up the reservation contract',
    akce5: 'Send the contract to the lawyer',
    akce6: 'Hand over the keys',
    coHleda: 'What they are looking for',
    doptatSe: 'Still to ask about:',
    typ: 'Property type',
    typNevybrano: 'Not set',
    lokalita: 'Area',
    lokalitaPlaceholder: 'City centre, within 20 minutes of the centre…',
    rozpocet: 'Maximum they will pay',
    dispozice: 'Layout',
    dispoziceAtypicke: 'Unconventional',
    nabidnoutPoradce: 'They will most likely need a mortgage — line up an adviser before it gets to the reservation.',
    nabidky: 'What we have offered them',
    nabidnuto: 'Offered: {n}',
    zadneNabidky: 'We have not offered them anything yet.',
    coJesteMuzeme: 'What else we can offer them',
    zadneDoporucene: 'They already know every property you have.',
    nabidnout: 'Offer',
    stahnout: 'Withdraw',
    nemovitostPryc: 'The property is no longer in the system',
    nabidkaStazena: 'Offer withdrawn.',
    ulozeno: 'Saved.',
    chybaUlozeni: 'Saving failed.',
    chybaFaze: 'The stage could not be moved.',
    chybaNabidky: 'Something went wrong with the offer.',
    chybaSeznamu: 'Buying requests could not be loaded.',
  },
  zakazky: {
    novaPoptavka: 'New buyer',
    filtrProdej: 'Selling',
    filtrNakup: 'Buying',
    nabidnutoKupujicim: 'Offered to buyers',
    otevritPoptavku: 'Open the request',
    poptavkaPryc: 'The request is gone',
    neaktivni: 'Sale stopped',
    tymUlozit: 'Save the team',
    neulozeno: 'Not saved',
    tymZavolat: 'Call',
    osaOdkaz: 'Link for buyers',
    historieVse: 'Show the whole history',
    historieMene: 'Show only the latest',
    /* Realitni pipeline (/reality) + prokliky z karty. */
    /* Souhrnne dlazdice nad realitni pipeline (vzor: hypotecni pipeline). */
    bezNemovitosti: "No property is linked to this deal, so there is no address, no viewers and no listing to show. Create the property in the listings overview.",
    souhrnProdej: "For sale",
    souhrnProdejSub: "total volume {v}",
    souhrnNakup: "Buyers",
    souhrnNakupSub: "looking for a property",
    souhrnStoji: "Stalled",
    souhrnStojiSub: "call before they call you",
    souhrnHotovo: "Completed",
    souhrnHotovoSub: "handed over and closed",
    souhrnNic: "—",
    pipelineNazev: 'Listings pipeline',
    pipelinePodnadpis: 'Where each property stands and how long it has been standing there',
    pipelineSeznam: 'List and new listing',
    pipelineOtevrit: 'Open pipeline',
    prodatNechat: 'Sell, or keep it?',
    prodatNechatSub: 'A rough comparison for the owner — sell now, or rent it out',
    sloupecNemovitost: 'Property',
    sloupecFaze: 'Phase',
    sloupecStani: 'In phase',
    sloupecDalsiKrok: 'Next step',
    sloupecCena: 'Price',
    denOne: '{n} day',
    denFew: '{n} days',
    denMany: '{n} days',
    teplotaVlazno: 'Standing too long — call the owner',
    teplotaHorko: 'Stuck — the owner has no idea what is going on',
    filtrVse: 'All',
    filtrStoji: 'Standing too long',
    stojiPocet: 'Standing too long: {n}',
    coTed: 'What to do now',
    akce0: 'Ask the owner for documents',
    akce1: 'Book the photographer',
    akce2: 'Publish the listing',
    akce3: 'Schedule a viewing',
    akce4: 'Draw up the reservation contract',
    akce5: 'Hand the contract to the lawyer',
    akce6: 'Hand the buyer over to an advisor',
    zajemci: 'Buyers and viewings',
    smlouvy: 'Reservation contract',
    tym: 'Who is working on it',
    tymSub: 'Photographer, advisor, lawyer. So you know who to call when it stalls.',
    tymPrazdno: 'Nobody yet.',
    tymPridat: 'Add a person',
    tymRole: 'Role',
    tymJmeno: 'Name',
    tymTelefon: 'Phone',
    tymOdebrat: 'Remove',
    tymUlozeno: 'Team saved',
    tymBezObchodu: 'The team is stored with the deal and this listing has none.',
    roleMakler: 'Agent',
    roleFotograf: 'Photographer',
    rolePoradce: 'Financial advisor',
    roleAdvokat: 'Lawyer',
    roleJine: 'Other role',
    osa: 'Timeline',
    osaSub: 'When the photos, when the listing, when each viewing. This is the answer to the owner asking what is going on.',
    osaHotovo: 'Done',
    osaNestalo: 'Not yet',
    osaUlozit: 'Save timeline',
    osaProhlidky: 'Viewings',
    osaProhlidkyPrazdno: 'No viewing scheduled yet.',
    osaPrihlaseno: 'signed up',
    osaVypsat: 'Schedule a viewing',
    mkPriprava: 'Preparation and photos',
    mkInzerce: 'Property portals',
    mkSite: 'Social media',
    mkPlacenaReklama: 'Paid advertising',
    mkPr: 'Offline PR',
    historie: 'What went out and to whom',
    historieSub: 'Records from the deal — emails to the owner, phase moves, your notes.',
    historiePrazdno: 'Nothing yet.',
    historiePridat: 'Log a call or a message',
    historieUlozit: 'Log it',
    historieZapsano: 'Logged to the deal',
    nazev: 'Listings',
    podnadpis: 'The properties you are selling and where they are in the process',
    nova: 'New listing',
    nacitam: 'Loading…',
    chyba: 'Could not load the listings.',
    zadne: 'No listings yet',
    zadneSub: 'Add the first property — address, owner, price. You can fill in the rest as you go.',
    hledat: 'Search by address or owner',
    typ: 'Property type',
    typByt: 'Flat',
    typDum: 'House',
    typPozemek: 'Land',
    typKomercni: 'Commercial',
    vlastnictvi: 'Ownership',
    vlastnictviOsobni: 'Freehold',
    vlastnictviDruzstevni: 'Co-operative',
    vlastnictviHint: 'Co-operative housing uses a different reservation contract template.',
    adresa: 'Address',
    adresaHint: 'Street, number and town. The contract and the listing both draw on this.',
    majitel: 'Owner',
    vyberMajitele: 'Pick the owner from your contacts',
    majitelHint: 'The seller. They have to be in your contacts — the listing is tied to them.',
    cenaNabidkova: 'Asking price',
    cenaOdhad: 'Market estimate',
    cenaHint: 'An empty field means not priced yet, not zero.',
    lvCislo: 'Title deed number',
    katUzemi: 'Cadastral area',
    podepsano: 'Agency agreement signed',
    exkluzivitaDo: 'Exclusivity until',
    exkluzivitaHint: 'With a consumer, six months at most (§ 17 of Act 39/2020).',
    provizePct: 'Commission (%)',
    stitek: 'Energy certificate',
    stitekMa: 'Has one',
    stitekChybi: 'Missing',
    stitekObjednano: 'Ordered',
    poznamka: 'Note',
    nezadano: 'Not filled in',
    zalozit: 'Create listing',
    zrusit: 'Cancel',
    ulozit: 'Save',
    ulozeno: 'Saved',
    krok: 'Step',
    dalsiKrok: 'Next step',
    hotovoKrok: 'Done, next step',
    zpetKrok: 'One step back',
    dokonceno: 'Listing completed',
    hotovoStav: 'done',
    cekaStav: 'waiting',
    tedStav: 'now',
    bezObchodu: 'This listing has no deal, so there is nowhere to record the phase. Create it again.',
    kdeJsme: 'Where we are in the process',
    faze0: 'Signing up',
    faze1: 'Preparation',
    faze2: 'Advertising',
    faze3: 'Viewings',
    faze4: 'Reservation',
    faze5: 'Purchase contract',
    faze6: 'Handover',
    ukol0: 'Sign the agency agreement, check the land registry and ask the owner for the details.',
    ukol1: 'Book the photographer, prepare the floor plan and home staging, sort out the energy certificate.',
    ukol2: 'Publish the listing on the portals and social media. Save the links here.',
    ukol3: 'Arrange viewings, ask how buyers will finance it and record every enquiry.',
    ukol4: 'Draw up the reservation contract, collect the holding deposit and send it to the lawyer.',
    ukol5: 'The lawyer is drafting the purchase contract. Track the phase and keep the owner informed.',
    ukol6: 'Record the meter readings, sign the handover protocol and transfer the utility contracts.',
    komunikace: 'What we send the owner',
    komunikaceSub: 'The system writes the text. Send it from here, or copy it and send it your own way.',
    podklady: 'Ask for the details',
    podkladySub: 'One link where the owner fills in their ID details, email and phone. We do not want a photo of the document.',
    uvitani: 'Welcome and plan',
    uvitaniSub: 'From day one the owner knows what is coming — photos, listings, social media, paid ads, PR.',
    nahled: 'Message preview',
    kopirovat: 'Copy the text',
    zkopirovano: 'Copied',
    vEmailu: 'Open in email',
    odeslatJmenem: 'Send in my name',
    odesilam: 'Sending…',
    odeslanoNa: 'Sent to',
    neodeslano: 'Not sent — you have no email connected. Copy the text and send it yourself.',
    bezEmailu: 'The owner has no email on their contact. Add one and try again.',
    odkazProMajitele: 'Link for the owner',
    platiDo: 'Valid until',
    udaje: 'Listing details',
    zpetNaSeznam: 'Back to listings',
    smazat: 'Delete listing',
    smazatPotvrd: 'Delete the listing? The deal and its history stay.',
    smazano: 'Listing deleted',
    nenalezena: 'Listing not found.',
  },
  /* Tri odkazy pro klienty (web nemovitosti /n/:slug, stav prodeje pro
     majitele /z/:token, podklady /f/:token) + obe verejne stranky. */
  nemWeb: {
    sekce: 'Links for clients',
    sekceSub: 'Three pages your clients open without signing in. One click each.',
    nenacetlo: 'The links could not be loaded. Try refreshing the page.',
    webNazev: 'Property page',
    webSub: 'Photos, description and a quick calculation for buyers. The address can be read out over the phone.',
    majitelNazev: 'Sale status for the owner',
    majitelSub: 'A private page where the owner sees what is happening. It writes itself from what you click.',
    podkladyNazev: 'Details from the owner',
    podkladyZnovu: 'Show again',
    zatimNevyrobeno: 'Not created yet',
    vyrobit: 'Create link',
    vyrobeno: 'Created',
    otevrit: 'Open',
    kopirovat: 'Copy link',
    odeslatMajiteli: 'Send to owner',
    odeslano: 'Sent',
    zatimNeodeslano: 'Not sent yet',
    zverejneno: 'Published',
    jenProTebe: 'Only you can see it',
    zverejnit: 'Publish',
    skryt: 'Unpublish',
    platny: 'Valid',
    propadly: 'Expired',
    obnovit: 'Create a new one',
    obnovitPotvrd: 'Create a new link? The old one stops working and the owner will not be able to open it from the email.',
    fotky: 'Photos',
    fotkyPrazdno: 'No photos yet.',
    fotkyPridat: 'Add photos',
    fotkyOdebrat: 'Remove',
    fotkyOdmitnuto: 'Not uploaded:',
    dotaznikNadpis: 'Short questionnaire',
    dotaznikSub: 'Answer eight short questions. The system composes the headline and description from them — you can rewrite it afterwards.',
    oDispozice: 'Layout',
    oDispoziceHint: 'e.g. 3+1, 2+kk, studio',
    oPlochaM2: 'Floor area (m²)',
    oPlochaM2Hint: 'e.g. 78',
    oPatro: 'Floor',
    oPatroHint: 'e.g. 2nd floor of 5, lift',
    oStav: 'Condition',
    oStavHint: 'e.g. renovated in 2023 / original, ready to move in',
    oNejlepsi: 'What is the best thing about it?',
    oNejlepsiHint: 'e.g. large balcony overlooking the park',
    oProKoho: 'Who does it suit?',
    oProKohoHint: 'e.g. a family with one or two children',
    oOkoli: 'What is in the neighbourhood?',
    oOkoliHint: 'e.g. nursery 200 m, tram, park',
    oProcProdava: 'Why is the owner selling?',
    oProcProdavaHint: 'e.g. they are moving for work',
    oProcProdavaVarovani: 'This goes into the listing. Do not write a sensitive reason (divorce, debt) here — it lowers the price and it is about the owner, not the property.',
    slozit: 'Compose text from answers',
    slozeno: 'Composed by the system',
    slozenoRucne: 'You wrote this text',
    slozitPotvrd: 'Overwrite the text you wrote by hand? It will be composed again from the answers.',
    chybi: 'Missing from the text — fill it in and compose again:',
    nadpisPole: 'Listing headline',
    lokalita: 'Location',
    fotkyPoradi: 'The first photo is the main one. Drag it to the front, or use Make main.',
    fotkyHlavni: 'Main',
    fotkyDatHlavni: 'Make main',
    cena: 'Price',
    najem: 'Local rent',
    najemHint: 'Rent is only used in the buyer calculation. If you do not know it, leave the field empty.',
    popis: 'Property description',
    ulozitText: 'Save listing text',
    nacitam: 'Loading…',
    neplatny: 'This listing is not available. Ask the agent for a new link.',
    neplatnyMajitel: 'This page is not available. Ask the agent for a new link.',
    propocet: 'What it means per month',
    zajemNadpis: 'I want a viewing',
    zajemSub: 'Leave your contact details and the agent will get back to you with a time.',
    zajemHotovo: 'Thank you, the agent will get back to you.',
    zajemOdeslat: 'Send',
    odesilam: 'Sending…',
    jmeno: 'Name',
    telefon: 'Phone',
    email: 'Email',
    vzkaz: 'Message (optional)',
    chybiJmeno: 'Please enter your name.',
    chybiKontakt: 'Please leave a phone number or an email so we can get back to you.',
    chybaOdeslani: 'Sending failed. Please try again.',
    kontaktNadpis: 'Handled by',
    zavrit: 'Close',
    majitelNadpis: 'The sale of your property',
    majitelPata: 'The page updates itself. Check it whenever you like.',
    zatimNic: 'There is nothing to show yet. As soon as something happens, you will see it here.',
    veFazi: 'in this stage',
    zajemceOne: 'enquiry',
    zajemceFew: 'enquiries',
    zajemceMany: 'enquiries',
    prohlidkaOne: 'viewing held',
    prohlidkaFew: 'viewings held',
    prohlidkaMany: 'viewings held',
    prohlidkyChystane: 'upcoming:',
    prohlidkyNadpis: 'Viewings',
    prohlidkaChysta: 'upcoming',
    krokyNadpis: 'What we are doing to sell it',
    krokChysta: 'coming up',
    tymNadpis: 'Who is looking after the sale',
    inzeratOtevrit: 'Open the listing',
    inzeratPopis: 'This is how buyers see the property',
  },
  webui: {
    bookNow: "Book now",
    bookFree: "Book a free meeting",
    bookMeeting: "Book a meeting",
    advisorRole: "Your financial advisor",
    freeSlots: "Free slots this week",
    downloadFree: "Download free",
    services: "Services",
    scroll: "scroll",
    readyToTalk: "Ready to talk?",
    firstMeetingFree: "First meeting is free · 30 minutes online",
    webNotFound: "Website not found or not published.",
    loadingError: "Loading error",
    backHome: "Back to beplan University",
    retry: "Try again",
    webLoadFailed: "The website could not be loaded right now. Check your connection and try again.",
    lmEmailLabel: "Email",
    bookingMeta: "Online via Google Meet · Free and non-binding · About 30 minutes",
    bookingHint: "The first meeting is free. Just pick a slot and bring your questions.",
    bookSlotBtn: "Book a slot",
    // controls (a11y)
    musicPlay: "Play music",
    musicMute: "Mute music",
    themeToDark: "Switch to dark",
    themeToLight: "Switch to light",
    playIntroVideo: "Play intro video",
    whatsappWrite: "Message on WhatsApp",
    // sections
    servicesHeading: "What I can help you with",
    aboutEyebrow: "About me",
    dayEyebrow: "A day with me",
    dayHeading: "This is what my day looks like",
    testimonialsEyebrow: "Testimonials",
    testimonialsHeading: "What clients say",
    testimonialItem: "Testimonial",
    testimonialPrev: "Previous testimonial",
    testimonialNext: "Next testimonial",
    quoteOpen: "“",
    quoteClose: "”",
    bookingEyebrow: "Booking",
    bookingHeading: "Pick a meeting slot",
    bookingInactive: "Online booking is not active yet. Contact the advisor directly:",
    faqHeading: "Frequently asked questions",
    partnersLabel: "I work with",
    finalCtaHeading: "Let's talk",
    writeEmail: "Send an email",
    // footer
    digitalCard: "Digital business card",
    privacy: "Privacy",
    madeIn: "Made in beplan University",
    // gallery / client stories (a11y)
    prev: "Previous",
    next: "Next",
    close: "Close",
    storyPrev: "Previous story",
    storyNext: "Next story",
    storyItem: "Story",
    // process (horizontal section)
    processEyebrow: "How we work together",
    processHeadingSuffix: "to finances you understand",
    processScrollHint: "Scroll down – the cards move to the right",
    processNextStep: "Next step",
    stepOne: "step",
    stepFew: "steps",
    stepMany: "steps",
    // default process steps (the advisor can rewrite them in website settings)
    step1Title: "First contact",
    step1Desc: "Just book a slot or call. We talk about what you need to solve.",
    step2Title: "Analysis of your situation",
    step2Desc: "I map it out for free – where you are, what you have, what is missing.",
    step3Title: "Plan proposal",
    step3Desc: "You get concrete tailored steps – mortgage, insurance, investments.",
    step4Title: "Implementation",
    step4Desc: "I handle the paperwork, the banks and the insurers. You focus on your work.",
    step5Title: "Annual review",
    step5Desc: "Once a year we go through how the plan is doing and what to adjust.",
    // client stories
    storiesEyebrow: "Client stories",
    storiesHeading: "How I helped them",
    storiesSubtitle: "Real situations. Real solutions. Real results.",
    storyClient: "Client",
    storyProblem: "Situation",
    storySolution: "What we did",
    storyResult: "Result",
    storyCta: "I want a result like this",
    // gallery
    galleryEyebrow: "Gallery",
    galleryHeading: "Behind the scenes",
    galleryPhotoAlt: "Photo {n}",
    // blog
    blogEyebrow: "Blog",
    blogHeading: "Tips and thoughts",
    blogRead: "Read the article",
    blogLoading: "Loading…",
    blogLoadError: "The article could not be loaded.",
    // lead magnet (PDF for an email)
    lmBadge: "Download free",
    lmInstant: "Instant download",
    lmNoSpam: "No spam",
    lmDone: "Done",
    lmDoneDesc: "The PDF is downloaded. Check your inbox as well.",
    lmNamePh: "Your name (optional)",
    lmEmailPh: "you@email.com",
    lmDownloading: "Downloading…",
    lmDownload: "Download the PDF free",
    lmPrivacy: "I use your data only to send you the PDF. I never spam.",
    lmInvalidEmail: "Enter a valid email",
    lmSuccess: "PDF downloaded + sent to your email",
    lmError: "Download failed",
    // calculators — shared
    calcEyebrow: "Run the numbers, no strings attached",
    calcHeading: "Try my calculators",
    calcSubtitle: "Simple, fast, no sign-up. First answers within a minute.",
    calcCompare: "Comparison",
    calcBookCta: "I want the exact numbers at a meeting",
    calcReset: "Try other values",
    calcDisclaimer: "Illustrative calculation. I run the exact numbers at a meeting – free and with no obligation.",
    calcUnitBn: "bn",
    calcUnitM: "m",
    calcUnitK: "k",
    calcUnitYears: "yrs",
    calcUnitPa: "% p.a.",
    calcUnitCount: "",
    // calculator: mortgage
    calcHypoTitle: "Mortgage calculator",
    calcHypoTagline: "Work out your monthly payment",
    calcHypoHint: "In 60 seconds you know what you pay",
    calcHypoAmount: "Loan amount",
    calcHypoRate: "Interest rate",
    calcHypoYears: "Loan term",
    calcHypoSubmit: "Calculate the monthly payment",
    calcHypoResult: "Your monthly payment will be",
    calcHypoSubtitle: "Over {years} {yearsUnit} you pay {total} in total",
    calcHypoContext: "Illustrative calculation for a level annuity payment. The real rate differs by LTV, creditworthiness and current market rates.",
    calcHypoBank: "Average bank ({rate} %)",
    calcHypoMine: "With my help ({rate} %)",
    calcHypoSavings: "You save {amount}",
    // calculator: investment
    calcInvestTitle: "Investing",
    calcInvestTagline: "How much can you earn long term?",
    calcInvestHint: "Compounding will surprise you",
    calcInvestMonthly: "I set aside monthly",
    calcInvestYears: "Investment horizon",
    calcInvestRate: "Expected return",
    calcInvestSubmit: "Calculate the future value",
    calcInvestResult: "In {years} {yearsUnit} you will have",
    calcInvestSubtitle: "Of which your own deposits: {deposited}",
    calcInvestContext: "The calculation assumes a steady average return – in reality it will differ year to year.",
    calcInvestBank: "Savings account at a bank (2 %)",
    calcInvestInvested: "Investment ({rate} %)",
    calcInvestDelta: "{amount} more",
    // calculator: life insurance
    calcLifeTitle: "Life insurance",
    calcLifeTagline: "How much cover you really need",
    calcLifeHint: "Without paying for extras you never use",
    calcLifeIncome: "Monthly net income",
    calcLifeLoans: "Mortgage + loans in total",
    calcLifeKids: "Number of children",
    calcLifeSubmit: "Calculate the sum insured you need",
    calcLifeResult: "Your sum insured should be",
    calcLifeSubtitle: "In the event of death or permanent disability",
    calcLifeContext: "Your family would have the debts repaid ({loans}), the children would have their education covered ({kids}) and 10 years of living costs from savings ({savings}). Most people are covered 10× less – paying a premium for a policy that saves nothing.",
    // calculator: financial independence
    calcFiTitle: "Financial independence",
    calcFiTagline: "When can you retire?",
    calcFiHint: "The 4 % rule will show you",
    calcFiTarget: "I want a monthly passive income of",
    calcFiCurrent: "Current savings / investments",
    calcFiYears: "I want to get there in",
    calcFiRate: "Expected return",
    calcFiSubmit: "Calculate my path to independence",
    calcFiResult: "For financial independence you need to build up",
    calcFiSubtitle: "Just set aside {monthly} a month for {years} {yearsUnit}",
    calcFiSubtitleDone: "Congratulations – your current savings will get there on their own in {years} {yearsUnit} 🎉",
    calcFiContext: "At a 4 % annual withdrawal rate this capital will generate {annual} a year ({monthly} a month) practically forever – without touching the principal.",
  },
  webtpl: {
    universal: {
      headline: "Your finances, under control.",
      subheadline: "I help clients set up their finances so they never have to fear the future again – mortgages, investments, insurance and retirement.",
      s1Title: "Mortgage", s1Desc: "I find you the best mortgage across all banks and guide you through the whole process.",
      s2Title: "Investments", s2Desc: "I build a portfolio tailored to your goals and risk profile.",
      s3Title: "Insurance", s3Desc: "Protection for your family, property and income. No pointless policies.",
      s4Title: "Retirement", s4Desc: "I show you how much to set aside for a comfortable retirement.",
    },
    family: {
      headline: "Finances for a family that wants peace of mind.",
      subheadline: "I look after families so they know where they stand – what is insured, where they save for the children, and how to enjoy retirement without worry.",
      s1Title: "Family protection", s1Desc: "Life and accident cover that truly protects – not policies that just collect premiums.",
      s2Title: "Saving for children", s2Desc: "How to start – and how much is enough – so the children have security at 18.",
      s3Title: "Housing", s3Desc: "Mortgage, property insurance, refinancing.",
      s4Title: "Health", s4Desc: "Private health insurance if you want faster care.",
    },
    mortgage: {
      headline: "A mortgage without the stress. I do it all for you.",
      subheadline: "13+ years of experience. I compare offers from all banks, negotiate the rate and take you from application to drawdown.",
      s1Title: "New mortgage", s1Desc: "From a flat to a family house. I handle the paperwork for you.",
      s2Title: "Refinancing", s2Desc: "Save thousands a month by moving to a bank with better terms.",
      s3Title: "Calculator", s3Desc: "We work out how much you can borrow and at what rate.",
      s4Title: "Free consultation", s4Desc: "The first meeting costs nothing – we review your situation.",
    },
    corporate: {
      headline: "Company finances without needless complexity.",
      subheadline: "I help business owners and managers structure their pay, employee benefits and their own investments.",
      s1Title: "Employee benefits", s1Desc: "Pension, life cover, meal allowance – set up tax-efficiently.",
      s2Title: "Owner compensation", s2Desc: "The optimal salary/dividend/benefit mix for a limited company owner.",
      s3Title: "Corporate investments", s3Desc: "How to put the company's spare cash to work.",
      s4Title: "Liability insurance", s4Desc: "D&O, cyber insurance, company property insurance.",
    },
    investments: {
      headline: "Building wealth. Long term. With discipline.",
      subheadline: "An investment portfolio built on data, low costs and your goals – not on promises of a guaranteed 20 % a year.",
      s1Title: "Global portfolio", s1Desc: "Diversification across markets, currencies and asset classes.",
      s2Title: "Goal-based investing", s2Desc: "A flat, retirement, the children's education – a separate strategy for each goal.",
      s3Title: "Rebalancing", s3Desc: "Regular portfolio maintenance so it keeps working for you.",
      s4Title: "Financial coaching", s4Desc: "I teach you how to think about money systematically.",
    },
  },
  klienti: {
    srcDoporuceni: 'Referral',
    srcInzerat: 'Advertisement',
    srcJine: 'Other',
    srcNabor: 'Recruiting',
    srcNavolavka: 'Cold calling via Beplan',
    srcTipar: 'Via a referrer',
    srcVlastni: 'Own network',
    crm: "CRM",
    title: "Clients",
    segmentace: "Segmentation",
    segmDesc: "gold, platinum, bronze, standard.",
    pipelineView: "Pipeline view",
    smartOnboarding: "Smart Onboarding",
    manual: "Add a new client",
    advanced: "Advanced",
    search: "Search a client by name, phone, email or city…",
    totalClients: "clients in total",
    active: "active",
    signedMonth: "signed this month",
    pipelineFull: "Pipeline view (KPIs, funnel, stages)",
    noContact: "No contact",
    fAll: "All",
    fActive: "Active",
    fStagnation: "Stalled 14+",
    fSigned: "Signed this month",
    fNoContact: "No contact 30+",
    fParked: "Not interested",
    colClient: "Client",
    colPhase: "Stage",
    colDays: "Days",
    colBj: "BJ",
    colAction: "ACTION",
    loading: "Loading…",
    noClients: "No clients",
    mNew: "New client",
    mSmartAdd: "I watch for duplicates as you type — by name, phone, email and company ID.",
    mIdent: "Identification",
    mName: "First name *", mSurname: "Last name", mPhone: "Phone", mEmail: "Email",
    mCity: "City", mAge: "Age", mIco: "Company ID / IČO (optional)", mCompany: "Company / sole trader",
    mCheckingDup: "Checking for duplicates…",
    mSegSource: "Segmentation and source",
    mDisc: "DISC typology (Pavel Procházka)",
    mRecruit: "Recruitment candidate (for the advisor team)",
    mNotePh: "Context, where you met, key information…",
    mCancel: "Cancel",
  },
  obchody: {
    addDealToPhase: 'Add a deal to the stage',
    addToPhase: 'Add to stage',
    awaitingPayout: 'awaiting payout',
    dealFew: 'deals',
    dealMany: 'deals',
    dealOne: 'deal',
    phaseOfTotal: 'Stage {poradi} of {celkem}',
    progressLeftRight: 'Deal progress from left to right',
    weighted: 'weighted',
    label: "Deals",
    caseOne: "deal", caseFew: "deals", caseMany: "deals",
    boardPre: "Deal", boardEm: "board",
    subtitle: "BJ in the pipeline · card colour = product type · drag a card to Won/Lost/Cancelled",
    newDeal: "New deal",
    search: "Search a deal, a client…",
    fAll: "All", fHypo: "Mortgage", fLoans: "Loans", fInsur: "Insurance", fInv: "Investments", fPension: "Pension",
    fReality: "Property",
    kanban: "Kanban", table: "Table",
    loading: "Loading deals…",
    unknownClient: "Unknown client",
    stale: "no activity", activeDeal: "active",
    modalTitle: "New deal", whatAbout: "What it is about", clientFromCard: "Client from the card",
    clientSearchPh: "Type the client's name, phone or email…", productType: "Product type *", provider: "Provider",
    dealName: "Deal name *", dealNamePh: "Enter the deal name", phase: "Stage", estBj: "Estimated BJ", valueCur: "Value",
    note: "Note", cancel: "Cancel", create: "Create deal", selectClient: "Select a client", cantCreate: "Cannot create the deal",
  },
  /* Realitni obchod ve slozce klienta (components/crm/RealityVeSlozce.js
     + realitni rezim v NewDealModal). Prodavajici a kupujici maji jiny obsah,
     proto jsou popisky oddelene od `zakazky`, ktere mluvi na kartu zakazky. */
  realSlozka: {
    kterouNemovitostVolitelne: 'Which property (optional)',
    zatimNevybrano: 'Not chosen yet',
    otevritPoptavku: 'Open the request',
    prodejNem: "Property sale",
    koupeNem: "Property purchase",
    nadpisProdej: "Selling",
    nadpisKoupe: "Buying",
    bezAdresy: "No address",
    cenaChybi: "price not set",
    veFaziNeznamo: "In this stage — start date unknown",
    bezObchodu: "This listing has no deal, the stage cannot be determined.",
    koupeBezObchodu: "No deal — only a reservation agreement.",
    zajemcu: "Enquiries",
    pristiProhlidka: "Next viewing",
    zadnaProhlidka: "No date yet",
    prihlaseno: "signed up",
    majitelOdkaz: "Owner page",
    majitelOdkazSub: "They can see for themselves what stage we are at and what we are doing.",
    majitelChybi: "Not created yet — create it on the listing card.",
    odkazPropadly: "expired",
    otevrit: "Open",
    kopirovat: "Copy link",
    zkopirovano: "Link copied",
    nezkopirovano: "Copying failed — select the link manually.",
    otevritZakazku: "Open listing",
    otevritObchod: "Open deal",
    zajemciAProhlidky: "Enquiries and viewings",
    inzeratOtevrit: "Open listing page",
    inzeratSkryty: "Listing page (private for now)",
    provize: "Sale commission",
    provizeNenastavena: "not set",
    postupZajemce: "Progress",
    rezervace: "Reservation agreement",
    rezervacePodepsana: "Signed",
    rezervaceRozepsana: "Drafted, not signed",
    rezervaceZadna: "None yet",
    rezervaceSepsat: "Draft reservation agreement",
    rezervaceOtevrit: "Open reservation agreement",
    hypoteka: "Mortgage",
    hypotekaZadna: "No mortgage case",
    hypotekaZalozit: "Start a mortgage",
    nemovitostNeznama: "The property is no longer in the system",
    predani: "Contact handover",
    predaniSub: "Handing a contact to another controller is processing of personal data. It only happens with consent and stays on record here.",
    predaniTy: "You",
    predaniNekdo: "Someone on the team",
    predaniPoradce: "Advisor",
    souhlasDan: "Consent given",
    souhlasNeznamy: "Consent without a recorded time",
    vzniklObchod: "Deal created",
    vzniklObchodJinde: "The advisor opened a case",
    vzniklObchodNe: "No deal has come of it yet",
    odmena: "Share",
    odmenaNenastavena: "Share not set — until you pick a base and a rate, nobody knows the amount.",
    chyba: "The property section failed to load. The deals below are fine.",
    adresa: "Property address",
    adresaPlaceholder: "Property address — 12 Main Street, Brno",
    adresaChybi: "Enter the property address",
    typNemovitosti: "Property type",
    cenaNabidkova: "Asking price",
    kterouNemovitost: "Which property",
    vyberNemovitost: "Pick a property",
    zadnaNemovitost: "You have no listings",
    nacitamNemovitosti: "Loading…",
    nemovitostiChyba: "Properties failed to load",
    koupePrefix: "Purchase —",
    koupeFaze0: "Enquired",
    koupeFaze1: "Viewing booked",
    koupeFaze2: "Attended viewing",
    koupeFaze3: "Serious interest",
    koupeFaze4: "Reservation",
    koupeFaze5: "Purchase contract",
    koupeFaze6: "Handover",
    predavkaStav: {
      navrzena: "Proposed",
      odeslana: "Sent",
      prijata: "Accepted",
      odmitnuta: "Declined",
      propadla: "Expired",
    },
  },
  dealmeta: {
    board: {
      analyza: "Financial analysis / Offered",
      proces: "Application / In progress",
      podpis: "Approval / Signature",
      cerpani: "Drawdown / Awaiting commission",
    },
    products: {
      hypoteka: "Mortgage", refinancovani: "Refinancing", podnikatelsky_uver: "Business loan",
      spotrebitelsky_uver: "Consumer loan", uver: "Loan", pojisteni_zivot: "Life", pojisteni_auta: "Motor",
      pojisteni_majetek: "Property", investice: "Investments", penzijko: "Pension", stavebni: "Building savings", jine: "Other",
      prodej_nemovitosti: "Property sale", koupe_nemovitosti: "Property purchase",
    },
  },
  /* BLOK:bilanceFlag START — generuje scratchpad/slovnik.py, ručně needitovat */
  bilanceFlag: {
    cfNegative: 'Expenses and instalments exceed income by {castka}/month',
    dstiHigh: 'High debt load — instalments are {pct} % of income (CNB recommends up to {max} %)',
    dstiHighBezRegulatora: 'High debt load — instalments are {pct} % of income',
    kidsNoLife: 'Family with children — check life cover (income protection)',
    reserveLow: 'Liquid reserve covers only {n} months — 6× expenses is ideal',
    reserveMid: 'Reserve covers {n} months — top it up to 6×',
    reserveOk: 'Reserve covers {n} months ✓',
  },
  /* BLOK:bilanceFlag END */
  bilancePanel: {
    title: "Live balance",
    close: "Close",
    netWorth: "Net worth",
    assets: "Assets",
    debts: "Debts",
    zTohoFinNefin: "financial {fin} · non-financial {nefin}",
    month: "Every month",
    income: "Income",
    expenses: "Expenses",
    repayments: "Repayments",
    free: "Free",
    deficit: "Shortfall",
    notEntered: "not entered",
    perMonth: "/month",
    reserve: "Liquid reserve",
    reserveUnit: "× expenses",
    dsti: "Debt load (DSTI)",
    /* Země bez závazného verdiktu DSTI (SK): jiná definice než NBS — AP-08, 19. 10. 2026. */
    dstiBezRegulatora: "Repayments / net income",
    savingRate: "Saving rate",
    cil: {
      reserve: "recommended {cil}×",
      dsti: "CNB guideline up to {max} %",
      saving: "ideal {ideal} %",
    },
    stav: {
      reserveLow: "low reserve",
      reserveMid: "top up to {cil}×",
      reserveOk: "met",
      dstiOk: "fine",
      dstiHigh: "above guideline",
      dstiHighBezRegulatora: "high debt load",
    },
    aria: {
      jmeni: "Net worth {ciste}: assets {majetek}, debts {dluhy}",
      mesic: "Monthly income {prijmy}: expenses {vydaje}, repayments {splatky}, free money {volne}",
      mesicSchodek: "Monthly income {prijmy}: expenses {vydaje} and repayments {splatky} exceed it by {schodek}",
    },
    chipNetWorth: "Net worth",
    chipFreeCf: "Free CF",
  },
  kompletnost: {
    jmeno: "Client's first and last name",
    narozeni: "Date of birth (age)",
    kontakt: "Contact (phone / e-mail)",
    cil: "At least one goal with an amount",
    prijmy: "Household income",
    vydaje: "Usual monthly expenses",
    rezerva: "Liquid reserve (accounts / cash)",
    investice: "Investments / savings",
    rizika: "Insurance / risks",
  },
  crmdash: {
    greetMorning: "Good morning", greetAfternoon: "Good afternoon", greetEvening: "Good evening",
    kObvolani: "{n} to call",
    poTerminuOne: "{n} task overdue", poTerminuFew: "{n} tasks overdue", poTerminuMany: "{n} tasks overdue",
    otevrenychUkoluOne: "{n} open task", otevrenychUkoluFew: "{n} open tasks", otevrenychUkoluMany: "{n} open tasks",
    podpisuOne: "{n} signing this month", podpisuFew: "{n} signings this month", podpisuMany: "{n} signings this month",
    bezPodpisu: "no signing yet this month", cistyStul: "Nothing waiting today — clean desk.",
    cipSplneno: "Plan met", cipVTempu: "On pace", cipZbyvaBj: "{n} BJ to go", cipBezPlanu: "No plan",
    cipPrazdnaPipeline: "Nothing in progress", cipPoTerminu: "{n} overdue", cipNicPoTerminu: "Nothing overdue", cipVolno: "No tasks",
    metrPlneni: "Monthly BJ plan progress", metrMesic: "Part of the month elapsed",
    rozvrzeni: "Layout", rozvrzeniKlasicke: "Classic", rozvrzeniDenMesic: "Day → Month", sekceDnes: "Today", sekceMesic: "Month",
    monthProgress: "Month progress", day: "day", of: "of",
    kpiBj: "BJ this month", planNotSet: "Plan not set", plan: "Plan",
    kpiProvize: "Commission this month", coef: "Coef.",
    kpiPipeline: "Active pipeline", openDeals: "open deals", contactsTotal: "contacts in total",
    kpiTasks: "Tasks to handle", noTasks: "No tasks", doneOf: "done out of",
    dealsPipeline: "Deal pipeline", openBoard: "Open the board", loadingDeals: "Loading deals…", noDeals: "No deals", more: "more",
    todayCalls: "To call today", upcomingTasks: "Upcoming tasks", stageDistribution: "Stage distribution",
    leadSources: "Lead sources", noData: "No data", pipelineByStage: "Pipeline by stage", recentActivity: "Recent activity",
    callAction: "Call", meetingAction: "Meeting", noInterestAction: "Not interested",
    funnelCalling: "Calls", funnelSigned: "Signed",
    saved: "Saved", saveFailed: "Could not save", loadFailed: "Could not load CRM data",
    noTasksYet: "No tasks", noCallsToday: "Nobody to call today", inPipeline: "In pipeline",
    subtitle: "Portfolio, diary and clients — all in one place.",
    openDiary: "Open the diary", adviser: "Advisor", adviserRole: "Advisor",
    topClients: "Top clients by AUM", topClientsSub: "Your strongest portfolios", allClients: "All",
    kpiClients: "Clients", kpiClientsHint: "Active portfolio", kpiVip: "VIP", kpiVipHint: "Gold tier",
    kpiWeek: "This week", kpiWeekHint: "Meetings scheduled", kpiAum: "AUM / BJ", kpiAumHint: "Under management",
    noTopClients: "No clients yet",
    bulkToday: "To today",
    bulkWeek: "By a week",
    bulkTodayHint: "Move every overdue task to today",
    bulkWeekHint: "Push every overdue task back by a week",
    bulkConfirmToday: "Move {n} overdue tasks to today?",
    bulkConfirmWeek: "Push {n} overdue tasks back by a week?",
    bulkRunning: "Moving…",
    bulkDoneOne: "{n} task moved",
    bulkDoneFew: "{n} tasks moved",
    bulkDoneMany: "{n} tasks moved",
    bulkPartial: "{ok} moved, {err} failed",
    bulkFailed: "Could not move the tasks",
  /* PANELY NÁSTĚNKY — dřív mapy PANEL_*_SK v pages/crm/CRMDashboardPage.js,
     které uměly jen cs+sk (Vietnamec i Ukrajinec dostal češtinu). */
  panelKat: {
    vse: 'All',
    prehledy: 'Quick overviews',
    obchod: 'Deals',
    klienti: 'Clients & service',
    nastroje: 'Tools',
  },
  panel: {
    zrcadlo: {
      title: 'Call mirror — who to call today',
      desc: 'Call queue: who has waited longest, where they came from, call in one click.',
      helpLabel: 'Call mirror',
      helpText: 'Who is waiting to be called — the same queue as the Call mirror page, just shortened. At the top how many people are waiting, below that the five who have waited longest (longest wait first), each with the lead source and phone number. Call opens the phone, Arranged moves the contact to the Introduction stage and it leaves the queue.',
    },
    brifink: {
      title: 'Morning briefing',
      desc: 'What is on today · what is overdue · what is done · what is coming.',
      helpLabel: 'Morning briefing',
      helpText: 'Four questions in one place: what is on today, what is overdue, what is done, what is coming. Each item shows the client and the deal it belongs to. All of it from the calendar, clients and deals — when there is nothing, the section says so. On an item: + add to the plan, clock snooze for later, × remove from today’s briefing.',
    },
    diar: {
      title: 'Calendar — week',
      desc: 'Meetings and tasks for the whole week in one place.',
      helpLabel: 'Calendar — week',
      helpText: 'Meetings and tasks for the whole week. The number next to a day = the number of tasks; clicking opens the calendar.',
    },
    radar: {
      title: 'Service radar',
      desc: 'Clients whose service meeting is coming up.',
      helpLabel: 'Service radar',
      helpText: 'Clients approaching the end of a rate fixation, an anniversary or maturity — who to contact about service.',
    },
    prilezitosti: {
      title: 'Opportunity radar',
      desc: 'Gaps in the portfolio and opportunities to reach out.',
      helpLabel: 'Opportunity radar',
      helpText: 'Gaps in client portfolios sorted by score — where the biggest opportunity to reach out is.',
    },
    kpi: {
      title: 'KPI tiles',
      desc: 'Key numbers of the month: BJ, commission, pipeline, tasks.',
      helpLabel: 'KPI tiles',
      helpText: 'Key numbers of the month (BJ, commission, pipeline, tasks). Clicking a tile opens the detail in Deals or Calendar.',
    },
    pipeline: {
      title: 'Deal pipeline',
      desc: 'Deals split by pipeline stage.',
      helpLabel: 'Deal pipeline',
      helpText: 'Open deals by stage (analysis → drawdown) including the weighted commission forecast. Click → Deals.',
    },
    akce: {
      title: 'Needs action today',
      desc: 'What is urgent today and waiting for your action.',
      helpLabel: 'Needs action today',
      helpText: 'Today’s queue: overdue tasks and deals with no next step planned. Click → detail.',
    },
    volani: {
      title: 'To call today',
      desc: 'Contacts that need calling today.',
      helpLabel: 'To call today',
      helpText: 'Contacts to call by priority VIP → A → B → C. Buttons: phone = call · ✓ meeting arranged · ✗ not interested.',
    },
    ukoly: {
      title: 'Upcoming tasks',
      desc: 'The nearest tasks sorted by due date.',
      helpLabel: 'Upcoming tasks',
      helpText: 'The nearest unfinished tasks by due date. Click → Calendar.',
    },
    emaily: {
      title: 'Emails',
      desc: 'Unread emails right on the dashboard.',
      helpLabel: 'Emails',
      helpText: 'The latest unread emails from the connected Gmail. Click → Mail.',
    },
    klienti: {
      title: 'Recent client activity',
      desc: 'The latest movement on your clients.',
      helpLabel: 'Clients',
      helpText: 'Recently edited clients — quick access to the folder. Click → Clients.',
    },
    topklienti: {
      title: 'Top clients by AUM',
      desc: 'The most valuable clients by asset volume.',
      helpLabel: 'Top clients by AUM',
      helpText: 'The most valuable clients by asset volume (BJ). Click → Clients.',
    },
    faze: {
      title: 'Stage distribution',
      desc: 'Contacts split by deal stage.',
      helpLabel: 'Stage distribution',
      helpText: 'The number of contacts at each deal stage — where the work piles up.',
    },
    zdroje: {
      title: 'Lead sources',
      desc: 'Where most of your leads come from.',
      helpLabel: 'Lead sources',
      helpText: 'Where most of your contacts come from (lead generator, referrals, web…).',
    },
    nastroje: {
      title: 'Quick tools',
      desc: 'Quick shortcuts to calculators and tools.',
      helpLabel: 'Quick tools',
      helpText: 'Shortcuts to calculators and tools split into categories.',
    },
    poznamky: {
      title: 'Notes',
      desc: 'A blank sheet for quick notes with labels.',
      helpLabel: 'Notes',
      helpText: 'A blank sheet for anything — the text saves itself. Sort notes with a label and filter by it at the top.',
    },
    vyvoj: {
      title: 'Deal trend',
      desc: 'Closed deals over time.',
      helpLabel: 'Deal trend',
      helpText: 'Closed deals over time — the trend of signed BJ by month. Switch the period with the buttons.',
    },
    plan: {
      title: 'Plan fulfilment',
      desc: 'How close you are to the monthly BJ plan.',
      helpLabel: 'Plan fulfilment',
      helpText: 'How close you are to the monthly BJ plan; the needle shows the % completed and the estimated commission.',
    },
    trychtyr: {
      title: 'Sales funnel',
      desc: 'How much you have in play at each stage.',
      helpLabel: 'Sales funnel',
      helpText: 'How many deals and BJ you have at each stage and how long they sit there on average.',
    },
  },
  },
  /* BLOK:diar START — generuje scratchpad/slovnik.py, ručně needitovat */
  diar: {
    activity: 'Activity',
    agenda: 'List',
    agendaSub: 'List of activities',
    agendaTitle: 'Upcoming',
    allDay: 'All day',
    calls: 'calls',
    dFri: 'Fri',
    dMon: 'Mon',
    dSat: 'Sat',
    dSun: 'Sun',
    dThu: 'Thu',
    dTue: 'Tue',
    dWed: 'Wed',
    day: 'Day',
    days: 'days',
    editActivity: 'Edit activity',
    filters: 'Filters',
    hintKlik: 'Click the grid',
    hintKlikZbytek: 'to create a quick event.',
    hintTah: 'Drag',
    hintTahZbytek: 'to move it; drag the bottom edge to change its length.',
    m01: 'January',
    m02: 'February',
    m03: 'March',
    m04: 'April',
    m05: 'May',
    m06: 'June',
    m07: 'July',
    m08: 'August',
    m09: 'September',
    m10: 'October',
    m11: 'November',
    m12: 'December',
    meetings: 'meetings',
    month: 'Month',
    monthOverview: 'Month overview',
    newActivity: 'New activity',
    nextWeek: 'Next week',
    prevWeek: 'Previous week',
    refreshed: 'Diary refreshed',
    sync: 'Sync',
    tDopis: 'Letter',
    tEmail: 'Email',
    tSchuzka: 'Meeting',
    tTelefonat: 'Phone call',
    tUdalost: 'Event',
    tUkol: 'Task',
    tasks: 'tasks',
    tip: 'Tip',
    today: 'Today',
    week: 'Week',
    weekNo: 'week',
  },
  /* BLOK:diar END */
  hypo: {
    active: "Active", waitOdhad: "Awaiting valuation", naKatastru: "At the Land Registry", blizkoCerpani: "Close to drawdown", cerpanoMesic: "Drawn down (month)",
    search: "Search a mortgage…", colClient: "Client", colBank: "Bank", colPhase: "Process stage", colWaiting: "Waiting for", colNextStep: "Next step", aiWatch: "AI WATCH", colAmount: "Amount / LTV", loading: "Loading mortgages…", shown: "Shown", activeMortgages: "active mortgages",
  },
  deal: {
    notFound: "Deal not found", dealValue: "Deal value", caseProgress: "Deal progress",
    save: "Save", edit: "Edit", nextStep: "Next step in the deal",
    subject: "Subject", price: "Price", ownFunds: "Own contribution", note: "Note",
    purchasePrice: "Purchase price", ownResources: "Own funds", monthlyPayment: "Monthly payment",
    keyParam: "Key parameter", keyPh: "Key (e.g. LTV)", valuePh: "Value",
    people: "People in the deal", addRole: "Quickly add a role",
    resWon: "Won", resLost: "Lost", resCancelled: "Cancelled", resOpen: "In progress",
    cantSave: "Cannot save", cantChangeStage: "Cannot change the stage", cantAddNote: "Cannot add the note",
    cantWin: "Cannot confirm the win", error: "Error", cancelled: "Cancelled", deleted: "Deleted",
    roleRealitni: "Estate agent", roleProdejce: "Seller", roleKupujici: "Buyer", roleOdhadce: "Valuer",
    roleBanker: "Banker", rolePravnik: "Lawyer / notary", roleDruhyKlient: "Second client", roleDeveloper: "Developer", roleHlavniKlient: "Primary client", rolePlaceholder: "Role (e.g. Banker)", roleSystemovaHint: "This role is set by the system and cannot be edited.",
  },
  /* Levá lišta + chrome aplikace. Dřív to byl SK-only overlay `SK_NAV`,
   * takže vietnamec i ukrajinec viděli českou navigaci na KAŽDÉ obrazovce. */
  /* Uvítací modal po prvním přihlášení (components/FirstLoginWizard.js).
   * {jmeno} se dosazuje v komponentě — nesmí se z překladu vypustit. */
  wizard: {
    /* Zástupné slovo, když poradce nemá vyplněné jméno. Do 23. 8. 2026
       bylo v FirstLoginWizard.js natvrdo české „svoji“, takže Vietnamec
       četl „danh thiếp số của svoji“. */
    zastupneJmeno: 'your',
    vitej: 'Welcome to BEplan University',
    nadpis: 'Set up {jmeno} digital business card',
    popisA: 'Your card is your public page — clients book a meeting, call you and find you on LinkedIn from there.',
    popisZvyraznene: 'It takes 30 seconds',
    popisB: 'and then all your Leadovač links and the referral card start working.',
    slugLabel: 'Your URL address (slug)',
    nahled: 'Preview:',
    nastavitVizitku: 'Set up card',
    preskocit: 'Skip for now',
    pozdejiA: 'If you skip now, you can set the card up any time in',
    pozdejiKde: 'Settings → Business card',
    pozdejiB: 'But we recommend doing it right away — without a slug Leadovač will not run.',
    hotovo: 'Done!',
    vrhnemeSe: 'Heading to the CRM…',
    ulozeno: 'Card saved!',
    chyba: 'Saving the slug failed. You can try again in Settings → Business card.',
  },
  lista: {
    nastenka: 'Dashboard',
    klienti: 'Clients',
    obchody: 'Deals',
    diar: 'Calendar',
    posta: 'Mail',
    manazer: 'Manager',
    vzdelavani: 'Learning',
    nastroje: 'Tools',
    adresar: 'Directory',
    zrcadloVolani: 'Call mirror',
    pipelineKlientu: 'Client pipeline',
    radarPrilezitosti: 'Opportunity radar',
    mapaKlientu: 'Client map',
    leadyProjekt100: 'Leads (Project 100)',
    obchodniNastenka: 'Deals dashboard',
    hypotecniPipeline: 'Mortgage pipeline',
    naborovaPipeline: 'Recruiting pipeline',
    naborovyRadar: 'Recruiting radar',
    zakazkyReality: 'Listings (real estate)',
    realitniPipeline: 'Listings pipeline',
    rezervacniSmlouva: 'Reservation agreement',
    prehledTymu: 'Team overview',
    ikKonzultace: 'IK consultations',
    mojiPoradci: 'My advisors',
    vyhlaseniVysledku: 'Results announcement',
    tymoveAkce: 'Team events',
    diarTymu: 'Team calendar',
    startNovacka: 'Rookie start (90-day path)',
    adaptace7: '7-day onboarding',
    adaptaceTymu: 'Team onboarding',
    akademieModuly: 'Academy — modules & infographics',
    metodikaPlan: 'Methodology: Building the plan',
    zkouskaCertifikat: 'Exam & certificate',
    skriptyNamitky: 'Scripts & objections',
    kdeShanetKlienty: 'Where to find clients',
    videaKurzy: 'Videos & courses',
    rozcestnikNastroju: 'Tools directory',
    financniMatematika: 'Financial maths',
    kalkulacky21: 'Calculators (20)',
    penzijniKalkulacka: 'Pension calculator',
    zivotniPojisteni: 'Life insurance',
    historickaKalkulacka: 'Historical calculator',
    investicniStrategie: 'Investment strategies',
    srovnavacFondu: 'Fund comparison',
    nemovitostPronajem: 'Buy-to-let property',
    provizniKalkulacka: 'Commission calculator',
    hledat: 'Search',
    hledatVCeleAplikaci: 'Search the whole app',
    naNastenku: 'To dashboard',
    profilPoradce: 'Advisor profile (set photo in Settings)',
    zavritMenu: 'Close menu',
    sbalit: 'Collapse',
    pripnout: 'Pin',
    sbalitListu: 'Collapse sidebar',
    pripnoutRozbalene: 'Pin expanded',
    novyZaznam: 'New record — client, lead, deal, task…',
    novyZaznamTlacitko: 'New record',
    ucet: 'Account',
    novyKlient: 'New client',
    novyKlientSub: 'Add to pipeline',
    novyLead: 'New lead',
    novyLeadSub: 'Opportunity / warm contact',
    obchodniPripad: 'Deal',
    obchodniPripadSub: 'Create deal right away',
    naborKandidat: 'Recruiting — candidate',
    naborKandidatSub: 'Create candidate right away',
    ukolSchuzka: 'Task / Meeting',
    ukolSchuzkaSub: 'Open Calendar',
    leadZDoporuceni: 'Referral lead',
    leadZDoporuceniSub: 'Link for the client',
    // horní lišta záložek (GlobalTabBar) — zbylých 28; ostatní sdílí klíče výše
    tabLeady: 'Leads',
    tabServisRadar: 'Service radar',
    tabKomunikace: 'Communication',
    tabDoporuceni: 'Referrals',
    tabCile: 'Goals',
    tabVyhlaseni: 'Announcement',
    tabSmlouva: 'Contract',
    tabHypoteky: 'Mortgages',
    tabNabor: 'Recruiting',
    tabHlasovyRezim: 'Voice mode',
    tabRezervace: 'Bookings',
    tabTrychtyre: 'Funnels',
    tabHistoricka: 'Historical',
    tabFinMatematika: 'Fin. maths',
    tabInvesticniStudio: 'Investment studio',
    tabStrategie: 'Strategies',
    tabPenze: 'Pension',
    tabIzp: 'Analysis for Vietnamese clients',
    tabRentaPorovnavac: "Withdrawal comparison",
    tabAnalyza: "Analysis",
    tabFixace: "Fixed period",
    tabSvoboda: "When you'll be free",
    tabHypotekaRozhodnuti: "Mortgage — decisions",
    tabPortfolioDoktor: 'Portfolio doctor',
    tabReality: 'Real estate',
    tabZakazky: 'Listings',
    tabRezervacniSmlouva: 'Reservation contract',
    tabNemovitost: 'Property',
    tabKalkulackaVizual: 'Calculator visual',
    tabProvize: 'Commissions',
    tabDesignLab: 'Design Lab',
    tabAdmin: 'Admin',
    tabAiKnowledge: 'AI Knowledge',
    tabHlasovky: 'Voice notes',
    tabHromadnyEmail: 'Bulk email',
    tabPortfolioAdmin: 'Portfolio (admin)',
    tabTrzniData: 'Market data',
    tabMesicnikAdmin: 'Monthly (admin)',
    tabMesicnik: 'Monthly',
    tabDataHygiena: 'Data hygiene',
    tabNastaveni: 'Settings',
    tabNovinky: 'What’s new',
  },
  nav: { dashboard: "Dashboard", calculators: "Calculators", tools: "Tools", admin: "Admin", logout: "Sign out", theme: "Theme" },
  login: {
    subtitle: "Education system for financial advisors",
    welcomePre: "Welcome to the",
    welcomeEm: "university",
    name: "Full name",
    accessCode: "Access code",
    registerClosed: "Registration is currently closed. Ask the administrator for an invite or to enable sign-ups.",
    email: "Email",
    password: "Password",
    submit: "Sign in",
    register: "Sign up",
    loading: "Loading…",
    loginOk: "Logged in successfully",
    registerOk: "Account created",
    loginErr: "Login failed",
    hasAccount: "Already have an account? Sign in",
    noAccount: "No account yet? Sign up",
    forgot: "Forgot your password?",
    forgotTitle: "Password reset",
    sendCode: "Send a code to my email",
    codeSent: "If the email exists, we have sent a code to it.",
    codeLabel: "Reset code from the email",
    newPass: "New password (min. 8 characters)",
    resetBtn: "Set the new password",
    resetOk: "Password reset — please sign in",
    backToLogin: "Back to sign in",
  },
  dash: {
    welcome: "Welcome to beplan University",
    subtitle: "Your education system for financial advisory",
    progress: "Total progress",
    completedVids: "Completed videos",
    activeSeries: "Active series",
    totalProgress: "Total progress",
    series: "Education series",
    done: "DONE",
    inProgress: "IN PROGRESS",
    vidsDone: "videos done",
    lastWatch: "Last watched",
  },
  detail: {
    notFound: "Series not found",
    locked: "Series locked",
    lockedDesc: "Finish the previous series to unlock.",
    back: "Back to dashboard",
    seriesLabel: "Series",
    markDone: "Mark as done",
    isDone: "Done",
    download: "Download materials",
    noMaterial: "Materials unavailable",
    comments: "Comments",
    writeComment: "Write a comment or feedback…",
    send: "Send",
    sending: "Sending…",
    noComments: "No comments yet. Be the first!",
    reply: "Reply",
    del: "Delete",
    writeReply: "Write a reply…",
    vidDone: "Video marked as done!",
    saveErr: "Save failed",
    commentOk: "Comment added",
    commentErr: "Comment failed",
    replyOk: "Reply added",
    delOk: "Comment deleted",
    delErr: "Delete failed",
  },
  calcPage: {
    title: "Financial calculators",
    subtitle: "Professional tools for financial planning and advisory",
    all: "All",
    realestate: "Real estate",
    investment: "Investment",
    insurance: "Insurance & Pension",
    personal: "Personal finance",
    open: "Open calculator",
  },
  toolsPage: {
    catObchod: "Sales & commission",
    catKalkulacky: "Calculators & maths",
    catVzdelavani: "Education",
    tileObchod: "Sales",
    tileKalkulacka: "Calculator",
    tileVzdelavani: "Education",
    title: "Tools for financial advisors",
    subtitle: "Professional tools for efficient work",
    open: "Open",
  },
  admin: { loading: "Loading…",
    title: "Administration",
    codeTitle: "Access code",
    codeDesc: "New users need this code to register. You can change it any time.",
    save: "Save",
    curCode: "Current code:",
    users: "Users",
    videoTitle: "Video management",
    videoDesc: "Add YouTube links and downloadable materials (Google Drive) for each video.",
    vids: "videos",
    ytUrl: "YouTube URL",
    matUrl: "Materials (Google Drive)",
    saving: "Saving…",
    saved: "Video updated",
    saveErr: "Save failed",
    loadErr: "Loading failed",
    codeOk: "Access code updated",
    codeErr: "Update failed",
    noName: "No name",
    confirmDelete: "Really delete this user?",
    userDeleted: "User deleted",
    deleteErr: "Delete failed",
    deleteUser: "Delete user",
  },
  common: {
    reset: "Reset",
    start: "Start",
    pause: "Pause",
    min: "min",
    progress: "Progress",
    phase: "Phase",
    search: "Search…",
    noResults: "No results",
    example: "Example",
    save: "Save",
    saving: "Saving…",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    add: "Add",
    close: "Close",
    back: "Back",
    next: "Next",
    yes: "Yes",
    no: "No",
    confirm: "Confirm",
    loading: "Loading…",
    copy: "Copy",
    copied: "Copied",
    open: "Open",
    new: "New",
    today: "Today",
    week: "Week",
    total: "Total",
    name: "Name",
    phone: "Phone",
    email: "Email",
    note: "Note",
    required: "Required",
    optional: "Optional",
    submit: "Submit",
    submitting: "Submitting…",
    detail: "Detail",
    settings: "Settings",
    backToSettings: "Back to settings",
  },
  crm: {
    title: "CRM Advisor",
    advisorWord: "Advisor",
    subtitle: "Contacts, pipeline, calls and IC — all in one place.",
    beginner: "Beginner",
    overview: "Overview",
    p100: "Project 100",
    calls: "Call reflection",
    pipeline: "Pipeline",
    ik: "IC consultation",
    goals: "Goals & Rocks",
    team: "My advisors",
    leadovac: "Leadovač",
    stages: {
      lead: "Lead",
      calling: "To call",
      meeting: "Meeting set",
      onboarding: "Onboarding",
      proposal: "Proposal",
      contract: "Contract",
      active: "Active client",
      lost: "Lost",
    },
    actions: {
      call: "Call",
      schedule: "Schedule",
      callback: "Callback",
      later: "Later",
      noInterest: "No interest",
      addContact: "Add contact",
      newLead: "New lead",
    },
  },
  leadovac: {
    title: "Leadovač",
    subtitle: "Sales funnel for capturing leads. Send the link to your client via WhatsApp — they go through the topic, run the calculator, leave a request. You get a new lead in your Call Reflection.",
    latestLeads: "Latest leads",
    latestLeadsSub: "Updates every 20s · incoming requests across topics",
    live: "live",
    today: "today",
    week: "week",
    total: "total",
    filter: { all: "All" },
    tools: "Your leadgen tools",
    toolsSub: "4 ready-made premium funnels — click and share with the client.",
    setSlugFirst: "Set up your URL slug first →",
    open: "Open",
    detail: "Detail & share",
    detailRef: "Create link for client",
    noLeads: "No leads yet. Send the link to a client and watch them come in.",
    moreLeads: "more — open this topic to see them",
    badgeLead: "lead",
    badgeLeads: "leads",
    badgeLink: "link",
    badgeLinks: "links",
  },
  leadForm: {
    eyebrowConsult: "30 minutes free",
    yourName: "Your name",
    yourNamePh: "Jane Doe",
    yourPhone: "Phone",
    yourPhonePh: "+1 555 555 555",
    yourEmail: "Email (optional)",
    yourEmailPh: "name@example.com",
    note: "Brief note (optional)",
    notePh: "What is most important to you, when you'd like to meet, etc.",
    preferredTime: "Preferred meeting time",
    preferredTimePh: "e.g. weekday afternoon",
    consent: "By submitting I agree to be contacted with my data.",
    successTitle: "Thank you!",
    successSubtitle: "I will contact you within 24 hours.",
    successHint: "Watch your phone — I usually call back the same day.",
    bookHeading: "Or pick a time directly",
    bookSubtitle: "Choose a day and time that works for you. No pressure, no obligation.",
    bookCta: "Pick a consultation time",
    ctaTryCalc: "Try the calculator",
    ctaWantConsult: "I want a consultation",
    notFound: "Page not found",
    unknownTopic: "Unknown topic",
    errName: "Please enter your full name",
    errPhone: "Please enter a valid phone number",
    errSend: "Sending failed, please try again.",
    calcEyebrow: "See for yourself",
    calcTitle: "{tema} calculator",
    calcSub: "Move the sliders and watch the numbers change live. It is not a scientific model, but an estimate accurate enough to get your bearings.",
    howEyebrow: "How it works",
    howTitle: "Four steps from question to solution",
    examplesEyebrow: "Model examples",
    examplesTitle: "What this could look like in your situation",
    examplesNote: "Illustrative scenarios — to show what can actually be solved. The real outcome always depends on your specific situation.",
    exSituation: "Situation:",
    exSolution: "Solution:",
    preparedBy: "This page was prepared for you by",
    bookPoint1: "30-45 minutes, online via Google Meet or in person",
    bookPoint2: "No pressure to sign anything",
    bookPoint3: "You get a written summary within 48 hours",
    nextWeek: "Next week",
    freeEyebrow: "No commitment · Free",
    getTitle: "What you get",
    get1: "A tailored calculation from your own numbers — free",
    get2: "I will get back to you within 24 hours, at a time that suits you",
    get3: "No strings attached — the decision is always yours",
    timeMorning: "Morning (11–13)",
    timeAfternoon: "Afternoon (13–17)",
    timeEvening: "Evening (17–20)",
    timeAnytime: "Anytime",
    privacy: "Privacy policy",
    weekdayShort: "Mon,Tue,Wed,Thu,Fri,Sat,Sun",
    midCtaHeading: "Just 30 minutes. Nothing to lose.",
    midCtaSub: "No pressure, no promises. Only numbers and a clear head.",
    whatToExpect: "What to expect from working together",
    wantToDiscuss: "Want to talk it through?",
    freeConsult30: "30 min consultation free · no obligation",
    term: "Slot",
    inquiry: "Enquiry",
  },
  vizitka: {
    title: "Digital business card",
    subtitle: "URL slug, QR code, colors and printable card — everything in one place.",
    slug: "URL slug",
    slugHelp: "3–40 chars, lowercase letters, digits, dash.",
    qrTitle: "URL slug & QR code",
    qrSaveHint: "Save the QR to email signature, business card, website…",
    print: "Generate printable card (A4)",
    colors: "Card colors",
    custom: "Custom",
    bg: "Background",
    accent: "Accent",
    save: "Save business card",
  },
  booking: {
    pub: {
      inactive: "This advisor has not enabled online booking yet.",
      notFound: "Advisor not found or the link is invalid.",
      loading: "Loading…",
      notAvailable: "Booking is not available",
      meeting: "Meeting",
      chooseService: "Choose a meeting type",
      changeService: "Change meeting type",
      pickHeading: "Select a date and time",
      pickDate: "Pick a date in the calendar",
      loadingSlots: "Loading available times…",
      noSlots: "No times available on this day.",
      prevMonth: "Previous month",
      nextMonth: "Next month",
      tzLabel: "Time zone",
      reservingFor: "You are booking",
      changeTime: "Change time",
      detailsHeading: "Your details",
      nameLabel: "Full name",
      emailLabel: "E-mail",
      phoneLabel: "Phone",
      noteLabel: "What would you like to discuss?",
      submitBtn: "Confirm booking",
      submitting: "Booking…",
      fillRequired: "Please fill in your name and e-mail",
      badEmail: "Please enter a valid e-mail",
      bookingFailed: "Booking failed",
      gdprInfo: "By submitting this booking you pass your name, e-mail, phone number and note to the advisor, who stores them in their client records so they can prepare for the meeting and get in touch. You can ask for deletion at any time.",
      confirmedTitle: "Meeting confirmed",
      date: "Time",
      sentTo: "Confirmation sent to",
      sentNone: "We could not send the e-mail confirmation right now — please note the time down. Your advisor will be in touch.",
      advisorContact: "If you need anything, write to your advisor at",
      meetLink: "Google Meet link",
    },
    svc: {
      uvod15: "Introductory meeting", uvod15d: "A quick, non-binding introduction — who I am, how I work and whether we click.",
      analyza45: "Financial analysis", analyza45d: "We go through your goals, income and expenses — the basis of a financial plan.",
      hypoteka: "Mortgage consultation", hypotekad: "We calculate the mortgage and compare offers from several banks.",
      servis60: "Service meeting", servis60d: "A review of your existing contracts and an update of your plan.",
    },
    title: "Online booking — settings",
    subtitle: "Connect Google Calendar, set working hours, buffer and meeting length. Clients book directly to your calendar.",
    enable: "Enable online bookings",
    embedTitle: "Show Cal.com embed on your card",
    embedSub: "Client books directly on the card (requires Calendar URL in profile).",
    googleConnected: "Google Calendar connected",
    connectGoogle: "Connect Google Calendar",
    workHours: "Working hours",
    meetingLength: "Meeting length (min)",
    buffer: "Buffer between meetings (min)",
    save: "Save settings",
    publicLink: "Public booking link",
    upcoming: "Upcoming meetings",
  },
  settings: {
    jazykAplikace: 'App language',
    jazykNeniMena: 'The language only changes the wording. The currency follows the country (Czechia → CZK, Slovakia → EUR), not the language.',
    menaAplikace: 'Currency of the whole app: {kod} ({symbol}). Switching the language does NOT change the currency and amounts are not converted — the app has no exchange rate. Changing the country only relabels newly entered amounts; existing data stays in its original currency.',
    motivAktivni: 'Active theme: ',
    motivJenHotove: 'Only finished themes are offered. Elite Light was removed and the dark theme was never completed, so you will not find them here.',
    motivPoznamka: ' · The theme is your personal setting in this browser and is never sent to clients. It does NOT change the colours of the client-facing business card — those live in the Digital business card.',
    oMne: 'About me (shown on the business card)',
    oMnePlaceholder: 'I help people reach financial freedom...',
    vzhledSub: 'Pick an app theme — the colours change instantly and your choice survives a page reload.',
    zeme: 'Country (sets the currency)',
    zemeCZ: 'Czechia',
    zemeSK: 'Slovakia',
    title: "Settings",
    profile: "Profile",
    web: "My website",
    webSub: "Pro mini-website with booking — template, services, references, FAQ.",
    booking: "Meeting bookings",
    bookingSub: "Google Calendar, working hours, buffer, meeting length.",
    vizitka: "Digital business card",
    vizitkaSub: "URL slug, QR code, colors, printable A4.",
    active: "ACTIVE",
    saveProfile: "Save profile",
    tabZakladni: "Basic details", tabVzhled: "App appearance", tabManazer: "My manager", tabSocialni: "Social networks",
    tabModelace: "Modelling", tabVideo: "Video intro", tabStatistiky: "Statistics", tabHeslo: "Change password", tabRezervace: "Meeting bookings",
    fJmeno: "Name *", fTelefon: "Phone", fEmail: "Public email", fSpolecnost: "Company",
    stareHeslo: "Old password", noveHeslo: "New password", potvrditHeslo: "Confirm new", zmenitHeslo: "Change password",
    fFotka: "Advisor photo", fLogo: "Company logo (optional)", fEmailManazera: "Manager's email",
  },
  cui: {
    mortgageModeling: "Mortgage model",
    loanSummary: "Loan summary",
    amortTableTitle: "Repayment schedule (by year)",
    tableYear: "Year",
    remaining: "Left to repay",
    interestOfWhich: "Of that, in interest",
    disclaimerMortgagePdf: "The calculation is indicative. The bank's actual offer may differ according to the client's creditworthiness, the LTV and current market conditions. The model does not replace a binding loan offer.",
    modelReady: "The model is ready",
    pdfFailed: "The PDF could not be generated. Please try again.",
    narrativeRate: "Both the payment and the total cost of the loan are driven above all by the interest rate and the length of the fixation — it pays to compare them regularly.",
    narrativeInterest: "Over the whole repayment period you pay considerably more in interest than the loan amount itself; a shorter term reduces the overpayment.",
    live: "Live calc",
    exportPdf: "Export PDF for client",
    mortgageHeadline: "How much will your <em>own</em> home cost?",
    propertyPrice: "Property price",
    downPayment: "Own funds",
    rate: "Interest rate",
    years: "Loan period",
    yearsUnit: "years",
    monthsUnit: "months",
    monthlyPayment: "Monthly payment",
    annuitySub: "Fixed-rate annuity payment",
    overpayment: "Overpayment",
    overPrincipal: "over principal",
    times: "×",
    loanAmount: "Loan amount",
    totalPaid: "You'll pay total",
    interestPaid: "of which interest",
    ltvLow: "Low LTV — you'll get a better rate.",
    ltvStd: "Standard LTV — fine with most banks.",
    ltvHigh: "Above the binding limit of {limit} — you need at least {castka} of own funds.",
    applicantAge: "Applicant's age",
    ltvLimit: "Binding {regulator} limit: {limit}.",
    ltvBezVeku: "Without an age the stricter limit of {limit} applies (under 36: {mladi}).",
    principal: "Principal",
    interest: "Interest",
    investmentHeadline: "Where could your money be in <em>X</em> years?",
    monthlyDeposit: "Monthly deposit",
    initialAmount: "Initial amount",
    horizon: "Investment horizon",
    expectedReturn: "Expected return",
    portfolioValue: "Portfolio value",
    deposited: "Deposited",
    earned: "Earned by interest",
    chartLegendDeposit: "Deposits",
    chartLegendValue: "Portfolio value",
    disclaimer: "Calculation is illustrative. Actual bank offer may differ based on client creditworthiness, LTV and current market conditions.",
    disclaimerInv: "Past returns do not guarantee future returns. Calculation is illustrative.",
    investmentModeling: "Investment modeling",
    oneTimeInvest: "One-time investment",
    monthlyInvest: "Monthly investment",
    investHorizon: "Planned investment horizon",
    riskProfile: "Risk profile",
    expectedValue: "Expected value",
    expectedValueSub: "Expected value at the end of investment",
    optimistic: "Optimistic scenario",
    pessimistic: "Pessimistic scenario",
    totalDeposited: "Total deposited",
    today: "Today",
    yearN: "year",
    deposit: "Deposit",
    zhodnoceni: "Growth",
    poslatKlientovi: "Send to client",
    rizikoPopis: "A higher risk profile can bring a higher return, but also larger swings in value. Figures are based on historical returns of global equity markets.",
    narrativeInv1: "Regular investing uses the power of compounding — the sooner you start, the more time works for you.",
    narrativeInv2: "This is a model estimate based on the chosen risk profile; returns are not guaranteed and the value of the investment fluctuates over time.",
  },
  // Series — titles + subtitles only (videos & descriptions fall back to Czech)
  s: [null,
    { t: "Mindset & Start", st: "Business basics and beplan values" },
    { t: "Financial plan & System", st: "Basics of financial planning and CRM" },
    { t: "Sales process & Skills", st: "From first call to signed contract" },
    { t: "Products", st: "Overview of financial products" },
    { t: "Case studies", st: "Real examples from practice" },
    { t: "Advanced", st: "Expert topics and team leadership" },
  ],
  // Calculator list — titles + short descriptions (deep details fall back to Czech market specifics)
  c: [
    { t: "Mortgage calculator", s: "Calculate monthly payment and total interest paid.", d: "Find the monthly payment, total overpayment and the breakdown of principal vs. interest over time.", i: ["Loan amount", "Interest rate", "Term"], o: ["Monthly payment", "Total paid", "Total overpayment", "Overpayment %"], ds: ["Principal", "Interest"] },
    { t: "Refinance calculator", s: "Compare current vs new mortgage and see your savings.", d: "Compare current and new mortgage. See monthly and total savings.", i: ["Remaining principal", "Current rate", "New rate", "Remaining term"], o: ["Monthly savings", "Total savings", "Old payment", "New payment"], ds: ["Old mortgage", "New mortgage"] },
    { t: "Early mortgage payoff", s: "See how much you save with extra payments.", d: "Find out by how many years your mortgage will be shortened thanks to extra payments.", i: ["Mortgage amount", "Interest rate", "Term", "Extra payment per year"], o: ["Shortened by", "Interest savings", "Original term", "New term"], ds: ["Without extras", "With extras"] },
    { t: "LTV calculator", s: "Loan-to-value ratio against property value.", d: "LTV shows the loan to property value ratio. Lower LTV = better rate.", i: ["Property value", "Loan amount"], o: ["LTV", "Own funds", "Rate assessment"], ds: ["Own funds", "Loan"] },
    { t: "Rent vs Buy", s: "Compare total cost of renting vs buying.", d: "Compare total cost of renting vs buying a property.", i: ["Property price", "Monthly rent", "Mortgage rate", "Horizon", "Property growth p.a."], o: ["Total rent cost", "Net buying cost", "Monthly payment", "Property value"], ds: ["Rent (cumulative)", "Buying (net)"] },
    { t: "Regular investment", s: "Portfolio growth with regular contributions.", d: "Regular investing is the most accessible way to build wealth.", i: ["Monthly investment", "Annual return", "Horizon", "Initial deposit"], o: ["Final value", "Total deposited", "Earnings", "Earnings %"], ds: ["Deposited", "Portfolio value"] },
    { t: "Compound interest", s: "The power of compound interest over time.", d: "Compound interest is the eighth wonder — interest earns more interest.", i: ["One-time investment", "Annual return", "Horizon"], o: ["Final value", "Initial deposit", "Total return", "Return %"], ds: ["Investment value"] },
    { t: "DCA vs lump sum", s: "Comparison of investment strategies.", d: "Dollar Cost Averaging means regular investing regardless of market.", i: ["Monthly DCA", "Horizon", "Average return", "Savings account return"], o: ["DCA result", "Lump sum", "Savings account", "Total deposited"], ds: ["DCA", "Lump sum", "Savings"] },
    { t: "Inflation calculator", s: "How inflation reduces the real value of money.", d: "Inflation reduces the real value of money every year.", i: ["Current amount", "Average inflation", "Horizon"], o: ["Real value", "Loss of purchasing power", "Loss in %"], ds: ["Nominal value", "Real value"] },
    { t: "FIRE calculator", s: "How much you need for financial independence.", d: "FIRE — capital needed for financial independence. The 4% rule.", i: ["Monthly retirement spend", "Current age", "Target FIRE age", "Portfolio return"], o: ["Required FIRE capital", "Monthly savings", "Years to FIRE"], ds: ["Capital accumulation", "Goal"] },
    { t: "Goal-based savings", s: "How long to save for a specific goal.", d: "Have a specific goal? Find out how long you need to save.", i: ["Goal amount", "Initial deposit", "Annual return", "Monthly savings"], o: ["Goal reached in", "Total deposited", "Extra return"], ds: ["Savings", "Goal"] },
    { t: "Pension calculator", s: "How much you'll save in the III. pillar.", d: "Average state pension only replaces 40–54% of your salary.", i: ["Age", "Retirement age", "Monthly contribution", "Employer contribution", "Fund return"], o: ["Total saved", "Total state contributions", "Monthly annuity (20 yrs)"], ds: ["Own", "Employer", "State", "Returns"] },
    { t: "Pension gap", s: "Difference between current income and state pension.", d: "State pension isn't enough to maintain standard of living.", i: ["Current net income", "Estimated state pension", "Retirement age", "Years in retirement"], o: ["Monthly gap", "Total gap", "Required capital"], ds: ["Current income (70%)", "State pension", "Gap"] },
    { t: "Life insurance need", s: "Recommended coverage based on life situation.", d: "Right insurance coverage covers the loss of income.", i: ["Monthly income", "Family monthly expenses", "Mortgage amount", "Years of coverage"], o: ["Death coverage", "Disability 3rd degree", "Sick pay/month"], ds: ["Recommended coverage"] },
    { t: "Building savings", s: "State subsidy up to 1,000 CZK per year.", d: "Building savings — only product with guaranteed state subsidy.", i: ["Monthly deposit", "Savings duration", "Interest rate"], o: ["Final amount", "Own deposits", "State subsidies", "Effective return p.a."], ds: ["Deposits", "State subs.", "Interest"] },
    { t: "Investment account — DIP", s: "Long-term tax-advantaged investment.", d: "DIP — long-term investment account with tax benefits up to 48,000 CZK/year.", i: ["Monthly investment", "Annual return", "Years until 60", "Personal tax rate"], o: ["Final value", "Tax savings (cumulative)", "Total deposited", "Total return"], ds: ["Deposited", "Tax savings", "Returns"] },
    { t: "Cash flow calculator", s: "Health of your monthly cash flow.", d: "Healthy cash flow is the foundation of any financial plan.", i: ["Net salary", "Other income", "Housing", "Food & household", "Transport", "Insurance", "Entertainment", "Savings & investments", "Other expenses"], o: ["Free cash flow", "Total income", "Total expenses", "Assessment"], ds: ["Housing", "Food", "Transport", "Insurance", "Fun", "Savings", "Other", "Free"] },
    { t: "Net worth", s: "Most important number in your financial health.", d: "Net worth = assets minus liabilities.", i: ["Real estate", "Investments & funds", "Pension savings", "Cash & savings", "Car & other", "Mortgage (balance)", "Consumer loans", "Other debts"], o: ["Net worth", "Total assets", "Total liabilities"], ds: ["Assets", "Liabilities"] },
    { t: "Tax savings", s: "Maximum tax savings from financial products.", d: "Properly set financial products can save you thousands per year.", i: ["Monthly gross salary", "Life insurance/mo", "Pension savings/mo", "Mortgage interest p.a.", "Donations & other deductions"], o: ["Annual tax savings", "Total deductions", "Tax without deductions", "Tax with deductions"], ds: ["Life ins.", "Pension", "Mortgage int.", "Donations"] },
    { t: "Loan calc — RPSN", s: "True cost of a loan including all fees.", d: "RPSN (Czech APR) shows the real cost of a loan. Always compare RPSN.", i: ["Loan amount", "Interest rate", "Monthly fee", "Term"], o: ["Monthly payment", "Total overpayment", "RPSN", "Total paid"], ds: ["Principal", "Interest", "Fees"] },
    { t: "Financial health score", s: "Comprehensive financial situation assessment.", d: "Comprehensive assessment of financial situation in 5 dimensions.", i: ["Liquid reserve (months of expenses)", "Debt (% of income)", "Savings rate (% of income)", "Insurance", "Investments"], o: ["Total score", "Category", "Recommendation"], ds: ["Your score"] },
  ],
  tools: {
    /* Nástroje ke schůzce — dlaždice na /nastroje. Bez těchhle klíčů by
       titulek i popis zůstaly česky ve všech jazycích (fallback). */
    "kalk-zlato": { t: "Gold — what the client is left with", d: "When the first gram arrives, how much the fee and the buy/buy-back gap eat, dollar currency risk shown separately, and a comparison with other assets. Grams in chỉ and lượng too.", short: "Grams, fee and the dollar rate" },
    "kalk-konsolidace": { t: "Loan consolidation", d: "Total now versus total after — not two instalments. Derives the rate of every loan and can show the case where consolidating does NOT pay off.", short: "Total now versus total after" },
    "kalk-podpojisteni": { t: "Underinsured premises", d: "What the insurer really pays when the sum insured is below the value of the property (section 2854). Includes the seasonal stock peak before Tết and Christmas.", short: "What the insurer really pays" },
    "kalk-doplaceni": { t: "Paying off a mortgage early", d: "Overpaying vs. investing on the same cash flow. A chart of two curves and their crossing point, three numbers for the client, a „market gives nothing“ scenario and decreasing cover. Presentation mode for the meeting.", short: "Overpay, or invest?" },
    provize: { t: "Commission calculator", d: "201 products from the BJ catalogue. Enter your position and products → commission for the first year and recurring. For advisors and recruiting.", short: "201 products from the BJ catalogue" },
    analyza: { t: "Financial analysis", d: "A guided 45-minute meeting — values, goals, resources, risks. The scripts guide even a beginner. Pick a client or create a new one.", short: "A guided 45-min meeting from A to Z" },
    posta: { t: "Mail + AI Email", d: "Your Gmail inside the CRM. A voice or text command → AI drafts the email and sends it. Bulk AI campaigns.", short: "Gmail in the CRM + AI emails" },
    leadgen: { t: "Leadovač", d: "15 lead-generation funnels — Mortgage, Investment, Self-employed, Family and more. Share the link, get leads into the CRM.", short: "15 lead funnels → CRM" },
    trychtyre: { t: "Funnels", d: "15 ready-made funnel landing pages (free value → contact). Preview it, copy your link, share it. The lead lands in the CRM.", short: "15 funnel landing pages to share" },
    "funnel-knihovna": { t: "Funnel library", d: "53 ready-made funnels in full: landing copy, e-mail sequences, ads, ebooks, webinar and call scripts. Plus a form that turns your answers into a brief for a new funnel.", short: "53 funnels + brief builder" },
    mesicnik: { t: "Client newsletter", d: "Send the published issue of the monthly newsletter to clients who gave marketing consent: email and web previews, one-click unsubscribe. Data from the CNB, ECB and other public sources.", short: "Monthly issue for clients" },
    "byznys-plan": { t: "My business plan", d: "The adviser’s yearly plan after the course template: last year’s numbers from the CRM, vision, business and personal goals, marketing, monthly goals with a reward, daily habits, review dates. Saved on the server, prints on A4.", short: "Vision, goals, marketing, monthly plan" },
    trychtyrBuilder: { t: "Funnel from A to Z", d: "A 7-step guide based on the Konverzky method: magnet, landing page, thank-you page, phone script, mini-webinar, e-mail sequence, ads and measurement (pixel). Fill-in templates without AI, saved for you; existing lead pages, funnels and your website are just linked in.", short: "7 steps from magnet to pixel" },
    "fin-matematika": { t: "Financial mathematics", d: "Loan / Mortgage, Investment and Income. The flag solves for anything. Large chart, validation, compounding frequency.", short: "Loan, investment, income — solve for any" },
    penze: { t: "Pension calculator (DPS/DIP)", d: "Pension savings and DIP: projection with state support and taxes, a historical calculator on real fund returns, fund comparison and an annuity plan.", short: "DPS + DIP, history, funds, annuity" },
    izp: { t: "Analysis for Vietnamese clients", d: "Explains to the client why life insurance matters: income, a 10/20/30 % package, risks, a chart to age 60/65/70, what the family gets and what is left.", short: "Insurance and investing, step by step" },
    "zivotni-pojisteni": { t: "Life insurance", d: "Recommended cover in seconds: death, disability, sick leave, permanent consequences, critical illness. Easy to sell even for a beginner.", short: "Recommended cover in seconds" },
    "rodinny-plan": { t: "Family financial plan (CZ/VI)", d: "Fifteen minutes with the client: income → expenses → what is left → what happens if the income stops → how much protection and how much towards assets. Bilingual Czech and Vietnamese, with a client mode. It does not start with a product.", short: "Fifteen minutes with the client" },
    historicka: { t: "Historical calculator", d: "Show the client on real data from 1926–2026 how the investment would have turned out. S&P 500, bonds, gold, inflation.", short: "Real data 1926–2026" },
    "svoboda": { t: 'When you will be free', d: 'Money translated into time. Instead of five percent above inflation, the client hears how many years sooner they can stop having to work. Move the extra slider and the marker slides left. Plus the price of waiting.', short: 'Money translated into time' },
    "hypoteka-rozhodnuti": { t: 'Mortgage — four decisions', d: 'End of the fixed period, 20 vs 30 years, how much own money, what time does. Compares the whole monthly outlay, not just the payment — which is why it often comes out the opposite of what the client expects. Each tab ends in one sentence.', short: 'Fix, term, own money, time' },
    fixace: { t: 'Fixed period under control', d: 'What happens AFTER the fixed period. Short fix vs long on one axis, the payment against the household budget, and one number: the rate above which it breaks. Built on real Czech National Bank rates 2006–2026 — including how often the rate actually jumped after refixing.', short: 'What happens after the fix' },
    "renta-porovnavac": { t: "Drawing an income — three methods", d: "What the client gets each month under a fixed %, a moving average and guardrails. The price is visible too: when and by how much it would have to be cut. A portfolio informed by the Nobel Foundation, documented on 1966 and 2000.", short: "Fixed % vs. average vs. guardrails" },
    "investicni-strategie": { t: "Investment strategies", d: "How the largest funds and the wealthiest invest — the Norwegian fund, the Nobel Foundation, Ray Dalio, Core-Satellite. For clients, plus compounding and perpetual income.", short: "How the largest funds invest" },
    "srovnavac-fondu": { t: "Fund comparator", d: "Compare two funds/ETFs — how much of the return the fees take. A catalogue of ETFs and Czech funds, a chart, the difference in money. For the client, without AI.", short: "Two funds and what the fees take" },
    "portfolio-doktor": { t: "Portfolio doctor", d: "The client's whole portfolio at once: weighted cost (and from how much of the assets it was calculated), how much difference it makes over the horizon, allocation, a verdict for every item — including “keep”. You enter the cost from the KID; the app invents nothing.", short: "The cost of the whole portfolio" },
    "investicni-studio": { t: "Investment studio (DEMO)", d: "A training presentation for the client: HWM Lab (performance fee), Today vs. proposal, Portfolio Composer, historical crises, cost breakdown. A model client, not personal advice.", short: "A training presentation for the client" },
    "nemovitost-pronajem": { t: "Property to let", d: "What a flat let out REALLY yields — cash flow over time, how many years you subsidise it, effective return, stress test. It breaks the client's rosy assumptions.", short: "What a flat to let really yields" },
    calculators: { t: "Calculators", d: "20 financial calculators — mortgage, investment, insurance, retirement, personal finance.", short: "20 financial calculators" },
    "portfolio-doctor": { t: "Portfolio Doctor", d: "Diagnostics of the client's portfolio — ISIN → ETF alternative + AI brief.", short: "ISIN → ETF alternative + AI brief" },
    "akademie-produkty": { t: "Product academy for newcomers", d: "10 modules: products, cold calling, argumentation, closing — with quizzes and scripts. From a beginner to a pro.", short: "10 modules with quizzes and scripts" },
    akademie: { t: "Advisor academy (videos)", d: "An educational video series — Mindset, Financial plan, Sales process and more.", short: "An educational video series" },
    income: { t: "Target income", d: "Reverse calculation from the income you want down to the number of meetings and calls.", labels: ["Target monthly income", "Average commission per contract", "Conversion meeting → contract", "Conversion call → meeting"], funnel: ["Calls per day", "Calls per month", "Meetings per month", "Contracts per month"] },
    objections: { t: "Objections & answers", d: "Click a card to see the recommended answer.", q: ["I'm not interested", "I already have an advisor", "I don't have time", "I don't have the money", "Send me an email", "I have to talk to my partner", "I'll do it myself", "My contracts are fine", "Now is not a good time", "How do you know you're better?"], a: ["I understand. May I ask what exactly sounds uninteresting to you?", "That's great! How often does your advisor review your financial plan?", "I understand, time is precious. I offer an efficient 45-minute meeting.", "That is exactly why we should meet. We help find savings in existing contracts.", "Happy to send one. Still, every situation is unique. Could we meet for 30 minutes?", "Of course! You will both be at the meeting — the decision should be a joint one.", "I respect that. Did you know the average person without an advisor loses 15–30 thousand a year?", "That's great! When did you last review them? The market keeps changing.", "I understand. When would suit you better? I'm happy to call back.", "We don't claim to be the best. Our strength is the comprehensive approach."] },
    checklist: { t: "A1 meeting checklist", d: "A complete checklist for the first meeting.", cols: ["Before the meeting", "During the meeting", "After the meeting"], before: ["Prepare the presentation", "Check the CRM data", "Prepare contracts for signature", "Confirm the client is available", "Prepare business cards and materials", "Set an alarm/reminder"], during: ["Ice break and building rapport", "Find out the client's expectations", "Introduce beplan", "Financial analysis (7 areas)", "Present the solution", "Agree the next step", "Ask for referrals"], after: ["Write notes into the CRM", "Send a summary by email", "Prepare the draft contracts", "Schedule the follow-up", "Update the pipeline"] },
    timer: { t: "Meeting timer", d: "A timer with 5 phases for a structured meeting.", phases: ["Ice break", "Expectations", "Introduction", "Principle of completeness", "Close and next date"] },
    pyramid: { t: "Personal finance pyramid", d: "Click a layer to see the detail.", layers: [{ n: "Investing", d: "Actively building wealth — equities, funds, real estate." }, { n: "Other needs", d: "Savings accounts, building savings, purpose-based saving." }, { n: "Housing", d: "Your own home or an investment property." }, { n: "Future income (pension)", d: "The Czech third pillar of pension savings with state contributions." }, { n: "Income protection", d: "Life insurance, accident cover, sick pay." }] },
    compare: { t: "Product comparison", d: "Financial products compared side by side." },
    glossary: { t: "Glossary", d: "A searchable glossary of financial terms." },
  },
  g: [
    { t: "RPSN", d: "Czech APR (annual percentage rate of charge) — shows the true cost of a loan including all fees.", e: "The bank offers a loan at a 5 % rate, but the RPSN is 6.2 % because of the fees." },
    { t: "LTV", d: "Loan to Value — the ratio of the loan amount to the value of the property.", e: "Buying a flat for CZK 5m with a CZK 4m mortgage gives an LTV of 80 %." },
    { t: "Disability, degree 1", d: "A loss of working capacity of 35–49 %. Entitles the client to a partial disability pension.", e: "A client with a chronic illness who can still work part time." },
    { t: "Disability, degree 2", d: "A loss of working capacity of 50–69 %.", e: "A client after a serious accident who can only do light work." },
    { t: "Disability, degree 3", d: "A loss of working capacity of 70 % or more. Full disability pension.", e: "A client who is unable to do any work at all." },
    { t: "DPS", d: "Doplňkové penzijní spoření — supplementary pension savings, the Czech third pillar with state contributions.", e: "Saving CZK 1,000 a month earns you a state contribution of CZK 230." },
    { t: "Transformed fund", d: "The original Czech pension funds with a guarantee of a non-negative return.", e: "Legacy supplementary pension insurance taken out before 2013." },
    { t: "Volatility", d: "How much the value of an investment fluctuates over time.", e: "Equities are more volatile than bonds." },
    { t: "Diversification", d: "Spreading an investment across several assets to reduce risk.", e: "Holding equities, bonds and real estate at the same time." },
    { t: "Compound interest", d: "Interest is added to the principal and then earns further interest.", e: "CZK 100,000 at 7 % p.a. over 20 years = CZK 386,968." },
    { t: "Cash flow", d: "The flow of money — the difference between income and expenses over a period.", e: "Monthly income CZK 55,000 minus expenses CZK 42,000 = free cash flow CZK 13,000." },
    { t: "Financial plan", d: "A comprehensive document that maps the client's financial situation and proposes the best solution.", e: "The plan covers insurance, investments, savings and retirement." },
    { t: "Insured event", d: "A random event that the policy covers.", e: "An accident, an illness, property damaged by a natural disaster." },
    { t: "Insurance benefit", d: "The amount the insurer pays out when an insured event occurs.", e: "After an accident with permanent consequences the insurer paid out CZK 500,000." },
    { t: "Fixed-rate period", d: "The period during which the mortgage interest rate stays unchanged.", e: "A 5-year fix means the rate will not change for 5 years." },
    { t: "Annuity payment", d: "The same monthly payment for the whole term of the loan.", e: "A payment of CZK 15,000 a month for the entire life of the mortgage." },
    { t: "Creditworthiness", d: "The client's ability to repay a loan, as assessed by the bank.", e: "The bank looks at income, expenses and existing debts." },
    { t: "ETF", d: "Exchange Traded Fund — a fund traded on an exchange that tracks an index.", e: "An S&P 500 ETF tracks the 500 largest US companies." },
    { t: "Bond", d: "A security in which the issuer promises to repay the principal plus interest.", e: "Government bonds are considered a safe investment." },
    { t: "Portfolio", d: "All of the client's investments and assets taken together.", e: "A portfolio made up of 60 % equities and 40 % bonds." },
    { t: "Rebalancing", d: "Regularly adjusting the portfolio back to its target allocation.", e: "If equities have grown to 70 %, sell part of them and buy bonds." },
    { t: "TER", d: "Total Expense Ratio — the total annual cost of a fund in percent.", e: "A fund with a TER of 0.5 % charges 0.5 % of the investment every year." },
    { t: "State contribution", d: "The state's contribution to pension savings or building savings.", e: "Max. CZK 230 a month to pension savings on a CZK 1,700 deposit." },
    { t: "Vinkulace (assignment of benefit)", d: "A restriction on the insurance benefit in favour of a third party.", e: "The property policy is assigned to the bank as security for the mortgage." },
    { t: "Deferred period", d: "The period from the insured event until the benefit starts being paid.", e: "A 28-day deferred period on sick leave cover." },
    { t: "Debt consolidation", d: "Merging several loans into one with better terms.", e: "Replacing 3 consumer loans with a single one with a lower payment." },
    { t: "FIRE", d: "Financial Independence, Retire Early — the financial independence movement.", e: "The goal: save 25× your annual expenses and live off a 4 % withdrawal." },
    { t: "Compliance", d: "Meeting the legal and regulatory requirements of the industry.", e: "Following the Czech National Bank (ČNB) rules for financial advisors." },
  ],
  // Notes panel on the dashboard — a blank sheet of paper plus tags.
  poznamky: {
    title: "Notes",
    new: "New note",
    placeholder: "Start writing…",
    emptyTitle: "No notes yet",
    emptyDesc: "Click and write — a blank page that saves itself.",
    allTags: "All",
    addTag: "Add tag",
    removeTag: "Remove tag",
    tagPlaceholder: "tag",
    filterEmpty: "Nothing with this tag.",
    clearFilter: "Clear filter",
    delete: "Delete note",
    deleteConfirm: "Really delete it?",
    saving: "Saving…",
    saved: "Saved",
    saveFailed: "Not saved — browser storage is full",
  },
  /* === NASTROJE: ruční převod jazykových ternárů (dávka „nastroje") === */
  nastroje: {
    /* === QUICK TOOLS IN THE ANALYSIS RAIL (side icon strip) ===
     * Calculators that slide OVER the analysis the adviser has open, prefilled
     * with that client's numbers. The model is NOT saved (panel footer), and
     * the payoff engine's messages reuse the already translated
     * `nastroje.schuzka.doplaceni.hlaska*` keys. */
    pruh: {
      nadpis: "Quick tools",
      otevrit: "Open quick tools",
      zavrit: "Close",
      tabHypo: "Mortgage",
      tabDoplaceni: "Mortgage with investing",
      tabZivot: "Life insurance",
      tabInvestice: "Investing",
      znovuZAnalyzy: "Load the numbers from the analysis again",
      neukladaSeTuk: "This model is not saved.",
      neukladaSeText: "Numbers from this panel do not reach the analysis or the plan, and they are gone once the page reloads. Whatever you want the client to keep, type it into the analysis or into the proposed solution.",
      padTuk: "The tool could not be displayed.",
      padText: "The analysis is fine and stayed open. Try another tool and report the error — the detail is in the browser console.",
      zAnalyzy: "from the analysis",
      zPrebytku: "from the surplus in the analysis",
      bezPrijmu: "Without a net income in the analysis the debt load cannot be calculated.",
      chybiNadpis: "Missing input",
      chybiObecne: "An input is missing or out of range — check the entries.",
      skriptNadpis: "What to say to the client",
      hypo: {
        zadani: "Property and loan",
        cena: "Property price",
        vlastni: "Own funds",
        sazba: "Interest rate",
        splatnost: "Term",
        dosaditPrumer: "Use the market average {sazba} ({obdobi})",
        prumerNeniNabidka: "Average rate offered on the market, not an offer from any particular bank.",
        vysledek: "Instalment and limits",
        splatka: "Monthly instalment",
        splatkaNote: "The same instalment for the whole term at the rate entered.",
        uver: "Loan amount",
        ltv: "LTV — loan to price",
        ltvLimit: "Binding limit {limit}.",
        bezVeku: "age is missing in the analysis, the stricter limit {limit} applies",
        ltvNad: "Above the limit — at least {castka} of own funds is needed.",
        dsti: "DSTI — instalments to income",
        dstiLimit: "Recommended limit {limit} of net income, existing instalments included.",
        dti: "DTI — debt to income",
        dtiLimit: "Recommended limit {limit}× net annual income.",
        celkemZaplaceno: "Total paid to the bank",
        zTohoUroky: "Of that, interest",
        stavajiciSplatky: "Existing instalments from the analysis",
        skript: "The bank looks at three numbers: how much you borrow against the price of the property, how much the instalments take out of your income, and how much you owe against your annual income. Let us see where you stand — and where more own funds would be needed.",
        chybiCena: "Enter the property price.",
        chybiSazba: "Enter the interest rate — without it there is no instalment.",
        chybiSplatnost: "Enter the term in years.",
        chybiVlastni: "Add the client's own funds — without them the loan amount cannot be calculated.",
        bezVlastnich: "Client has no own funds",
        chybiVlastniNadCenu: "Own funds exceed the property price — nothing is left to borrow.",
      },
      doplaceni: {
        zadani: "Mortgage and spare money",
        jistina: "Outstanding principal",
        sazba: "Mortgage interest",
        splatnost: "Term",
        volnaCastka: "Spare money per month",
        vynos: "Expected investment return",
        horizont: "Wants to pay it off in",
        predpoklad: "adviser's assumption",
        neniVAnalyze: "not in the analysis — fill it in",
        predpokladyPoznamka: "A fund charge of {ter} a year and tax on the sale at payoff are included. Enter the return in nominal terms, the same way as the mortgage rate — otherwise the investment would be handed the whole of inflation for free.",
        stitkyPoznamka: "The labels under the fields say where each number came from when the panel opened. Whatever you overwrite is your own assumption.",
        chybiJistina: "Enter the outstanding mortgage principal.",
        chybiSazba: "Enter the mortgage interest rate. Zero is not a rate, and without a rate the investment would always win.",
        vysledek: "In {roky}: what the client is left with",
        cestaSplaceni: "Overpay the mortgage",
        cestaSplaceniNote: "Mortgage paid off in {kdy}, then the same amount is invested.",
        cestaInvestice: "Invest and pay it off in one go",
        cestaInvesticeNote: "Portfolio after tax {portfolio} minus the remaining debt {dluh}.",
        vitezInvestice: "Investing comes out better",
        vitezInvesticeText: "In {roky} the client is left with {castka} more than by overpaying. That holds only if the market really delivers the return.",
        vitezSplaceni: "Overpaying comes out better",
        vitezSplaceniText: "In {roky} the client is left with {castka} more by sending the money into the mortgage. The instalment is certain, the return is not.",
        remiza: "Both paths come out the same",
        remizaText: "In {roky} the difference between the paths is negligible. So certainty decides, not return — and the certain one is the overpayment.",
        splatka: "Mortgage instalment",
        vydajObe: "Leaves the budget on both paths",
        usporaSplaceni: "Interest saved — overpaying",
        usporaInvestice: "Interest saved — investing",
        danPriDoplaceni: "Tax on the sale at payoff",
        poplatky: "Total investment fees",
        hranice: "Break-even investment return",
        hraniceNote: "Below this return the investment loses — already after tax and fees. Above it, it earns.",
        hraniceNikdy: "Investing does not beat the overpayment even at a very high return — typically because of a short horizon, fees or tax.",
        prusecikText: "The portfolio first covers the remaining debt in {roky}. Paying off would take {castka} — from then on the client can choose.",
        prusecikNikdy: "Within the horizon entered the portfolio never reaches the amount needed to cover the debt.",
        urokyPoznamka: "Interest saved is compared all the way to full repayment, not just to the payoff date — otherwise the path that still owes money would look thriftier than it is.",
        orientacniNadpis: "Indicative model",
        orientacni: "This is not a loan offer or a promise of any payout, and it does not reflect the terms of any particular contract. Check the free overpayment limit, the bank's fees and the rate after the fixed period in the contract; tax rules may change before the payoff date.",
        plnaKalkulacka: "Market-crash scenarios, the fixed period and decreasing cover are calculated by the full calculator under Tools.",
        skript: "You have two ways to get rid of the mortgage. Either you send extra money into it, or you invest that money and pay the mortgage off in one go. Let us calculate both — and above all what happens if the market does not earn as much as we expect.",
      },
      zivot: {
        zadani: "Family and liabilities",
        nezbytne: "Essential household expenses",
        horizont: "Years of cover needed",
        dluhy: "Total debt",
        rezerva: "Liquid reserve",
        vdovsky: "Widow's pension",
        sirotci: "Orphans' pension total",
        davkaSablona: "country template — override per client",
        varianta: "Cover variant",
        smrt: "Sum insured — death",
        invalidita: "Sum insured — disability",
        zavazne: "Critical illness",
        tnu: "Permanent consequences of an accident",
        pn: "Sick leave",
        denne: " / day",
        rozpad: "Of that, debt {dluhy}, goals {cile} and household expenses {vydaje}.",
        chybiPrijem: "Nobody in the analysis has an income — the capital method then has nothing to work from.",
        chybiVydaje: "Enter the essential household expenses.",
        chybiHorizont: "Enter how many years the cover has to last.",
        chybiPozustalostni: "We have no verified survivors' pension for this country — without it the death cover would come out too low. Add it to the insurance limits.",
        skript: "I will work this out the other way round from an insurer. Not how much you can afford to pay, but how much the family would need to go on living the same way and finish what you have planned. Only from that number do we start talking about price.",
      },
      invest: {
        zadani: "Contributions and horizon",
        mesicne: "Monthly",
        jednorazove: "One-off today",
        rezervaNeni: "the liquid reserve is not filled in here",
        roky: "Investment period",
        vynos: "Expected return",
        vynosPredpoklad: "adviser's assumption",
        vysledek: "What it adds up to",
        konecnaHodnota: "Value at the end",
        vDnesnichCenach: "In nominal terms, not restated into today's prices — inflation will reduce the purchasing power.",
        vlozeno: "Total contributed",
        vynosCelkem: "Of that, return",
        neniGaranceNadpis: "The return is not guaranteed.",
        neniGarance: "It is an assumption, not a promise. The market can fall for several years and the value may end up below the amount contributed. Say this to the client before you show them the final figure.",
        skript: "This is what is left over every month. Leave it sitting in the account and in ten years it will still be the same amount, you will just buy less with it. Here is the other option — and with it the sentence I have to say: the return is an assumption, not a promise.",
        chybiVklad: "Enter a monthly contribution or a one-off amount.",
        chybiRoky: "Enter the investment period in years.",
        chybiVynos: "Enter the expected return.",
      },
    },
    /* === NÁSTROJE KE SCHŮZCE (zlato / konsolidace / podpojištění) ===
     * Klientské kalkulačky na /kalkulacka/:nastroj. Texty jsou psané tak, aby
     * je poradce mohl na schůzce ŘÍCT NAHLAS — proto tu jsou celé věty, ne
     * jen štítky. Vietnamská verze nese české odborné termíny v závorce,
     * protože klient i úřad je uvidí na smlouvě.
     * ⚠️ Čísla v kalkulačkách jsou ŠABLONA, ne nabídka — viz `sablonaText`. */
    schuzka: {
      sekce: "Meeting tools",
      titulek: "Calculators the client sees on the table",
      podtitulek: "Four calculations that make or break a meeting: how much gold the client is really left with, whether consolidating pays off — including when it does not — what the insurer really pays out, and whether to overpay the mortgage or invest and pay it off in one go. The currency comes from your tenant's country, not from the language.",
      zpet: "Back to Tools",
      tabZlato: "Gold",
      tabKonsolidace: "Loan consolidation",
      tabPodpojisteni: "Underinsurance",
      tabDoplaceni: "Paying off a mortgage",
      zadani: "Inputs",
      vysledek: "Result",
      vetaNaSchuzku: "Say this in the meeting — word for word",
      kdyNedoporucit: "When NOT to recommend this",
      postup: "Step by step",
      orientacniTuk: "Indicative calculation, not an offer.",
      orientacniText: "The model exists to explain how the product works. It is not an offer, not a promise of payout and not personal advice. Binding numbers come only from the contract, the fee schedule and the policy terms.",
      sablonaTuk: "The numbers are a template — verify them before the meeting.",
      sablonaText: "Prices, rates and fees change. Pull the current values from the partner portal or the fee schedule on the day of the meeting and rewrite them here.",
      mesicOne: "month",
      mesicFew: "months",
      mesicMany: "months",
      rokOne: "year",
      rokFew: "years",
      rokMany: "years",
      zlato: {
        popis: "The client is not buying gold alone — they are buying gold, a fee, the gap between the buy and buy-back price, and a foreign currency on top. Show all of it at once so there is no surprise two years later.",
        jednorazove: "One-off deposit",
        mesicne: "Monthly payment",
        roky: "Horizon",
        typ: "Contract type — how much of each payment goes to the fee",
        typJednorazovy: "One-off purchase",
        typPopis100: "100/0 — until the fee is paid off, the client buys no gold at all. Say this first.",
        typPopis7030: "70/30 — seventy percent of the payment goes to the fee, thirty to metal. Grams accumulate from day one, but the fee is higher.",
        typPopis5050: "50/50 — half to the fee, half to metal. Fastest start, most expensive fee.",
        typPopisJednorazovy: "One-off purchase — no fee is deducted from payments, the client pays only the metal price and the buy/buy-back gap.",
        vstupniPoplatek: "Entry fee",
        vstupniPoplatekHint: "In programmes where the fee is charged per bar, add up all the bars.",
        cenaNakup: "Buy price per gram",
        cenaVykup: "Buy-back price per gram",
        cenyHint: "Pull both prices from the portal on the day of the meeting. The gap between them is a cost you will not find in any fee schedule.",
        rustKov: "Metal price growth (in USD) % p.a.",
        zmenaKurzu: "USD/{mena} exchange rate change % p.a.",
        kurzHint: "Gold is quoted in dollars while the client lives in the home currency. When the home currency strengthens, the dollar gain is lost on the way. That is why there are two sliders here, not one.",
        gramy: "How much gold they will hold",
        jednotky: "{chi} chỉ · {luong} lượng (Vietnamese gold units)",
        vlozeno: "Total paid in",
        hodnota: "Value at buy-back",
        rozdil: "Difference: {castka}",
        naklady: "Paid in fees and price gap",
        spread: "Buy / buy-back gap",
        vynosPa: "Return p.a. (internal rate of return)",
        nedoplaceno: "The entry fee stays unpaid",
        prvniGramNadpis: "First gram of gold",
        prvniGramHned: "The client buys metal from the very first payment.",
        prvniGramZa: "The client buys the first gram only in month {mesic}. Until then they are paying the fee.",
        prvniGramNikdy: "Over the whole horizon the client buys no gold at all — the fee never gets paid off. Shorten the target or raise the payment.",
        bodZvratuNadpis: "When the client breaks even",
        bodZvratu: "In month {mesic}, that is roughly {roky} years.",
        bodZvratuNikdy: "Over the chosen horizon the client never gets back what they paid in. Say so before they sign.",
        menoveRizikoNadpis: "Currency risk — the client is not buying gold alone",
        menoveRizikoText: "The gold price is in dollars, but the client pays and collects in {mena}. Anyone who bought gold while the home currency was weak lost part of the gain once it strengthened. This number shows how much of the result came from the exchange rate — not from the metal.",
        kurzUdelal: "Produced by the exchange rate",
        kurzScenareNadpis: "What if the rate moves differently",
        kurzScenarLabel: "Rate {proc} p.a.",
        grafNadpis: "Money paid in versus the value of the metal",
        grafVlozeno: "Paid in",
        grafHodnota: "Value at buy-back",
        grafRok: "Year",
        porovnaniNadpis: "The same money in other assets",
        porovnaniText: "Long-run nominal averages from public data (1928–2024, in dollars), before fees and taxes on both sides. Use it to compare orders of magnitude, not to pick a product — and never as a promise of return.",
        aktivumAkcie: "Broad equity index",
        aktivumZlato: "Gold (historical average)",
        aktivumDluhopisy: "Bonds",
        aktivumNemovitosti: "Real estate",
        aktivumHotovost: "Cash and savings account",
        aktivumTentoPlan: "This gold plan",
        mesicuInfo: "The model runs month by month, {mesicu} in total.",
        skript: "“Before we sign anything, let me show you three numbers. First: you buy your first gram of gold only in the month you can see here on the screen — until then you are paying the fee. Second: there is a gap between the buy price and the buy-back price, so right after the purchase your gold is worth less than what you paid. And third: gold is priced in dollars while you live in the home currency — if that currency strengthens, the exchange rate takes part of your gain. If that works for you, we carry on. If not, I have a different solution for you.”",
        kdyNe: [
          "The client has no liquid reserve covering three to six months of expenses. Gold is not a reserve — a buy-back takes days and the price may be down at that moment.",
          "The client has expensive debt. A credit card at twenty percent a year beats any expected return on gold. Consolidate first, buy metal later.",
          "The horizon is shorter than five to seven years. The entry fee and the buy/buy-back gap will not be recovered in that time.",
          "The client has no income and housing protection in place. Gold will not pay the mortgage when an injury stops them working.",
          "The client wants to put most of their wealth into gold, or to live off it. Gold pays no interest and no dividend — an income from gold means selling the asset off piece by piece.",
        ],
      },
      konsolidace: {
        popis: "A lower instalment is not a cheaper loan. What gets compared are two total amounts, not two instalments. This calculator can also show the case where consolidation does not pay off — and that is what makes you an adviser the client trusts.",
        predlohy: "Pre-filled situations",
        predlohaVyplati: "Example: it pays off",
        predlohaNevyplati: "Example: it does not pay off",
        predlohyHint: "Model numbers for practice, not real client data. Click and rewrite them to match what the client brought in.",
        uveryNadpis: "What the client is repaying today",
        pridat: "Add a loan",
        smazat: "Remove loan",
        zustatek: "Outstanding balance",
        splatka: "Monthly instalment",
        zbyva: "Instalments left",
        poplatekPredcasne: "Early repayment fee",
        dopoctenaSazba: "Implied rate",
        sazbaNelze: "cannot be derived",
        nazevKreditka: "Credit card",
        nazevNebankovni: "Non-bank loan",
        nazevSplatkovyProdej: "Purchase in instalments",
        nazevBankovniPujcka: "Bank loan",
        nazevAutoUver: "Car loan",
        nazevNovy: "Another obligation",
        nabidkaNadpis: "What the bank is offering",
        novaSazba: "New rate",
        novaSplatnost: "New term",
        poplatekZaSjednani: "Arrangement fee",
        splatkaRucne: "Instalment quoted by the bank",
        splatkaRucneHint: "Leave it at zero and the instalment is derived. If the bank quoted one, type it here.",
        celkemTed: "Total paid if nothing changes",
        celkemTedNote: "Current instalments: {splatka}",
        celkemPo: "Total paid after consolidation",
        celkemPoNote: "New instalment: {splatka}",
        uspora: "Saving",
        zaplatiNavic: "Pays extra",
        ulevaMesicne: "Monthly relief",
        prodlouzeni: "Repayment extended by",
        prodlouzeniZadne: "not extended",
        odsunuto: "How much of the relief is merely deferred",
        sazbaTed: "Current weighted rate",
        novaJistina: "New principal including fees",
        poplatkyCelkem: "Fees in total",
        verdiktVyhra: "It pays off",
        verdiktVyhraText: "The client pays less monthly and less in total. Check the early repayment fees and get a zero-balance confirmation from every original creditor.",
        verdiktLevnejsi: "Cheaper in total, but the instalment goes up",
        verdiktLevnejsiText: "The client pays less overall but has to carry more each month. Check the budget can take it — otherwise you have pushed them towards arrears.",
        verdiktUleva: "Lower instalment, but they pay more",
        verdiktUlevaText: "This can still be the right call when the point is to avoid arrears and credit registers. But it has to be said out loud: the client is buying relief and paying for it. Never sell it as a saving.",
        verdiktNevyplati: "It does not pay off",
        verdiktNevyplatiText: "Neither in total nor on the instalment. Tell the client straight away and offer something else — an extra payment, a different term, or consolidating only the most expensive debts.",
        hranice: "For consolidation to at least break even on cost, the term must not exceed {mesicu}.",
        hraniceNelze: "At this rate consolidation does not come out cheaper at any term. Ask for a different offer.",
        skript: "“Look at these two numbers. On the left is what you pay if you leave everything as it is. On the right is what you pay after consolidation. Your instalment goes down — that is true. But we decide on those two totals, not on the instalment. If the right-hand number is bigger, it means you are buying peace of mind and paying for it. That is a legitimate decision, you just have to know you are making it.”",
        kroky: [
          "Write down every obligation: balance, instalment, instalments remaining, rate and early repayment fee.",
          "Have the client bring statements from the credit registers. They usually forget two or three debts — without those your maths is wrong.",
          "Work out both totals first, and only then talk about the instalment.",
          "File the application with the documents: identity document, contracts for every loan being merged, proof of income or bank statements.",
          "Once everything is paid off, get a zero-balance confirmation from each original creditor. This is the single most common mistake in the whole process.",
          "Close the credit cards and overdrafts that have just been freed up. Otherwise the client is back in debt within a year and you have not helped.",
        ],
        kdyNe: [
          "The new rate is the same or higher and the only change is a longer term.",
          "The client would merge debts that are due to finish in a few months — there is almost no interest left in those.",
          "Early repayment fees plus the arrangement fee eat the whole saving.",
          "The client keeps the credit cards and overdrafts open.",
          "Part of the debt is in enforcement, overdue, owed to the state or to private individuals — a bank will not take those into a consolidation even though they drain the budget.",
        ],
      },
      podpojisteni: {
        popis: "When the sum insured is lower than the true value of the property, the insurer cuts the payout in the same proportion — and it cuts small claims too. In a food shop that usually means a difference of hundreds of thousands.",
        polozkyNadpis: "Add up what is really in the premises",
        polozkyHint: "Most underinsurance happens because something was forgotten. Go through it together, item by item.",
        stavebniUpravy: "Fit-out and built-in works",
        vybaveni: "Equipment and machinery",
        elektronika: "Electronics and till",
        zasoby: "Stock of goods",
        hotovost: "Cash on the premises",
        veciKlientu: "Items taken in from customers",
        polozkyCelkem: "Total value",
        dosadit: "Use in the calculation",
        hodnota: "True value of the property",
        hodnotaHint: "What it would cost to buy again, not what it cost back then.",
        castka: "Sum insured in the policy",
        castkaHint: "Copy it from the policy, not from memory.",
        skoda: "Size of the claim",
        spoluucast: "Deductible",
        sezonni: "Seasonal stock peak",
        sezonniHint: "Before Tết and before Christmas a shop holds several times its usual stock. The sum insured is still the one from the day it was arranged — and that is exactly when losses happen.",
        podpojisteni: "Underinsurance",
        pomerNote: "{pomer} of the value is covered",
        vyplati: "The insurer pays",
        doplaci: "The client covers the rest",
        hodnotaVeSpicce: "Property value at the peak",
        chybiVCastce: "Raise the sum insured by",
        ztrataProti: "Loss versus a properly arranged policy",
        varovaniTuk: "This policy is underinsured.",
        varovaniText: "The insurer will cut the payout in the same proportion as the sum insured bears to the value of the property. That applies to small claims too. Raise the sum insured, or tell the client straight away how much they will be covering themselves.",
        vporadkuTuk: "Cover matches the value of the property.",
        vporadkuText: "The payout will not be cut. Check it again at every service meeting — building and stock prices rise while the sum insured does not move on its own.",
        tabulkaNadpis: "Small claims get cut too",
        tabSkoda: "Claim",
        tabPlneni: "Insurer pays",
        tabDoplaci: "Client covers",
        zakonNadpis: "Where this comes from",
        zakonText: "Czech Civil Code (89/2012 Sb.), section 2854: if at the time of the insured event the sum insured is lower than the insurable value of the property, the insurer reduces the payout in the same proportion — unless the contract states that the payout will not be reduced. Always check the specific policy terms.",
        skript: "“Your sum insured is lower than what this shop is actually worth. It does not mean the insurer will refuse to pay — it means that out of every claim they will pay only the percentage the shop is insured for. Let me show you: here is your claim, and here is what actually lands in your account. And before Tết, when the storeroom is full, that gap is even bigger. Let us fix it now, while nothing has happened.”",
        kdyNe: [
          "The client will not or cannot document the value of the property — do not invent a sum insured, have it derived from the accounts or by a valuer.",
          "The contract states that the payout is not reduced. Then this calculation does not apply and you must work from the specific policy terms.",
          "The client wants to raise the sum insured but has not met the security, inspection or hygiene requirements — the insurer can still cut the payout on other grounds and a higher sum will not help.",
          "These are items of special value such as valuables and precious metals — they carry their own sub-limits in the policy and this calculation does not cover them.",
        ],
      },
      /* === DOPLACENÍ HYPOTÉKY (mimořádné splátky vs. investice) ===
       * Nástroj, kterým se klient přemlouvá, aby NESPLÁCEL dluh. Texty proto
       * musí unést i opačný závěr: `verdiktSplaceni`, `rizikoText`, scénáře
       * a `kdyNe` nejsou zdvořilostní vata — bez nich je to slib výnosu.
       * Odborné termíny nechávej v závorce česky, klient je uvidí na smlouvě. */
      doplaceni: {
        popis: "The client has a mortgage and a few thousand spare each month. Either it goes into the mortgage, or it gets invested and the debt is paid off in one go at an agreed date. Both paths spend exactly the same from the budget — they differ only in what the client is left with. And above all you can see the moment when the investment first covers the remaining debt.",
        prezentace: "Start presentation",
        zadaniHypoteka: "Mortgage",
        jistina: "Outstanding balance",
        jistinaHint: "The remaining principal, not the original loan amount. Take it from the statement, not from the client's memory.",
        sazba: "Interest rate",
        splatnost: "Term",
        horizont: "Pay off in how many years",
        horizontHint: "The payoff date is fixed. The market does not care — that is why the risk panel sits next to the saving.",
        fixace: "Fixed-rate period",
        fixaceHint: "Zero = one rate the whole time. Otherwise the instalment is recalculated after the fixed period, just like the bank does it.",
        sazbaPoFixaci: "Rate after the fixed period",
        splatkaInfo: "Monthly instalment {splatka} · the mortgage ends on its own in {splatnost}.",
        zadaniInvestice: "Spare money and the investment",
        volnaCastka: "Spare amount per month",
        volnaCastkaHint: "The same money runs down both paths — once into the mortgage, once into the investment. Without that the comparison would not be fair.",
        jednorazovyVklad: "Lump sum today",
        vynos: "Expected return",
        rezim: "The return entered is",
        rezimNominalni: "Nominal (like the interest)",
        rezimRealny: "Real (above inflation)",
        rezimHint: "Mortgage interest is nominal. Putting a real 6 % against a nominal 4.9 % hands the investment the whole of inflation for free — which is why this has to be chosen, not guessed.",
        poplatekVstupni: "Entry fee on every contribution",
        poplatekRocni: "Ongoing charge (TER)",
        poplatkyHint: "A real fund costs 1–2 % a year. Zero is the fastest way to overstate the investment.",
        trojiceNadpis: "What the client is left with in {roky}",
        cestaSplaceni: "Overpay the mortgage",
        cestaSplaceniNote: "The mortgage is gone in {kdy}, then the freed instalment is invested.",
        cestaInvestice: "Invest, then pay it off",
        cestaInvesticeNote: "Portfolio after tax {portfolio} minus remaining debt {dluh}.",
        rozdilZisk: "More with investing",
        rozdilZtrata: "Less with investing",
        rozdilNote: "Difference in net worth between the two paths.",
        vydajObe: "Leaves the budget on both paths",
        urokyBezZasahu: "Interest if nothing is done",
        urokySplaceni: "Interest when overpaying",
        urokyInvestice: "Interest when investing",
        usporaSplaceni: "Interest saved — overpaying",
        usporaInvestice: "Interest saved — investing",
        danPriDoplaceni: "Tax on the sale used to pay off",
        poplatkyCelkem: "Total investment fees",
        urokyPoznamka: "Interest is counted until the mortgage is genuinely gone, not just up to the chosen year. A path that still owes money in the target year would otherwise claim a saving it has merely not paid yet.",
        verdiktInvestice: "Investing comes out better — and the client must know why",
        verdiktInvesticeText: "The difference comes from a return above the mortgage rate, and that is not guaranteed. Go through the risk panel right below with the client and tell them the break-even return as well.",
        verdiktSplaceni: "Overpaying comes out better",
        verdiktSplaceniText: "The interest saved is certain and untaxed; the investment return is neither. Nothing to explain here — recommend overpaying.",
        verdiktRemiza: "Both paths come out the same",
        verdiktRemizaText: "When the difference is pocket change, certainty and the client's peace of mind decide, not the table. The instalment is certain, the return is not.",
        grafNadpis: "Debt falls, the investment grows",
        grafDluh: "Remaining debt",
        grafPortfolio: "Investment value after tax",
        grafRok: "Year",
        grafJednotka: "The vertical axis is in thousands of {mena}. Hover the curve for the exact amount.",
        prusecikNadpis: "The moment there is enough to pay it off",
        prusecikText: "In roughly {rok} the investment first covers the remaining debt ({castka}). From then on the client can choose whether to pay off or let the money keep working.",
        prusecikNikdy: "Within the chosen horizon the investment never covers the remaining debt. Raise the spare amount or move the payoff date — and tell the client before they decide.",
        rizikoNadpis: "And what if the market gives nothing",
        rizikoText: "The mortgage instalment is certain, the investment return is not. Show the client both sides — the adviser who also brings the bad scenario is the one who gets trusted. A positive number means investing comes out better, a negative one means overpaying does.",
        scenarBezVynosu: "Market gives nothing",
        scenarPesimisticky: "Pessimistic return",
        scenarZadani: "As entered",
        scenarPropad: "Market crash in the payoff year",
        hraniceNadpis: "Break-even return",
        hraniceText: "Below {nominalni} nominal (that is {realni} above inflation) overpaying wins. Note that the threshold sits ABOVE the mortgage rate — tax and fees take the difference.",
        hraniceNelze: "The break-even return cannot be computed for these inputs — investing does not beat overpaying even at an extreme return.",
        pojNadpis: "Decreasing cover",
        pojPopis: "If the client died or became disabled, the policy covers the rest of the debt. The sum falls together with the debt — it is the area under the curve. The sum insured is calculated by the capital method from household income and expenses; the mortgage is only its decreasing part.",
        pojZapnout: "Include",
        pojVypnout: "Skip",
        pojPrijem: "Net monthly income",
        pojVydaje: "Essential household expenses",
        pojVydajeHint: "What the household must spend every month to keep running — no saving, no goals.",
        pojDeti: "Number of children",
        pojSmrt: "Sum insured — death",
        pojInvalidita: "Sum insured — disability",
        pojZToho: "Of which mortgage {hypoteka} (falling) and household {domacnost} (constant).",
        pojCena: "Indicative premium",
        pojCenaNote: "Per month, a rate template. Not an offer.",
        pojGrafKryti: "Sum insured",
        pojPrumerSplaceni: "Average outstanding debt — overpaying",
        pojPrumerInvestice: "Average outstanding debt — investing",
        pojRozdilText: "This is the price of the strategy that nobody says out loud: the investing path keeps the debt high the whole time, so the decreasing policy has to run longer and costs more. The real gap for the survivors is smaller on that path, though, because the portfolio is an asset. The adviser needs both numbers, not the friendlier one.",
        pojSablona: "Sums insured and rates are a template from the adviser's practice, not an offer or a guarantee. Verify the actual limits and price with the insurer.",
        pojBezPrijmu: "Without an income the capital method has nothing to work with, so only the decreasing mortgage cover is shown. Fill in the net income and essential expenses and the part that keeps the household running will be calculated too.",
        skript: "„Today you send an extra {volna} into the mortgage. Let me show you the other option: the same money keeps working and you pay the mortgage off in one go. Look at the chart — here the debt falls, here the investment grows, and here they cross. That is the moment you get to choose. And let me show you the other side straight away: if the market gave nothing, this is how it ends. That is why a policy belongs to this, one that covers the debt if something happened to you.“",
        kroky: [
          "Take the outstanding principal, the rate, the instalment and the end of the fixed period from the statement. Not from the client's memory — the gap is usually in the hundreds of thousands.",
          "Ask how much they have spare each month and whether they can keep sending it in five years' time. An unstable amount breaks the whole calculation.",
          "Set the year they want the mortgage gone. That date does not move afterwards.",
          "Say out loud whether the return entered is nominal or above inflation. It is the single most common mistake in this type of calculation.",
          "Fill in the fund fees from the KID document. Without them the investment result is overstated.",
          "Show the chart and the crossing point. Only then the numbers.",
          "Go through the risk panel including the scenario where the market gives nothing. Do not skip it.",
          "Turn on the decreasing cover and work out what happens if the client drops out. Without it the whole strategy is uncovered.",
          "Check the contract for the free early-repayment limit and any fees on extra payments.",
        ],
        kdyNe: [
          "The client has no reserve for three to six months of expenses. Reserve first, this second.",
          "The expected return is below or close to the mortgage rate. Then investing has no way to win and overpaying is clearly better.",
          "The client would not sleep if the portfolio dropped thirty per cent. The payoff date is fixed and the market does not care.",
          "The spare amount is uncertain — variable income, a seasonal sole trader, fresh parental leave. Overpaying survives a gap; investing to a fixed date does not.",
          "The fixed period ends in a year or two and the new rate is unknown. Get the rate first, then calculate.",
          "The client has no death and disability cover. Without it the strategy rests on nothing going wrong.",
          "The bank charges compensation for extra payments above the statutory limit. Check the contract — the calculation does not model it.",
        ],
        metodika: "Tax on the sale is calculated per individual purchase under today's law. A sale in {rok} is therefore judged by today's rules, and the law may change several times before then. The result is indicative; it is not an offer or personal advice.",
        hlaskaJistina: "Enter the outstanding mortgage principal.",
        hlaskaSazbaChybi: "Enter the mortgage interest rate.",
        hlaskaHorizontChybi: "Enter in how many years the client wants the mortgage paid off.",
        hlaskaHorizontNekladny: "The payoff horizon must be at least one year.",
        hlaskaSplatnost: "Enter the mortgage term in years.",
        hlaskaNicNavic: "The client has nothing spare — there is nothing to compare. Enter a monthly spare amount or a lump sum.",
        hlaskaZapornaAmortizace: "The instalment does not even cover the monthly interest — the debt would grow and the mortgage would never be repaid. Check the principal, the rate and the term.",
        hlaskaVynosPodUrokem: "The expected return {vynos} is below or equal to the mortgage rate {sazba}. Investing cannot win even before tax and fees — recommend overpaying.",
        hlaskaDoplaceniNevyslo: "The portfolio is not enough to pay off. After the sale and tax there is {castka} missing and the client is left with debt. Raise the spare amount or move the payoff date.",
        hlaskaHorizontZaSplatnosti: "The mortgage ends on its own in {roky}, sooner than the client wants to pay it off. There is nothing to pay off.",
        hlaskaSplatnostNedosazena: "With the instalment entered the mortgage is not repaid even over the whole modelled horizon. Check the inputs.",
        hlaskaNad25: "The annual volume of extra payments exceeds a quarter of the original principal. By law only repayment of up to 25 % a year in the month before the contract anniversary is free of charge; above that the bank may charge compensation. Check the contract.",
        hlaskaPrepocetNaNominalni: "The real return entered was converted to {vynos} nominal for comparison with the mortgage (inflation {inflace}). Mortgage interest is nominal.",
        hlaskaPoplatkyNezadany: "Investment fees are not filled in — zero is assumed. A real fund costs 1–2 % a year and the investment result is overstated by that much.",
        hlaskaFixaceBezDelky: "You entered a rate after the fixed period but not its length — the other rate will therefore never apply.",
        hlaskaSok: "A market drop of {propad} in year {rok} is being modelled.",
        hlaskaObecna: "The calculation hit a value it cannot process. Check the inputs.",
        krokDluh: "DEBT",
        krokCesta: "THE PATH",
        krokVysledek: "RESULT",
        krokRiziko: "RISK",
        krokOchrana: "PROTECTION",
        prezRok: "Year",
        prezZavrit: "Close the presentation",
        prezNapoveda: "click / → next · Esc to end",
        prezKonec: "Let us work it out for you",
        prezDisclaimer: "An indicative model, not an offer or a promise of benefits. Binding figures come from the contract, the price list and the policy terms.",
        prezDluhStitek: "You owe today",
        prezDluhVeta: "Instalment {splatka} a month at a rate of {sazba}.",
        prezDluhUroky: "You will pay {castka} in interest if nothing changes",
        prezProtnutoTuk: "Here you already have enough",
        prezProtnutoText: "The investment covered the remaining debt for the first time — around year {rok}.",
        prezCestaBezi: "Watch — debt down, investment up…",
        prezCestaHotovo: "Around year {rok} the curves cross. That is where you get to choose. Click for the result →",
        prezCestaNikdy: "Within the chosen period the curves never cross — it is not enough to pay off yet. Click on →",
        prezVysledekStitek: "What you are left with in {roky}",
        prezVysledekVeta: "Both paths spend exactly the same from your budget. They differ only in where that money sat in the meantime.",
        prezRizikoStitek: "And what if the market gives nothing",
        prezRizikoVeta: "The worst of the scenarios calculated: {scenar}. A negative number means investing would end up worse than overpaying.",
        prezRizikoNeznamo: "The scenarios could not be calculated for these inputs.",
        prezOchranaStitek: "If something happened to you",
        prezOchranaRozpad: "Of that, the mortgage is {hypoteka} — it falls together with the debt. The remaining {domacnost} keeps the family running.",
        prezOchranaVeta: "Roughly {cena} a month. A rate template, not an offer.",
        prezOchranaVypnuto: "Decreasing cover is switched off. Turn it on in the calculator and go through this part with the client too — without it the whole strategy rests on nothing going wrong.",
      },
    },
    finMat: {
      freqCtvrtletni: 'Quarterly',
      freqDenni: 'Daily',
      freqMesicni: 'Monthly',
      freqRocni: 'Annual',
      rokFew: 'years',
      rokMany: 'years',
      rokOne: 'year',
      tabInvestice: 'Investment',
      tabRenta: 'Income',
      tabUver: 'Loan / Mortgage',
      varovaniNekonecnaRenta: 'The income is lower than or equal to the return → the capital will never be exhausted (perpetual income). 🎉',
      varovaniZapornaAmortizace: 'The payment is lower than the monthly interest → the loan will never be repaid (negative amortisation). Increase the payment.',
    },
    investStrategie: {
      aktivaAkcie: 'Equities (S&P 500)',
      aktivaBtc: 'Bitcoin',
      aktivaDluhopisy: 'Bonds',
      aktivaMsci: 'MSCI World',
      aktivaPt: 'Cash / money market',
      aktivaReit: 'Real estate',
      aktivaZlato: 'Gold',
      akumulacniInsight: 'Time tames risk. Over 15+ years equities have historically always beaten everything else.',
      akumulacniKdo: 'For the young and a long horizon',
      akumulacniName: 'Accumulating (100 % equities)',
      akumulacniStory: '100 % equities in accumulating ETFs — dividends are reinvested automatically (tax efficient). The longer the horizon, the more equities.',
      coreInsight: 'The main part cheap and passive, a pinch for a higher return. The best ratio of cost to result.',
      coreKdo: 'The standard among professionals and funds',
      coreName: 'Core–Satellite',
      coreStory: 'The core (80 %) = a cheap global index that grows boringly reliably. The satellites (20 %) = the spice — themes, gold, crypto.',
      dalioInsight: 'When a crisis comes, you sleep well. Smaller swings = fewer panic mistakes.',
      dalioKdo: 'Bridgewater, the largest hedge fund in the world',
      dalioName: 'Ray Dalio — All Weather',
      dalioStory: 'An “all weather” portfolio — balanced so that it survives growth, recession, inflation and deflation. Balanced by risk, not by money.',
      milionariInsight: 'Wealth is not built by saving, but by owning assets that grow and pay out.',
      milionariKdo: 'UBS / Knight Frank Wealth Report',
      milionariName: 'How dollar millionaires invest',
      milionariStory: 'The wealthy do not sit on piles of cash — they own assets: equities, real estate, businesses, gold. Broad diversification across everything.',
      nobelInsight: 'This is an income portfolio: you draw from it and the capital does not fall. Exactly like your future income.',
      nobelKdo: 'Has been paying out Nobel Prizes for 120+ years',
      nobelName: 'The Nobel Foundation',
      nobelStory: 'Every year it hands out millions in Nobel Prizes — and its capital today is larger than at the start. Because it invests the money instead of letting it sit.',
      norskyInsight: 'A state that could spend freely invests globally instead. Diversification and patience.',
      norskyKdo: 'The largest sovereign fund in the world ($1.8 trn)',
      norskyName: 'The Norwegian oil fund',
      norskyStory: 'Norway does not spend its oil money — it invests it for future generations in some 9,000 companies worldwide. Over 70 % in equities.',
      rokFew: 'years',
      rokMany: 'years',
      rokOne: 'year',
    },
    pdDisclaimer: {
      titulek: 'What the client must know',
    },
    pdGraf: {
      let: 'years',
      popisGrafu: 'Value of both options over time',
      zdroj: 'Source: model calculation from the adviser inputs — not historical performance or a forecast.',
    },
    pdModel: {
      horizont: 'Horizon (years)',
      horizontAria: 'Horizon in years',
      jenPorovnatelna: '— only the part of the portfolio we can compare with our option in the same category.',
      kurzPouzit: 'Foreign currencies converted at the rate of {datum} ({seznam}). Source: {zdroj}.',
      kurzNepouzit: 'Foreign currencies are not converted — {duvod} Amounts in different currencies are therefore not added up.',
      kurzStary: 'the rate sheet from {datum} is older than 30 days.',
      kurzChybi: 'the rate for {meny} is missing.',
      kurzBezListku: 'no valid rate sheet.',
      tisk: 'Print / PDF',
      tiskTitle: 'Prints the page or saves it as PDF',
      smazat: 'Clear inputs',
      smazatTitle: 'Clears the tables and model settings',
      mena: 'Home currency',
      menaNapoveda: 'by the organisation’s country, not by the language',
      nepocitaSe: 'not calculated',
      pocatecniHodnota: 'Starting value of the model',
      popis: 'The model return is YOUR input assumption, not a forecast. The app suggests no return — without it nothing is modelled.',
      titulek: '3 · Model settings',
      vklad: 'Monthly contribution',
      vkladNapoveda: 'empty = no regular contributions',
      vstupni: 'Entry fee of the current portfolio %',
      vstupniAria: 'Entry fee of the current portfolio',
      vstupniNapoveda: 'applies to FUTURE contributions only — it is not charged again on money already invested',
      vynos: 'Model gross return % p. a.',
      vynosAria: 'Model gross return',
      vynosNapoveda: 'you fill it in — the app suggests nothing',
    },
    pdPrazdny: {
      krok1Nadpis: 'Copy in the client’s positions',
      krok1Popis: 'From the account statement or the distributor’s portal. The ISIN is optional — if you enter it, the check digit is validated.',
      krok2Nadpis: 'Fill in the costs from the KID',
      krok2Popis: 'Every fund has a KID (Key Information Document). Ongoing charges and entry costs are in the Costs section, the 1–7 risk level in the Summary Risk Indicator section.',
      krok3Nadpis: 'Enter our option and the model',
      krok3Popis: 'You enter the cost of our strategy — the app does not know it. Then set the horizon and the model gross return.',
      pridatPrvni: 'Add the first position',
      proc: 'The app knows the cost of no fund — it will not look it up by ISIN nor estimate it from the category. You enter every number from a documented source. That is what makes the output defensible in front of the client and the regulator.',
      titulek: 'Nothing to calculate yet',
    },
    pdRozlozeni: {
      bezKategorie: 'No category set',
      bezMeny: 'No currency filled in',
      kategoriePopis: 'Based on the categories you entered. We do not compute the overlap of individual shares inside the funds — without the funds’ real holdings that would be a made-up number.',
      kategorieTitulek: 'Breakdown by category',
      menyPopis: 'From filled-in data only. A missing currency is not silently turned into Czech koruna — it goes to “unspecified”.',
      menyTitulek: 'Currency breakdown',
    },
    pdTabulka: {
      hodnota: 'Value',
      hodnotaNapoveda: 'how much the client holds in it',
      isin: 'ISIN',
      isinNapoveda: 'optional — from the statement or the KID',
      kategorie: 'Category',
      kategorieNapoveda: 'compared only within the same one',
      mena: 'Currency',
      menaNapoveda: 'currency of the position',
      nazev: 'Fund name',
      nazevNapoveda: 'exactly as it is on the statement',
      neuveden: 'not stated',
      prazdno: 'Nothing yet — add the first row.',
      pridatRadek: 'Add a row',
      smazatRadek: 'Delete the row',
      sri: 'Risk 1–7',
      sriNapoveda: 'KID, summary risk indicator',
      ter: 'TER % p. a.',
      terNapoveda: 'KID, Costs section — ongoing charges',
      vstupni: 'Entry fee %',
      vstupniNapoveda: 'KID, Costs section — entry costs',
      zdroj: 'Source of the number',
      zdrojEmt: 'EMT (documented)',
      zdrojKatalog: 'catalogue — indicative',
      zdrojKid: 'KID (documented)',
      zdrojNapoveda: 'only the KID or EMT counts as documented',
      zdrojPoradce: 'entered by the advisor',
    },
    pdVerdikt: {
      hodnota: 'value',
      hodnotaPonechat: 'Value with the verdict keep',
      keZvazeni: 'to consider',
      nakladovostPolozky: 'Cost of the position',
      naseVarianta: 'our option',
      nescitaSe: 'not summed (multiple currencies)',
      popis: 'Material for a conversation with the client, not investment advice nor an instruction to sell. Comparison happens only within the same category.',
      rozdil: 'difference',
      stitekNelze: 'Cannot be assessed',
      stitekPonechat: 'Keep',
      stitekZvazit: 'Consider a change',
      stretZajmu: 'Conflict of interest: we compare against a product we distribute and are paid for arranging.',
      titulek: 'Verdict position by position',
    },
    pdVety: {
      aDalsi: 'and {n} more',
      bezHodnoty: 'Value is not filled in for {n} {polozek}.',
      bezKategorie: 'No category is set for {n} {polozek}.',
      bezMeny: 'Currency is not filled in for {n} {polozek}.',
      bezTer: 'We do not know the cost for {n} {polozek}.',
      duvodBezReference: 'We have no variant of ours with the cost filled in — without it there is nothing to compare against. Add it from the KID.',
      duvodMichaneMeny: 'The comparable items are in several currencies without conversion. The core does not know the exchange rates, so they are not summed up — unify the currency, or model each one separately.',
      duvodNulovaHodnota: 'All comparable items have zero value and their costs differ — weighting is not possible.',
      duvodPrazdno: 'The portfolio is empty — the model is not calculated.',
      duvodZadnaShoda: 'No client item has our variant in the same category with a known cost. No comparison is made across categories — add our variant to the category you want to assess.',
      koncentrace: 'That is concentration — it is not a mistake, but ask about it.',
      menySeznam: 'Currencies: {seznam}. Shares cannot be calculated — values are missing.',
      modelujeCast: 'Only the comparable part of the portfolio is modelled — {z} % of its value.',
      modelujeVse: 'The whole portfolio is modelled.',
      nakladovostNejde: 'The portfolio cost cannot be calculated — we do not know it for a single item.',
      nakladovostNulaHodnot: 'The cost cannot be weighted — all items have zero value.',
      nejvetsiKategorie: 'The largest category “{kategorie}” makes up {podil} of the portfolio.',
      nevstupujeFew: 'do not enter',
      nevstupujeMany: 'do not enter',
      nevstupujeOne: 'does not enter',
      orientacniHlavniCislo: 'Part of the costs is not evidenced by a KID or an EMT — the headline number is therefore only indicative.',
      orientacniTer: 'The cost for {n} {polozek} is indicative — verify it in the KID.',
      podilyNejdou: 'Shares cannot be calculated — values are missing.',
      polozkaBezNazvu: 'item without a name',
      polozkaBezNazvuCislo: 'Item without a name{cislo}',
      polozkaFew: 'items',
      polozkaMany: 'items',
      polozkaOne: 'item',
      porovnaniVKategorii: 'Each item is compared with our variant in its own category — no comparison is made across categories.',
      prazdnePortfolio: 'The portfolio is empty.',
      rokFew: 'years',
      rokMany: 'years',
      rokOne: 'year',
      rozdilZa: 'Difference over {roky} {rok}',
      souhrnNelze: '{n}× cannot be assessed',
      souhrnPonechat: '{n}× keep',
      souhrnZvazit: '{n}× consider a change',
      spocitanoZ: 'Calculated from {z} % of the portfolio value.',
      uPolozkyFew: 'items',
      uPolozkyMany: 'items',
      uPolozkyOne: 'item',
      vazenaNakladovostVeta: 'Weighted portfolio cost {pct} % p. a.',
      viceMenHodnoty: 'The values are in several currencies without conversion — the shares are indicative.',
      viceMenPodily: 'The portfolio is in several currencies without conversion — the shares are indicative.',
      viceMenVahy: 'The portfolio is in several currencies without conversion — the weights are only indicative.',
      vynechaneVeta: '{n} {polozek} {nevstupuje} the model: {vypis}.',
      vynechanoBezHodnoty: 'value not filled in',
      vynechanoBezKategorie: 'no category set',
      vynechanoBezReference: 'we have no variant to compare with in its category',
      vynechanoBezTer: 'cost unknown',
      vynechanoBezTerReference: 'the cost of our variant is unknown',
      vynechanoJineRiziko: 'markedly different risk level',
      zadnaMena: 'Currency is not filled in for a single item.',
    },
    pdVysledek: {
      doModelaceVstupuje: 'Entering the model',
      doplnVstupy: 'Fill in the model inputs.',
      hodnotaNaKonci: 'value at the end',
      hodnotyPortfolia: 'of the portfolio value',
      klientVyhral: 'The current portfolio is cheaper on costs. Cost is therefore no reason to move.',
      lepeVychazi: 'Comes out better: {popis}',
      nepocitaSe: 'The model is not being calculated yet',
      neuvedeno: 'not stated',
      porovnatelnaNase: 'Comparable part — our options',
      porovnatelnaSoucasne: 'Comparable part — current portfolio',
      referenceBezNakladu: 'Reference with no costs at all',
      rozdilPorovnatelne: 'Difference in the comparable part',
      rozpadModelace: 'Model breakdown',
      rozpadPopis: 'Fees paid and lost return are TWO DIFFERENT numbers. Lost return also contains what the paid money would have earned — do not call it a fee. The entry fee the client once paid on the way in is NOT counted into the current portfolio again — it is a sunk cost.',
      spocitanoZ: 'calculated from',
      stejnyVynosPoznamka: 'Both variants are calculated with the same gross return of {vynos} p. a. The model therefore compares COSTS, not the ability of the funds to earn. A model calculation, not a promise of return.',
      uslyVynos: 'lost return (including compounding)',
      vazenaNakladovost: 'Weighted portfolio cost',
      vazenaPopis: 'Weighted by the value of the position. A position with unknown cost is NOT counted into the average — zero is never substituted.',
      vlozenoCelkem: 'Total invested',
      vyvojVCase: 'Value over time',
      zanedbatelny: 'The difference is negligible',
      zaplacenePoplatky: 'fees actually paid',
    },
    portfolioDoktor: {
      karta1: '1 · The client’s portfolio',
      karta1Popis: 'You type straight into the table — no modals, no clicking into a detail. An empty field means “we don’t know”, not zero.',
      karta2: '2 · Our strategy for comparison',
      karta2Popis: 'You enter the cost of our option — it is hard-coded nowhere. Comparison always happens within the same category, so add a row for every category you want to assess.',
      kteraVarianta: 'Which option goes into the model',
      nadrazenaSekce: 'Tools',
      naseVarianty: 'Our options (by category)',
      porovnatelnaCast: 'Comparable part of the current portfolio',
      pridejVariantu: 'Add our option, otherwise there is nothing to compare against.',
      soucasnePortfolio: 'Current portfolio',
      stretZajmu: 'Conflict of interest: we compare against a product we distribute and are paid for arranging. That is why the tool is allowed to end with the verdict “keep” — and when that is the result, it says so.',
      titulek: 'Portfolio doctor',
      uvod1: 'Write down what the client holds, add the costs from the KID and you will see what the portfolio costs him and how big a difference that makes over the horizon.',
      uvod2: 'The app knows the cost of no fund',
      uvod3: '— you enter the numbers from a documented source.',
      vseZKid: 'All from the KID',
      vseZKidTitle: 'Marks the filled-in costs as documented from the KID',
    },
    provize: {
      add: 'Add a product',
      amount: 'amount',
      koef: 'Coefficient',
      kpi1: 'Commission, 1st year',
      kpi5: 'Total over 5 years',
      kpi5Sub: '1st year + 4× recurring',
      kpiRep: 'Recurring / year',
      kpiRepSub: 'servicing + fee',
      notFound: 'Nothing found',
      note: '💡 An indicative calculation from the catalogue. The exact terms follow the commission annexes on the portal. “Recurring” = servicing BJ (motor/property from year 2, investments management fee, life insurance from year 6).',
      pick: '— pick a product —',
      pos: 'Your position',
      repeat: 'recurring',
      sample: 'sample',
      sub: 'Enter your position and the products → you will see the first-year and the recurring commission. 201 products from the BJ catalogue · commission = BJ × coefficient.',
      title: 'Commission calculator',
      tools: 'Tools',
      year1: '1st year',
    },
    srovnavacFondu: {
      coSniPoplatky: 'What the fees eat up',
      disclaimer: 'TER rates and entry fees are indicative — verify them in the current KIID / fee schedule. The same gross return for both serves to isolate costs; real funds may track different indices. Past performance is no guarantee of future performance.',
      disclaimerTuk: 'A model calculation, not a promise of return.',
      hintA: 'our fund / ETF',
      hintB: 'the client’s fund',
      hledatPlaceholder: 'Type the client’s fund… (e.g. “dynamic”)',
      hrubyVynos: 'Gross return',
      nadrazenaSekce: 'Tools',
      nicNenalezeno: 'Nothing found — pick a custom fund and enter the TER manually.',
      rok: 'Year',
      ter: 'TER (annual cost)',
      uvod1: 'Find the client’s fund in the search box (part of the name is enough, accents optional) and compare it with our fund — how much of the return the fees take. The same assumed gross return for both, so what you see is purely the',
      uvod2: 'difference in costs',
      uvod3: '. No AI, it is calculated right here.',
      vicNaKonci: 'MORE AT THE END',
      vlastniFond: 'Custom fund',
      vlastniFondRucne: 'Custom fund (enter the TER manually)',
      vlozenoCelkem: 'Total invested',
      vstupni: 'entry fee',
      vstupniPoplatek: 'Entry fee',
      vstupniProc: 'Entry fee %',
      vyvojHodnoty: 'Value over time',
      zisk: 'Profit',
    },
  },
  /* === /NASTROJE === */
  /* CRISIS PLAN — see the comment in cs.js. Nothing here may promise insurer behaviour. */
  krize: {
    nadpis: 'Crisis plan',
    podnadpis: 'What to do when something happens',
    uvod1: 'Keep this part. It is not for today — it is for the day you will need it.',
    uvod2: 'There is nothing here you must manage right away. The order is always the same: take care of yourself, call me, report it to the insurer.',
    proKoho: 'Crisis plan for {jmeno}',
    platnost: 'Prepared on {datum} from the contracts on file at that time.',

    kontaktNadpis: 'Call me first',
    kontaktText: 'You do not need to know what was arranged where, or who to write to. That is what I am here for.',
    kontaktRole: 'Your adviser',
    kontaktFirma: 'Company',
    kontaktTelefon: 'Phone',
    kontaktEmail: 'E-mail',
    kontaktWeb: 'Website',
    kontaktRezervace: 'Book a meeting',

    krokyNadpis: 'What to do',
    podkladyNadpis: 'What to have ready',
    pozorNadpis: 'Watch out for',
    smlouvyNadpis: 'Contracts that may apply here',
    smlouvaBezCisla: 'contract number not on file yet',
    smlouvaBezInstituce: 'institution not on file yet',
    bezSmluv: 'I have no contract on file for this risk. That does not mean you have none — it means we have to track it down together.',
    bezSmluvVse: 'I have no insurance contract on file at all. The steps below still apply; we will just first go through what you actually have.',
    navrhNavic: 'Added suggestion',

    pravniNadpis: 'Where this comes from',
    pravniOvereno: 'verified',
    disclaimer1: 'This overview says WHAT to do. It does not say whether or how much the insurer will pay — that follows the wording of your contract and its exclusions. We will go through them together.',
    disclaimer2: 'The sections quoted are general rules, not a promise of payment. Every contract has its own deadlines and conditions.',
    disclaimer3: 'The steps follow Czech law. Contracts arranged in another country follow that country rules.',

    chybiNadpis: 'Before you send this to the client',
    chybiKontaktVse: 'The adviser profile has neither a phone number nor a public e-mail. A crisis plan without a contact makes no sense — add them in Settings.',
    chybiJmeno: 'Adviser name is missing.',
    chybiTelefon: 'Adviser phone number is missing.',
    chybiEmail: 'Adviser public e-mail is missing.',
    chybiWeb: 'Adviser website is missing.',
    chybiRezervace: 'No booking link — add a business card page or a calendar.',
    chybiSmlouvy: 'No insurance contracts are on file.',
    chybiCislaSmluv: 'Some contracts have no number. A client in a crisis will not go looking for it.',

    pravni: {
      oznameni: 'An insured event must be reported to the insurer without undue delay.',
      setreni: 'After the report the insurer starts its investigation without undue delay. It communicates the result, and the reasoning behind the amount or the reason for refusal, in text form.',
      splatnost: 'Unless the contract sets a different due date, the payment is due within fifteen days of the END of the investigation. It is not a deadline for settling the whole case.',
      zaloha: 'If the investigation cannot be closed within three months of the report, the insurer states the reasons in text form and, on request, provides a reasonable advance.',
      stupne: 'Disability degrees follow the loss of working capacity: 1st degree 35–49 %, 2nd degree 50–69 %, 3rd degree at least 70 %.',
      nahradaMzdy: 'For the first 14 calendar days of temporary incapacity for work an employee receives wage compensation from the employer.',
      zadostID: 'A disability pension application is filed at the district social security office or submitted electronically. The medical condition is assessed by an assessment physician, usually from the documentation. The statutory time limit for a decision is 90 days.',
    },

    uraz_nemoc: {
      nadpis: 'Injury or illness — short-term sick leave',
      kdy: 'You are at home on sick leave and expect to be back in a few weeks.',
      kroky: [
        { n: 'Have the sick note issued', d: 'Your treating doctor issues it electronically. You do not carry paper to your employer.' },
        { n: 'Let your employer know', d: 'A short message with the first day of your sick leave is enough.' },
        { n: 'Get in touch with me', d: 'We will go through your contracts and say which of them apply here.' },
        { n: 'Report it to the insurer', d: 'Section 2796 of the Civil Code requires reporting without undue delay. If you are unsure how, we will report it together.' },
        { n: 'Keep every document', d: 'Doctor reports, pharmacy receipts, confirmation of how long the sick leave lasted. They are harder to obtain later.' },
      ],
      podklady: [
        'Insurance contract number',
        'Proof of identity',
        'Bank account number for the payment',
        'Confirmation of sick leave — from and to',
        'Medical reports on the injury or illness',
      ],
      pozor: 'For the first 14 calendar days the employer pays wage compensation; from day 15 the social security administration pays sickness benefit. A self-employed person receives sickness benefit only with voluntary sickness insurance. The waiting period in an insurance policy is a different thing — every contract sets its own and we will find yours.',
    },

    dlouhodoba_pn: {
      nadpis: 'Long-term sick leave',
      kdy: 'The sick leave is dragging on for months and it is clear this is not a two-week matter.',
      kroky: [
        { n: 'Call me before the money runs out', d: 'The earlier we know, the more can still be done with the budget and the instalments.' },
        { n: 'We will work out the monthly shortfall', d: 'Sickness benefit replaces only part of net income. The gap is exactly what has to be covered.' },
        { n: 'Claim the daily benefit from your policy', d: 'Sick leave cover and daily injury benefit are claimed separately — even if you already reported the injury once.' },
        { n: 'Tell the bank in time', d: 'A deferral is requested before an instalment is missed. After a missed instalment it gets much harder.' },
        { n: 'We will set a review meeting', d: 'In a long sick leave the situation changes every month. I do not want you watching that alone.' },
      ],
      podklady: [
        'Decision on temporary incapacity for work',
        'Ongoing medical reports',
        'Insurance contract numbers',
        'Overview of instalments and standing orders',
        'Bank statements for the recent months',
      ],
      pozor: 'Sickness benefit is not paid indefinitely — the support period is limited, and its length and any extension are assessed by the social security administration in your case. We will check it together so we know when to plan the next step.',
    },

    zavazne_onemocneni: {
      nadpis: 'Critical illness',
      kdy: 'A diagnosis such as cancer, heart attack or stroke. Those are usually listed in policies by name.',
      kroky: [
        { n: 'Treatment comes first', d: 'None of the steps below is for this afternoon. The paperwork can wait a few days.' },
        { n: 'Call me', d: 'We will check whether your diagnosis is among the covered ones. The list differs in every contract.' },
        { n: 'Ask for a medical report stating the diagnosis', d: 'Including the date it was made. Without it the claim cannot be evidenced.' },
        { n: 'Report it to the insurer', d: 'Without undue delay, section 2796 of the Civil Code. We will fill in the form together.' },
        { n: 'Deal with the lost income too', d: 'A critical illness usually means long sick leave as well. We claim both, not just one.' },
      ],
      podklady: [
        'Medical report with the diagnosis and its date',
        'Hospital discharge report',
        'Test results the report refers to',
        'Insurance contract number and proof of identity',
        'Bank account number for the payment',
      ],
      pozor: 'Every contract has its own list of diagnoses, its own definitions and its own waiting period. What applies to you we will read straight from your contract — it cannot be said in general.',
    },

    invalidita: {
      nadpis: 'Disability',
      kdy: 'Your health is poor long term and returning to work at the original level is not realistic.',
      kroky: [
        { n: 'Call me at the start, not at the end', d: 'Months pass before the decision arrives. During that time a lot can still be done with instalments and the budget.' },
        { n: 'File the disability pension application', d: 'It is drawn up at the district social security office, or submitted electronically.' },
        { n: 'Gather the medical reports in advance', d: 'An assessment physician reviews your health, usually from the documentation. The more complete the file, the smoother the process.' },
        { n: 'Know what is being decided', d: 'The degree of disability by loss of working capacity: 1st degree 35–49 %, 2nd degree 50–69 %, 3rd degree at least 70 %. The statutory time limit for a decision is 90 days.' },
        { n: 'Take the decision to the insurer', d: 'Most contracts refer to the granted degree of disability. Keep the decision — it is the key document.' },
      ],
      podklady: [
        'Proof of identity',
        'Complete medical reports',
        'Proof of education and an overview of your work history',
        'The occupational questionnaire the social security office sends you',
        'The disability decision and the insurance contract number',
      ],
      pozor: 'A state disability award and an insurance payout are two separate procedures. The insurer decides by the wording of your contract and may reach a different conclusion than the state. That is exactly why you should not handle this alone.',
    },

    umrti: {
      nadpis: 'Death',
      kdy: 'Someone close is reading this part. There is nothing here that has to happen today.',
      kroky: [
        { n: 'Arrange only what is necessary', d: 'The registry office issues the death certificate; the funeral service usually arranges it. Ask for several copies, they will be needed in several places.' },
        { n: 'Call me', d: 'You do not need to know what was arranged where. I have the overview of the contracts we did and I will go through them with you.' },
        { n: 'Report it to the insurers', d: 'Section 2796 of the Civil Code requires reporting without undue delay. We will report it together, including contracts at other institutions.' },
        { n: 'Apply for survivor pensions', d: 'Widow, widower and orphan pensions do not start on their own — each is applied for at the social security office.' },
        { n: 'Do not rush big decisions', d: 'Selling the flat, cancelling contracts, repaying the loan. None of that belongs to the first weeks.' },
      ],
      podklady: [
        'Death certificate — preferably several copies',
        'Proof of identity of the surviving relative',
        'Insurance and loan contract numbers',
        'Marriage certificate, birth certificates of the children',
        'Bank account number for the payment',
      ],
      pozor: 'Debts do not disappear on death; they are dealt with in probate. With some loans the payment protection cover sits directly in the loan contract, not in the life policy. That is why we will contact the bank as well.',
    },

    skoda_na_majetku: {
      nadpis: 'Damage to property',
      kdy: 'A flood, fire, windstorm, burglary — or damage you caused to someone else.',
      kroky: [
        { n: 'Stop the damage if it is safe to do so', d: 'Turn off the water, switch off the electricity. If there is danger, call 112.' },
        { n: 'Photograph everything before you start clearing up', d: 'Photos and video are the strongest evidence. Do not throw damaged items away before the insurer has seen them.' },
        { n: 'Call the police for a burglary or a road accident', d: 'Without a police record such damage is hard to evidence.' },
        { n: 'Report it to the insurer and get in touch with me', d: 'Without undue delay, section 2796 of the Civil Code. I will help with the damage list and the form.' },
        { n: 'List the damage item by item', d: 'What it was, when it was bought, for how much. Receipts, invoices, warranty cards — whatever you have.' },
      ],
      podklady: [
        'Photos and video of the damage',
        'List of damaged items with values',
        'Receipts, invoices, warranty cards',
        'Insurance contract number and proof of identity',
        'Police report for a burglary or an accident',
      ],
      pozor: 'Do not start repairs before agreeing with the insurer — many contracts require an inspection first. And if you caused damage to someone else, do not admit liability or pay anything before we go through it together.',
    },
  },

  /* STAV UKLÁDÁNÍ ANALÝZY — cs/sk/uk/vi to měly, angličtina jako jediná ne,
   * takže poradce v anglickém rozhraní viděl u indikátoru syrový klíč.
   * Zelená smí svítit JEN tehdy, když na serveru sedí přesně to, co je na
   * obrazovce. Texty musí být krátké — jedou v liště vedle tlačítek. */
  /* BLOK:analyza START — generuje scratchpad/slovnik.py, ručně needitovat */
  analyza: {
    instituceVyber: {
      nabidka: 'List of institutions',
      sipka: 'Show the full list',
    },
    propis: {
      ceka: 'Waiting to be copied to the folder: {n}',
      chyba: 'Could not copy to the client folder right now, I will try again',
      hotovo: 'Copied to the folder',
      hotovoNove: 'new: {n}',
      hotovoUpravene: 'updated: {n}',
      klid: 'The client folder matches the analysis',
      nehotove: 'Unfinished rows waiting to be completed: {n}',
      nepropisovane: 'Accounts and cash are not copied to the folder yet: {n}',
      probiha: 'Copying to the client folder…',
      smazane: 'A row deleted from the analysis stays in the folder: {n}',
    },
    uklad: {
      ceka: 'Waiting to save',
      cekaDetail: 'The last change is not on the server yet.',
      nepovedlo: 'Not saved — retrying',
      nepovedloDetail: 'Attempt {n}, next in {s} s',
      nepovedloPokus: 'Attempt {n}',
      obnova: 'We found unsaved changes — restore them?',
      obnovaAno: 'Restore',
      obnovaNe: 'Discard',
      obnovaSCasem: 'We found unsaved changes from {cas} — restore them?',
      uklada: 'Saving…',
      ulozeno: 'Saved',
      zastaveno: 'Not saving — the analysis failed to load',
      zastavenoDetail: 'Reload the page so your data does not get overwritten.',
    },
  },
  /* BLOK:analyza END */

  /* === AUTO: keys extracted from language ternaries (scripts/i18n-ternary-codemod.js) === */
  /* BLOK:auto START — generuje scratchpad/slovnik.py, ručně needitovat */
  auto: {
    aIEmailBulkModal: {
      aiFiltrujePise: 'AI is filtering + writing…',
      cileni: 'Targeting:',
      hromadnyAiMailSmartemailing: 'Bulk AI mail (Smartemailing free)',
      jmeno: 'First name',
      klientu: 'clients',
      klientuOdpovidaFiltru: 'clients match the filter',
      klientumOtazka: 'clients?',
      n2NahledEmailuPlaceholders: '2. Email preview (placeholders replaced on send)',
      odeslano: 'Sent:',
      opravduOdeslatEmail: 'Really send the email to',
      osloveni: 'Salutation',
      poradce: 'Advisor',
      posliVsemCoNemaji: 'Send everyone without a pension plan that there is a promo + CTA to call…',
      prepsano: 'Transcribed',
      prijemci: 'Recipients',
      prijmeni: 'Last name',
      prikladyPosliVipKlientum: 'Examples: „send VIP clients a newsletter about ČNB“ · „send everyone who signed life insurance the partner info“ · „a 2026 tax tip to all active clients“',
      selhalo: 'failed',
      skrytSeznamPrijemcu: 'Hide the recipient list',
      spustitKampan: 'Launch the campaign →',
      teloTemplate: 'Body (template):',
      uspesne: 'successfully',
      vybratVse: 'Select all',
      vyfiltrovatKlientyNapsatEmail: 'Filter clients + Write email',
      zadniKlientiNeodpovidajiFiltru: 'No clients match the filter',
      zadny: 'None',
      zobrazitUpravitSeznam: 'Show / edit the list',
    },
    aIEmailDraftModal: {
      aiEmailKlientovi: 'AI email to the client',
      aiPise: 'AI is writing…',
      aiVygenerujEmail: 'AI, generate the email',
      emailOdeslanSipka: 'Email sent',
      emailOhledne: 'an email about...',
      klientNemaEmailVCrm: '(the client has no email in the CRM)',
      klienta: 'the client',
      komu: 'To:',
      komuKlientACeho: 'To whom (client) and what it concerns (deal)',
      n2NahledEmailu: '2. Email preview',
      obchod: 'deal',
      odeslatNa: 'Send to',
      odeslatZMehoGmailu: 'Send from my Gmail',
      odpovezNaEmailOd: 'Reply to the email from',
      posliPavloviInfoO: 'Send Pavel info about the service meeting on Tuesday at 14:00…',
      posliPredJmenem: 'Send',
      prepsanoKlikniAiVygeneruj: 'Transcribed — click „AI generate“',
      sPredmetem: 'with the subject',
      spustitNahravani: 'Start recording',
      telo: 'Body:',
      volitelneObchod: 'Optional: deal…',
      zastavitNahravani: 'Stop recording',
    },
    academyLayout: {
    },
    analyzaTiskPage: {
      analyza: 'Analysis',
      castka: 'Amount',
      celkem: 'Total',
      cisteJmeni: 'Net worth',
      coBudemeResit: 'What we will work on together',
      coBudemeResitUvod: 'These topics came out of the numbers we went through together. We will cover them when preparing your plan.',
      coJeProVasDulezite: 'What matters to you',
      coOcekavate: 'What you expect from working together',
      coOdVasPotrebuji: 'What I need from you',
      coZnamenajiPenize: 'What money means to you',
      dalsiKrok: 'Next step',
      dedictviBudouciProdej: 'Inheritance / future sale',
      dluhy: 'Debts',
      dobryDenPosilamShrnuti: 'Hello, here is a summary of our financial analysis. Have a look and get in touch if anything comes up.',
      financniAnalyza: 'Financial analysis',
      financniMajetek: 'Financial assets',
      firmaPodnikani: 'Company / business',
      investiceOpfEtfAkcie: 'Investments (mutual funds/ETFs, shares)',
      majetekCelkem: 'Total assets',
      naZakladeTechtoCisel: 'Based on these figures we will propose the next steps in the financial plan — get in touch and we will go through them together.',
      nasobekVydaju: '{n}× expenses',
      nemovitostiAutoCennosti: 'Real estate / car / valuables',
      nezavazne: 'This overview is non-binding. It serves as a basis for preparing your financial plan. Specific solutions, products and their terms will be discussed and agreed only at implementation.',
      penzijniDip: 'Pension / DIP',
      pocetCilu: 'Number of goals',
      prijmyMes: 'Income / mo',
      pripravujiAnalyzu: 'Preparing the analysis…',
      registrace: 'Registration {regulator}: {cislo}',
      rezerva: 'Reserve',
      schuzkaDne: 'Meeting on {datum}',
      shrnutiNasiAnalyzy: 'Summary of our analysis: net worth {jmeni}, a financial reserve of {rezerva}× monthly expenses and free cash flow of {cf} per month.',
      shrnutiSchuzky: 'Meeting summary',
      splatkaMes: 'Payment/mo',
      stavebniSporeni: 'Building savings',
      strucneOSituaci: 'Your situation in brief',
      terminDomluvime: 'We will agree on the date of our next meeting together.',
      uctyAHotovost: 'Accounts and cash',
      vaseCile: 'Your goals',
      volnyCashFlowMes: 'Free cash flow / mo',
      vydajeMes: 'Expenses / mo',
      zavazkyCelkem: 'Total liabilities',
      zaznamZAnalyzy: "A record of the analysis dated {datum}, in today's prices. It serves as the basis for the financial plan; we update it whenever the situation changes.",
      /* Vzhled zeleného PDF (25. 10. 2026): podnadpisy, velká karta volných peněz, pata listu. */
      dulezitUpozorneni: 'Important notice',
      majetekAZavazky: 'Assets and liabilities',
      prijmyAVydaje: 'Income and expenses',
      volneProstredky: 'Money left over',
      volneProstredkyPopis: 'What you have left each month after expenses and loan repayments.',
      vydajePodleKategorii: 'Expenses by category',
      vytvoreno: 'Created {datum}',
    },
    businessCharts: {
      celkemBj: 'Total BJ',
      cil: 'target',
      nastavMesicniPlanBj: 'Set your monthly BJ plan in Goals & Rocks.',
      plneniPlanuBj: 'Plan fulfilment (BJ)',
      provize: 'Commission',
    },
    cashflowGraf: {
      cashflowVCaseMesicni: 'Cash flow over time — monthly surplus',
      naKonci: 'at the end',
      nastupHypoteky: 'mortgage starts',
      poNastupuHypoteky: 'after the mortgage starts',
      prebytekKlesneJenO: '). The surplus drops only by the difference between the payment and the rent that ends, not by the whole payment.',
      splatkaHypotekySeV: 'The mortgage payment shows up in the cash flow only from drawdown (yr ',
      start: 'start',
    },
    casovaOsaCilu: {
      casovaOsa: 'Timeline',
      casovaOsaCiluOd: 'Timeline of goals from today to',
      chybi: 'missing',
      dnes: 'today',
      dosahne: 'reaches',
      kdySeKteryCil: 'When each goal is met',
      let: 'yrs',
      letech: 'years old',
      letos: 'this year',
      seNesplniChybiCelkem: 'will not be met — missing in total',
      ve: 'at',
      vekKlientaUMilniku: 'The client age is missing at the milestones — the analysis has no date of birth.',
      zatimZadnyCilOsa: 'No goal yet — the timeline fills in as soon as you add the first one.',
    },
    cilCinema: {
      dalsi: 'Next',
      poznamkaPoradce: 'Advisor note ',
      poznamkaPoradceN: 'Advisor note (N)',
      prehrat: 'Play',
      proKlientskyRezimTu: 'There is no approved content for client mode here yet',
      scenyTohotoCileCekaji: 'The scenes for this goal are awaiting methodology approval. You can play them in advisor mode — we are not showing them to the client yet.',
      zavrit: 'Close',
      zpet: 'Back',
    },
    clientDealsTab: {
      archiv: 'Archive',
      archivovane: 'Archived',
      klikniNovyObchodPro: 'Click “New deal” to create one.',
      nacitam: 'Loading…',
      nelzeNacistObchodyKlienta: 'Cannot load the client’s deals',
      obchodySeNepodariloNacist: 'The deals could not be loaded',
      otevritDetail: 'Open detail',
      prohraZruseno: 'Lost/Cancelled',
      rozjednane: 'In progress',
      rozjednaneObchody: 'Deals in progress',
      vProcesu: 'in progress',
      vyhrane: 'Won',
      vyhraneSmlouvy: 'Won → contracts',
      zadneObchodyVTeto: 'No deals in this category',
      zkusToZnovuNejde: 'Try again — this is not an empty list, it is a connection error.',
    },
    clientMapPage: {
      kratkyServis: 'Quick service',
      seznamKlientu: 'Client list ({n})',
      vTrase: '{n} in route',
      zavritSeznam: 'Close list',
      shlukKlientuOne: '{n} client',
      shlukKlientuFew: '{n} clients',
      shlukKlientuMany: '{n} clients',
      shlukAOkoli: '{mesto} and surroundings',
      shlukStejneMisto: 'At the same place',
      shlukPriblizit: 'Zoom to all',
      shlukZavrit: 'Close cluster list',
      shlukTip: '{pocet} — click for the list',
      shlukZpet: 'Back to list ({n})',
      shlukSeznam: 'Clients in cluster',
      typKlient: 'Client',
      typNabor: 'Recruit',
      typLead: 'Lead',
      typOstatni: 'Other',
    },
    composeEmailModal: {
      dobryDen: 'Hello,…',
      eMailOdeslan: 'Email sent',
      komuNapisJakykolivE: 'To * — type any email (you do not have to pick a client)',
      neboVyberKlientaVolitelne: '…or pick a client (optional — fills in the email and saves it to their history)',
      nelzeOdeslat: 'Cannot send',
      novyEMail: 'New email',
      obchodniPripadVolitelneVazba: 'Deal (optional — a link for looking it up later)',
      odeslat: 'Send',
      predmet: 'Subject *',
      predmetEMailu: 'Email subject',
      teloZpravy: 'Message body *',
      zadejPredmet: 'Enter a subject',
      zadejPrijemce: 'Enter a recipient',
      zadejTextEMailu: 'Enter the email text',
      zavrit: 'Close',
      zrusit: 'Cancel',
    },
    dashboardPage: {
      akademieProNovackyKlikaci: 'Academy for newcomers · click-through guide',
      coJePoradenstviEtika: 'What advisory is, ethics, the process, products, cold calling, argumentation, closing + quizzes.',
      vitejteVBeplan: 'Welcome to beplan ',
      zNovackaProfikKrok: 'From newcomer to pro — step by step',
    },
    dealAutocomplete: {
      najdiObchodniPripadKlienta: 'Find the client’s deal…',
      nejprveVyberKlienta: 'Pick a client first…',
      obchodniPripad: 'Deal',
      vymazat: 'Clear',
      zadnyOtevrenyObchodniPripad: 'The client has no open deal.',
    },
    dealResultModal: {
      datumUzavreni: 'Closing date',
      duvodVolitelneZapiseSe: 'Reason (optional — it is written into the history)',
      konecnaCenaBj: 'Final price (BJ)',
      naprKlientZustalU: 'E.g. the client stayed with their current bank…',
      zpet: 'Back',
    },
    diarPageV3: {
      adresatJmenoAdresa: 'Recipient (name + address)',
      aktivitaUlozena: 'Activity saved',
      aktivitaVytvorena: 'Activity created',
      aktualizovano: 'updated',
      bezKlienta: 'No client?',
      cehoSeToTyka: 'What it relates to',
      celodenni: 'All day',
      celyDen: ' · all day',
      dalsiMesic: 'Next month',
      dalsiUcastniciVolitelneOddelene: 'Other participants (optional, comma-separated)',
      dalsich: 'more',
      datum: 'Date *',
      delkaUpravena: 'Duration updated',
      diarVeTvemKalendari: 'Your diary in your calendar',
      dnesVelke: 'Today',
      doba: 'Duration',
      doplnitKlienta: 'Add a client',
      editaceAktivity: 'Edit activity',
      editovat: 'Edit',
      importZGoogleCalendar: 'Import from Google Calendar into the Diary',
      importovano: 'Imported',
      jindeOnline: 'Elsewhere / online',
      kalendar: 'Calendar',
      kalendarSeAktualizujeKazdou: 'The calendar refreshes roughly every hour.',
      kdeSeSchuzkaKona: 'Where the meeting takes place',
      klient: 'Client',
      klientNemaVyplnenouAdresu: 'The client has no address — type it in and pick from the suggestions.',
      kopirovat: 'Copy',
      mistoAdresa: 'Place / address',
      mistoVolitelne: 'Place (optional)',
      nacitam: 'Loading…',
      nacitamOdkaz: 'Loading the link…',
      nacitamStav: 'Loading the status…',
      nacteSchuzkyAUdalosti: 'Loads meetings and events from your Google calendar (-7 days to +6 months) and shows them in the Diary as activities. Meetings created in beplan are not duplicated.',
      napisAdresuMestoMisto: 'type an address / city / place…',
      nastaveni: 'Settings',
      nastaveniKalendare: 'Calendar settings',
      neboJenExportApple: 'Or export only (Apple / Outlook)',
      nelzeNacistUkoly: 'Cannot load the tasks',
      nelzePresunoutUkol: 'Cannot move the task',
      nelzeUlozit: 'Cannot save',
      nelzeVratit: 'Cannot undo',
      nenaplanovano: 'Not scheduled',
      nepodariloSeNacistOdkaz: 'The link could not be loaded',
      nepodariloSeVytvoritKlienta: 'The client could not be created',
      nepovedloSe: 'It did not work',
      nizka: 'Low',
      nova: 'New',
      novaAktivita: 'New activity',
      novouPridasTlacitkemAktivita: 'Add a new one with the “Activity” button.',
      novyBezpecnostniKodVytvoren: 'A new security code has been created',
      obchodniPripadVolitelne: 'Deal (optional)',
      obnovit: 'Refresh',
      odchozi: 'Outgoing',
      odkazNaTvujKalendar: 'Link to your calendar',
      polozkaUzNeniDostupna: 'This item is no longer available',
      pracovniDobaDo: 'Working hours to',
      pracovniDobaOd: 'Working hours from',
      predchoziMesic: 'Previous month',
      preskoceno: 'skipped',
      presunuto: 'Moved',
      presunutoDoCasu: 'Moved to',
      prichozi: 'Incoming',
      pridatDoAppleOutlook: 'Add to Apple / Outlook',
      pridatDoGoogle: 'Add to Google',
      priorita: 'Priority',
      resitel: 'Assignee',
      schovatRealizovane: 'Hide completed',
      smerHovoru: 'Call direction',
      soukromaAktivita: '(private activity)',
      soukromaAktivita2: 'Private activity',
      stavPropojeniSeNepodarilo: 'The connection status could not be determined.',
      stredni: 'Medium',
      synchronizace: 'Sync',
      synchronizaceSelhala: 'Sync failed',
      synchronizovatDoGoogleApple: 'Sync to Google / Apple / Outlook',
      synchronizovatTed: 'Sync now',
      synchronizuji: 'Syncing…',
      tahniProCas: '⇅ drag to set the time',
      telefonniCislo: 'Phone number',
      tentoDen: 'This day',
      typAktivity: 'Activity type',
      uKlienta: 'At the client’s',
      uKlientaProste: 'At the client’s',
      uNas: 'At our office',
      uNasVKancelari: 'At our office',
      ucet: 'Account',
      ukladam: 'Saving…',
      ukolNaplanovan: 'Task scheduled',
      uloziSeDoDiare: 'It will be saved to the diary',
      ulozitJakoSoukromou: 'Save as private',
      ulozitZmeny: 'Save changes',
      vice: 'More',
      volnoAiZavolejA: 'Free slot · call the A-leads',
      vraceno: 'Reverted',
      vratit: 'Undo',
      vseNaplanovano: 'Everything is scheduled.',
      vychoziDelkaAktivity: 'Default activity duration',
      vychoziTypNoveAktivity: 'Default type of a new activity',
      vychoziZobrazeni: 'Default view',
      vysledekHovoruPoDokonceni: 'Call result (once it is finished)',
      vysoka: 'High',
      vytvorit: 'Create',
      zacatek: 'Start *',
      zadejDatumACas: 'Enter a date and time',
      zadejNazevPredmet: 'Enter a name / subject',
      zadneNadchazejiciAktivity: 'No upcoming activities',
      zavritFiltry: 'Close the filters',
      zitra: 'Tomorrow',
      zkopirovano: 'Copied',
      zkopirujOdkazRucne: 'Copy the link manually',
      zkusitZnovu: 'Try again',
      zmenitBezpecnostniKod: 'Change the security code',
      zmenitBezpecnostniKodStary: 'Change the security code? The old link will stop working and the calendars will have to be added again.',
      zmeskany: 'Missed',
      zobrazeni: 'View',
      zobrazitZrusene: 'Show cancelled',
      zrusit: 'Cancel',
    },
    dotaznikCteni: {
      definiceDotaznikuSeNenacetla: 'The questionnaire definition did not load.',
      hodnotuSeNepodariloNacist: 'The value could not be loaded.',
      rodneCisloACislaDokladu: 'The national ID number and document numbers are hidden. Revealing one is a deliberate step and after 20 seconds the value hides again.',
      skryt: 'Hide',
      zobraziSeNa20Sekund: 'Shown for 20 seconds',
      zobrazit: 'Show',
    },
    editableGoals: {
      akontace: 'Down payment %',
      akontace2: 'Down payment',
      akontaceSplnenaNa: 'Down payment covered to',
      budouciNavyseniVkladu: 'Future contribution increases',
      castJeVProduktech: 'part of it is tied up in products',
      cil: 'Goal',
      cilSplnen: 'goal met',
      dleProfiluVolnaHotovost: '(per profile). Available cash',
      dobaSplaceniLet: 'Repayment period (years)',
      financniNezavislostRenta: 'Financial independence — passive income',
      horizont: 'horizon',
      horizontLet: 'Horizon (years)',
      hypotecniCil: 'Mortgage goal',
      jakNasetritAkontaci: 'How to save up the down payment',
      jednorazove: 'One-off',
      jednorazoveDnes: 'One-off today',
      kombinace: 'Combination',
      ktereSeMusiZrusit: 'which would have to be cancelled (often costly). Better to invest',
      let: 'yrs',
      letDosahnes: 'years you will reach',
      letDriv: 'years earlier!',
      letDvojtecka: 'years:',
      letPrida: 'years adds',
      mesicne: 'Monthly',
      navrhniPravidelne: 'Suggest a regular amount',
      navrhniZMajetku: 'Suggest from assets',
      nutnoRusitZvazPravidelne: 'they would have to be cancelled. Consider a regular amount.',
      o: 'a full',
      pocitanoSVynosem: 'Calculated with a return of',
      potrebnyKapital: 'Capital needed',
      pravidelne: 'Regularly',
      pravidelne2: 'regularly',
      pridatNavyseniNapr: 'Add an increase (e.g. after a pay rise)',
      realne: '% real',
      renta: 'passive income',
      splatka: 'payment',
      splneni: 'Completion',
      splneni2: 'completion',
      tolikVolneHotovostiKlient: 'The client does not have that much cash available',
      uver: 'loan',
      volneMaKlientJen: 'The client only has',
      za: 'in',
      zaLet: 'In (years)',
      zaVelke: 'In',
      zadneCileZAnalyzy: 'No goals from the analysis. Add goals in the analysis and come back to fine-tune how they will be met.',
      zamcenoVProduktech: 'locked in products',
      zbytekJeVeStavebku: '— the rest is in building savings/pension',
    },
    finMatematikaPage: {
      cerpaniNekonecna: '♾️ perpetual',
      chartRok: 'Year',
      dobaCerpani: 'Drawdown period',
      dobaCerpaniRenty: 'Annuity drawdown period',
      dobaSplaceni: 'Repayment period',
      dopocitatPole: 'Solve for this field',
      financniMatematika: 'Financial mathematics',
      frekvenceUroku: 'Interest compounding frequency',
      hodnotaInvestice: 'Investment value',
      jednorazovyVklad: 'Lump-sum deposit',
      jednotkaLet: 'years',
      kartaCelkemVlozite: 'Total you deposit',
      vstupniPoplatek: 'Entry fee on the target amount',
      kartaPoplatek: 'Fee',
      kartaCilovaCastka: 'Target amount',
      vetaPoplatek: 'The entry fee on the target amount {cilova} is {poplatek} ({pct} %), deducted right at the start.',
      dipPrepinac: 'DIP tax deduction',
      dipBez: 'Without DIP',
      dipS: 'With DIP',
      kartaStatDip: 'State refund (DIP)',
      kartaSDip: 'Total with DIP',
      vetaDip: 'With DIP the state refunds {stat} of tax over {roky} years (15 % of contributions, max CZK 7,200 a year). Reinvested it grows to {hodnota}, of which {vynos} is return. Condition: withdrawal at 60 at the earliest and after 10 years of the contract, otherwise the deduction is taxed back.',
      rozpisPoLetech: 'Year-by-year breakdown',
      thSplaceno: 'Paid',
      thUrok: 'Interest',
      thJistina: 'Principal',
      thZustatek: 'Balance',
      thVlozeno: 'Paid in total',
      thVynos: 'Return total',
      thHodnota: 'Value',
      thVyplaceno: 'Paid out total',
      thCelkem: 'Total',
      tiskZadani: 'Inputs',
      tiskVysledek: 'Result',
      tiskPripraveno: 'Prepared {datum}',
      upozorneniUver: 'Model annuity payment at a fixed rate for the whole term. The actual payment, APR and fees depend on the bank’s offer.',
      upozorneniInvestice: 'Model with a fixed annual return, not a guarantee. Real returns fluctuate and can be negative; past or model returns do not guarantee future ones.',
      upozorneniRenta: 'Model drawdown with a fixed return, not a guarantee. Real returns fluctuate; the income may last a shorter time.',
      kartaCelkemZaplatite: 'Total you pay',
      kartaDoba: 'Term',
      kartaDobaCerpani: 'Drawdown period',
      kartaJednorazovyVklad: 'Lump sum',
      kartaKonecnaHodnota: 'Final value',
      kartaMesicniRenta: 'Monthly income',
      kartaMesicniSplatka: 'Monthly payment',
      kartaPocatecniHodnota: 'Initial value',
      kartaPravidelnaMes: 'Regular monthly',
      kartaRentaCelkem: 'Income in total',
      kartaSplatnost: 'Maturity',
      kartaUrokPa: 'Interest p.a.',
      kartaVyseUveru: 'Loan amount',
      kartaZTohoUroky: 'Of that, interest',
      kartaZhodnoceniPa: 'Return p.a.',
      konecnaHodnotaInvestice: 'Final investment value',
      mesZkratka: 'mo',
      mesicniSplatka: 'Monthly instalment',
      pocatecniHodnota: 'Initial value',
      pravidelnaMesInvestice: 'Regular monthly investment',
      splatnost: 'Maturity',
      urokovaSazba: 'Interest rate',
      vetaInvestice: 'From {vlozeno} deposited you make {konec} — that is {navic} extra thanks to compounding. Time does the work for you.',
      vetaRenta: '{kapital} pays you {renta}/{mes} for {roky} {rok} (in total {celkem}).',
      vetaRentaNekonecna: '{kapital} at {sazba} % yields more than you draw — the income is PERPETUAL. That is financial independence. 🎉',
      vetaUver: 'A loan of {castka} over {roky} {rok} at {sazba} % — you pay {celkem} in total, of which {uroky} is interest.',
      vlozenoCelkem: 'Total invested',
      vyseMesicniRenty: 'Monthly annuity amount',
      vyseUveru: 'Loan amount',
      vyvojHodnotyInvestice: 'Investment value over time',
      vyvojRentyCerpaniKapitalu: 'Annuity over time (capital drawdown)',
      vyvojZustatkuUveru: 'Loan balance over time',
      zhodnoceniPA: 'Return p.a.',
      zhodnoceniRentyPA: 'Annuity return p.a.',
      zustatek: 'Balance',
      zustatekUveru: 'Loan balance',
    },
    funnelCalc: {
      casPrida: 'Time adds ',
      cil: 'target',
      coJsiVlozil: 'What you put in',
      investiceNeseRizikoHodnota: 'Investing carries risk — the value fluctuates and can fall; past returns do not guarantee future ones.',
      jakByToRostlo: 'How it would grow over time',
      mesicnePotrebujesOdkladat: 'You need to set aside monthly',
      orientacniVypocetZeSlozeneho: 'Illustrative calculation based on compound interest.',
      potrebnyKapitalNaRentu: 'Capital needed for the annuity: ',
      spocitejSiToNazivo: 'Run the numbers — live',
    },
    globalSearch: {
      beplanGlobalniHledani: 'Beplan · global search',
      chytreHledani: 'Smart search',
      hledat: 'Search…',
      hledatCmdCtrlK: 'Search (Cmd/Ctrl + K)',
      hledatKlientaUkolHashtag: 'Search a client, a task, a #hashtag, a phone number…',
      navigaceOtevritEscZavrit: '↑↓ navigate · ↵ open · ESC close',
      otevrit: 'Open',
      ukoly: 'Tasks',
      zadneVysledkyPro: 'No results for',
      zavrit: 'Close',
    },
    globalTabBar: {
      hledat: 'Search',
      nastaveni: 'Settings',
      odhlasit: 'Sign out',
      zavritVse: 'Close all',
      zavritVsechnyZalozky: 'Close all tabs',
    },
    gmailConnectCard: {
      gmailOdpojen: 'Gmail disconnected',
      gmailPropojen: 'Gmail connected',
      nacitamStavGmailPropojeni: 'Loading the Gmail connection status…',
      odpojeniSelhalo: 'Disconnect failed',
      odpojit: 'Disconnect',
      opravduOdpojitGmailNebudes: 'Really disconnect Gmail? You will no longer be able to send emails straight from the CRM.',
      pripojSvujGmail: 'Connect your Gmail',
      pripojitGmail: 'Connect Gmail',
      propojeniGmailuZatimNeni: 'The Gmail connection is not enabled yet',
      serverNeodpovedelNevimeJestli: 'The server did not respond. We do not know whether Gmail is connected — try reloading the page.',
      stavEMailuSe: 'The email status could not be determined',
    },
    gmailMessageDetail: {
      komu: 'To',
      kopie: 'Cc',
      nepodariloSeNacistEmail: 'The email could not be loaded',
      odpovedetAi: 'Reply with AI',
      otevritVGmailu: 'Open in Gmail',
      textZpravyTadyNezobrazime: 'We do not show the message text here',
    },
    hypotecniPipelinePage: {
      excelLikePrehledVsech: 'Excel-like overview of all open mortgages and refinancing · click a row to open the deal',
      hypotekaZalozena: 'Mortgage created',
      kanbanPohledPouzivaObchodni: 'The Kanban view belongs to the Deal board — for mortgages we recommend the Table view. ',
      klikNaRadekDetail: 'Click a row → deal detail',
      nelzeNacistHypoteky: 'Cannot load the mortgages',
      otevritObchodniNastenku: 'Open the Deal board ›',
      pripraveno: 'ready',
      tabulka: 'Table',
      tentoTyden: 'This week',
      urgentni: 'urgent',
      uverovaPipeline: 'Lending pipeline',
      vLimitu: 'within limit',
      vReseni: 'in progress',
      vse: 'All',
      vyzadujeAkci: 'Needs action',
      zadneHypotekyNeodpovidajiFiltru: 'No mortgages match the filter.',
    },
    investicniStrategiePage: {
      celkemVlozi: 'Total deposited',
      cenaNecinnosti: 'The cost of doing nothing',
      citat: '“How much is enough? Enough that the return covers your expenses. Then you are financially independent — the money works for you.”',
      coSiKlientOdnese: 'What the client takes away',
      doba: 'Period',
      hodnotaLegenda: 'Value',
      inflaceNiciHotovost: 'Inflation destroys cash',
      inflaceText: 'Money in cash quietly loses value. In {roky} {rok} at 3 % inflation, only about {realne} of purchasing power is left from {vlozeno}. Doing nothing is a decision too — just the most expensive one.',
      investicniStrategie: 'Investment strategies',
      kapital: 'Capital',
      kapitalZustava: '…and the capital of {kapital} stays untouched for the children.',
      kino: 'Cinema',
      kinoTooltip: 'Start the cinema presentation',
      klientTip: 'It matters less “how much” — what matters is starting and letting time do the work.',
      mes: 'mo',
      mesSlash: '/mo',
      mesicniVklad: 'Monthly deposit',
      naKonciMa: 'Ends up with',
      nekonecnaMesicniRenta: 'Perpetual monthly income ({sazba} p.a.)',
      nekonecnaRentaSazba: 'Perpetual income ({sazba} p.a.)',
      nevymyslimeNicNovehoKopirujeme: 'We invent nothing new — we copy the best',
      odklada: 'Sets aside',
      odkladaHodnota: '{castka}/{mes} × {roky} {rok}',
      podnadpisA: 'Show the client that their plan rests on strategies that have worked for the largest funds in the world for years. Click a strategy → you calculate it over 100 years of real data. Or start the ',
      podnadpisB: ' with an interactive world map.',
      podnadpisTucne: 'cinema presentation',
      prezentovatKlientovi: 'Present to the client',
      procInvestovat: 'Why invest',
      procNedojde: 'Why the income never runs out',
      rentaMilion: 'every million = about {naMilion} {symbol} a month, forever',
      rentaNavzdy: 'Income forever',
      rentaText: 'From {kapital} at {sazba} a year you get an income of {renta}/{mes} — forever, and the capital stays. That is financial independence.',
      rentaVetaA: 'When you draw only the ',
      rentaVetaB: ' (not the principal), the capital is never exhausted. At {sazba} a year ',
      rentaVetaC: ' — and the million is still yours.',
      rentaVynos: 'return',
      silaSlozeneho: 'The power of compound interest',
      spocitat: 'Calculate over 100 years',
      svoboda: 'Freedom',
      urokText: 'In {roky} {rok} your money earns {rust} on its own. The sooner you start, the longer compounding works for you.',
      urokZUroku: 'Interest on interest',
      vlozenoLegenda: 'Deposited',
      vynosPa: 'Return p.a.',
      zTohoVydelaly: 'Of that, earned by the money itself',
      zadejteVklad: 'Enter a deposit — show the client their growth',
    },
    klientiPage: {
      aresNapoviADoplni: 'ARES will suggest and fill it in',
      chybaPriUkladani: 'Error while saving: ',
      coMaUMe: 'What they hold with me',
      coVlastni: 'What they own',
      dnes: 'today',
      jmeno: 'First name',
      jmenoJePovinne: 'First name is required',
      jmenoNazev: 'Name / company name',
      karty: 'Cards',
      kategorie: 'Category',
      kategorieKlienta: 'Client category',
      klientPridan: 'Client added',
      klientTrvaleSmazan: 'Client permanently deleted',
      klientVracenDoPipeline: 'Client returned to the pipeline',
      kos: 'Trash',
      kosJePrazdny: 'The trash is empty',
      kosOdstraneniKlientiKdykoli: 'Trash — removed clients; you can restore them any time',
      kosSeNepodariloNacist: 'The trash could not be loaded',
      moznaDuplicita: 'Possible duplicate',
      moznaDuplicitaPotvrdZe: 'Possible duplicate — confirm that you want to add it anyway',
      naborKandidat: 'Recruitment — candidate',
      nacitamKos: 'Loading the trash…',
      nactenoZAres: 'Loaded from ARES',
      napisteJmenoNeboNazev: 'Type the client’s name or company name…',
      nepovedloSeUlozit: 'Could not save',
      neznamaChyba: 'unknown error',
      obnoveniSeNezdarilo: 'The restore failed',
      obnovit: 'Restore',
      odlozenDoSkupinyBez: 'moved to the not-interested group',
      odlozitZatimBezZajmu: 'Set aside — not interested for now',
      odstraneniKlientiSeObjevi: 'Removed clients show up here — you can restore them back into the pipeline any time.',
      otevrit: '→ open',
      poznamkaPriZakladani: 'Note added on creation',
      pridejKlientaVCrm: 'Add a client in the CRM Pipeline.',
      prijmeni: 'Last name',
      resetovatFiltry: 'Reset the filters',
      smazaniSeNezdarilo: 'The delete failed: ',
      smazatNavzdy: 'Delete forever',
      tabulka: 'Table',
      telefon: 'Phone',
      titoKlientiSeVelmi: 'These clients look very similar — open one of them, or confirm that you really want to create a new record.',
      trvaToDlouhoKlikni: 'Taking too long? Click to refresh',
      trvaleSmazatNevratne: 'Delete permanently — this cannot be undone',
      typologie: 'Typology',
      ukladam: 'Saving…',
      ulozit: 'Save',
      ulozitAOtevrit: 'Save and open',
      vKosiKlientiNejsou: 'in the trash · the clients are not deleted — you can restore them any time',
      vKosiOd: 'in the bin since',
      vimZeToNeni: 'I know this is not a duplicate — create a new record',
      volat: 'Call',
      vratitDoPipeline: 'Return to the pipeline',
      vratitKlientaZpetDo: 'Return the client back into the pipeline',
      vse: 'All',
      vymazat: 'Clear',
      vymazatVsechnyPokrocileFiltry: '× Clear all advanced filters',
      zadniKlienti: 'No clients.',
      zadnyKlientNeodpovidaHledani: 'No client matches the search.',
      zadnyKlientNeodpovidaKombinaci: 'No client matches this combination of filters. Try narrowing the selection or resetting the filters.',
      zdroj: 'Source',
      zpetNaKlienty: 'Back to clients',
    },
    leadgenCalculatorPremium: {
      orientacniVypocetPresnouNabidku: '* Illustrative calculation. I will prepare an exact offer after a short consultation.',
    },
    newDealModal: {
      klientaSeNepodariloZalozit: 'The client could not be created',
      krokAnalyza: 'Analysis',
      krokCerpani: 'Drawdown',
      krokPodpis: 'Signature',
      krokProces: 'Process',
      napisNejdrivJmenoNoveho: 'First type the new client’s name into the search',
      pravdepodobnostUzavreni: 'Probability of closing',
      ulozitAOtevrit: 'Save and open',
      zadejNazevObchodnihoPripadu: 'Enter the deal name',
    },
    notFoundPage: {
      strankaNenalezena: 'Page not found',
      tatoAdresaNeexistujeNebo: 'This address does not exist or has moved.',
      zpetNaHlavniStranku: 'Back to the home page',
    },
    notesPanel: {
      klikneteAPistePrazdny: 'Click and write — a blank page that saves itself.',
      neulozenoUlozisteProhlizeceJe: 'Not saved — browser storage is full',
      sTimtoStitkemNic: 'Nothing with this tag.',
      ulozeno: 'Saved',
      vse: 'All',
      zatimZadnaPoznamka: 'No notes yet',
    },
    notificationCenter: {
      celyDen: 'all day',
      pripominkySeNepodariloNacist: 'The reminders could not be loaded.',
      tohleNeniStavMas: 'This is NOT an “all clear” — the data failed to load.',
    },
    obchodyPage: {
      akce: 'Action',
      akciSeNepodariloDokoncit: 'The action could not be completed',
      archivSoftDelete: 'Archive · Soft-delete',
      cekaNaVyplatu: 'awaiting payout',
      cekamNaProvizi: 'Waiting for the commission',
      duvod: 'Reason',
      faze: 'Stage',
      kategorieKlienta: 'Client category',
      klient: 'Client',
      klientObchod: 'Client · Deal',
      n1SchuzkaPredstaveni: '1st meeting — introduction',
      nacitamOdlozeneObchody: 'Loading the deferred deals…',
      nelzeNacistArchiv: 'Cannot load the archive',
      nelzePresunoutObchod: 'Cannot move the deal',
      nelzeReaktivovat: 'Cannot reactivate',
      nelzeSmazat: 'Cannot delete',
      obchod: 'Deal',
      obchodVytvoren: 'Deal created',
      odlozene: 'Deferred',
      odlozeneObchodySoftDelete: 'Deferred deals — a soft-delete archive the deals can be reactivated from',
      odlozeno: 'Deferred',
      odlozenychObchoduMuzesKdykoliv: 'deferred deals — you can reactivate them at any time',
      otevritSlozku: 'Open the folder',
      otevritSlozkuKlienta: 'Open the client folder',
      planUzavreni: 'Plan — closing',
      prejitNaSloupec: 'Go to the column',
      presunutoDo: 'Moved to',
      pretahnoutObchodSem: 'Drag a deal here',
      pridatAktivitu: 'Add an activity',
      produkt: 'Product',
      prohra: 'Lost',
      prohraUzavrenoK: 'Lost — closed on',
      reaktivovat: 'Reactivate',
      spustitPrezentaciFinancnihoPlanu: 'Start the financial plan presentation — it leads the client to signing',
      spustitPrezentaciPro1: 'Start the presentation for the 1st meeting — it leads the client to the financial analysis',
      trvaleSmazatZDatabaze: 'Delete permanently from the database (irreversible)',
      typ: 'Type',
      vazena: 'Weighted:',
      vratitObchodDoAktivni: 'Return the deal to the active pipeline',
      vyhraSmlouva: 'Won → Contract',
      vyhraUzavrenoK: 'Won — closed on',
      zadneObchody: 'No deals',
      zadneOdlozeneObchody: 'No deferred deals',
      zruseno: 'Cancelled',
      zrusenoK: 'Cancelled on',
    },
    onePagePlanPage: {
      dnesSPlanemAz: 'today · with the plan up to',
      dobryDenPosilamVas: 'Hello, here is your financial plan. Have a look and get in touch if anything comes up.',
      financniNezavislost: 'Financial independence',
      financniPlan: 'Financial plan',
      financniPlanNaJedne: 'Financial plan on one page',
      financniZdravi: 'Financial health',
      financniZdraviDnesS: 'Financial health (today → with the plan)',
      hypotekouSplatka: 'with a mortgage · repayment',
      jednorazove: 'one-off',
      kapital: 'capital',
      kapitalProRentu: 'Capital for passive income',
      klesajiciCastkyKryjeDeficit: 'decreasing sums · covers the family shortfall, debts and goals',
      mesicneNaCileA: 'Monthly towards goals and passive income',
      mesicneProCile: 'Monthly for goals (agreed)',
      naAnalyzu: 'To the analysis',
      naplneniFinancniNezavislosti: 'Financial independence funded',
      naplneno: 'funded',
      narativCislaVDnesnichCenach: "The figures are in today's prices. Real returns above inflation: equities {akcie} %, bonds {dluhopisy} %, cash {cash} %; the average accumulation return works out at ≈ {prumer} % a year. Passive income is drawn at {renta} % of the capital a year. Past returns do not guarantee future ones.",
      narativPlanNaJednuStranu: 'A financial plan on a single page — your why, three steps for the next 90 days, and how you will fund your goals and your passive income.',
      navrhReseni: 'Proposed solution',
      nepodariloSeNacistData: 'The data could not be loaded',
      oLetDrive: ' · {n} yrs earlier',
      ochranaPrijmuVarianta: 'Income protection ({varianta})',
      planJeVDnesnich: "The plan is stated in today's prices. Real returns above inflation: equities {akcie} %, bonds {dluhopisy} %, cash {cash} %; the average accumulation return works out at ≈ {prumer} % a year. Passive income is drawn at {renta} % of the capital a year. Recommendations depend on the data provided; we update them roughly every 3 years or whenever your situation changes. Past returns do not guarantee future ones.",
      prijmyRodiny: 'Family income',
      pripravujiPlan: 'Preparing the plan…',
      procToVsechnoDelame: 'Why we are doing all this — in your words',
      rentaFinancniNezavislost: 'Passive income (financial independence)',
      vDnesnichCenachRealne: "in today's prices (real, above inflation)",
      vasPoradce: 'Your advisor',
      vaseBilance: 'Your balance sheet',
      vaseCileAJak: 'Your goals and how we will fund them',
      volnyCashFlow: 'Free cash flow',
      vydajeSplatky: 'Expenses + repayments',
      zkontrolujtePripojeni: 'Check your connection and try again.',
      zkusitZnovu: 'Try again',
    },
    pipelineFunnelCompact: {
      bjVPipeline: 'BJ in the pipeline',
      pipelinePoFazich: 'Pipeline by stage',
      vymazatFiltr: 'Clear the filter',
    },
    planPrehled: {
      azPoCilovemDatu: ' — only after the target date',
      rentaOdVekuPenzijka: ' — into the income from age {vek}: income +{castka}',
      bezCerpaniZdroju: 'no sources drawn',
      cerpani: 'Drawdown',
      doraziV: 'arrives at ',
      finMajetek: 'Fin. assets',
      investice: 'Investments',
      jednorazove: 'one-off',
      let: 'yrs',
      letech: ' years old',
      likvidni: 'Liquid',
      likvidni2: 'liquid',
      mesice: 'month',
      nefinancni: 'Non-financial',
      nezapojeno: 'Unallocated',
      od: 'from',
      ostatniUcty: 'Other accounts',
      penzijkoRenta: 'Pension → passive income',
      poPlanu: 'After the plan:',
      pravidelne: 'regularly',
      prebytek: 'Surplus',
      precerpanoO: 'overdrawn by',
      precerpanoTolikKlient: '— overdrawn, the client does not have that much',
      prubeznyPrehled: 'Running overview',
      stavebko: 'Building savings',
      stavebko2: 'building savings',
      volnyPrebytek: 'free surplus',
      za: 'in',
      zbyva: 'left',
      zbyvaLikvidni: 'liquid left',
    },
    planPrezentacePage: {
      abysteDosahliSvychCilu: '„…so that you reach your goals **by the safest possible route**.“',
      abysteNemuselRusit: '„So that you never have to cash out strategic investments at a loss because of an unexpected expense. It goes to a savings account (~3 %) — this is **not about getting rich, it is about peace of mind**. Six salaries in reserve means nothing touches your plan.“',
      akcie: 'shares',
      akciePodilyVNejvetsich: '„Shares are stakes in the largest companies in the world. They swing in the short run, but they are **the only thing that reliably beats inflation over time** — while money in the account loses purchasing power for certain.“',
      aleJePotrebaPro: '„…but it takes doing something about it.“',
      anoCimZacneme: 'Yes — where do we start?',
      barva: 'colour',
      bezJednorazovehoVkladu: 'without a one-off contribution',
      bezPlanuUcetInflace: 'Without a plan (current account + inflation)',
      chtelJsteVeta: 'You wanted **{castka}** within **{roky}**.',
      chtelJsteVetaBezTerminu: 'You wanted **{castka}**. We have not set a date yet.',
      chtelJsteVetaHned: 'You wanted **{castka}** — and **right now**.',
      chybi: 'missing',
      chybiCastka: '{castka} missing',
      cilPokryt: '✓ goal covered',
      ciluFinancnePodlozeno: 'goals financially backed',
      coDnesPlanOhrozuje: 'What threatens the plan today',
      coToCelkemStoji: 'What it costs in total',
      coZaToMate: 'What you get for it',
      dalsiZpetNamitkyEsc: '→ next · ← back · ? objections · Esc to end',
      davaVamToSmysl: 'Does this **make sense** to you?',
      deficitBezOchrany: 'Shortfall without protection',
      den: '/day',
      dluhopisy: 'bonds',
      dnesSiVymenimeRole: 'Today we swap roles.',
      doRokaBudeteMit: 'Within a year you will have',
      dobraZpravaMatePlan: 'Good news: **you have a plan.**',
      dobreALevneZajistit: 'Protect assets and future income well and cheaply',
      domluvenoCoKdoPripravi: 'Agreed — who prepares what',
      doplnitLikvidniRezervu: 'Top up the liquidity reserve',
      dotazySiProsimNechte: '„Please keep your questions for the end — first I want you to see the whole picture, the entire strategy.“',
      druhaBezpecnejsiCesta: 'And the second is even better: **we will take the safer route.**',
      druhaNezavislostDrive: 'And the second is even better: **independence {roky} sooner.**',
      dveBudoucnostiVyberteSi: 'Two futures — take your pick',
      financniMajetekCelkem: 'Total financial assets',
      glideRokTooltip: 'year {rok}: shares {akcie} % · bonds {dluhopisy} % · cash {hotovost} %',
      hotovost: 'cash',
      iVNejhorsimObdobi: 'Even in the **worst** of {pocet} historical periods the plan ended at **{vysledek}** — still {kde} the {vlozeno} invested. __Time decides, not market timing.__',
      invalidita: 'disability',
      investice: 'investments',
      jaPoradce: 'Me (the adviser)',
      jedenZOsmiInvalidita: 'Long-term disability — we insure **the paycheque, not death**',
      jednorazoveOdkud: 'One-off — from where',
      jenVicNavic: 'Just **{vklad}** more → after {roky} you are **{kdobru}** better off. That is time working, not you.',
      kazdyCilSiVezme: 'Each goal takes its share — and **you see what is left**.',
      kazdyMilionRentaMesicne: '„every million pays {naMilion} a month, forever“',
      kdeJsteDnesStartovni: 'Where you stand today — the starting line',
      kdybysteInvestovalPred20: '„If you had invested 20 years ago…“ — 100 years of history',
      kdybysteTenhlePlanJel: 'If you had run this plan for **{roky}** at any point in the last 100 years…',
      kdybysteTohleInvestoval: 'If you had invested this for the past **{roky}**, based on **real data** you would have today:',
      krok_bezVsSPlanem: 'WITHOUT vs. WITH A PLAN',
      krok_cile: 'GOALS',
      krok_coDelateDobre: 'WHAT YOU DO WELL',
      krok_dveZpravy: 'TWO PIECES OF NEWS',
      krok_kdeJsteDnes: 'WHERE YOU STAND TODAY',
      krok_kroky: 'STEPS',
      krok_motivace: 'MOTIVATION',
      krok_proc: 'WHY',
      krok_rezerva: 'RESERVE',
      krok_rizika: 'RISKS',
      krok_rozpocet: 'BUDGET',
      krok_silaCasu: 'THE POWER OF TIME',
      krok_souhrn: 'SUMMARY',
      krok_uvod: 'INTRODUCTION',
      krok_vaseCesta: 'YOUR PATH',
      krok_zaver: 'CLOSING',
      krytiInvalidita: 'Disability',
      krytiInvaliditaProc: 'a long-term loss of income the reserve cannot cover — while expenses go up',
      krytiOdskodne: 'Daily accident benefit',
      krytiOdskodneProc: 'an accident stops the income from day one — no waiting period',
      krytiPn: 'Sick leave',
      krytiPnProc: 'sick pay covers only part of the income; the benefit tops the budget up from month {mesic}',
      krytiSmrt: 'Death',
      krytiSmrtProc: 'replaces the income for the family — expenses, instalments and goals; a decreasing sum costs less',
      krytiTrvaleHodnota: '{castka} with progression',
      krytiTrvaleNasledky: 'Permanent consequences of an accident',
      krytiTrvaleProc: 'more serious consequences mean a higher payout (in our model at most 2.8× the sum insured — insurers differ)',
      mamProVasDve: 'I have two pieces of news for you',
      mate: 'You have:',
      mateZCehoStavet: 'you have something to build on — that is a huge advantage',
      mesicneNaStejnouRentu: 'a month for the same passive income',
      mezernik: 'SPACEBAR',
      minuleJsemSePtal: '„Last time I was the one asking and you were talking — today I will do the talking.“',
      motivAplikace: 'App theme',
      motorPlanu: 'That is the engine of the plan — **{rok}/year** to work with. Nothing on top of it.',
      moznaJeTechCisel: 'That may be a lot of numbers — but it is simple',
      naCileARentu: ' towards goals and passive income',
      naNavrh: 'To the proposal',
      naZacatkuJsteRekl: '„At the beginning you said the most important thing for you is **„{hodnota}“** — and this is exactly the plan to make it happen. If it makes sense, let us agree on where we start.“',
      nadPrebytek: 'Your free cash flow is {prebytek} a month — the plan is {rozdil} higher. Let us go through where that difference comes from.',
      nadVlozenymi: 'above',
      namitka1: '„I need to think about it.“',
      namitka1Odpoved: '„I understand — what exactly is on your mind? The numbers, the insurance, or the amount? Let us solve it now so you do not have to think it through alone.“ (Find the REAL objection — „think about it“ is a cover.)',
      namitka2: '„I will discuss it with my wife/husband.“',
      namitka2Odpoved: '„Absolutely right — this is a family decision. Let us set up a meeting for the three of us so that I explain it to your partner and you do not have to defend numbers that are not yours.“ (Never let the client sell for you.)',
      namitka3: '„I cannot afford it right now.“',
      namitka3Odpoved: '„The plan costs nothing extra — it only uses the surplus you approved yourself. And if it is smaller, we start with a smaller amount. When is it better to start: today, or in five years at 40 % more?“ (Show the Cost of waiting slide.)',
      namitka4: '„Insurance is a waste of money.“',
      namitka4Odpoved: '„I agree — bad insurance is. That is why we cancel the expensive policies and keep only the protection of your paycheque, so the budget gap never happens. It is a parachute — you are not paying for the fall, you are paying for the landing.“ (Go back to the Risks slide.)',
      namitka5: '„Shares are gambling / I am afraid of a crash.“',
      namitka5Odpoved: '„In the short run you are right — that is why the plan has a reserve and a brake. But let me show you 100 years of data: every crisis ended and the market came back. The real gamble is leaving the money idle and handing it to inflation for sure.“ (Open the historical calculator — the flight through crises.)',
      nasporenoZaLet: 'Saved in {roky}',
      navrhKrytiJeV: 'the proposed cover is in the analysis',
      nejdrivToCoUz: 'First, what you already do well',
      nejdrivVyplnAnalyzu: 'Fill in the analysis first',
      nemateZadneSpatneDluhy: 'You have no bad debt',
      nepojisteno: 'Not insured: {co}',
      nesplaceneZavazky: 'Outstanding liabilities',
      neuplnaRezerva: 'Incomplete reserve',
      nezSePustimeDo: '„Before we start securing the goals, I recommend protecting your **assets** and above all your **future income**.“',
      nezUkazuPlan: 'Before I show the plan, let me show **where we start from**.',
      nezZacnemeInvestovatOchranime: 'Before we start investing — we protect you',
      nicJsmeSiNevymysleli: '„We made nothing up — we started with what you have today and split it across your goals. A zero on the last line means every unit of your money and every monthly surplus has a job to do.“',
      nikdyNebudeteMitVice: '„You will never have **more time than you have today**. Every delay costs money.“',
      oMinMene: '**{vklad}** less → after {roky} that is **{mene}** less. Do you see the difference?',
      ochrana: 'protection',
      osvc: ' · self-employed',
      pilirMajetek: 'property and liability',
      pilirPrace: 'work',
      pilirPrijem: 'your income (life insurance)',
      poKazdemCiliVidite: 'After each goal you can see **how much is left**.',
      poblizVlozenym: 'close to',
      pochvalaMajetek: 'You have built up financial assets of {castka}',
      pochvalaOdkladate: 'You set aside {pct} % of your income ({castka})',
      pochvalaRezerva: 'Your reserve is {pct} % complete',
      posunteSiSamiMesicni: 'Move the slider yourself — monthly investment:',
      povinne: 'essentials',
      pravidelne: 'regularly',
      pravidelneInvestovatVolneCash: 'Invest the free cash flow regularly',
      prebytekNeznamy: 'We do not have the free cash flow worked out yet — we will fill in the expenses and compare the amount.',
      prezentaceFinancnihoPlanu: 'Financial plan presentation',
      prijem: 'income',
      pripravujiPrezentaci: 'Preparing the presentation…',
      proTentoHorizontA: 'For this horizon and these contributions we do not have enough historical windows yet.',
      projitZnovu: 'Go through it again',
      protiPlanu: 'versus the plan',
      prvniJeDobra: 'The first one is good: **your goals can be met.**',
      realneVynosyNadInflaci: 'Real returns above inflation (SBBI 1926–2026). Past returns are no guarantee of future ones — this is a range, not a promise.',
      renta: 'passive income',
      rentaJeZatimNa: 'Passive income is at **{pct} %** so far — and we know exactly what to do about it.',
      rentierskePortfolio5035: 'income portfolio 50 / 35 / 15',
      rentierskePortfolioDrziSe: 'Income portfolio (kept during drawdown too)',
      rizikoDluhy: '{castka} — the family is left with this if something happens',
      rizikoInvalidita: 'in case of disability {castka} is missing',
      rizikoRezerva: 'covers {pct} % of the 6 salaries needed',
      rocneRealne: 'per year in real terms',
      rodinaZajistenaAtSe: 'protection of the family income',
      rozdilProtiPlanu: 'Difference versus the plan',
      rozdilZaLet: 'Difference over {roky}: {castka}',
      rozkliknoutNa100Letech: 'Open on 100 years of history + strategy',
      rozlozeniVCaseGlide: 'Allocation over time — fewer equities towards the end',
      rozlozitSoucasneUsporyNa: 'Spread the current savings across the goals',
      rozpocetPlanuKamJdou: 'The plan budget — where your money goes',
      sNefinancnim: 'including non-financial assets',
      sPlanem: 'With the plan',
      scenarOptimisticky: 'Optimistic scenario',
      scenarOptimistickyPozn: 'the best 5 % of periods',
      scenarPesimisticky: 'Pessimistic scenario',
      scenarPesimistickyPozn: 'the worst 5 % of periods (including major crises)',
      scenarRealisticky: 'Realistic scenario',
      scenarRealistickyPozn: 'the median — half of the periods turned out better',
      silaCasuCoRika: 'The power of time — what 100 years of history says',
      silaSlozenehoUroceniRoste: 'The power of compounding grows with time',
      smrt: 'death',
      souhrnDoporuceniCelehoPlanu: 'Summary of the whole plan recommendations',
      splneno: 'achieved',
      spravneZajisteniJeZaklad: '„Proper protection is the foundation of the plan — we are not protecting a policy, we are protecting what you called the most important thing: **„{hodnota}“**.“',
      stavimeNaDobrychZakladech: '„We are building on good foundations — now let us finish the job.“',
      stejnePenizeStejnyClovek: '„Same money, same person — different decisions.“',
      styl: 'style',
      tahakNaNamitkyJen: 'Objection cheat sheet (for your eyes only)',
      tahakNaNamitkyKlient: 'Objection cheat sheet (not visible to the client)',
      takhleToDopadneKdyz: '„This is how it ends if we do nothing…“ — click',
      toNedela8Z: 'regular saving is the foundation for everything else',
      tohleJeVaseCestaRok: 'This is your path — **year by year**.',
      tohleJeVychoziBod: '„This is the starting point. Now I will show you how we build the whole plan on it.“',
      tohleNejsouStatistiky: '„These are not statistics — this is **your budget**. On the day the salary does not arrive, the family is short __{castka}__. Every month.“',
      uCileBezTrzniho: 'for a goal without market risk',
      udelJstePrvniKrok: 'You have taken the first step — you are having a plan made',
      ukazuVamCoUz: 'I will show you **what you already do well**, **where you may be losing money** — and above all __what percentage of your goals you can reach__ and what it takes to get there.',
      ukolKlient1: 'scan the existing contracts (by Friday)',
      ukolKlient2: 'fill in the investment questionnaire',
      ukolKlient3: 'email any questions about the plan',
      ukolPoradce1: 'insurance contracts in line with the plan',
      ukolPoradce2: 'brokerage agreement (the route to investing)',
      ukolPoradce3: 'setting up the portfolios according to the plan',
      vasMajetek: 'Your assets',
      vaseCestaKamTecou: 'Your path — where your money flows',
      vaseCestaKdySe: 'Your path — when each goal is reached',
      vaseCileJedenPo: 'Your goals — one by one',
      vaseCileStojiNa: '▲ your goals rest on…',
      ve25MajiLide: "„At 25 people feel they should enjoy life. At 35 the income goes on the mortgage. At 45 they pay for the children's schools. And at 60 they find out **it is too late**. You are starting today.“",
      vejdeSeDoPrebytku: '= it fits within the free cash flow of {prebytek} a month that we worked out together.',
      vetsinaLidiFinanceOdklada: 'the first step is often the hardest',
      vetsinaRodinNemaAni: 'a reserve is the foundation the whole plan stands on',
      vkladNavicNeZ: "an extra contribution, not from today's savings",
      vlozenoCelkem: 'Total invested **{celkem}** ({jedn} one-off + {mes}) · strategy {akcie} % shares / {dluhopisy} % bonds',
      volneCashFlow: 'Free cash flow',
      volnyPrebytekKazdyMesic: 'Free surplus every month',
      vy: 'You',
      vyhovujeVamSchuzkaZase: '„Does a meeting next Wednesday at the same time suit you?“',
      vypadekPrijmu: 'Loss of income',
      vzacnostGratuluji: 'a rare thing — congratulations',
      zPrebytkuDokudNedoplnime: 'out of the surplus until it is topped up',
      zToho: 'of which',
      zaLet: ' (in {roky} yrs)',
      zaLetBudeteMit: 'In {roky} you will have',
      zaLetProste: 'in {roky} yrs',
      zacnuDnes: 'I start TODAY',
      zadneZasadniRizikoZ: 'No major risk came out of the analysis — an excellent starting position.',
      zdrojInvestice: 'Investments and savings',
      zdrojInvesticePozn: 'working for you',
      zdrojLikvidni: 'Liquid (accounts, cash)',
      zdrojLikvidniPozn: 'available right away',
      zdrojNefinancni: 'Non-financial assets',
      zdrojNefinancniPozn: 'real estate, business, inheritance',
      zivotniStyl: 'lifestyle',
      zmeniloSeZaTen: '„Has anything important changed over the past week?“',
    },
    planVystupPage: {
      akceKoupit: 'Buy',
      akceNavysit: 'Increase',
      akcePonechat: 'Keep',
      akceProdat: 'Sell',
      akcie2: 'Shares',
      alokaceDela92Vysledku: 'allocation drives ~92 % of the result',
      alokaceRadek: 'shares {akcie} % · bonds {dluhopisy} % · cash {penize} %',
      alokaceStartGlide: 'The split at the start. The closer the goal, the more the plan shifts from equities into bonds and cash — the final year before the goal sits fully in cash.',
      casuDost: 'Plenty of time…',
      co: 'What',
      coKdyProc: 'what / when / why',
      davkyOdhadPozn: 'The disability pension is an indicative estimate based on income; the actual amount is set by the social security authority from the insurance history.',
      dluhopisy: 'Bonds',
      dnes: 'today',
      doporucenaAlokace: 'Recommended allocation',
      doporucenePortfolio: 'Recommended portfolio',
      doporuceniProVas: 'Recommendations for you',
      doporuceniVychazejiZPoskytnutych: 'The recommendations are based on the data provided. Real returns above inflation: equities {akcie} %, bonds {dluhopisy} %, cash {cash} %; the average accumulation return works out at ≈ {prumer} % a year. Passive income is drawn at {renta} % of the capital a year. The document serves as a working basis and must be updated regularly. Past returns do not guarantee future ones.',
      doporucujemeDiverzifikovatMenove: 'We recommend diversifying by currency and by region (the world index is ~72 % USA) and using funds from large managers rated by Morningstar. Inspiration: the Norwegian fund, the Nobel Foundation.',
      financniNezavislost: 'Financial independence',
      financniNezavislostPoRealizaci: 'Financial independence after implementation',
      horizont: 'Horizon',
      hotovost2: 'Cash',
      invalidita: 'Disability',
      kapitalovaMetodaKlesajiciPojistn: 'Capital method (decreasing sums insured): it covers the income gap, debts and goals after deducting assets and the surviving household surplus. The capital for passive income counts only for disability — after death nobody draws it any more.',
      kdy: 'When',
      klient: 'Client',
      klient1: 'Client 1',
      klient2: 'Client 2',
      konkretniProdukty: 'specific products',
      likvidniRezerva: 'Liquidity reserve',
      mesicneInvestovatNaCile: 'Monthly investment towards goals and passive income',
      narativ1: 'This is your financial plan — how much to set aside each month and how to spread your investments so you reach financial independence and your other goals.',
      narativ2: "The figures are in today's prices. Real returns above inflation: equities {akcie} %, bonds {dluhopisy} %, cash {cash} %; the average accumulation return works out at ≈ {prumer} % a year. Passive income is drawn at {renta} % of the capital a year; we update the plan together on a regular basis. Past returns do not guarantee future ones.",
      naseDoporuceni: 'Our recommendations',
      nehledejteVymluvy: 'DO NOT LOOK FOR EXCUSES',
      nejdrivVyplnAnalyzu: 'Fill in the analysis first',
      nepodariloSeNacistData: 'The data could not be loaded',
      oSveBudoucnostiRozhodnete: 'Decide about your future TODAY.',
      planProDosazeniFinancni: 'A plan to reach financial independence and your other goals',
      planVytvorenDne: 'Plan created on',
      poRealizaci: 'after implementation',
      poznamka: 'Note:',
      prijmyCelkem: 'Total income',
      proc: 'Why',
      produkt: 'Product',
      profilDynamicky: 'Dynamic',
      profilKonzervativni: 'Conservative',
      profilVychozi: 'default — no other profile was selected',
      profilVyvazeny: 'Balanced',
      riziko: 'Risk',
      rizikovyProfil: 'Risk profile',
      rizikovyProfil2: 'risk profile',
      skorePlanuDnesS: 'Plan score (today → with the plan)',
      smrt: 'Death',
      socialniDavky: ' State benefits: disability pension {inval}/mo{davka}.',
      socialniDavkyStarobni: ', old-age pension {starobni}/mo',
      soucasnePortfolio: 'Current portfolio',
      souhrnMajetkuADluhu: 'Summary of assets and debts',
      splatkyUveru: 'Loan instalments',
      vaseHodnoty: 'Your values',
      vaseStrategickeCile: 'Your strategic goals',
      vasichHodnotACilu: 'your values and goals',
      vekNejlepsiCas: 'You are {vek} today — the best time to start is now.',
      vstupniInformace: 'input data',
      vydajeSpotreba: 'Expenses (consumption)',
      vymluva25: 'We are young and just starting out. We do not earn much yet. There is nothing to save from.',
      vymluva35: 'The mortgage instalment and the bills eat up all our income. And surely we are entitled to a holiday too!',
      vymluva45: 'We cannot afford to save. The children are at school — ideally abroad.',
      vymluva55: 'It is not easy to start at this age.',
      vymluva65: 'We should have started many years ago. Today it is too late.',
      zajisteniPrijmuVPripade: 'protecting your income if something unexpected happens',
      zivotniPojisteni: 'Life insurance',
    },
    popisZdroje: {
      jednorazovyVklad: 'one-off contribution',
    },
    portfolioDoctorPage: {
      aktualniTerAVstupni: '— current TER and entry fees from the managers’ websites',
      bezJmena: '(no name)',
      briefProSchuzkuClaude: 'Brief for the meeting · Claude Haiku 4.5',
      briefSCnbCompliant: 'A brief with ČNB-compliant wording',
      celkovyModelovyRozdilVe: 'Total model difference in favour of the ETF · ',
      coDoctorUmi: 'What Doctor can do',
      diagnostikaSelhalaZkusTo: 'The diagnostics failed. Try again.',
      doporuceni: 'Recommendation',
      etfAlternativa: 'ETF alternative:',
      fondIsinNeboNazev: 'Fund — ISIN or name',
      hledamFondyNaWebu: 'Searching the web for funds… (15–30 s)',
      ie00b4l5y983NeboConseqActive: 'IE00B4L5Y983 or “Conseq Active Invest Dynamický”',
      investovanaCastkaKc: 'Invested amount (Kč)',
      janNovak: 'Jan Novák',
      kategorieFonduUrcujeEtf: 'Fund category (determines the ETF replacement)',
      klientJmeno: 'Client (name)',
      klientovyPoziceIsinCastky: 'Client positions (ISIN + amounts)',
      knihovna35NejcastejsichCz: 'A library of 35+ of the most common Czech funds with real parameters',
      knihovnaFondu: 'fund library',
      marketingoveSdeleniCnbEsma: 'Marketing communication · ČNB / ESMA disclaimer',
      mesicneDaleKc: 'Monthly from now on (Kč)',
      modelovaKalkulaceMinulaVykonnost: 'A model calculation. Past performance is not a guarantee of future performance.',
      modelovyRozdilVeProspech: 'Model difference in favour of the ETF:',
      naprConseqActiveInvest: 'E.g. “Conseq Active Invest Dynamický”',
      naprKlientSeBoji: 'E.g. “The client is afraid of volatility, his wife wants to retire at 60.”',
      nazevFondu: 'Fund name',
      nepodariloSeNacistDiagnostiku: 'The diagnostics could not be loaded.',
      odebratFond: 'Remove fund',
      otevritZdroj: 'Open the source ↗',
      overenoNaWebu: 'Verified on the web:',
      posledniDiagnostiky: 'Recent diagnostics',
      pozice: 'Position',
      poznamkaProAiBrief: 'Note for the AI brief (optional)',
      prepocitanoSTvymiHodnotami: 'Recalculated with your values',
      prepocitatSMymiHodnotami: 'Recalculate with my values',
      pridatIsin: 'Add ISIN',
      pridejAlesponJednuPozici: 'Add at least one position.',
      rozpoznaUcitsEtfPres: 'Recognises UCITS ETFs via justETF (~2 800 funds)',
      rucniZadani: 'manual entry',
      smazaniSelhalo: 'Deleting failed.',
      smazano: 'Deleted',
      smazat: 'Delete',
      smazatTutoDiagnostiku: 'Delete this diagnostic?',
      spocita20LetyDopad: 'Calculates the 20-year impact of fees in Kč',
      spustitDiagnostikuPortfolia: 'Run portfolio diagnostics',
      tentoFondJeUz: 'This fund is already a good one.',
      terEtfCelkem: 'ETF TER, total',
      terFondCelkem: 'Fund TER, total',
      terMusiByt0: 'TER must be 0–10 %',
      terPod05: 'TER below 0.5 % and an accumulating ETF — we do not recommend changing it.',
      tvojeKnihovna: 'your library',
      ulozeniSelhalo: 'Saving failed',
      uloziFondDoKnihovny: 'Saves the fund to the library — from next time Doctor recognises it automatically',
      ulozitDoKnihovny: 'Save to library',
      upravit: 'Edit',
      upravitParametryFondu: 'Edit fund parameters',
      upravitRucne: 'Edit manually',
      veProspechEtf: 'in favour of the ETF',
      vek: 'Age',
      vlozenoCelkem: 'Total invested:',
      vstupni: 'Entry fee (%)',
      vstupni010: 'Entry fee must be 0–10 %',
      vstupni2: 'Entry fee',
      vstupniPop: 'Entry fee',
      vyberKategorii: 'Pick a category',
      vyplnNazevTerA: 'Fill in the name, TER and entry fee',
      zadejteFondIsinNebo: 'Enter the fund (ISIN or name), how much the client holds and the horizon. Within 30 seconds you get a model fee diagnostic, a comparison with a UCITS ETF alternative and a 3-paragraph brief for the meeting.',
      zatimZadneUlozeneDiagnostiky: 'No saved diagnostics yet.',
      zavrit: 'Close',
      zrusit: 'Cancel',
    },
    postaPage: {
      aHlasTextPrikazem: 'and generate a new mail with a voice or text command.',
      aiEmailKlientovi: 'AI email to the client',
      bezPristupuKeGoogle: 'The app has no Google access from the administrator — waiting for Gmail is pointless.',
      firemniEmailSmtp: 'company email (SMTP)',
      gmailPrepojenyPredek: 'Your Gmail is connected, but for',
      gmailPrepojenyTucne: 'reading mail in the CRM',
      gmailPrepojenyZadek: 'we need to widen the permission. Just go through the OAuth screen again — it takes 10 seconds.',
      gmailZatimPripojitNejde: 'Gmail cannot be connected yet',
      hledatVGmailu: 'Search in Gmail…',
      klikneTeToNa: 'This takes you to a Google screen where you only approve „Read mail“.',
      nacteniEmailuSelhalo: 'Loading emails failed',
      neboKlikniNa: 'Or click',
      neboSpojka: ', or',
      nepodariloSeOveritGmail: 'Gmail could not be verified',
      nepodariloSeSpustitReconnect: 'Reconnect could not be started',
      noveOpravneniPosta: 'New Mail permission',
      obnovit: 'Refresh',
      otevritNastaveni: 'Open Settings',
      postaSeObjeviZde: 'Mail shows up here as soon as you connect an email in Settings. You have two options:',
      pripojSiEMail: 'Connect your email',
      pripojitFiremniEMail: 'Connect the company email',
      sLibovolnouAdresou: 'and with any address (Seznam, Microsoft 365, @beplan.cz…). You connect it in a few minutes and write and read right here.',
      slozkaDorucene: 'Inbox',
      slozkaHvezdickovane: 'Starred',
      slozkaKoncepty: 'Drafts',
      slozkaKos: 'Trash',
      slozkaOdeslane: 'Sent',
      slozkaVse: 'All',
      slozky: 'Folders',
      smtpFungujeHned: 'The company email (SMTP) works right away',
      spojeniNaChviliSelhalo: 'The connection dropped for a moment. Try again — your Gmail is most likely still connected.',
      tenFungujeSLibovolnou: '— that one works with any address and does not wait for Google.',
      vyberEmail: 'Pick an email',
      zadneEmailyVeSlozce: 'No emails in the folder',
      zkusitZnovu: 'Try again',
      znovuPripojitGmail1: 'Reconnect Gmail (1 click)',
      zpetNaSeznam: 'Back to the list',
    },
    publicBookingPage: {
      vybratTermin: 'Pick a slot',
    },
    radarPrilezitostiPage: {
      dalsi: 'more',
      detailMezer: 'Gap detail',
      kdeMaKlientMezeru: 'Where the client has a gap — pick it, write, close it.',
      klientuKOsloveni: 'clients to reach out to',
      kritickychMezer: 'critical gaps',
      napsatEMail: 'Send e-mail',
      napsatNaWhatsapp: 'Message on WhatsApp',
      obchodSeNepodariloZalozit: 'Could not create the deal.',
      obchodniPripadZalozen: 'Deal created.',
      obnovit: 'Refresh',
      odlozenoO30Dni: 'Snoozed for 30 days.',
      odlozitNa30Dni: 'Snooze for 30 days',
      otevritSlozkuKlienta: 'Open client folder',
      prilezitostiCelkem: 'opportunities in total',
      radarPrilezitosti: 'Opportunity radar',
      radarSeNepodariloNacist: 'Could not load the Radar. Try again in a moment.',
      radarSeNepodariloNacist2: 'Could not load the Radar',
      sbalit: 'Collapse',
      skenujiSmlouvyAAnalyzy: 'Scanning contracts and analyses…',
      skorePrilezitostiKlikniPro: 'Opportunity score — click for detail',
      terminyFixaceVyrociHlida: 'Deadlines (rate fixation, anniversaries) are tracked by the Service radar. Snoozed gaps come back in 30 days.',
      tohleNeniZadnePrilezitosti: 'This is NOT „no opportunities“ — the data failed to load.',
      ukol: 'Task',
      ukolSeNepodariloVytvorit: 'Could not create the task.',
      ukolVytvorenZa3: 'Task created (in 3 days).',
      vse: 'All',
      zadneOtevrenePrilezitosti: 'No open opportunities.',
      zkusitZnovu: 'Try again',
    },
    reseniCilu: {
      akcie: 'equities',
      akontacePct: 'down payment {pct} %',
      bezRustuNeboKroku: 'No growth or no steps — the template will pre-fill nothing.',
      bezpecneCerpani4: 'safe withdrawal 4 %',
      castka: 'Amount',
      chybi: 'Missing',
      chybiProkazatelnyPrijem: 'The analysis has no provable income — the app does not know what the salary should grow from.',
      cil: 'target',
      cilJeVTomhle: 'The goal is unreachable with these settings — the number is only an indicative ceiling.',
      cilKrytyJednorazoveBez: 'Goal covered by a one-off amount — no regular investment.',
      cilVelke: 'Goal',
      cilovaCastka: 'Target amount',
      cimSeCilPoridi: 'How the goal gets paid for',
      cnbDo36Let: 'ČNB: under 36 you only need 10 % of your own funds (LTV 90 %), otherwise 20 %. 100% financing is the advisor decision — 10 % of the price is covered by a building-savings loan. The payment shows up in the cash flow only from the loan drawdown',
      dluhopisy: 'bonds',
      dopocitat: 'calculate',
      dopocteno: 'calculated',
      dynamicky: 'Dynamic',
      glidePathAlokaceV: 'Gradual de-risking over time',
      horizontVLetech: 'Horizon in years',
      hotovost: 'cash',
      hypotekou: 'with a mortgage',
      inflacePct: 'Inflation (%)',
      jakToVyresit: 'How to solve it',
      jeNadVolnymPrebytkem: 'is above the household free surplus',
      jednorazove: 'One-off',
      jednorazoveDnesNavic: 'One-off today (extra)',
      jednorazovy: 'one-off',
      kCili: 'To goal',
      kapital: 'capital',
      kazdychLet: 'Every (years)',
      konzervativni: 'Conservative',
      krokuRustu: 'steps',
      ktereSeTuNezapocitava: ', which is not counted here.',
      let: 'yrs',
      mesice: 'month',
      mesicne: 'Monthly',
      mesicniRentaKlienta: 'Client monthly passive income',
      mimoradnyPrijem: 'extraordinary income',
      navrh: 'suggestion',
      nbsAkontace: 'NBS: normally 20 % of your own funds (LTV 80 %), 10 % only as an exception. 100% financing is the advisor decision — 10 % of the price is covered by a building-savings loan. The payment shows up in the cash flow only from the loan drawdown',
      neresiSe: 'not used',
      nominalne: 'nominal',
      nominalneMinusInflace: 'nominal − inflation',
      nominalneNeprekonaInflaci: 'nominal does not beat inflation',
      oboji: 'Both',
      od: 'from',
      odR: 'from',
      odebratPritok: 'Remove inflow',
      planSlibujeVicNez: '— the plan promises more than the client can afford today.',
      pocetKroku: 'Number of steps',
      pocitaSeJakoSporeni: 'Counted as SAVING: the client is to save the whole amount {castka}. With a loan they only save the down payment.',
      polovina: 'halfway',
      posledni: 'last',
      posledniRok100Hotovost: '— the last year is 100 % cash: no market risk',
      pravidelnaInvestice: 'Regular investment',
      pridat: 'Add',
      pridatBudouciPritok: 'Add a future inflow',
      pripadnyKoncikiNajem: '; any rent that ends will partly offset the payment.',
      realneNadInflaci: 'real (above inflation)',
      realneTempoDoKroku: 'in real terms — this pace goes into the salary-growth steps.',
      renta: 'passive income',
      rentaDrziRentierskePortfolio: '— passive income keeps the 50/35/15 rentier portfolio even during drawdown',
      rentaVCerpaniPortfolio: '— during drawdown the income portfolio is {a}/{d}/{c}',
      posledniRokTabulka: '— final year {c} % cash and {d} % bonds',
      rentierskePortfolio: 'rentier portfolio',
      resiSeUverem: 'Only the down payment is saved, the rest is covered by the loan — the instalment starts at drawdown.',
      resimeJenZeZdroju: 'Solved from sources and monthly only.',
      rocniRustPct: 'Growth (%)',
      rok: 'year',
      rustMzdy: 'salary growth',
      rustVkladuNastaveni: 'Contribution growth — settings',
      sablonaNicNepredvyplni: 'The template pre-fills nothing right now.',
      sablonaPredvyplniPritoky: 'The template pre-fills future salary inflows across the plan — the advisor then adjusts them.',
      splatka: 'payment',
      splatnost: 'term',
      splatnostHypotekyLet: 'Mortgage term in years',
      typ: 'Type',
      urok: 'rate',
      urokHypotekyPa: 'Mortgage interest rate in % p.a.',
      uverZeStavebka: 'building-savings loan',
      uverem: 'with a loan',
      vR: 'in',
      vkladNadRamecZdroju: 'A contribution beyond the sources — the monthly payment is calculated.',
      vlastniZdroje: 'own funds',
      vlozenoCelkem: '— contributed in total',
      vybrano: 'selected',
      vychazi: 'works out',
      vychozi: 'default',
      vychoziHodnoty: 'default values',
      vychoziParametryHypo: "Left blank = the plan uses the defaults {sazba} % p.a. over {roky} years, not a bank's offer. The building-savings loan in the 100 % option has its own rate and these fields do not change it.",
      vyvazeny: 'Balanced',
      zAnalyzy: 'from analysis',
      zTohoVlastni: 'of that from your own funds',
      zTohoVyjde: 'That gives',
      zVlastnichPenez: 'from own money',
      za: 'in',
      zaLet: 'In (years)',
      zadanePctJe: 'The entered % is',
      zadano: 'entered',
      zadat: 'enter',
      zadneCilSeResi: 'None — the goal is funded by a regular investment from the surplus.',
      zadnyRealnyRust: 'real growth is zero, the template pre-fills nothing.',
      zahoditKroky: 'Discard the salary-growth steps',
      zpetNaHodnotuZ: 'Back to the value from the analysis',
      zpetNaVychozi: 'back to default',
      zpetNaVychoziRust: 'back to defaults',
      zrusit: 'Cancel',
    },
    rezerva: {
      poznKlientuvCilNezbytne: 'The methodology recommends 6× essential expenses plus instalments, i.e. {metodika}. Your target is {nasobek}× that base.',
      poznKlientuvCilObvykle: 'The methodology recommends 6× essential expenses plus instalments. Essential expenses are not in the analysis, so from usual expenses plus instalments this comes to {metodika} — your target is {nasobek}× that base.',
      poznNeznamy: 'There is nothing yet to calculate the reserve target from — expenses are missing.',
      poznObvykle: 'Essential expenses are not filled in the analysis — calculated from usual expenses instead. Add them and the amount will be refined.',
      titulKlientuvCil: 'Reserve — your target',
      titulNezbytne: 'Reserve (6× essential expenses + instalments)',
      titulNeznamy: 'Reserve',
      titulObvykle: 'Reserve (6× usual expenses + instalments)',
    },
    rozpocetPlanu: {
      aniTakToAleNa: 'Even so it is not enough for all the goals —',
      cekaNaCil: ' is waiting for a goal.',
      chybiCelkem: 'missing in total',
      doraziAzPoCilovem: 'arrives only AFTER the target date — it does not affect the target amount',
      financniMajetekJednorazove: 'Financial assets — one-off',
      hned: 'right away',
      jePenzijniSporeniDps: ' is pension savings (DPS/DIP) — it is the client asset and the plan counts all of it towards passive income, it just reaches the goal ',
      jePenzijniSporeniDps2: ' is pension savings (DPS/DIP). It is the client asset, but no goal draws on it yet — it belongs to passive income and the client has no financial-independence goal. It stays under „left“.',
      jednorazove: 'one-off',
      jednorazoveA: ' one-off and ',
      jednorazoveO: 'one-off by',
      jesteNeniRozdelenoVsechno: 'Not everything has been allocated yet: ',
      kolikZbyvaPoKazdem: 'What is left after each goal',
      let: 'yrs',
      letech: 'years old',
      mesicneO: 'monthly by',
      mesicniPrebytekPravidelne: 'Monthly surplus — regularly',
      mesicu: 'months',
      miraUspor: 'Savings rate',
      necerpaZRozpoctu: 'draws nothing from the budget',
      planJeHotovy: ' The plan is complete.',
      planJednorazovePrerozdeluje: 'The plan reallocates liquid accounts, building savings and the pension in one go. Left outside is ',
      planNemaZCeho: 'the plan has nothing to pay from. Start with the household budget.',
      podiloveFondyKzpOstatni: ' (mutual funds, endowment policies, other accounts) — total financial assets ',
      povinneVydaje: 'Mandatory expenses',
      pravidelne: 'regularly',
      prebytek: 'Surplus',
      prebytekJeVAnalyze: 'The surplus was entered manually in the analysis — it does not exactly match income minus expenses.',
      prebytekNesediNaRozpad: 'The surplus does not match income minus expenses and instalments — please check the budget in the analysis.',
      prebytekNulaKlientskyVystup: 'The monthly surplus is zero — a client plan will not be built from zero. Fill in the amount you agreed with the client in the analysis.',
      precerpano: 'Overdrawn',
      precerpanoPlanNevychazi: 'Overdrawn — the plan does not work out',
      prideleno: 'Allocated',
      prijmy: 'Income',
      rozpocetPlanu: 'Plan budget',
      tolikKlientNema: ' — the client does not have that much.',
      v: 'at',
      vydajeASplatkyPrevysuji: 'Expenses and repayments exceed income by ',
      vyrovnanoVsePrideleno: 'Balanced — everything allocated',
      zBudoucihoPritoku: 'from a future inflow (outside the budget)',
      zPenzijkaDpsDip: 'from the pension (DPS/DIP) · arrives ',
      zToho: 'Of that ',
      za: 'in',
      zatimNeniCoRozdelovat: 'There is nothing to allocate yet — the client has neither free financial assets nor a monthly surplus. The plan starts with the household budget, not with a product.',
      zatimZadnyCilRozpocet: 'No goal yet — the budget fills in as soon as you add the first one.',
      zbyva: 'Left',
      zbyva0A0: '0 and 0 left — every coin and every monthly surplus has a job.',
    },
    sekceCinema: {
      dalsi: 'Next',
      prehrat: 'Play',
      tvojeVeta: 'Your line ',
      zavrit: 'Close',
      zpet: 'Back',
    },
    spolecne: {
      aiGeneraceSelhala: 'AI generation failed',
      chybaPrepisu: 'Transcription error',
      chybaSite: 'Network error',
      cil: 'Goal',
      jedMes: '/mo',
      klient: 'client',
      klientu: 'clients',
      let: ' yrs',
      mikrofonNeniDostupny: 'The microphone is not available',
      n1HlasovyNeboTextovy: '1. Voice or text command',
      napisNeboNahrajPrikaz: 'Type or record a command',
      napsatEMail: 'Write an email',
      nevimeCile: 'The analysis has no goals with an amount yet — that is why there is no percentage.',
      nevimeHorizont: 'The goal has no horizon — add in how many years the client wants it.',
      nevimeRenta: 'No income-independence goal set — add how much per month and from when.',
      nevimeRezerva: 'The reserve target is unknown — household expenses are missing.',
      nevimeSkore: 'The score cannot be calculated — basic data is missing.',
      nevimeVydaje: 'Household expenses are missing — free cash flow cannot be calculated.',
      odesilam: 'Sending…',
      odeslaniSelhalo: 'Sending failed',
      poradce: 'advisor',
      poslatKlientovi: 'Send to client',
      prazdnaAnalyzaText: "The analysis has no income, expenses, assets or goals yet. Fill them in and the plan will be built from the client's data — invented numbers do not belong in a client document.",
      prazdnaAnalyzaTitul: 'This analysis cannot produce a plan',
      prebytekChybiTextDopocet: 'Income minus expenses and instalments gives a monthly surplus of zero. We will not build a plan from zero. Check the household budget in the analysis — or fill in the surplus you agreed with the client.',
      prebytekChybiTextNezadano: 'The monthly surplus is unknown — the analysis is missing the expenses it would be calculated from. Add them, or enter the amount you agreed with the client.',
      prebytekChybiTextNula: 'The agreed monthly surplus is zero. We will not build a plan from zero — no charts drawn from money that is not there, and no claim to the client that the monthly solution fits their surplus. Fill in the amount you agreed with the client, or go through the household budget first.',
      prebytekChybiTitul: 'How much per month did we agree on?',
      predmet: 'Subject:',
      prepisSeNezdarilNapis: 'Transcription failed — type the command manually',
      rentaOdvozena: "No income-independence goal set — we use today's expenses instead.",
      ukladam: 'Saving…',
      ulozit: 'Save',
      vytisknoutUlozitPdf: 'Print / save PDF',
      zavrit: 'Close',
      zkusitZnovu: 'Try again',
      zmenitPrikaz: 'Change the command',
      zrusitFiltr: 'Clear the filter',
    },
    srovnavacFonduPage: {
      horizont: 'Horizon: {roky} {rok}',
      jednorazoveKc: 'Lump sum ({mena})',
      mesicneKc: 'Monthly ({mena})',
      rozdilVeProspech: 'Difference over {roky} {rok} in favour of:',
      srovnavacFondu: 'Fund comparison',
      vlastniA: 'Custom A',
      vlastniB: 'Custom B',
    },
    tokPenez: {
      beznyUcet: 'Current account',
      budouciPritok: 'Future inflow',
      chybi: 'missing',
      chybiPrecerpano: 'missing / overdrawn',
      coKlientDnesNema: 'what the client does not have today',
      dnesniMajetek: 'assets today',
      doraziAzPoCilovem: 'arrives only AFTER the target date',
      doraziAzPoCilovem2: 'arrives only AFTER the target date — it does not affect the target amount',
      doraziV: 'arrives at',
      hotovost: 'Cash',
      jednorazoveZFinancniho: 'One-off — from financial assets',
      klikniZnovuZpetNa: 'Click again = back to the calculated proposal',
      letech: 'years old',
      mesicneZPrebytku: 'Monthly — from the surplus',
      mesicniPrebytek: 'Monthly surplus',
      mesicniPrebytek2: 'monthly surplus',
      najedteNaProudUkaze: 'Hover over a flow — it shows where from, where to and how much.',
      nezarazenyZdroj: 'Unclassified source',
      odkudKamTecouVase: 'Where your money flows from and to',
      penzijkoAzPozdeji: 'pension — only later',
      penzijkoDpsDip: 'Pension DPS/DIP',
      posliCelyTenhleZdroj: 'Send this whole source to this goal',
      posliSem: 'send here',
      precerpanoTolikKlient: 'Overdrawn — the client does not have that much',
      splneno: 'met',
      sporiciUcet: 'Savings account',
      stavebniSporeni: 'Building savings',
      tokPenez: 'Money flow',
      uvolnenePenizeARustMzdy: 'Freed money and salary growth',
      vkladNavic: 'Extra contribution',
      zatimNeniCoRozdelovat: 'There is nothing to allocate yet — the client has neither free financial assets nor a monthly surplus.',
    },
    whatsAppSender: {
      klientNemaTelefonDopln: 'The client has no phone number — add it to the contact.',
      navrhDleFazeKlienta: 'Suggestion based on the client’s stage',
      otevreWhatsappSTimto: 'Opens WhatsApp with this text — you still press send yourself (free, no API).',
      otevritWhatsapp: 'Open WhatsApp',
      sablona: 'Template',
      zpravaUpravPodlePotreby: 'Message (edit as needed)',
      zrusit: 'Cancel',
    },
  },
  /* BLOK:auto END */
  /* === /AUTO === */
  /* Client-facing WHY for life insurance — see cs.js. */
  /* VEŘEJNÁ SDÍLENÁ MODELACE /m/:token — čte to KLIENT, ne poradce.
   * Snapshot je uložený natrvalo, ale texty jsou KLÍČE, takže se přeloží do
   * jazyka toho, KDO SE DÍVÁ — ne toho, kdo modelaci vytvořil. */
  modelace: {
    nacitam: 'Loading your plan…',
    neplatnyOdkaz: 'This link is not valid or has expired.',
    proVas: 'Prepared for you',
    vaseModelace: 'Your plan',
    pripravenoPro: 'Prepared for',
    jakRozumet: 'How to read this',
    vasPoradce: 'Your adviser',
    paticka: 'Indicative modelling. Past returns are no guarantee of future ones.',
    ctaSchuzka: 'Book a meeting',
    ctaWhatsApp: 'Message on WhatsApp',
    ctaSpojit: 'Get in touch',
    chybaNacteni: 'The plan could not be loaded right now. Check your connection and try again.',
    zkusitZnovu: 'Try again',
    prehrat: 'Play',
    zastavit: 'Stop',
    nahledKlient: 'What the client will see',
  },
  /* Popisky snapshotu životní kalkulačky pro /m/:token (a PDF).
   * ⚠️ Placeholder {castka} musí být ve všech pěti jazycích STEJNÝ. */
  zivotkoModelace: {
    heroSmrt: 'What the family needs (death of the earner)',
    pocetOsob: 'People',
    nezbytneVydaje: 'Essential spending',
    zaMesic: '{castka}/mo',
    zaDen: '{castka}/day',
    variantaKryti: 'Cover variant',
    varianta_narocna: 'Full cover',
    varianta_stredni: 'Middle ground',
    varianta_uskromnit: 'Tighten the belt',
    varianta_cena: 'Price first',
    krytiSmrt: 'Cover in case of death',
    krytiInvalidita: 'Cover in case of disability',
    pnRodina: 'Sick leave (family)',
    narativ1: 'The numbers say what the family would receive if the worst happened — so it can keep its home, keep its standard of living and the children can finish school.',
    narativ2: 'Disability comes out higher than death, because a sick person at home also needs care and adaptations. Sick-leave cover tops up the lost income during a short illness or injury.',
    narativ3: 'A non-binding indicative proposal. We will agree the specific terms and prices together.',
  },
  zivotkoProc: {
    nadpis: 'Why disability matters most',
    podnadpis: 'Step by step, from your own numbers',
    osloveni: '{kdo}, this is your projection — and above all, WHY these particular numbers.',
    proOsobu: 'Calculated for {kdo}.',
    proOsobuVice: 'Calculated for {kdo} — the highest earner in the family. Everyone else has their own calculation.',
    proOsobuViceBezJmena: 'Calculated for the highest earner in the family. Everyone else has their own calculation.',
    k1Nadpis: 'Today',
    k1Popis: 'The family has {prijem} a month and needs {vydaje} of it for essentials.',
    k1PopisBezVydaju: 'The family currently has {prijem} a month.',
    k2Nadpis: 'The income stops',
    k2Popis: '{kdo} can no longer work. The family is left with {zbytek} a month.',
    k2PopisBezJmena: 'This income stops coming. The family is left with {zbytek} a month.',
    k2PopisNic: '{kdo} can no longer work. No other earned income is left.',
    k2PopisNicBezJmena: 'This income stops coming. No other earned income is left.',
    k3Nadpis: 'But the costs GO UP',
    k3Popis: 'The bills do not disappear — care, medication, trips to the doctor and home adaptations are added on top. The model assumes an increase of {pct} %, i.e. {vydaje} a month. That is the difference from death: the person lives on, and living costs money.',
    k3PopisBezNarustu: 'The bills do not disappear. The family still needs {vydaje} a month.',
    k4Nadpis: 'The state covers only part of it',
    k4Popis: 'The disability pension is {duchod} a month. Once every remaining income and benefit is counted in, {chybi} is still missing every month.',
    k4PopisBezDiry: 'The disability pension is {duchod} a month. The family would cover everyday costs from the remaining income and benefits — the gap only appears with debts and goals.',
    k5Nadpis: 'And it is missing every month for {roky} years',
    k5Popis: 'To close that gap for a full {roky} years, capital of {kapital} is needed. It is not a plain sum of {naivne} — the money keeps earning in the meantime, so less is enough. The calculation uses {sazba} % a year above inflation.',
    k5PopisBezSazby: 'To close that gap for a full {roky} years, capital of {kapital} is needed.',
    k6Nadpis: 'Plus debts and goals',
    k6NadpisDluhy: 'Plus debts',
    k6NadpisCile: 'Plus family goals',
    k6Popis: 'Capital for living costs is one part. The other is liabilities and plans. Debts are never scaled down — you cannot pay off 80 % of a mortgage.',
    k6PopisBezDluhu: 'Capital for living costs is one part. The other is the family plans that should not stop.',
    k6Dluhy: 'Debts to repay: {castka}',
    k6Cile: 'Family goals: {castka}',
    souhrnNadpis: 'Total for disability',
    souhrnNadpisOsoba: 'For disability — {kdo}',
    souhrnNadpisJedna: 'For disability — this one person',
    souhrnPopis: 'That is the sum the policy should carry so the family can live on for another {roky} years without losing their home.',
    souhrnPopisBezLet: 'That is the sum the policy should carry so the family can live on without losing their home.',
    srovnaniVyssi: 'For death the figure is {smrt}. Disability is {rozdil} higher — and that is exactly why it comes first. Someone who has died does not eat, does not need housing and does not need care. Someone alive does.',
    srovnaniStejne: 'For death the figure is {smrt}. In your case the two numbers are close — what then decides is whichever happens first.',
    pausalNadpis: 'Why not five times annual income',
    pausalMene: 'The textbook rule of thumb — five times annual income — would give {pausal} in your case. That is {rozdil} less than your own costs, benefits and time horizon produce. A rule of thumb knows nothing about your mortgage or your children, which is why there is none here.',
    pausalVice: 'The textbook rule of thumb — five times annual income — would give {pausal} in your case, i.e. {rozdil} more than your own numbers produce. A rule of thumb knows nothing about your costs or your benefits, which is why there is none here.',
    rizikaNadpis: 'The other risks — and what they cover',
    rizikaNadpisOsoba: 'The other risks — and what they cover for {kdo}',
    rizikaNadpisJedna: 'The other risks — and what they cover for the same person',
    coJe: 'What it is',
    bez: 'What happens without cover',
    resi: 'How much it covers',
    smrtNazev: 'Death',
    smrtCoJe: 'The breadwinner dies — through accident or illness.',
    smrtBez: 'Costs and debts remain, one income disappears. The family ends up selling the home in the very year they have the least strength for it.',
    trvNazev: 'Permanent injury',
    trvCoJe: 'An accident that leaves a lasting limitation — arm, leg, sight, spine.',
    trvBez: 'One-off costs (rehabilitation, accessible adaptations, a different car) come out of savings. When that is not enough, out of a loan.',
    trvResiPopisek: 'Progressive payout: the more serious the injury, the higher the payment — in our model up to {nasobek}× the agreed sum, insurers differ.',
    pnNazev: 'Sick leave',
    pnCoJe: 'Illness or injury lasting weeks to months. Then the person returns to work.',
    pnBez: 'Income drops to sick pay while costs stay the same. Savings are gone within a few months.',
    pnBezOsvc: 'A self-employed person without sickness insurance gets nothing from the state. Costs carry on and savings are gone within a few months.',
    pnResiDen: '{castka} / day',
    pnKarenceOd: 'Savings cover the first months, so the benefit is proposed from month {od}.',
    pnKarenceHned: 'Proposed from day one.',
    zavNazev: 'Critical illness',
    zavCoJe: 'Cancer, heart attack, stroke and other diagnoses on the insurer list.',
    zavBez: 'Treatment and recovery take months to years. The person works less, pays more — and has no time to deal with money.',
    zavResiPopisek: 'Paid as a lump sum of {nasobek}× the annual income.',
    ditNazev: 'A serious event involving a child',
    ditCoJe: 'After an accident or illness the child remains permanently dependent on care.',
    ditBez: 'The biggest gap is not the treatment — it is the parent who leaves work for good in order to provide care.',
    ditResiPopisek: 'The sum on each child policy. It is derived from the lost income of the parent who would provide the care.',
    ditResiStrop: 'The sum on each child policy. Part of the need ({castka}) is something no insurer will underwrite on a child — that part belongs in savings and investments.',
    cenaNadpis: 'Price',
    cenaZadana: 'The cover comes to {cena} a month. This is the figure from the quote entered by your adviser — the final price is confirmed by the insurer in the contract, once your health has been assessed. Until then it is an estimate, not an offer.',
    cenaChybi: 'There is deliberately no price in this document. Your adviser will add it once the insurer is chosen — until a contract is signed, no figure here is an offer.',
    cenaDen: 'That works out at {denne} a day.',
    cenaPct: 'That is {pct} % of the family net income.',
    poznamkaModelace: 'This is a projection, not an insurance contract and not personal advice. The numbers come from what you provided — if income, costs or goals change, the result changes too.',
    poznamkaSablona: 'The figures for permanent injury, critical illness and child risk are an indicative template from advisory practice. Specific limits, exclusions and waiting periods are set by the insurer.',
    poznamkaDavky: 'The disability pension and sick pay are an estimate based on Czech rules. The actual amount is determined by the social security authority.',
    poznamkaMetodika: 'Methodology {verze}.',
  },

  /* Klientské formuláře (/f/:token) — JEDINÁ obrazovka appky, kterou otvírá
   * klient, ne poradce. Otevře ji v telefonu, bez přihlášení, a může to být
   * Vietnamec nebo Ukrajinec — proto tu nesmí být ani jeden dvoujazyčný ternár.
   *
   * ZNĚNÍ OTÁZEK TU NENÍ. Popisky polí, nápovědy i texty souhlasu chodí ze
   * serveru přeložené (backend/lib/formulare/*). Backend je jediný zdroj pravdy
   * o tom, jaká pole formulář má a která z nich jsou citlivá; kdyby si seznam
   * držel frontend, stačila by jedna překlepnutá klíčovka a rodné číslo by
   * skončilo v nešifrované části dokumentu.
   */
  formKlient: {
    castZ: "Part {n} of {celkem}",
    /* Příjmy a výdaje — obrazovka skupiny výdajů a „Váš přehled“ (26. 10. 2026). */
    pv: {
      prehledNadpis: "Your overview",
      prehledPodnadpis: "Check the numbers and send them to your advisor. Edit anything that is off.",
      prijmy: "Income",
      vydaje: "Expenses",
      mesicne: "per month",
      zbyva: "Left each month",
      zbyvaPopis: "income − expenses − loan payments",
      zbyvaZaporne: "Expenses and loan payments are higher than income.",
      bezPrijmu: "Without income we cannot work out what is left.",
      rozpad: "Where the money goes",
      rozpadPrazdno: "You have not filled in any expenses yet.",
      rozpadAria: "Monthly expenses by group, the largest is {skupina}: {castka}",
      porovnaniAria: "Income {prijmy}, expenses {vydaje}",
      splatky: "Loan payments",
      sporeni: "Savings and investments",
      neniVydaj: "not counted as an expense",
      firma: "Business (kept separate from the household)",
      minimum: "essential minimum",
      minimumCelkem: "Essential minimum in total",
      osoba1: "You",
      osoba2: "Partner",
      dalsiPrijmy: "Rent, investment income, bonuses",
      pravidlo: "Rule of thumb 50 / 30 / 20",
      pravidloPopis: "Fixed expenses and loan payments 50–60 %, lifestyle 20–30 %, future ideally 20 % of income. A guide, not a verdict.",
      povinne: "Fixed",
      zivot: "Lifestyle",
      budoucnost: "Future",
      cil: "target {rozsah}",
      skupinaCelkem: "Group total",
      vydajeZatim: "Expenses so far",
      podrobnosti: "Details: essential minimum",
      podrobnostiSkryt: "Hide details",
      minimumPopis: "How much of it is the essential minimum — the amount you cannot do without in a month with no income.",
    },
    nacitam: "Loading the form…",
    neplatnyNadpis: "This link is no longer valid",
    neplatnyText: "Form links have a limited lifetime. Message your advisor and they will send you a new one.",
    chybaNadpis: "The form could not be loaded",
    chybaText: "Try reloading the page. If that does not help, contact your advisor.",
    hotovoNadpis: "Sent, thank you",
    hotovoText: "{poradce} will get in touch. Anything you left out you can fill in together.",
    hotovoTextBezJmena: "Your advisor will get in touch. Anything you left out you can fill in together.",
    jazyk: "Language",
    krokZ: "Question {n} of {celkem}",
    sekceOtazek: "Questions in this part: {n}",
    zacit: "Start",
    pokracovat: "Continue",
    zpet: "Back",
    dale: "Next",
    preskocit: "Skip",
    nepovinne: "Optional",
    ukladam: "Saving…",
    ulozeno: "Saved — you can close this and come back later.",
    chybaUlozeni: "The last changes could not be saved. We will try again on your next edit.",
    chybaUlozeniOdkaz: "This link is no longer valid — please contact your advisor.",
    zamek: "Stored encrypted",
    ulozenoZasifrovane: "Stored encrypted: {maska}. Leave blank if it should stay as it is.",
    platiDo: "The link is valid until {datum}.",
    vyberte: "Choose",
    nevyplneno: "Not filled in",
    pridatRadek: "Add a row",
    smazatRadek: "Delete row",
    zvlastniKategorie: "Special category data",
    souhlasNadpis: "Before we start",
    souhlasPokracovat: "I agree and want to continue",
    souhlasOdmitnout: "I do not agree",
    souhlasNutny: "Without your consent the form cannot be filled in.",
    souhlasOdmitnutoNadpis: "Understood",
    souhlasOdmitnutoText: "We saved nothing and closed the link. If you change your mind, your advisor will send you a new one.",
    odvolatSouhlas: "Withdraw consent and close this link",
    rekapitulaceNadpis: "Check and send",
    rekapitulacePodnadpis: "Anything you left out you can fill in with your advisor. It does not have to be complete.",
    upravit: "Edit",
    prazdno: "You have not filled anything in yet.",
    odeslat: "Send to my advisor",
    odesilam: "Sending…",
    chybiPovinne: "Still missing before sending: {pole}.",
    chybaOdeslani: "Sending failed. Please try once more.",
    poradce: {
      /* Příjmy a výdaje — banner v analýze a složka (26. 10. 2026). */
      pv: {
        banner: "The client sent income and expenses ({datum})",
        prevzit: "Take into the analysis",
        prevzato: "Taken into the analysis",
        zobrazit: "Show",
        skryt: "Hide",
        coSeZapise: "What will be written into the analysis",
        drivTed: "before {pred} → now {po}",
        partnerChybi: "The client filled in a partner too, but the analysis has no second person. Only person 1 will be written — add the partner and take it over again.",
        splatkySporeni: "Loan payments and savings were given for the overview only — they are not written into expenses (they belong to Liabilities and Resources).",
        nicKPrevzeti: "The form is empty — nothing to take over.",
        hotovo: "Income and expenses taken into the analysis.",
        chybaRazitka: "The numbers are in the analysis, but the “taken over” mark was not saved — the notice may show again.",
        chyba: "Taking over failed.",
        chybaNacteni: "The client's answers could not be loaded.",
        pole: {
          prokaz1: "Person 1 — provable income",
          ostatni1: "Person 1 — business / other",
          prokaz2: "Person 2 — provable income",
          ostatni2: "Person 2 — business / other",
          pasivni: "Passive income",
          bonusyRok: "Bonuses per year",
          obvykle: "Usual expenses (including insurance from the analysis)",
          minimalni: "Essential expenses",
          rozpis: "Items in the expense breakdown",
        },
      },
      nadpis: "Client forms",
      popis: "Pick a type, generate a link and send it to the client through your own channel. The app never sends anything itself.",
      typ: "Form type",
      platnost: "Link lifetime",
      dnu: "{n} days",
      vytvorit: "Create a link",
      vytvarim: "Creating…",
      zkopirovat: "Copy the link",
      zkopirovano: "Copied",
      zkopirovatZpravu: "Copy the message for the client",
      zneplatnit: "Revoke",
      zneplatnitPotvrzeni: "Revoke this link? The client will no longer be able to open it.",
      stavCeka: "Waiting for the client",
      stavRozpracovano: "In progress",
      stavVyplneno: "Completed",
      stavVyprselo: "Link expired",
      stavZneplatneno: "Revoked",
      stavOdvolano: "The client withdrew consent",
      zobrazit: "Show the answers",
      skryt: "Hide the answers",
      zvlastniKategorie: "Special category — health data",
      zvlastniHint: "The answers are encrypted as a whole and never shown in the preview. Every opening is written to the audit log.",
      kUklidu: "This data has been here for more than {n} days. Consider whether you still need it.",
      bezFormularu: "You have not sent this client any form yet.",
      chybaNacteni: "The forms could not be loaded.",
      chybaVytvoreni: "The link could not be created.",
      chybaOdpovedi: "The answers could not be loaded.",
      odhalit: "Reveal",
      platiDo: "Valid until {datum}",
      vyplneno: "{n} of {celkem} fields filled in",
      jazykOdkazu: "Language for the client",
      nicNeodesilame: "The link is only generated. Send the message through your own channel so you can see who receives it.",
    },
  },
  /* Porovnávač tří způsobů čerpání renty (/renta-porovnavac).
   * 🔴 PRÁVNÍ: „poučené Nobelovou nadací“ NIKDY ne „portfolio Nobelovy nadace“;
   * modelace ≠ investiční doporučení; historie ≠ příslib budoucího výnosu. */
  /* Kdy budeš volný (KFP 20) — peníze přeložené na čas.
   * 🔴 PRÁVNÍ: modelace ≠ investiční doporučení; výnos je NAD inflací,
   * takže renta je v dnešních penězích. Nesmí se to podat jako příslib. */
  /* Hypotéka — čtyři rozhodnutí (KFP 02, 10, 11, 13).
   * 🔴 PRÁVNÍ: modelace, NE úvěrová ani investiční nabídka. Sazby zadává
   * poradce. Porovnává se celé měsíční zatížení, ne jen splátka. */
  hypoR: {
    zalRefixace: 'End of fix',
    zalSplatnost: '20 or 30 years',
    zalVyse: 'How much own money',
    zalCas: 'What time does',
    vyseMeneVlastnich: 'Less own money, invest the rest',
    vyseVicVlastnich: 'More own money, smaller loan',
    chybiVstupy: 'Fill in the inputs on the left. Nothing is calculated until they are there — an empty field is not zero.',
    zpet: 'Tools',
    nadpis: 'Mortgage — four decisions',
    podnadpis: 'The four questions a client actually asks about a mortgage. Each ends in one sentence, not a table. The whole monthly outlay is compared — otherwise it would be apples against oranges.',
    vstupyLabel: 'The client\'s mortgage',
    cena: 'Property price',
    vlastniA: 'Option A — own money',
    sazbaA: 'Option A — rate',
    vlastniB: 'Option B — own money',
    sazbaB: 'Option B — rate',
    sazbaBHint: 'A bank offers a better rate at lower LTV. That difference is the whole point here — without it the calculation would be meaningless.',
    jistina: 'Loan amount',
    sazba: 'Rate',
    splatnost: 'Term',
    let: 'years',
    fixace: 'Fixed period',
    kratsi: 'Shorter option',
    kratsiHint: 'The longer option is the Term field above. With it, the difference in payment is invested from the first month.',
    prijem: 'Net monthly income',
    vydaje: 'Other monthly spending',
    zaLet: 'Look ahead',
    rustPrijmu: 'Income growth',
    vynos: 'Investment return',
    inflace: 'Inflation',
    inflaceHint: 'Every difference is shown twice: in future money (the big number) and in today\'s money (what it actually buys).',
    refVerdiktLabel: 'When the fixed period ends',
    refVerdiktVeta: 'more per month if the rate rose by 1 pp. Over the remaining {roky} years that is {celkem}.',
    refTabulka: 'Payment by new rate',
    refDnes: 'Today',
    refPoznamka: 'Over {roky} years of the fixed period the client repays {splaceno} of the principal ({pct} %). The rest is refinanced at the new rate — hence the jump in the payment.',
    splVerdiktLabel: 'At the same monthly outlay, the winner is',
    splRemiza: 'a tie',
    splRemizaVeta: 'Both options come out practically the same. It comes down to what suits the client better.',
    splVerdiktVeta: 'By {rozdil} in future money — that is {dnes} today. Both options cost the client the same {zatizeni} a month.',
    splMajetek: 'Assets at the end',
    splRadek: '{let} years · payment {splatka}',
    splPoznamka: 'With the longer option, the difference in payment ({rozdil} a month) is invested from the first month. With the shorter one, the whole payment is invested once the loan is repaid. That is why both cost the same and only the outcome differs.',
    vyseVerdiktLabel: 'After {roky} years the better one is',
    vyseVerdiktVeta: 'By {rozdil}, which is {dnes} in today\'s money.',
    vyseTabulka: 'Both options side by side',
    vyseVlastni: 'Own money',
    vyseUver: 'Loan',
    vyseSazba: 'Rate',
    vyseSplatka: 'Payment',
    vyseVolne: 'Free to invest',
    vyseMajetek: 'Assets at the end',
    casVerdiktLabel: 'The payment stays the same, everything else does not',
    casVerdiktVeta: 'The payment\'s share of income after {roky} years. Inflation alone erases {umazala} of the debt — without a single extra payment.',
    casRozpocet: 'Monthly budget',
    casDnes: 'Today',
    casPozdeji: 'In {roky} years',
    casPrijem: 'Income',
    casSplatka: 'Payment',
    casVydaje: 'Other spending',
    casZbyva: 'Left over',
    casZatizeni: 'Payment takes this share of income',
    casPoznamka: 'Debt remaining after {roky} years: {nom} in nominal terms, but only {real} in today\'s money. The {umazala} difference is inflation\'s work, not the client\'s.',
    disclaimer: 'A model, not a loan or investment offer. Rates are entered by the adviser — the app does not claim the client will get them. Investment returns are not guaranteed and the real outcome depends on markets, taxes and fees.',
  },

  svoboda: {
    rok: 'year',
    roky: 'years',
    let: 'years',
    mesic: 'month',
    mesice: 'months',
    mesicu: 'months',
    hned: 'right now',
    zpet: 'Tools',
    nadpis: 'When you will be free',
    podnadpis: 'Money translated into time. Add anything extra and see how much sooner your assets start paying the bills instead of your job.',
    nedosazitelneNadpis: 'This will not get you there.',
    zNedosazitelnehoNadpis: 'Now it can be reached.',
    nedosazitelneText: 'With what is being set aside today, the goal will not be met in a lifetime. That is not a calculation error — it is the answer. Try increasing the monthly amount or lowering the target income.',
    zNedosazitelnehoText: 'The goal was previously out of reach entirely. With this increase it is reachable — but by how much sooner cannot be said, because there was no previous date.',
    ziskLabel: 'This increase buys you',
    zatimNic: 'nothing yet',
    ziskDovetek: 'sooner than if everything stayed as it is',
    ziskVyzva: 'move the sliders below and watch what happens',
    dnesPlan: 'Today\'s plan',
    sNavysenim: 'With the increase',
    osaLabel: 'The road to independence',
    zaStropem: 'The date is past the end of the axis — the marker sits on the edge.',
    dnes: 'today',
    cilKapital: 'Target',
    cilVysvetleni: '= {renta} per month in today\'s money',
    vstupyLabel: 'How it stands today',
    renta: 'Monthly income wanted',
    rentaHint: 'In today\'s money. How much would need to arrive so that going to work becomes optional.',
    majetek: 'Already set aside for this',
    majetekHint: 'Investments and savings genuinely earmarked for this goal — not the emergency fund and not the car money.',
    mesicne: 'Set aside each month',
    vynos: 'Return above inflation',
    vynosHint: 'ABOVE inflation, not total. That is why the numbers look lower than expected — and why the income figure is in today\'s money.',
    coKdyby: 'And what if they added',
    jednorazove: 'One-off, now',
    skokNula: 'none',
    navic: 'Extra per month',
    pomerLabel: 'What it buys',
    pomerText: 'For {penize} extra they get {cas} of life in which they do not have to.',
    cokdybyPrazdno: 'Both sliders are at zero. Raise one and watch the accent marker slide left along the axis.',
    cekaniLabel: 'The price of waiting',
    cekaniText: 'If the start were postponed. The money sits in an account meanwhile — the same in nominal terms, eaten by inflation in real terms. That is exactly why the loss exceeds the wait itself.',
    inflace: 'Inflation',
    cekaniOdklad: 'Starts {doba} later',
    cekaniNedosazitelne: 'no longer reachable',
    cekaniDovetek: 'longer than today',
    disclaimer: 'A model, not investment advice and not a promise of returns. Calculated in today\'s money (the return is entered above inflation). The real outcome depends on markets, taxes and fees.',
  },

  rentaPorov: {
    zPlanuOdkaz: "Compare the three withdrawal methods",
    zaMesic: "/mo",
    zpusobPevne: "Fixed percentage",
    zpusobKlouzavy: "Moving average",
    zpusobMantinely: "Guardrails",
    jakPevne: "{pct} of the current value",
    jakKlouzavy: "{pct} of the {let}-year average",
    jakMantinely: "start at {pct}, then rule-based adjustments",
    vyhodaPevne: "The capital theoretically never runs out — you always take only a share.",
    vyhodaKlouzavy: "The income is calmer; a single bad year does not drag it all down.",
    vyhodaMantinely: "The highest income at the start.",
    presetPoucene: "Nobel-informed",
    presetOpatrne: "Cautious",
    presetDynamicke: "Dynamic",
    cenaPevne: "The income swings with the market, fully and immediately.",
    cenaKlouzavy: "After a crash it pays out more than the portfolio is actually worth.",
    cenaMantinely: "Cuts when the market disappoints. It is not a better rule — it is a different risk.",
    rok: "Year",
    mil: "M",
    tis: "k",
    zpet: "Back to Tools",
    kicker: "Drawing an income",
    title: "Three withdrawal methods side by side",
    subtitle: "Same capital, three withdrawal rules. What the client gets each month, what is left — and what it costs.",
    zPlanu: "Capital taken from the client plan",
    pouceneTitul: "A portfolio informed by the Nobel Foundation",
    pouceneText: "The Nobel Foundation targets 3 % real return a year and, next to equities, bonds and cash, holds roughly a fifth in alternatives and a tenth in real estate and infrastructure. We do not model those here. The allocation below is our simplification for a client who does not hold them — it is not the Nobel Foundation portfolio.",
    jenModelace: "This is a model, not investment advice.",
    vstupyTitul: "What you draw from",
    vstupyPopis: "All amounts are real, in today's prices — returns are already above inflation and the income is not indexed.",
    kapital: "Capital to draw from",
    roky: "For how long",
    letPocet: "{n} years",
    alokace: "Portfolio allocation",
    vynosPortfolia: "Real portfolio return",
    paNadInflaci: "p.a. above inflation",
    akcie: "Equities",
    dluhopisy: "Bonds",
    penezniTrh: "Money market",
    scenar: "Return scenario",
    scenarModel: "Model return",
    scenarHistorie: "Actual history",
    scenarPoradi: "The same years reversed",
    scenarModelHint: "The same every year: {pct}. It shows the principle, not reality — markets never move like this.",
    scenarHistorieHint: "The years {od}–{do} exactly as they happened. Real, after inflation. It is not a forecast, only an answer to „what if it repeated“.",
    scenarPoradiHint: "The same set of returns, the same average — only the order is reversed. It shows sequence-of-returns risk.",
    startRok: "Start year",
    historieKratsi: "From {rok} the history covers only {let} years. A shorter run is computed — nothing is filled in by the model.",
    cpiNespolehliva: "The inflation series is flat for 1927–1946. Real returns from a start this old are therefore unreliable.",
    pokrocile: "Advanced settings",
    sazbaCerpani: "Withdrawal rate",
    startMantinelu: "Guardrail start rate",
    oknoLet: "Moving-average window",
    naStartuMes: "Monthly at the start",
    rozpetiRenty: "Income range",
    zbudePo: "Left after {let} years",
    celkemVyplaceno: "Total paid out",
    nejhlubsiPropad: "Deepest income drop",
    vRoce: "year {rok}",
    bezPropadu: "income never fell",
    kapitalDosel: "Capital ran out in year {rok}",
    pocetSkrtu: "{n} cuts",
    pocetZvyseni: "{n} raises",
    nadvyplata: "Over the whole horizon that is {castka} more than the fixed percentage.",
    cenaTitul: "What the higher starting income costs",
    cenaPopis: "Guardrails are not a „better 4 % rule“. You trade a small risk of running out for a moderate risk of deep cuts lasting many years.",
    cenaPridano: "Extra at the start",
    cenaOprotiPevnemu: "compared to the fixed percentage",
    cenaSkrtStitek: "The price of it",
    cenaSkrtVeta: "In year {rok} the income would have to be cut by {pct}",
    cenaSkrtZNa: "from {z} to {na} a month",
    cenaSkrtuCelkem: "{n} cuts over the whole horizon",
    cenaDno: "Deepest point: {pct} below the highest income (year {rok}) — {castka} a month",
    cenaBezSkrtuStitek: "No cuts in this scenario",
    cenaBezSkrtu: "That does not mean cuts would never be needed. Look at the documented years below — there they were.",
    cenaVycerpano: "In this scenario the capital would run out in year {rok}.",
    dolozenoTitul: "Documented on real years",
    dolozenoKdo: "Someone who started drawing in {rok}",
    dolozenoKratsi: "that is all the history there is",
    dolozenoDno: "income bottom −{pct}",
    dolozenoSkrty: "{n} cuts, first in year {rok}, bottom −{pct}",
    dolozenoBezSkrtu: "no cuts",
    dolozeno1966: "In the 1970s it was not only equities that lost — inflation ate bonds and the money market too. Diversification did not help then.",
    dolozeno2000: "The year 2000 was an equity problem. Bonds and the money market were earning then, so a portfolio holding them held up better.",
    dolozenoObecne: "The historical series from this start, real after inflation.",
    grafRenta: "Monthly income over time",
    grafRentaPopis: "This is what actually lands in the client account. In today's prices.",
    grafKapital: "Capital over time",
    grafKapitalPopis: "What is left in the account. Zero means the money ran out.",
    poradiTitul: "Sequence-of-returns risk",
    poradiPopis: "Same years, same average return — just in a different order. A crash early in the drawdown is a killer, because you sell at the bottom.",
    poradiVpred: "How the years {od}–{do} actually went",
    poradiVzad: "The same years reversed",
    poradiVyplaceno: "The client received in total",
    poradiKapital: "Left at the end",
    poradiDno: "Income bottom",
    poradiSkrtu: "Guardrail cuts",
    poradiZaverShoda: "The final capital comes out exactly the same, yet the client received {pomer}× different money in hand. The whole risk sits in the income, not in the account statement.",
    poradiZaverObecne: "The order of years changed the payout {pomer}×.",
    prehledTitul: "All historical starts",
    prehledPopis: "{n} runs of {let} years, covering {od}–{do}. Real, after inflation.",
    prehledSelhani: "Ended with nothing",
    prehledSelhaniPocet: "{n} of {celkem}",
    prehledZadne: "none",
    prehledMedianDno: "Typical income drop",
    prehledNejhorsiDno: "Deepest drop",
    prehledNejhorsiStart: "Worst start",
    prehledDoslo: "{rok} — ran out in year {kdy}",
    prehledPozor: "Zero failures is not proof of safety. With a fixed percentage you always take only a share of what is left — the account never empties, even if the income falls to almost nothing. So read the income drop next to the failure count.",
    pravniTitul: "What this page is and is not",
    pravni1: "A model, not investment advice. It does not assess the situation, knowledge or goals of any specific client.",
    pravni2: "Historical data is not a promise of future returns. Markets can fall, and they will.",
    pravni3: "A portfolio informed by the Nobel Foundation — not the Nobel Foundation portfolio. Nobel also holds alternatives (~20 %) and real estate (~9 %), which are absent here, and targets 3 % real.",
    pravni4: "All amounts are real, in today's prices. Returns are already above inflation and the income is not indexed.",
    pravni5: "The historical series is US data (equities, government bonds, treasury bills) converted to real returns using US inflation. A Czech portfolio behaves differently.",
  },
  manazerUi: {
    obnovit: 'Refresh',
    pozvankyDole: 'You will find the invitations you created below among the advisor cards — including the link and a ready-made message.',
    pridatPoradce: 'Add an advisor to the team',
    pridatPoradceHint: 'Enter the advisor\'s email. An invitation is created that they have to accept in their Settings — only then will you see their clients, pipeline, calendar and goals. We do not send the e-mail yet, so tell them.',
    vytvoritPozvanku: 'Create invitation',
    zadnyTym: 'No team yet',
    zadnyTymHint: 'Invite an advisor with the button above. They appear here as soon as they accept the invitation in their own Settings — until then you cannot see their data. After that you will see their performance and can assign them tasks.',
  },
  naborUi: {
    hledatKandidata: 'Search candidates…',
    nikdoSeNenasel: 'Nobody found',
    klikniAUvidis: 'Click to see who this is',
    coJeNabor: '📣 What recruiting is:',
    coJeNaborText: 'you attract experienced advisors away from competitors.',
    eyebrow: 'Recruiting pipeline',
    inProc: 'in progress',
    kpiPipe: 'In recruiting',
    krok1: 'add a candidate',
    krok2: 'fill in their numbers (production, network, client base) — we calculate the score 🔥',
    krok3: 'you send them an offer they cannot refuse, built on their own numbers',
    krok4: 'you drag the card through the pipeline all the way to “active”.',
    prvniKandidat: 'Add your first candidate',
    sub: 'Recruiting advisors from competitors · score = production × network × client base · drag the card between stages',
    title: 'Recruiting',
    zadnyKandidat: 'No candidates yet',
    zadnyKandidatHint: 'Start with one name from a competitor — someone you would like on your team. Add them, fill in their numbers and we will calculate how much they would gain by joining you.',
  },
  motivApp: {
    aktivni: 'Active',
    midnight: 'Dark — for evening work',
    violet: 'Bold, youthful, different',
    lime: 'Technical, high-contrast, sharp',
    cobalt: 'Cool accent on a warm surface',
    indigo: 'Clean, data-driven, fintech',
    legenda: 'App theme',
    sage: 'Warm, organic, reassuring',
    vybrat: 'Switch app theme to',
  },
  pojVar: {
    cena: 'Price first',
    cenaPopis: 'essential expenses, goals −60 %',
    narocna: 'Premium cover',
    narocnaPopis: 'goals and expenses in full',
    sablonaUpozorneni: 'Template amounts from advisory practice — an indicative example, not an offer or a guarantee. The advisor will confirm actual limits and prices with the insurer.',
    stredni: 'Golden mean',
    stredniPopis: 'goals −30 %, expenses unchanged',
    uskromnit: 'Cut back',
    uskromnitPopis: 'essential expenses, goals −50 %',
    variantaBezKratceni: 'the variant cuts GOALS, not the standard of living. Debts are never cut.',
  },
  davkyUi: {
    invalidI: 'Disability pension, level I',
    invalidIHint: 'partial limits on working',
    invalidII: 'Disability pension, level II',
    invalidIIHint: 'serious limits on working',
    invalidIII: 'Disability pension, level III',
    invalidIIIHint: 'full disability — you cannot work',
    nemocenska: 'Sick pay (from day 15)',
    nemocenskaHint: 'short illness / injury — 60 % of the reduced base',
    poznamka: 'Indicative estimate under the rules effective 1 Jan 2025. The figures change every January — the advisor will verify the current social-security numbers. Not a guarantee or an offer.',
    starobni: 'Old-age pension',
    starobniHint: 'estimate if you retired on today\'s income (no indexation)',
  },
  duchodCil: {
    nazev: 'Retirement — keep the same standard of living',
  },
  zdrojAnalyza: {
    naposledy: 'Last updated',
    vysvetleni: 'Carried over from the financial analysis. Amounts and the name are overwritten by the analysis; notes and the address stay with the advisor.',
    zaklad: 'from the analysis',
  },
  osaObchodu: {
    bezData: 'no date',
    bezDataHlavicka: 'No date',
    diar: 'calendar',
    dnes: 'Today',
    faze: 'stage',
    naplanovano: 'scheduled',
    poznamkaChyba: 'The change could not be saved',
    poznamkaDlouha: 'The note is too long ({delka} of max {max} characters).',
    poznamkaPrazdna: 'The note cannot be empty.',
    poznamkaUlozena: 'Note updated',
    prazdna: 'No activity yet. Add the first note below.',
    stav: { deleted: 'cancelled', detached: 'detached', done: 'done', planned: 'pending' },
    typ: { call: 'call', email: 'e-mail', note: 'note', sms: 'SMS', system: 'system' },
    ulozit: 'Save',
    upraveno: 'edited',
    upravenoTitul: 'Edited',
    upravitPoznamku: 'Edit note',
    zaznamu: 'records',
    zeZalozeni: 'from creation',
    zobrazitStarsi: 'Show older ({pocet})',
    zrusit: 'Cancel',
  },
  /* M13 · rizika samotného dítěte v Návrhu řešení — components/plan/DetskaRizikaBlok.js */
  /* BLOK:detiRizika START — generuje scratchpad/slovnik.py, ručně needitovat */
  detiRizika: {
    deti: 'Children ({n}×)',
    dite: 'Child',
    hlavicka: "children's policy",
    hlavickaKazde: 'amounts per child',
    hospitalizace: 'Hospital stay',
    hospitalizacePozn: 'for every night in hospital — the parent stays with the child instead of working, and the state benefit covers only part of it',
    kojenec: 'under 1 year old',
    naDite: ' / child',
    nadpis: 'Child protection ({n}×)',
    odskodne: 'Daily benefit while an injury heals',
    odskodnePozn: 'from the first day of treatment, no waiting period — recovery at home costs the parent more days at work',
    odskodneStrop: 'Daily benefits exceed the caring parent net daily income ({strop}) — above the underwriting limit, check with the insurer.',
    pc: 'Sum insured on the child policy',
    pcPozn: 'the two items above, capped at what insurers underwrite',
    radekTrvale: 'Permanent consequences and care',
    rodic: 'parent',
    sablona: 'TEMPLATE',
    sablonaPozn: 'The amounts are a template from advisory practice, not an offer or a guarantee. The advisor verifies the actual limits, exclusions and price with the insurer.',
    sekceTrvale: 'If the child needs permanent care',
    sekceVlastni: 'The child own risks — separate riders',
    stitekNadStropem: 'above the limit',
    stitekSablona: 'template',
    strop: 'The full need is {potreba}; on a child policy insurers underwrite roughly up to {strop}. The remaining {zbytek} belongs in the emergency fund and the investment plan, not in the policy.',
    tnu: 'Permanent consequences of an accident',
    tnuPozn: 'progressive payout in bands — in our model at most 2.8× the sum insured, insurers differ',
    uvod: 'A child has no income to insure yet. What gets insured is what actually costs the family money: the parent who has to stop working to care for the child, and the cost of treatment.',
    vekFew: '{n} years old',
    vekMany: '{n} years old',
    vekOne: '{n} year old',
    vypadekRodice: 'Lost income of the caring parent',
    vypadl: '{kdo} would stop working',
    vypadlAuto: '{kdo} would stop working — assumed, the parent with the lower income',
    zaDen: '/day',
    zaNoc: '/night',
    zavazne: 'Critical illness',
    zavazneBezZakladu: 'The caring parent has no income in the analysis — the advisor fills the amount in, the system does not invent it.',
    zavaznePozn: 'leukaemia, tumours, type 1 diabetes, epilepsy — a lump sum for treatment and so the parent can stay home with the child',
    zavazneStrop: 'The need calculated from the caring parent income is {potreba}; child policies cover roughly up to {strop}. The remaining {zbytek} belongs in the emergency fund.',
  },
  /* BLOK:detiRizika END */

  /* BLOK:zivotkoKalk START — generuje scratchpad/slovnik.py, ručně needitovat */
  zivotkoKalk: {
    celkemMesicne: 'Total per month',
    cenaNadpis: 'Cost of cover (premium)',
    cenaPopis: 'Enter the real monthly premium from the chosen insurer — the total cost of the protection is calculated.',
    cil: 'Goal',
    cilBydleni: 'Pay off the home',
    cilDuchod: 'Retirement',
    cilVzdelani: 'Children education',
    cileMale: 'goals',
    cilePlanNadpis: 'Goals — how much to invest monthly',
    cilePlanPopis: 'At a return of {vynos} % a year. The annuity converts to capital with a ×{nasobek} coefficient — that is {pct} % safe withdrawal per year (1 million = {koef}).',
    cilePripocet: 'The amount is added to the cover (death/disability). Financial independence = annuity → investment plan below (how much to invest monthly).',
    cileRodiny: 'Family goals',
    cileZadanych: 'Goals: entered',
    cilovaCastka: 'Target amount',
    cistyPrijem: 'Net monthly income',
    cistyPrijemMaly: 'net income',
    davkyNadpis: 'State benefits overview and income gaps',
    davkyPopis: 'How much the client really gets from the state — and how much is missing every month. An indicative estimate from income and age.',
    davkyPoznamka: 'An indicative estimate (the real social-security figure may differ). Fill in the age of the person for a closer estimate.',
    davkyPoznamkaKratka: 'An indicative estimate (the real social-security figure may differ).',
    den: 'day',
    denNaHlavu: 'day per person',
    denniDavkyPn: 'Daily benefit (sick leave)',
    dluhy: 'Debts (to be repaid)',
    dluhyMale: 'debts',
    dnesniHodnota: 'present value',
    do1Roku: 'within 1 year',
    grafNadpis: 'What is left when income drops',
    grafPopis: 'The green part is the cushion — what is left once the unavoidable bills are paid.',
    hned: 'right away',
    invDuchodPodleZakona: 'by law',
    invalidita: 'Disability',
    invalidniDuchodMaly: 'disability pension',
    invalidniDuchodMes: 'Disability pension / mo',
    jehoPodil: 'their share',
    klient: 'Client',
    likvidniRezerva: 'Liquid reserve',
    mesTecka: 'mo',
    mesZkratka: 'mo',
    mesicneInvestovat: 'Invest monthly',
    naXLet: 'for {roky} years',
    navrhOchrany: 'Family protection proposal',
    nazevCile: 'Goal name',
    nejvetsiDopad: 'Biggest impact',
    nemocenska: 'sick pay',
    nezbytneVydaje: 'Essential expenses / mo',
    odMesice: 'from month {n}',
    odPrvnihoDne: 'from day 1',
    odkazTitle: 'Send the client a link to this model',
    osoba: 'Person',
    osobaN: 'Person {n}',
    osobaPlaceholder: 'Person {n} — name',
    osvc: 'Self-employed',
    osvcPlne: 'Self-employed (no sick pay)',
    osvcVarovani: 'On sick leave they get nothing from the state → a higher need for sick-pay cover.',
    paramKoefRenty: 'Annuity coefficient',
    paramKoefRentyHint: '= {pct} % safe withdrawal per year · annuity → capital ×{nasobek} (a lower amount = a higher multiple)',
    paramNarust: 'Rise in expenses with disability',
    paramNarustHint: 'care, home adaptations, medication',
    paramPokles: 'Drop in expenses after a death',
    paramPoklesHint: 'the family spends less after losing a member',
    paramTnPrah: 'Permanent-injury threshold (payout from %)',
    paramTnPrahHint: 'below the threshold nothing is paid; full cover at about 60 %',
    paramVynos: 'Investment return (p. a.)',
    paramVynosHint: 'for calculating the monthly investment towards the goals',
    parametryMetodiky: 'Methodology parameters',
    patickaDavky: 'Social benefits (widow pension {vdovsky}{sirotci}, disability pension) are an INDICATIVE ESTIMATE from income — not a promise of the state. The advisor will verify the real amount.',
    patickaMetodika: 'Indicative recommended cover under the beplan methodology (methodology {verze}): disability/death by the capital method at a real 4 % — household expenses after the event minus the income the family keeps, minus state benefits. Sick leave = net income − sick pay. The actual premium and terms depend on the chosen insurer. The advisor has the final word.',
    patickaSirotci: ', orphan benefit total {castka}',
    pdfInvaliditaPopis: 'when you can no longer work',
    pdfJakRozumet: '<b>How to read this:</b> The figures show what the family would receive if the worst happened — so it can keep its home, keep its standard of living and the children can finish school. <b>Disability</b> carries a higher amount than death, because an ill person at home also needs care and home adaptations. <b>Sick leave</b> tops up the income gap during a short illness or injury.',
    pdfPaticka: 'A non-binding indicative proposal. We will agree the exact terms and prices together.',
    pdfPnPopis: 'a short illness or injury',
    pdfSmrtPopis: 'so the family has nothing to fear',
    pdfTitle: 'Download / print the client PDF',
    pdfTnuPopis: 'a more serious injury = a higher payout',
    pdfZavaznePopis: 'cancer, heart attack, stroke…',
    perex: 'Enter the family income and expenses → I will calculate the recommended cover: disability, death, sick leave, permanent injury and critical illness.',
    pnCelkem: 'The family needs sick-leave cover of',
    pnUraz: 'Sick leave / injury',
    pocetDeti: 'Number of children',
    podPrahem: '→ below the threshold',
    podilDluhu: 'share of the debts',
    podilNezbytnych: 'share of the essentials',
    pojistnaCastka: 'Sum insured:',
    poskozeni: 'impairment',
    poslatKlientovi: 'Send to client',
    potrebnyKapital: 'Capital needed',
    pozustalostniDavky: 'survivor benefits',
    pracNeschopnost: 'Sick leave',
    pracovniNeschopnost: 'Sick leave',
    prezentovat: 'Present',
    pridatCil: 'Add goal',
    pridatOsobu: 'Add person',
    prijemMaly: 'income',
    prijmyOstatnich: 'income of the others',
    procInvalidita: 'The income is gone for good and expenses GO UP (a carer, home adaptations). It often ruins a family faster than death — that is why it is number one.',
    procNadpis: 'Why this protection matters',
    procPn: 'Illness or injury for a few months: the state pays little (the self-employed get nothing). The daily benefit tops up the gap — at home you deal with recovery, not bills.',
    procSmrt: 'So that the breadwinner leaves the family security, not debts and a mortgage. The children finish school and the partner does not have to change their life.',
    procTnu: 'A serious accident means a permanent limitation. Progressive payout: the more serious the injury, the higher the lump sum for adaptations and living.',
    progresivni: 'progressive',
    renta: 'annuity',
    rentaMes: 'Annuity / mo',
    rezervaHint: 'lasts ~{mes} mo',
    rezervaPokryje: 'the reserve covers the first {mes} months, the benefit is proposed from month {odMes}',
    rodina: 'Family',
    sloupecChybi: 'Missing /mo',
    sloupecChybiMes: 'Missing / mo',
    sloupecDokryt: 'To cover with insurance',
    sloupecDostane: 'Gets from the state',
    sloupecSituace: 'Situation',
    sloupecStat: 'State /mo',
    sloupecStupen: 'Level',
    smrt: 'Death',
    stupneNadpis: 'Disability by level',
    stupneNota: 'The cover-with-insurance column is the capital that closes the gap for {roky} years.',
    stupnePopis: 'A higher level means a higher state benefit, but also a bigger loss of income → more to cover with insurance. III = full disability (cannot work), I = partial limitation.',
    tela: 'of the body',
    titul: 'Life insurance calculator',
    tnuNadpis: 'Permanent injury — progressive payout',
    tnuPrah: 'Paid from {prah} % of impairment, the full needed cover at about 60 %.',
    tnuVzorec: 'Payout = amount × multiple × %.',
    tnuZeCastky: 'From the sum insured',
    toJePctPrijmu: 'that is {pct} % of the family net income',
    trvaleNasledky: 'Permanent injury',
    trvaleNasledkyUrazu: 'Permanent injury from an accident',
    typCastka: 'Amount',
    typRenta: 'Fin. independence',
    uvodniZprava: 'Hello, here is a proposal for protecting your family — how much the family would need if something happened. Take a look and get in touch any time.',
    variantaKryti: 'Cover variant (death + disability)',
    variantaKrytiKratce: 'Cover variant',
    variantaSlovo: 'variant',
    vek: 'Age (years)',
    vekHint: 'for the state benefits overview',
    vekPrijem: '{vek} years · income {castka}',
    vydajeRodiny: 'family expenses',
    vyssiVydaje: 'expenses higher by {pct} % (care, adaptations)',
    waTitle: 'Send the proposal to the client via WhatsApp',
    xLet: '{n} years',
    xOsob: '{n} people',
    xRocniPrijem: '{n}× annual income',
    zaKolikLet: 'In how many years',
    zadejPrijem: 'Enter at least one income.',
    zajistitNa: 'Secure for (years)',
    zamestnanec: 'Employee',
    zavazneOnemocneni: 'Critical illness',
  },
  /* BLOK:zivotkoKalk END */
  rozvahaGraf: {
    bezOceneni: '{pocet} {polozka} still have no value — they are left out of the totals.',
    cisteJmeni: 'Net worth',
    cisteJmeniPod: 'what they own minus what they owe',
    coDluzi: 'What they owe',
    coVlastni: 'What they own',
    financni: 'Financial assets',
    nefinancni: 'Property and possessions',
    podilDluhu: 'Debt makes up {pct} % of the assets — the rest is truly theirs.',
    vecnyMajetek: 'Of that, physical assets',
    zavazky: 'Liabilities',
  },
  menaAnalyzy: {
    bezRazitka: 'This analysis comes from a time when the currency was not stored with the data — we read it as {mena}. The account works in {ucet} today.',
    neprepocitava: 'Amounts are NOT converted — they stay exactly as they were entered, the app has no exchange rate. The labels below show {symbol}. Verify the figures before you show them to the client.',
    pozor: 'Mind the currency.',
    ulozena: 'The analysis is stored in {mena}, the account works in {ucet} today.',
  },
  zivotkoGraf: {
    celyPrijem: '— the whole income',
    cenaDenne: '{castka} a day for each of the {hlav} family members.',
    cenaInvalidita: 'disability',
    cenaPctPrijmu: 'That is {pct} % of your income.',
    cenaPresahuje: 'It exceeds it — and we are not going to hide that.',
    cenaSablona: 'A ballpark estimate from our rate template — a TEMPLATE, not an offer. The insurer sets the exact price based on age and the health questionnaire.',
    cenaSmrt: 'death',
    cenaStrop: 'The cap of {pct} % of income = {castka}.',
    cenaVejde: 'It fits within it.',
    cenaZavira: 'This closes the gap you have just seen:',
    davkaInvalidIII: 'Disability pension',
    davkaNemocenska: 'Sick pay',
    davkaObecna: 'Benefit',
    davkaPozustalostni: 'Widow + orphan benefit',
    mesZkr: 'mo',
    mesZkratka: 'mo',
    nazevDnes: 'Today',
    nazevInvalidita3: 'Disability, level III',
    nazevMzda5: 'The boss cuts 5 %',
    nazevPn: 'A long illness',
    nazevSmrt: 'Death of the breadwinner',
    popisChybi: 'It is missing every single month.',
    popisDnes: 'This is what is left when everything is fine.',
    popisDnesNapjato: 'The budget is stretched already today — there is no cushion.',
    popisNastve: 'It will annoy you. But you can handle it yourself.',
    popisRezervaMesice: 'The reserve covers it for {mes} months.',
    popisRezervaZadna: 'There is no reserve for it at all.',
    popisZvladnete: 'You will manage. Saving and holidays will stop.',
    proporceNecerpa: 'The reserve is not touched — income and benefits cover the expenses.',
    proporceRezerva: 'Your reserve',
    proporceSchodek: 'With a shortfall of {castka} a month the reserve covers {pct} % of that period.',
    proporceStat: 'The state during illness — the support period',
    proporceStrop: 'Sick pay is capped at {dni} days.',
    proporceTrvani: 'Time left to retirement',
    proporceVek: '{vek} years old, {roky} years left to retirement ({duchodVek}).',
    vynechanoCena: 'The price step is skipped: the cost of cover has not been entered and cannot be estimated.',
    vynechanoHlavy: 'The daily breakdown is hidden: there is nothing to compute the number of family members from.',
    vynechanoMena: 'The chart is hidden: the app can only model Czech state benefits so far. Czech benefits divided by an exchange rate are not Slovak benefits.',
    vynechanoPoDuchodu: 'The step „how long it lasts“ is skipped: the main person is already at retirement age.',
    vynechanoPrijem: 'The chart is hidden: no income has been entered. Without income every step would be zero.',
    vynechanoVek: 'The step „how long it lasts“ is skipped: the main person has no age filled in.',
    vynechanoVydaje: 'The chart is hidden: essential expenses have not been entered. Without them there is nothing to measure the income against.',
  },
  navrhVystupy: {
    jednaStrana: '1 page',
    jednaStranaTitul: 'One-page plan',
    plnyPlan: 'Full plan',
    plnyPlanTitul: 'Full financial plan',
    poznamka: 'Note on the proposal',
  },
  slozkaKlienta: {
    adresyKontakty: 'Addresses and contacts',
    aktivita: 'Activity',
    analyza: 'Analysis',
    kraj: 'Region',
    mobil: 'mobile',
    nabor: 'RECRUITING',
    odhadPotencialu: 'Estimated client potential',
    prijmeniPriklad: 'Smith',
    sidloKlienta: 'Client address',
    stitky: 'Tags',
    vlastnik: 'Owner',
    vztahKlient: 'Client',
    vztahPartner: 'Partner',
    zalozkyKlienta: 'Client tabs',
    zdrojKontaktu: 'Contact source',
    zdrojLeadovac: 'Leadovač',
    zdrojReklama: 'Advertising',
  },
  duchodKarta: {
    aktualizovatCil: 'Update the goal',
    bezVeku: 'fill in the age, otherwise the saving horizon cannot be computed (and we will not guess it).',
    chceMitMesicne: 'Wants to have monthly',
    chybi: 'Missing',
    cilovyStandard: 'Target standard in retirement',
    daStat: 'The state gives',
    disclaimer: 'The state pension is an INDICATIVE ESTIMATE from income and age, without indexation — not a promise of the state. The target standard is the advisor choice, not a measurement. Amounts are in today money.',
    doDuchodu: '· {roky} years to retirement',
    duchodovyVek: 'Retirement age',
    kapitalRadek: 'capital {castka} · {roky} years · {vynos} % p. a.',
    mesicneOdkladat: 'Set aside monthly',
    nadpis: 'To retirement — keeping the standard of living',
    nahradiPct: 'replaces {pct} % of the net income',
    odPoradce: 'from the advisor',
    osoba: 'Person',
    poDuchodovemVeku: 'The age is already past retirement — there is no time left to save, the amount is needed right away.',
    popis: 'How much of the income the state replaces and how much the client has to add. The button turns this into a financial-independence goal.',
    prepsatDuchod: 'Overwrite the state pension',
    pridatJakoCil: 'Add as a goal',
    radekVek: '{vek} years · {castka}/mo',
    sablona: 'Template',
    standardHint: '% of today net income. Less than 100 %, because in retirement everything the client pays BECAUSE they work and save for a pension falls away.',
    statNeodhadujeme: 'We do not estimate the state pension here',
    statNeodhadujemeHint: 'the estimate only applies to Czechia. Enter the amount and I will compute the rest.',
    statPokryjeCely: 'the state covers the whole goal',
    statPokryvaPct: 'the state covers {pct} % of the goal',
    vekHint: 'an estimate, feel free to overwrite',
  },
  /* Srovnávač fondů (/srovnavac-fondu). Doplněno 23. 8. 2026 — klíče se
     volaly, ale nebyly v žádném slovníku, takže vietnamský i ukrajinský
     poradce viděl český fallback. */
  fondy: {
    export: {
      chyba: "The chart could not be prepared.",
      hotovo: "Downloaded.",
      pngChyba: "The PNG could not be created. Try SVG — it opens in a browser.",
      nese: "The image carries its source, date and disclaimer.",
      csvSrovnani: "Download comparison CSV",
      csvRady: "Download series CSV",
    },
    tabulka: {
      popisek: "Six criteria side by side. The app does not rank funds by quality and recommends none of them — the choice is the advisor's.",
    },
    prazdno: {
      nadpis: "There is no fund data in the catalogue yet",
      veta: "The comparator is ready — it is only waiting for data. Historical values are not copied here from charts; they are loaded by importing three CSV files as described in docs/penze/JAK-DODAT-DATA.md. An empty screen is more honest than invented numbers.",
      demo: "Show with demo data",
    },
    srovnavac: {
      nadpis: "Historical fund comparator",
      kotva: "The period is counted back from the last day of the supplied data, not from today — otherwise a five-year window would hold only four years.",
    },
    filtr: {
      obdobi: "Period",
      zobrazeni: "Show",
      jednotlive: "Individual funds",
      prumeryNapoveda: "The average is calculated only from funds that cover the whole period.",
      prumery: "Strategy averages",
      strategie: "Strategy",
      skupiny: "Investment groups",
      spolecnost: "Pension company",
      historie: "Shorter history",
      jenPlna: "Exclude funds without full history",
      zrusit: "Clear filters",
      prazdno: {
        nadpis: "No fund matches the filter",
        veta: "Try removing some of the constraints — or the catalogue does not contain such a fund yet.",
      },
    },
    vyloucene: "You excluded from the comparison:",
    varianty: {
      metrika: "COMPARE BY",
    },
    vyber: {
      nadpis: "How to choose a fund",
      veta: "The highest historical return is not a criterion. What belongs side by side is the client's horizon, volatility, how long a history the fund actually has, its size, the statutory SRI risk indicator and costs. The app shows numbers; only an advisor can judge which of them fit a particular client.",
    },
    prumery: {
      nadpis: "How the averages are calculated",
    },
    demo: {
      odznak: "DEMO DATA",
      veta: "Sample invented figures. Do not use with a client.",
      vysvetleni: "Nobody published these series — they are invented so that screens can be developed. They grow by the same percentage every year, which does not happen in reality. Real data is supplied by import; the guide is in docs/penze/JAK-DODAT-DATA.md.",
    },
  },

  penzeUi: {
    zaklad: { nominalne: "Nominal", dnesniCeny: "In today's money", nominalneKratce: "nominal", dnesniCenyKratce: "in today's money" },
    rada: { vlastni: "Your contributions", zamestnavatel: "Employer", stat: "State contribution", zhodnoceni: "Investment growth" },
    most: { vklad: "Your contribution", zamestnavatel: "Employer", strategie: "Strategy" },
    strategie: { konzervativni: "Conservative", vyvazena: "Balanced", dynamicka: "Dynamic", stare: "Old pension scheme" },
    cesta: { dnes: "Current setup", kombinace: "Combination DPS + DIP", zamestnavatel: "With employer" },
  },
  /* Personal insurance (Proposed solution + plan presentation). */
  /* BLOK:pojisteniOsob START — generuje scratchpad/slovnik.py, ručně needitovat */
  pojisteniOsob: {
    bezPrijmu: 'No dependent income — the household surplus covers the gap.',
    cena: '≈ Indicative premium',
    cenaCelkem: '≈ Indicative premium, all insured',
    denni: '/day',
    diteRozporText: 'The analysis contains a child row with no name and no date of birth. An orphan pension for a child who is not in the analysis would lower the sums insured, so this row was not counted. Add the child to the analysis, or delete the empty row.',
    diteRozporTitul: 'A child with no name is not counted',
    doplnitNarozeni: 'Add date of birth',
    invalidita: 'Disability (grade 2–3)',
    klient1: 'Client 1',
    klient2: 'Client 2',
    mesicni: '/mo',
    metodika: 'Capital method @ 4 % real: household spending after the event − the income the family keeps − state benefits, over {roky} years + debts ({dluhy}) + goals − liquid assets. The {varianta} variant counts goals ×{kCile} and {vydaje}; debts are never cut. The figures are a proposal — the adviser has the last word.',
    odskodne: 'Daily accident benefit',
    osvc: 'self-employed',
    partnerNespocteno: '{jmeno}: cover not calculated — date of birth missing',
    partnerNespoctenoText: 'The plan does not insure the partner or price their cover.',
    pn: 'Sick leave',
    pnPozn: 'from month {mesic} — until then the reserve holds',
    pnPoznNic: 'reserve plus sick pay cover the gap',
    pnPoznOsvc: 'from month {mesic} — until then the reserve holds',
    popisInvalidita: 'Disability means a long income gap the reserve cannot cover — and spending goes up on top (care, home adaptations). Financially a bigger risk than death.',
    popisOdskodne: 'An accident stops the income from day one — no waiting period. The daily benefit tops up the lost income for as long as the treatment lasts.',
    popisPn: 'A short income gap beyond the reserve: sick pay covers only part of the net income, the benefit tops the budget up. The first few months are held by the reserve, so a longer waiting period means a lower premium.',
    popisSmrt: 'Replaces the family income: it covers everyday spending, loan payments and goals already under way, so the family need not change its life overnight. Only up to financial independence; a decreasing sum is cheaper.',
    popisTnu: 'Permanent damage after an accident means permanently higher spending. Progressive payout in bands: the graver the consequences, the higher the payout (in our model at most 2.8× the sum insured — insurers differ).',
    popisZavazne: 'Cancer, heart attack, stroke: treatment takes months, income drops and costs rise. A lump sum lets the client stop working and recover without the family draining its reserve or investments.',
    prijem: 'income',
    rozporText: 'The second person has income {castka} filled in, but no name and no date of birth. Coverage for someone who is not in the analysis would not stand up in front of the client. Add the partner to the analysis, or correct the income.',
    rozporTitul: 'Second person is not calculated — not in the analysis',
    smrt: 'Death',
    titul: 'Personal insurance — sized to meet every goal',
    tnu: 'Permanent injury',
    tnuPozn: 'progressive payout in bands — in our model at most 2.8× the sum insured, insurers differ',
    tnuPrilepek: ' with progression',
    zavazne: 'Critical illness',
    zavaznePozn: '{nasobek}× annual income',
    zavaznePoznVyplata: 'A lump sum for the treatment and for the time the client cannot work.',
  },
  /* BLOK:pojisteniOsob END */
  /* ADVISOR MANUAL VALUES — overriding sums insured and prices in the proposal. */
  rucniPojisteni: {
    chip: "manual",
    upravit: "Edit manually",
    hotovo: "Done",
    vratit: "Back to calculated",
    system: "The system calculates {castka}",
    titul: "Override prices and sums with the real quote",
    vysvetleni: "Click the pencil next to any sum or price and enter what the client actually has arranged. The manual value is labelled and the calculated one stays next to it, so the difference can be shown or reverted at any time.",
    pocet: "{n} manual",
    vratitVse: "Revert everything to calculated",
    cenaOsoby: "Indicative premium",
    nezadanaVarianta: "No price entered for this variant",
    perVarianta: "Sums insured and prices are stored SEPARATELY FOR EACH VARIANT (currently {varianta}). Model the variants with the insurer and enter the sums and the price for each one — with the client you then switch between them and show the limit next to the price.",
    odhadSablona: "estimate from the rate template, not an insurer's quote",
    ukladam: "Saving manual values…",
    ulozeno: "Manual values saved",
    chyba: "The manual values could not be saved — try the Save proposal button",
  },
  /* BLOK:srovnaniPojisteni START — generuje scratchpad/slovnik.py, ručně needitovat */
  srovnaniPojisteni: {
    aspon: 'min.',
    celkem: 'Total',
    chybi: {
      cena: '{kdo}: no price is entered for the {varianta} variant. Model it with the insurer and write it in with the pencil on the Personal insurance card — the price is stored separately for each variant.',
      cenaBezVarianty: '{kdo}: no price is entered for the selected variant. Model it with the insurer and write it in with the pencil on the Personal insurance card — the price is stored separately for each variant.',
      cenaCastecna: 'A price is entered for only some of the people, so the total is partly an estimate. Add it with the pencil for the remaining people on the Personal insurance card.',
      cenaDetske: 'The proposal also includes a child policy and the app can only estimate its premium — the sum of the adults is therefore not the price of the whole proposal. Enter the total price from the insurer.',
      limitRizika: '{kdo}: the existing policy has no sum insured for {riziko}. Add it in the analysis on the policy.',
      platba: '{kdo}: the existing policy has no monthly payment — without it there is no way to say what they pay today.',
      platbaCastecna: '{kdo}: policies {smlouvy} have no monthly payment, so „pays today“ is lower than reality.',
      prirazeni: 'Policies {smlouvy} have risks entered without a person, so they are counted for the breadwinner. They split per person once you pick whose risks they are in the analysis (Insurance contracts → Risks in contracts).',
      smlouvaPartnera: 'Policies {smlouvy} are assigned to a partner who is not in the analysis — they are left out of the comparison.',
      smlouvaPartneraNespocteno: 'Policies {smlouvy} belong to the partner whose cover the plan did not calculate (date of birth missing) — they are left out of the comparison and the plan does not cancel them.',
      smlouvaSpolecnaBezPartnera: 'From the joint policies {smlouvy}, only the client’s part is counted — the partner is not in the analysis.',
      smlouvaSpolecnaNespocteno: 'Policies {smlouvy} may also cover the partner, whose cover the plan did not calculate (date of birth missing) — so the plan does not cancel them. Add the partner’s date of birth in the analysis.',
      zadneSmlouvy: 'The analysis has no insurance policy with a sum insured.',
    },
    dnesNekryty: 'not covered today',
    dnesNeplati: 'pays nothing today',
    domacnost: 'Household (both people)',
    doplnKde: 'Add it in the analysis: Liabilities and policies → Insurance policies → Risks in contracts → disability / death for the person. Only then can you show the client that the new limit is several times higher while the price is not.',
    doplnTitul: "Without the old policy's sum insured this is not a comparison, it is a price rise",
    doplnTlacitko: 'Add it in the analysis',
    hlavicka: {
      budePlatit: 'Will pay',
      nasobekCeny: 'Price',
      nasobekKryti: 'Cover',
      novy: 'New sum insured',
      platil: 'Pays today',
      puvodni: 'Sum insured today',
      riziko: 'Risk',
    },
    nezadano: 'not entered',
    novyNula: 'no cover proposed',
    podtitul: '{varianta} variant',
    poznamka: "„Will pay“ is the insurer's quote you entered manually for this variant — the app never fills it in from the rate template. An empty cell means not entered yet, not zero.",
    prirazenoZiviteli: 'risks without a person — counted for the breadwinner, specify in the analysis',
    riziko: {
      invalidita: 'Disability',
      smrt: 'Death',
    },
    titul: 'Before and after — what they have today and what they will have',
    vyhra: '{kdo}: the cover grows {pomer}× faster than the price.',
    zivitel: 'family breadwinner',
  },
  /* BLOK:srovnaniPojisteni END */
  /* POJIŠTĚNÍ MAJETKU A ODPOVĚDNOSTI (karta v Návrhu řešení).
     Násobek u odpovědnosti vůči zaměstnavateli je ZÁKONNÝ STROP a v každé zemi
     jiný (CZ 4,5× / SK 4×) — do vět chodí parametrem `{nasobek}`, NIKDY ho sem
     nepiš natvrdo. Zdroj předpisu drží lib/odpovednostZamestnavateli.js. */
  pojisteniMajetku: {
    titul: "Property and liability insurance",
    nemovitost: "Property",
    nemovitostPopis: "Insure the full value from the analysis — the sum insured equals the cost of building it again (beware of underinsurance).",
    domacnost: "Household contents",
    domacnostPopis: "Furniture, electronics, valuables. Estimate from what the client owns and adjust it with them.",
    odpovednost: "Personal liability",
    odpovednostPopis: "Damage you cause to others has no ceiling (injury, water damage, a knocked-down cyclist) — set the limit as high as possible.",
    zamestnavatel: "Liability towards the employer",
    zamestnavatelOsoba: "Liability towards the employer — {jmeno}",
    zamestnavatelPopis: "An employer can claim damages of up to {nasobek} times the average monthly earnings — the limit is derived from the gross salary. The cap does not apply to damage caused intentionally or under the influence of alcohol.",
    zamestnavatelPopis2: "A separate policy for the second person — the limit comes from THEIR gross salary, not from the household income. The same cap of {nasobek} times the average monthly earnings applies.",
    hrubaMzda: "Gross salary",
    limit: "Limit {nasobek}×",
    zdrojLimitu: "The multiple is a statutory cap, not our estimate: {predpis}. Verified {datum}. The basis is average monthly earnings — with bonuses it tends to exceed the gross salary, so treat the limit as a floor.",
    pravni: "Legal expenses cover",
    pravniPopis: "A lawyer and court costs in disputes — employment, neighbours, consumer.",
    nabidnout: "offer",
    nenabizet: "do not offer",
    osvcTitul: "Business — self-employed and company",
    osvcPodtitul: "The analysis shows business income or a company among the assets. Go through with the client what they really own and what would sink them.",
    podnikatelske: "Business insurance",
    podnikatelskePopis: "Professional liability, company property, business interruption. A household policy does not cover this — damage done on a job is not paid from it.",
    resit: "include",
    neresit: "skip",
    zasoby: "Stock",
    zasobyPopis: "Material, goods and work in progress in the warehouse and in the van. If the storage burns down, without this item the client gets nothing.",
    moviteVeci: "Movables and equipment",
    moviteVeciPopis: "Tools, machines, technology, premises equipment. Add up what the client would have to buy again to be able to work tomorrow.",
    odpovednostPodnikatele: "Business liability",
    odpovednostPodnikatelePopis: "Damage caused to a customer or a third party while doing business. Recommended minimum {limit} — one flooded shop or an injured customer easily runs over a million.",
    bezLimitu: "skip",
    mil: "m",
    odhadTitul: "Indicative total property premium",
    disclaimer: "An indicative estimate from a rate template — not an offer and not a price guarantee. The actual premium is confirmed by the adviser according to age, health, tariff, excess and the exclusions of the chosen insurer.",
    mesic: "/mo",
    patka: "Always with an excess — small losses are covered by the reserve and the policy is cheaper. Specific tariffs and exclusions are chosen by the adviser.",
  },
  /* Per-goal recommendation — system draft from plan numbers + advisor text. */
  /* HORIZONT CILE — jedno misto pro "hned" a pro sklonovani let (audit R13).
   * Do 25. 8. 2026 si horizont dopocitavalo osm mist a kazde jinak: rezerva
   * "hned" (roky = 0) byla na karte "za 1 let", v tisku "—" a na slajdu
   * "za 0 let". Sklonovani dela t.plural (Intl.PluralRules podle jazyka),
   * ne ceske pravidlo 1 / 2-4 / 5+ — jinak ukrajinstina cte "za 21 rokiv".
   * Trojice One/Few/Many musi byt ve vsech peti slovnicich. */
  /* SHRNUTI — ROZDELOVNIK PLANU (predloha majitele, obrazovka „Shrnutí“ z FIP).
   * Tri pocitadla nahore, radek na cil. Texty NIKDY netvrdi nulu tam, kde je
   * neznamo: „bez vkladu“ / „doplň termín cíle“ misto „0“ a misto „0 %“.
   * Presplneny cil se rika slovem („splněno · přebývá X“), ne minusem —
   * predloha psala −749 471 a majitel si to sam vytkl. */
  /* BLOK:shrnutiPlan START — generuje scratchpad/slovnik.py, ručně needitovat */
  shrnutiPlan: {
    azPoCilovemDatu: "after the goal's date — it does not count towards the target",
    bezCiluKde: 'Add them in the analysis under Goals — without a target amount a goal never enters the plan.',
    bezCiluTitul: 'The plan has no goals yet.',
    bezVkladu: 'no deposit',
    dnesPosle: 'the client sends {kc} today',
    doplnCastku: 'add the target amount',
    doplnTermin: "add the goal's date",
    doplnenoEnginem: 'added by the calculation',
    doraziPozdeji: 'of which {kc} arrives later',
    doraziVeVeku: 'of which {kc} arrives at {vek}',
    dorovnat: 'top up',
    dorovnatJednJak: 'Pins the monthly payment and the app works out the lump sum needed for the goal to be met in full.',
    dorovnatPravJak: 'Pins the lump sum and the app works out the monthly payment needed for the goal to be met in full.',
    editaceJak: 'The “Lump sum” and “Regular deposit” columns can be overwritten right in the row — the number you enter is taken out of the pot above and the app works out the other one. ↺ restores the calculated proposal.',
    financni: 'Financial assets',
    kapital: 'capital',
    mesicne: '/mo',
    nadKapacitu: "above the household's capacity",
    neboJednorazove: 'or {kc} as a lump sum',
    neboPravidelne: 'or {kc} per month',
    nedosazitelne: 'the goal cannot be closed',
    nefinancni: 'Non-financial assets',
    nefinancniJak: 'Property and the business. An inheritance is not counted in this figure — it is shown separately as a future asset. They reach the goals only as a future inflow (a sale) — you enter that in the Proposal under Meeting the goals.',
    nelzeInvestovat: 'Cannot be used for investing.',
    nezapojeno: 'Not in play',
    nezapojenoJak: 'Mutual funds, unit-linked policies, term deposits and foreign currency. The plan does not reallocate them as a lump sum, so they are in neither “Allocated” nor “Left”.',
    nicNeni: 'nothing more',
    plusKroky: '+ stepped increase ({n})',
    pocitam: 'Calculating the summary…',
    podtitul: 'Three pots at the top, one row per goal. Keep allocating until both read “Left 0”. The numbers are the same ones as in the Proposal — this screen is a second view of them and you allocate right here.',
    poradce: 'Advisor',
    poznPlaceholder: 'A note on this goal for the client…',
    poznPrebiji: 'overrides the system proposal in the outputs',
    poznZpet: 'back to the proposal',
    prebytek: 'Monthly surplus',
    prebytekNeznamy: 'The surplus is unknown — add the expenses in the analysis',
    prebyva: '{kc} to spare',
    precerpano: 'Overdrawn — the client does not have that much',
    pridatJenJedn: '← solved as a lump sum',
    pridatJenPrav: 'solved per month →',
    prideleno: 'Allocated',
    rezervaJednNelze: 'The plan builds the reserve from the sources and the surplus — no lump sum is pinned to it.',
    rezimJednorazove: 'Lump sum',
    rezimMesicne: 'Monthly',
    rezimOboji: 'Both',
    rezimZpet: 'calculated proposal',
    rozdano: 'All allocated — 0 left',
    schodek: 'Expenses and instalments exceed income — the plan cannot be paid for',
    splneno: 'met',
    systemBezVkladu: 'The system itself adds no extra lump sum.',
    thCil: 'Goal (what?)',
    thDosazeno: 'Value reached',
    thJedn: 'Lump sum',
    thKdy: 'In how many years? (when?)',
    thKolik: 'Amount (how much?)',
    thPozn: 'Note',
    thPrav: 'Regular deposit',
    thPridatJedn: 'Add as a lump sum',
    thPridatPrav: 'Add per month',
    titul: "Table — the plan's allocation sheet",
    tlacitko: 'Table',
    uklada: 'Saving…',
    ulozeniJak: 'Numbers save themselves — shortly after you stop typing and when you leave the page. “Saved” only lights up once the server has them. The Proposal stays alongside: the same plan, just in cards.',
    ulozeniSelhalo: 'Saving failed — the change is only on screen.',
    ulozeno: 'Saved',
    vkladNavic: 'on top of the sources',
    vysvetlivka: '“Add” = how much more it would take for the goal to be fully met, on top of what the plan already allocates to it. It is not a payment, it is the missing part. A goal that is met has a word here, not a number.',
    vysvetlivkaRezim: '“Add” is shown only in the column that matches how the goal is solved: a lump sum, or a monthly payment. When it is solved by both, the two numbers are ALTERNATIVES — either the lump sum, OR the monthly payment. Do not add them up: each one only holds if the other deposit stays as it is.',
    zPritoku: '+ {kc} from a future inflow',
    zadneZdroje: 'Nothing to allocate — the client has no free financial assets',
    zbyva: 'Left',
    zdrojeDoRentyJak: 'A pension plan or DIP can be cancelled, but it usually goes to a long-term goal. “To the pension income” sends it there — and if the client has no pension-income goal, to the goal with the longest horizon.',
    zdrojeDoRentyTitul: 'Building savings and pension',
    zdrojeDoRentyVyp: 'to the nearest goal',
    zdrojeDoRentyZap: 'to the pension income',
    zpetNaNavrh: 'Back to the proposal',
  },
  /* BLOK:shrnutiPlan END */
  /* POŘADÍ KROKŮ — JEDNO PRO CELOU APPKU (diktát majitele 24. 9. 2026).
     Kroky i jejich stavy drží lib/poradiKroku.js; tady jsou jen jejich názvy
     a věty. Čísla kroků se do textů NEPÍŠÍ — dopočítá je `poradiKroku(id)`,
     jinak by text po přeskládání lhal. Věty `chybi*` vidí JEN PORADCE na své
     obrazovce: je to jeho domácí úkol, ne text pro klienta. */
  /* BLOK:poradiKroku START — generuje scratchpad/slovnik.py, ručně needitovat */
  poradiKroku: {
    chybiMajetkove: 'Step {cislo} — property insurance: fill in and save the Property insurance card above.',
    chybiRezerva: 'Step {cislo} — reserve: fill in the essential expenses in the analysis. Without them there is no reserve target and the row would lie with a zero.',
    chybiTitulek: 'Steps left out of the table because the input is missing:',
    chybiZivotni: 'Step {cislo} — life insurance: with no income and expenses in the analysis there is nothing to calculate the sums insured from.',
    cile: 'Goals',
    cilePozn: 'invest the spare money regularly towards the goals and the passive income',
    dluhy: 'Clear the bad debt',
    dluhyPozn: 'expensive loans and credit cards go first — you pay the interest for sure, investment returns are not certain',
    majetkove: 'Property insurance',
    majetkovePozn: 'home, contents, car, liability — and business assets for the self-employed',
    na90Dni: 'Steps for the next 90 days',
    rezerva: 'Build the reserve',
    rezervaPozn: '3–6 months of essential expenses at hand, so the first unexpected repair does not stop the plan',
    slideZaver: '„These steps lead to your passive income and financial independence — in this order.“',
    tabMajetekCo: 'Insure property and liability ({kryti}) — roughly {cena} per month.',
    tabMajetekKdy: 'Right away',
    tabMajetekProc: 'A single loss on the property, or one caused to someone else, drags the whole plan under.',
    tabRezervaCo: 'Top the liquid reserve up to {cil} — {gap} short today.',
    tabRezervaCoFondy: 'Top the liquid reserve up to {cil} — {gap} short today, of which {fondy} is topped up from funds (selling mutual funds, ETFs or shares).',
    tabRezervaHotovo: 'Keep the {cil} reserve full — done.',
    tabRezervaKdy: 'Before investing',
    tabRezervaProc: 'A cushion for the unexpected. Without it the first breakdown is paid for by debt or by cashing an investment in.',
    ukolCile: 'Start regular investments of {castka} towards goals and passive income',
    ukolDluhy: 'Clear the bad debt — {castka} today',
    ukolMajetkove: 'Arrange property and liability cover — roughly {cena}',
    ukolOsoba: '{jmeno}: disability {invalidita}, death {smrt}',
    ukolOsobaBezInvalidity: '{jmeno}: death {smrt}',
    ukolRezerva: 'Top the reserve up to {cil} ({gap} short)',
    ukolRezervaFondy: 'Top the reserve up to {cil} ({gap} short — {fondy} topped up from funds)',
    ukolRezervaHotovo: 'The {cil} reserve is full — keep it that way',
    ukolZivotni: 'Arrange term cover — disability {invalidita}, death {smrt}',
    ukolZivotniBezInvalidity: 'Arrange term cover — death {smrt}; disability cover is not calculated without an income',
    ukolZivotniOsoby: 'Arrange term cover — {osoby}',
    ukolZivotniOsobyBezInvalidity: 'Arrange term cover — {osoby}; disability cover is not calculated without an income',
    uvod: '…but it takes doing something about it. In this order:',
    zivotni: 'Life insurance',
    zivotniPozn: 'cover disability and death well and cheaply — lost income must not sink the family',
  },
  /* BLOK:poradiKroku END */
  cilHorizont: {
    hned: "now",
    bezTerminu: "no target date set yet",
    zaOne: "in {n} year",
    zaFew: "in {n} years",
    zaMany: "in {n} years",
    rokOne: "year",
    rokFew: "years",
    rokMany: "years",
  },
  /* NAVRH — TABULKY „NASE DOPORUCENI" A „PRODUKTY" (audit R11).
   * Skladaji se ZIVE z aktualnich cisel planu; ukladaji se jen prepisy poradce.
   * Radky jednotlivych cilu tu nejsou schvalne — ty ma plan ve vlastni, taky
   * zive pocitane sekci (dopCil.*). Viz lib/navrhTabulky.js. */
  /* BLOK:navrhTabulky START — generuje scratchpad/slovnik.py, ručně needitovat */
  navrhTabulky: {
    alokaceCo: 'Invest according to the profile: equities {akcie} %, bonds {dluhopisy} %, cash {penize} %.',
    alokaceKdy: 'Now',
    alokaceProc: 'Allocation drives about 92 % of the outcome; inspired by the Norwegian fund and the Nobel Foundation.',
    alokaceZProfilu: 'The split at the start, derived from the profile chosen above in Goal solving. As the goal approaches, it gradually shifts towards safety.',
    davkyOdhadPodlePrijmu: 'An indicative estimate based on income — the very number the sums insured are derived from.',
    diverzifikaceCo: 'Diversify across currencies and regions (world index is about 72 % USA).',
    diverzifikaceKdy: 'Now',
    diverzifikaceProc: 'A steadier portfolio, protected against a local downturn.',
    dluhyCo: 'Clear expensive debt (currently {castka}).',
    dluhyKdy: 'As soon as possible',
    dluhyProc: 'You pay the interest for sure, investment returns are not certain.',
    pojisteniCo: 'Protect the income with insurance — disability {invalidita}, death {smrt} (decreasing sums).',
    pojisteniCoBezInvalidity: 'Protect with insurance — death {smrt} (decreasing sums). Disability cover is not calculated without an income; add an income.',
    pojisteniCoOsoby: 'Protect the income with insurance — {osoby} (decreasing sums).',
    pojisteniCoOsobyBezInvalidity: 'Protect with insurance — {osoby} (decreasing sums). Disability cover is not calculated without an income; add an income.',
    pojisteniKdy: 'Now',
    pojisteniProc: 'If the income stops, the family must not lose its standard of living or its goals.',
    produktAkcie: 'Equity ETF (world, MSCI World)',
    produktDluhopisy: 'Bond ETF (world)',
    produktPenize: 'Money market / savings account (reserve + cash)',
    upravenoPoradcem: 'edited by the advisor',
    zivyNavrh: 'system proposal — recalculated from the current plan figures',
    zpetNaNavrh: 'Back to the system proposal',
  },
  /* BLOK:navrhTabulky END */
  /* RESENI U POJISTKY — navrh systemu + text poradce (lib/doporuceniPojisteni.js).
   * Sklada se ZIVE z cisel srovnani „pred a po“; uklada se jen prepis poradce
   * (navrh.solver.doporuceniPojisteni). Zadny produkt ani pojistovna — je to
   * regulovany vystup (IDD), navrh rika CO chybi, ne u koho to sjednat. */
  dopPoj: {
    titul: "Insurance solution",
    podtitul: "The system drafts it from the comparison figures; the adviser has the last word.",
    domacnost: "Whole household",
    titulVystup: "What we recommend for insurance",
    odSystemu: "system draft",
    odPoradce: "advisor text",
    upravit: "Edit text",
    zpetNaNavrh: "Back to system draft",
    placeholder: "What we recommend to the client on insurance…",
    hint: "The system draft is assembled from the numbers in this comparison. The advisor has the final word — their text is printed into the plan and the client presentation.",
    prazdneVarovani: "An empty recommendation is not printed for the client. Go back to the system draft, or write your own text.",
    nicKRict: "There is nothing to build a recommendation from yet — fill in today's sums insured and the price of the variant.",
    rizikoSmrt: "Death",
    rizikoInvalidita: "Disability",
    bezSmlouvy: "The client has no policy with a sum insured today — income protection has to be built from scratch.",
    nekrytyRiziko: "{riziko}: no cover today, {novy} needed.",
    nekrytyRizikoBezCastky: "{riziko}: no cover today.",
    nizkyLimit: "{riziko}: today's {puvodni} is below the needed {novy} — {rozdil} short.",
    pokrytoRiziko: "{riziko}: today's {puvodni} covers the needed {novy}.",
    argument: "Cover grows ×{kryti}, price ×{cena}.",
    argumentVyhra: "Cover grows ×{kryti}, price only ×{cena} — disproportionately more cover for disproportionately less money.",
    brzdaLimit: "{riziko}: add today's sum insured to the analysis — without it there is no way to say what the client is missing.",
    brzdaNovy: "{riziko}: the selected variant has no sum insured calculated yet.",
    brzdaPlatba: "Add what the client pays for the current policies today — without it the price cannot be compared.",
    brzdaPlatbaCastecna: "One of the current policies has no premium filled in — the price comparison is therefore only partial.",
    brzdaCena: "Add the price of the selected variant — without it there is no way to say what the client will pay.",
  },
  /* REZERVA — na kolik mesicu (majitel 25. 9. 2026: „rezerva bud 3 - 6 - 12
   * mesicu, no to je jedno“). Jeden prepinac, tri volby: pocet mesicu plati na
   * CELY zaklad, tedy nezbytne vydaje i splatky. Prepinac stoji u cile rezervy,
   * ne v nastaveni; volby 18 / 24 / 36 se zrusily i s rozdelenym zakladem. */
  rezervaMesicu: {
    titul: "Reserve for",
    m3: "3 months",
    m6: "6 months",
    m12: "12 months",
    hint: "How long the reserve lasts. It is counted from essential expenses and loan payments — in a crisis both keep running.",
  },
  /* ZTRATA Z PREDCASNEHO ZRUSENI PENZIJKA (planSolver, ztrata.kody).
   * ZADNE CISLO — engine nezna sazbu ani kolik uz klient dostal, takze veta
   * mluvi o tom, CO se vraci, nikdy o kolik. */
  ztrataPenzijka: {
    titul: "What taking it early costs",
    statniPrispevek: "Cancelling early means paying back the state contributions.",
    danovaVyhoda: "Cancelling early means paying back the tax relief already claimed.",
    druhNeznamy: "One of the contracts has no product type selected (DPS / DIP) — add it so it is clear what exactly the client loses.",
  },
  /* BLOK:dopCil START — generuje scratchpad/slovnik.py, ručně needitovat */
  dopCil: {
    brzdaBezCastky: 'The goal has no amount — fill it in inside the analysis.',
    brzdaBezHorizontu: 'The goal has no horizon — fill in how many years the client wants it in. Without it the goal cannot be budgeted or put into the plan.',
    brzdaKapacita: 'Careful: {prav} per month is above the free household surplus ({kapacita} per month) — either a longer horizon, a lower goal, or room in the budget.',
    brzdaNedosazitelne: 'With this setting the goal does not work out even at the maximum contribution — a longer horizon or a lower amount is needed.',
    hint: 'The system draft is assembled from the numbers in this plan. The advisor has the final word — their text is printed into the plan, the one-page plan and the client presentation.',
    jakGlide: 'Invested: first year {start}, last year {konec} (equities/bonds/cash) — the risk is switched off towards the end.',
    jakJedn: 'Solution: {jedn} up front, nothing extra per month.',
    jakNic: 'Solution: the money you already have covers the goal without further contributions.',
    jakNicNevychazi: 'Solution: there is nothing to fund this goal with yet — the plan has allocated neither a lump sum nor a monthly amount.',
    jakOboji: 'Solution: {jedn} up front and {prav} per month.',
    jakPrav: 'Solution: {prav} per month.',
    jakRenta: 'The retirement portfolio {alokace} (equities/bonds/cash) is kept during the drawdown as well — the income comes from returns.',
    jakRezerva: 'The reserve is not invested — it belongs in a savings account so it is available from one day to the next.',
    jakStabilni: 'Invested {start} (equities/bonds/cash) for the whole horizon.',
    nicKRict: 'Nothing to build a recommendation from yet — fill in the goal amount and horizon.',
    odPoradce: 'advisor text',
    odSystemu: 'system draft',
    placeholder: 'What we recommend to the client for this goal…',
    prazdneVarovani: 'An empty recommendation is not printed for the client. Go back to the system draft, or write your own text.',
    titul: 'Recommendation for this goal',
    titulVystup: 'What we recommend for each goal',
    upravit: 'Edit text',
    vysledekChybi: 'In {roky} years that comes to {konec} — {chybi} is missing ({pct} % of the goal).',
    vysledekChybiHned: 'Within a year that comes to {konec} — {chybi} is missing ({pct} % of the goal).',
    vysledekOk: 'In {roky} years that comes to {konec} — the goal is covered at {pct} %.',
    vysledekOkHned: 'Within a year that comes to {konec} — the goal is covered at {pct} %.',
    zadaniBezne: 'Goal {cil} in {roky} years.',
    zadaniBezneBezLet: 'Goal {cil}.',
    zadaniHypo: 'Own funds {cil} in {roky} years (option {varianta}). The instalment is then {splatka} per month.',
    zadaniHypoBezLet: 'Own funds {cil} (option {varianta}). The instalment is then {splatka} per month.',
    zadaniRenta: 'An income of {renta} per month means capital of {cil} — 4 % of it can be drawn every year indefinitely. Horizon {roky} years.',
    zadaniRentaBezLet: 'An income of {renta} per month means capital of {cil} — 4 % of it can be drawn every year indefinitely.',
    zadaniRezerva: 'Liquid reserve {cil} — a cushion for unexpected costs. It comes before investing.',
    zdroje: 'Up front from: {zdroje}.',
    zdrojeFondyRezerva: 'The missing {fondy} is topped up from funds — selling mutual funds, ETFs or shares the client already has.',
    zpetNaNavrh: 'Back to system draft',
  },
  /* BLOK:dopCil END */
  /* ── boLab — NÁHLED MOTIVU „beplan“ (design-lab/beplan-orange) ───────────
   * Texty interní náhledové stránky /design-lab/beplan-orange. NENÍ v produkční
   * navigaci a NEPŘEBARVUJE aplikaci — tokeny motivu jsou zavřené v `.bo-scope`
   * (frontend/src/design-lab/brand-orange/motiv.css).
   * Klíč po klíči shodné ve všech pěti jazycích (214 klíčů) — hlídá
   * design-lab/brand-orange/__tests__/klicePetJazyku.test.js.
   * ⚠️ Barva se jmenuje neutrálně „brand oranžová“. Pracovní název ze zadání se
   * nepoužívá: koliduje s historickým pojmem z války ve Vietnamu a aplikaci
   * používají vietnamští poradci i klienti.
   * ──────────────────────────────────────────────────────────────────────── */
  boLab: {
    boLab: {
      cil: {
        brzda: "Plan brake",
        brzdaText: "The goals ask for",
        brzdaText2: "but the free surplus is only",
        brzdaText3: "Short by",
        bydleniText: "Czech National Bank: under 36 you only need 10 % of your own funds (LTV 90 %). On a price of 4 500 000 Kč that is 450 000 Kč.",
        chybi: "Short by",
        cilova: "Target amount",
        cilu: "goals",
        dnes: "Today",
        historie: "Change history",
        hned: "now",
        let: "years",
        mesicne: "Monthly",
        plneni: "Progress",
        prebytek: "Free surplus",
        prepocitat: "Recalculate plan",
        prijem: "Net income",
        rezervaText: "The reserve covers barely 2 months of spending instead of the recommended 6. Until it is built, raising investments makes no sense.",
        rozdeleno: "Allocated",
        srovnat: "Rebalance priorities",
        stavNevime: "Unknown",
        stavNevychazi: "Falls short",
        stavSplneno: "Works out",
        stavTesne: "Tight",
        titul: "Plan — goals",
        upravit: "Edit goal",
        zaHorizont: "At horizon",
        zbyva: "Left over",
      },
      jedMes: "/mo",
      klient: {
        bezneVydaje: "Regular spending",
        chybiPrijemPartnera: "Partner income missing",
        chybiUdaje: "3 fields missing",
        cistyPrijem: "Net income",
        deti: "Children",
        domacnost: "Household",
        dopad: "What this means",
        dopadHorniOdhad: "upper estimate — nobody has looked up the state benefit yet.",
        dopadText: "Disability level 3 wipes out the whole income. Cover is short by roughly",
        dps: "Pension savings",
        fazeRealizace: "Stage: Execution",
        hotovo: "Complete",
        invalidita: "Disability level 3",
        investice: "Investments",
        jmeno: "Name",
        kOvereni: "To verify",
        klientOd: "client since",
        let: "years old",
        majetekZavazky: "Assets and liabilities",
        mezera: "Gap",
        narozeni: "Date of birth",
        nekryto: "not covered",
        overeno: "verified",
        partner: "Partner",
        pn: "Sick leave",
        pojisteni: "Insurance",
        prijemPartnera: "Partner income",
        prijmyVydaje: "Income and spending",
        rezerva: "Liquid reserve",
        roky: "years",
        sdeleno: "stated",
        sekce: "Client sections",
        servis: "Service 14 Nov 2026",
        smrt: "Death",
        splatkyUveru: "Loan payments",
        spotrebitelsky: "Consumer loan",
        statniDavka: "State disability pension",
        stavSmlouva: "Under contract",
        telefon: "Phone",
        telefonPartner: "Partner phone",
        tisk: "Print",
        ulozit: "Save",
        zalozkaAnalyza: "Analysis",
        zalozkaDokumenty: "Documents",
        zalozkaHistorie: "History",
        zalozkaObchody: "Deals",
        zalozkaPlan: "Plan",
      },
      lab: {
        coJeVidet: "What this screen shows",
        dnes: "Today",
        dnesBezTmave: "Today has NO dark variant — the app has none, so the left side stays light. This is not a bug in the preview.",
        dnesPopis: "Sage & Clay — what the advisor sees now",
        jenDnes: "Today only",
        jenNavrh: "Proposal only",
        miraTitul: "Content width vs frame width. When content overflows, the page goes into horizontal scroll.",
        motiv: "Theme",
        navrh: "Proposal",
        navrhPopis: "brand orange + navy — light",
        navrhPopisTmava: "brand orange + navy — dark",
        notebook: "Laptop 1440",
        obrazovky: "Screens",
        odznak: "Preview — the app is unchanged",
        preteka: "overflows",
        sedi: "fits",
        sirka: "Width",
        svetla: "Light",
        telefon: "Phone 390",
        titul: "Design Lab · beplan theme",
        tmava: "Dark",
        vedleSebe: "Side by side",
        zobrazeni: "View",
        zpet: "Back",
      },
      login: {
        claim: "A financial plan the client actually understands.",
        claimSub: "Analysis, plan and service in one place — for the advisor and for the client.",
        email: "E-mail",
        heslo: "Password",
        prihlasit: "Sign in",
        sso: "or with a company account",
        zalozkaPrihlaseni: "Sign in",
        zalozkaRegistrace: "Register",
        zapomenute: "Forgot password",
        zpusob: "Sign-in method",
      },
      mesic: {
        cerven: "J",
        cervenec: "J",
        kveten: "M",
        rijen: "O",
        srpen: "A",
        zari: "S",
      },
      nastenka: {
        bj: "Points (BJ)",
        bjZPlanu: "BJ of the monthly plan",
        diar: "Calendar — today",
        dnesUkoly: "5 tasks today",
        kpi: "Key numbers this month",
        mezera: "Gap",
        mezeraText: "Hájek — disability level 3 not covered.",
        mezeraText2: "Dvořáková — reserve under 2 months of spending.",
        nadKapacitu: "The plan is above the household capacity.",
        novyKlient: "New client",
        obchodu: "9 deals",
        pipeline: "Pipeline",
        plneniPlanu: "Plan progress",
        poTerminu: "11 days overdue",
        podtitul: "Tuesday 25 August · 3 meetings · 2 overdue tasks",
        prebytek: "Plan in progress — Hájek",
        prilezitosti: "Opportunity radar",
        provize: "Commission",
        radar: "Service radar",
        rozdeleno: "Allocated to goals",
        rust: "+18 %",
        titul: "Good morning, Mr Čung",
        typPlan: "Plan",
        typPrvni: "First meeting",
        typServis: "Service",
        ukoly: "Overdue",
        vejdeSe: "Fits within the surplus.",
        volnyPrebytek: "Free surplus",
        vyplaceno: "paid 15 Aug",
        vyvoj: "Deal trend",
        zPlanu: "68 % of plan",
        za2mesice: "service in 2 months",
        za3tydny: "service in 3 weeks",
        zbyva: "6 working days left this month.",
      },
      nav: {
        diar: "Calendar",
        hlavni: "Main navigation",
        klienti: "Clients",
        nastenka: "Dashboard",
        nastroje: "Tools",
        obchody: "Deals",
        plan: "Plan",
        poradce: "Mr Čung",
      },
      nevyplneno: "not filled in",
      neznamo: "unknown",
      obrazovka: {
        cil: "Goal card",
        klient: "Client card",
        nastenka: "Dashboard",
        prihlaseni: "Sign in",
        verejna: "Public page",
        vystup: "Client output",
      },
      pozn: {
        cil: "The most complex screen. Four goals of the sample client, a capacity brake at the top (the plan is 5 300 Kč a month above what the household can afford) and problem, impact, step under the numbers.",
        cilSazba: "The only place in the preview where the layout differs too, not just the colours. Switch the width to Phone 390 and compare the meters above the panels.",
        klient: "Form density. Field borders, legibility of small labels and above all the difference between not filled in and zero: empty fields are dashed and amber, not zero.",
        nastenka: "How much orange a screen can carry. The rule: one saturated orange surface per screen (the New client button). States are green, amber, red and blue as dark text on a light tint — action and state then differ by shape, not only colour.",
        prihlaseni: "First impression. Logo, orange button, underlined active tab. The beach photo from the reference is replaced by a navy surface with the arrow from the logo — text over a photo sits on unknown lightness, so contrast cannot be guaranteed.",
        verejna: "What the client sees first. The only screen where orange may be large — it is a brand surface, not a control. The text on it is navy, not white.",
        vystup: "The strictest place in the theme. Paper stays white even in dark mode, orange on it is always the darker shade, and every bar carries a number and a word next to it so black-and-white printing loses nothing.",
      },
      vystup: {
        castka: "Amount",
        chybi: "short by",
        cil: "Goal",
        disclaimer: "Recommendations are based on data provided by the client as of the processing date. This is not investment advice nor a promise of return. The models shown are indicative.",
        eyebrow: "Financial plan",
        kdeJsteDnes: "Where you stand today",
        mesice: "months",
        mesicneCelkem: "Monthly total",
        pokryto: "covered",
        poslat: "Send to client",
        prebytek: "Free surplus",
        prijem: "Net income",
        prvniKrok: "First step",
        prvniKrokText: "Top the liquid reserve up to 168 000 Kč. Until then the reserve comes before investing — without it any unexpected expense breaks the rest of the plan.",
        rezervaMa: "Reserve lasts",
        splneniCilu: "Progress on your goals",
        tisk: "Print / save PDF",
        vaseCile: "Your goals",
        vytvoreno: "Prepared by Mr Čung · 25 August 2026",
      },
      web: {
        claim: "Let your money follow a plan, not chance.",
        claimSub: "The first meeting is free and without obligation. It takes about 30 minutes, online via Google Meet.",
        oMne: "About me",
        online: "Online, 30 minutes",
        otazky: "Questions",
        reference: "References",
        referenceSablona: "Space for references the advisor fills in personally. The preview deliberately leaves it empty — an invented reference with a name is a legal risk.",
        rezervace: "Booking",
        rezervovat: "Book a meeting",
        role: "Your financial advisor",
        sCimPomuzu: "What I can help you with",
        sluzba1: "Reserve and budget",
        sluzba1Sub: "So an unexpected expense cannot knock you down.",
        sluzba2: "Your own home",
        sluzba2Sub: "How much you need and when it works out.",
        sluzba3: "Income and independence",
        sluzba3Sub: "How much to set aside so that one day it is enough.",
        sluzby: "Services",
        volneTerminy: "Free slots this week",
        vyberTermin: "Pick a meeting time",
        vybratTermin: "Pick a time",
        zdarma: "Free",
      },
    },
  },
  rezSmlouva: {
    nazev: 'Reservation agreement',
    podnadpis: 'Fill in the heading, the price and the deposit. The rest is filled in for you and the system checks the contract before you print it.',
    zpetNaZakazku: 'Back to the listing',
    jizRozepsane: 'This property already has an agreement in progress:',
    bezKupujiciho: 'no buyer yet',
    vzorLabel: 'Contract template',
    pracovniVzor: 'Working template — not yet approved by a lawyer. Do not use it with a client yet.',
    skupina_penize: 'Money and term',
    skupina_hlavicka: 'Heading',
    skupina_strany: 'Parties',
    skupina_nemovitost: 'Property',
    skupina_kancelar: 'Agency',
    skupina_ostatni: 'Other details',
    doplneno: 'filled in',
    vyber: '— choose —',
    ano: 'Yes',
    ne: 'No',
    neniVyplneno: 'not filled in',
    odvozeneNadpis: 'Calculated by the system',
    slovyPopis: 'The amount in words, the balance and the end of the reservation are written by the system, so they cannot drift from the figures.',
    odvozene_kupni_cena_slovy: 'Purchase price in words',
    odvozene_blokacni_poplatek_slovy: 'Deposit in words',
    odvozene_doplatek: 'Balance of the price',
    odvozene_doplatek_slovy: 'Balance in words',
    odvozene_rezervace_do: 'Reservation valid until',
    kontrolaNadpis: 'Check before printing',
    kontrolaCisto: 'Nothing found. You can print.',
    kontrolaBlokuje: 'Printing stays closed until you fix this.',
    pocitam: 'Calculating…',
    nahledNadpis: 'Contract preview',
    ulozit: 'Save',
    ulozeno: 'Saved',
    vytisknout: 'Print',
    podepsano: 'Mark as signed',
    jePodepsana: 'Signed',
    podepsanaZamek: 'a signed contract can no longer be edited',
    advokat: 'E-mail to the lawyer',
    advokatHotovo: 'The message is only prepared. Send it from your own e-mail together with the attachment.',
    zkopirovat: 'Copy',
    zkopirovano: 'Copied',
    nejdrivUloz: 'Save the contract first.',
    tiskZablokovan: 'The browser blocked the print window. Allow pop-ups and try again.',
    chybaNacteni: 'Could not load. Try again.',
    chybaUlozeni: 'It was not saved.',
    chybaKopie: 'Copying failed.',
  },

  /* BLOK:izp START — generuje scratchpad/slovnik.py, ručně needitovat */
  izp: {
    argumenty: {
      jak1: 'You pay a single monthly amount. Part of it pays for the cover, the rest goes into the investment component.',
      jak2: 'The scope of cover can be changed over time — add a risk, raise or lower the sum insured.',
      jak3: 'The investment component can usually be withdrawn from or reduced. Notice periods and conditions differ from contract to contract.',
      jak4: 'The contract can be terminated. What exactly is paid out in that case is set by its own conditions.',
      jak5: 'If the income changes, how much goes to protection and how much to investment can be adjusted as well.',
      jakNadpis: 'How it generally works',
      nadpis: 'Why have it and how it generally works',
      nasobekCeny: 'price ×{x}',
      nasobekKryti: 'cover ×{x}',
      oci: 'Arguments',
      pomerChybi: 'For each risk, fill in what the client has today — the cover and the price. Without that the cover-to-price ratio cannot be calculated.',
      pomerNadpis: 'Cover against price',
      pomerNejslabsi: 'The weakest of the compared risks is used (count: {pocet}).',
      pomerVyhra: 'The cover rises faster than the price.',
      pomerZdroj: 'Calculated from the risks where both the current and the new cover are entered (count: {pocet}). The weakest risk is used, not the best one.',
      popis: 'A general principle, not the conditions of any particular contract.',
      potvrdiKratce: 'A general principle, not the terms of a specific contract. What the contract allows will be confirmed by the adviser from the quotation.',
      potvrdiText: 'This is a general principle, not the conditions of any particular contract. What a contract actually allows — changes, withdrawals, termination and the conditions attached to them — will be confirmed by the adviser from the specific quotation.',
      potvrdiTuk: 'What the adviser confirms',
      proc1: 'Income is what keeps a household running. If it stops, the outgoings stay — and some of them grow.',
      proc2: 'The state covers only part of it, and not straight away. The rest is left to the family.',
      proc3: 'Commitments are not paid out of resolve but out of money. The mortgage carries on even when the income does not.',
      proc4: 'Protection and saving are handled by one amount, which you split yourself.',
      procNadpis: 'Why have it',
    },
    davka: {
      pozustalostni: 'Survivors’ pensions — widow’s and orphan’s',
    },
    diagnoza: {
      detskeChronicke: 'Chronic conditions arising in childhood, for example type 1 diabetes or epilepsy',
      detskeNadory: 'Childhood cancers, for example leukaemia',
      infarkt: 'Heart attack (myocardial infarction)',
      mozkovaPrihoda: 'Stroke (cerebrovascular accident)',
      nadory: 'Cancer',
      neurologicka: 'Neurological conditions — multiple sclerosis, Parkinson’s and Alzheimer’s disease',
      ochrnuti: 'Paralysis following injury or illness',
      operaceSrdce: 'Surgery of the heart and major arteries',
      selhaniOrganu: 'Organ failure — kidneys, liver, respiratory system',
      smysly: 'Loss of sight, hearing or speech',
      transplantace: 'Transplant of a vital organ',
      zenska: 'Conditions affecting women only, and complications in pregnancy',
    },
    diagnozy: {
      deti: 'A child policy has a different list — it covers the diagnoses that appear in childhood.',
      nadpis: 'Which illnesses are covered',
      smlouva: 'The exact list of diagnoses, their definitions, stages and waiting periods is set by the insurance policy and differs from one insurer to another. We will go through what is covered in your case in the policy terms and conditions.',
      uvod: 'These are the groups of diagnoses most often discussed in connection with critical illness.',
    },
    graf: {
      aria: 'Chart: you pay {zaplaceno} in total, of which {investice} is invested. Model value of the investment after {roky}: {hodnota}. A model, not a guarantee.',
      celkemVlozeno: 'Total paid in',
      dnesnimiOcima: 'In today’s money {hodnota} (inflation {inflace})',
      hodnotaVModelu: 'Investment value in model',
      horizonty: {
        d: {
          hodnota: 'Model value',
          nasobek: 'Multiple of payments',
          vlozeno: 'Paid in',
          vlozenoPoplatek: 'of which fee {poplatek}',
          vynos: 'Of which return',
        },
        detailNadpis: 'After {roky}',
        maStitek: 'has',
        nadpis: 'The longer, the more',
        oci: 'Time',
        poPoplatkuStitek: 'paid in after fee',
        predpoklad: 'At a model return of {vynos} a year',
        sloupec: '{roky}: model value {hodnota}, paid in {vlozeno}',
        vlozenoStitek: 'paid',
        vrstvy: {
          nadpis: 'The power of compounding',
          vklady: 'Payments',
          vkladyPoPoplatku: 'Payments after fee',
          zVkladu: 'Return on payments',
          zVynosu: 'Return on returns',
        },
        vyber: 'Choose how many years',
      },
      konec: {
        hodnota: 'Model',
        investice: 'Invested',
        zaplaceno: 'Paid',
      },
      krivka: {
        hodnota: 'Model value',
        investice: 'Invested',
        ochrana: 'Protection (not returned)',
        zaplaceno: 'Paid in total',
      },
      legendaHodnota: 'Modelled value',
      legendaVlozeno: 'Paid in',
      milnik: {
        kratce: {
          plnoletost: '18',
          vysoka: 'Uni',
        },
        plnoletost: '{jmeno}: 18',
        vysoka: '{jmeno}: university',
      },
      modelText: 'The chart is a model calculation based on the amount entered and the rate of return selected. Future returns are not guaranteed; actual performance may be lower or higher. The specific solution will be confirmed by your adviser.',
      modelTuk: 'A model scenario, not a guarantee',
      modelovaHodnota: 'Modelled value',
      modeloveZhodnoceni: 'Modelled growth',
      nadpis: 'What happens to the investment part by the selected age',
      oci: 'Chart',
      osaRok: 'Year {rok}',
      osaVekKonec: 'age {vek}',
      popis: 'Choose an age and an expected rate of return. The chart shows a modelled path, not a guaranteed outcome.',
      poplatek: {
        naKonci: 'At the end',
        naKorunu: 'Per 1 {symbol} paid in',
        nadpis: 'Three ways to pay the fee',
        navic: 'incl. {poplatek} fee paid extra up front',
        oci: 'Entry fee',
        pole: 'Entry fee (% of the target amount)',
        poleHint: 'usually {min}–{max} %',
        poslano: 'Total money paid in',
        radek: {
          expres: 'Fee {poplatek} · from payments ({mesicu} mo.)',
          expresHned: 'Fee {poplatek} · paid extra upfront',
          pulNaPul: 'Fee {poplatek} · half from payments ({mesicu} mo.)',
        },
        souhrn: '{pct} of the target amount {cilova} is {poplatek}',
        varianta: {
          expres: {
            nazev: 'Express from payments',
            popis: 'The whole payment goes to the fee until it is paid off ({mesicu} mo.).',
          },
          expresHned: {
            nazev: 'Pay up front',
            popis: 'Fee paid separately; the whole payment is invested from month one.',
          },
          pulNaPul: {
            nazev: '50/50 from payments',
            popis: 'Half of each payment to the fee, half invested right away ({mesicu} mo.).',
          },
        },
        zToho: 'of which {poplatek} goes to the fee',
      },
      poradcePozn: 'Switch the age and the return in front of the client — let them see how the figure changes.',
      priVynosu: 'At a return of {vynos}',
      rizika: {
        deti: 'Children',
        doplnte: 'add in Risks',
        doporucene: "Recommended cover calculated from the family's figures. The adviser adjusts the risks and exact amounts under Risks.",
        klient: 'Client',
        nadpis: 'For {cena} a month of protection, the family receives if something happens',
        nadpisBezCeny: 'What the family receives if something happens',
        podminky: 'Paid according to the policy terms. The amounts do not add up.',
        zadna: 'No risks selected yet — add them in Risks.',
      },
      tooltip: {
        dnes: 'Today · age {vek}',
        vek: 'Age {vek} · in {roky}',
        vynos: 'Model return {castka}',
      },
      vek60: '60 years',
      vek65: '65 years',
      vek70: '70 years',
      vekLabel: 'Up to what age',
      vekVlastni: 'to age {vek}',
      vekVlastniLabel: 'Or enter an age',
      vynos4: '4 % a year',
      vynos7: '7 % a year',
      vynos9: '9 % a year',
      vynosLabel: 'Expected return',
      vynosProti: 'against {investice} invested · {vynos} a year',
      vynosVModelu: 'Model return',
      zaplaceno: {
        investice: 'Of which invested',
        investicePopis: '{mesicne} a month',
        ochrana: 'Of which protection',
        ochranaPopis: 'cost of cover, not returned',
        popis: '{mesicne} a month × 12 × {roky}',
        popisPoplatek: '{mesicne} a month × 12 × {roky} + fee {poplatek}',
        stitek: 'Total you pay',
      },
    },
    hadani: {
      odkryt: 'Reveal the actual amount',
      pole: 'Your guess (monthly)',
      rozdil: 'Difference from your guess',
      skutecnost: 'The state pays a month',
      vyzva: 'How much do you think the state will pay you? Make a guess before we reveal it.',
    },
    hranice: {
      davkyOdhad: 'State benefits are an indicative estimate. The actual amount is set by the authority.',
      modelace: 'This is a model scenario, not an insurance contract or a personal recommendation.',
      odhadKlienta: 'Your guess is only for comparison. It does not enter the calculation or the printout.',
      potvrdiPoradce: 'The specific solution, the limits and the price are confirmed by the adviser with the insurer.',
      sablona: 'The marked amounts are an indicative example from the adviser’s practice, not an offer or a guarantee.',
      vynosNeniGarantovan: 'Future returns are not guaranteed. Actual performance may differ, even substantially.',
    },
    jednotka: {
      denni: 'daily benefit',
      jednorazova: 'lump sum',
      renta: 'monthly income',
      zaDen: 'per day',
      zaMesic: 'per month',
    },
    karta: {
      cenaHint: 'Copy it from the insurer’s illustration. If you do not have it yet, leave it blank.',
      cenaNezadana: 'No price entered — this risk is left out of the total.',
      cenaPole: 'Monthly price',
      dnesCenaPole: 'Pays today',
      dnesHint: 'Copy from their current policy. Without it the ratio cannot be calculated.',
      dnesKrytiPole: 'Cover today',
      dnesNadpis: 'What they have today',
      formaNezadana: 'Type of income not entered — sick pay is calculated as for an employee.',
      jakSePocita: 'How it is worked out',
      jenZeny: 'women only',
      krytiPole: 'Sum insured',
      nezadano: 'not entered',
      osvcBezNemocenske: 'As self-employed (OSVČ) without voluntary sickness insurance, you do not receive sick pay.',
      otazka: 'Question for the client',
      oznacProbrano: 'Mark as discussed',
      poOsobach: 'By person',
      pomerCena: 'price',
      pomerKryti: 'cover',
      pomerNadpis: 'Ratio against today’s cover',
      potreba: 'How much is needed',
      preskoceno: 'Skipped',
      preskocit: 'Skip',
      proDeti: 'children too',
      probrano: 'Discussed',
      radekPotreba: 'need',
      sbalit: 'Collapse',
      statDa: 'What the state pays',
      tvar: 'Form of benefit',
      vCene: 'In the price',
      varianty: 'Cover options',
      vratit: 'Restore',
      vyradit: 'Exclude',
      zapsat: 'Enter figures',
      zaradit: 'Include',
    },
    neznamo: 'Not entered',
    poznamka: {
      cenaOdPoradce: 'The adviser confirms the price and the specific solution from the insurer’s quote.',
      hodnotaDnesnimaOcima: 'In today’s money, at inflation of {inflace} % a year, that is',
      investiceVynesla: 'In the model, the investment part earned',
      modelovyScenar: 'A model scenario, not an insurance contract or a personal recommendation.',
      nezbytneJsouCeleVydaje: 'The cover need is calculated from total household expenses. Essential expenses are usually lower — the full life insurance calculator gives the exact figure.',
      odhadKlientaNeniUdaj: 'Your estimate is only for comparison — it does not enter the calculation or the printed summary.',
      vlozenoDoOchrany: 'Over {roky} years you have paid into protection',
      vynosNeniGarantovan: 'Future returns are not guaranteed. The value of the investment can fall as well as rise.',
    },
    prehled: {
      balicekVysvetleni: 'The package is a percentage of income, not of what is left over. That is why you can see whether it fits within the spare money. This is a model scenario; the adviser will confirm the actual solution.',
      balicky: 'How much could be set aside',
      balickyPodnadpis: 'Select a package. Part goes to protection, the rest is invested — you set the split just below.',
      chybi: 'Short by',
      doporuceno: 'The highest that fits',
      nadVolnymi: 'This is not a ban — the client may choose more. It only means that together we need to find where that money will come from.',
      nadpis: 'What passes through the household',
      podnadpis: 'Two figures the client already knows about themselves. And one they usually do not.',
      prijem: 'Net household income',
      prijemNotePar: 'Husband and wife combined.',
      vejdeSe: 'It fits within the spare money.',
      vlastni: 'Custom amount',
      vlastniHint: 'Enter the figure the client gave.',
      vlastniLabel: 'How much they want to set aside',
      vlastniPopis: 'the amount the client states',
      vlastniPrazdna: 'Enter the amount the client gave — otherwise there is nothing to calculate from.',
      volne: 'Spare money left',
      volneKratce: 'Income minus expenditure.',
      volneNote: 'Income minus expenditure. This is what can be set aside.',
      volneZaporne: 'The household spends more than it earns. Before we talk about insurance, we need to find where the money is leaking away.',
      vybrano: 'Selected',
      vydaje: 'Household expenditure',
      vydajeNote: 'Including loan repayments.',
      zPrijmu: 'of income',
      zTohoRodine: 'incl. {castka} to parents / family',
    },
    prezentace: {
      dal: 'Next: {nazev}',
      krok: {
        cas: {
          nadpis: 'How to pay the fee and what time does',
          otazka: 'What happens if you let the money work longer?',
          say: 'Pick a bar. You will see how much you put in and what time made of it.',
          stitek: 'Fee and time',
          tip: 'Let the client click. A model, not a promise.',
        },
        cisla: {
          nadpis: 'Your numbers',
          otazka: 'How much comes into your household each month, and how much goes out again?',
          say: 'Roughly is fine, we will fine-tune it together.',
          stitek: 'Numbers',
          tip: 'Clients rarely know their free money — let them read it themselves.',
        },
        investice: {
          nadpis: 'The rest of the package works for you',
          otazka: 'How many years could this money work?',
          say: 'The chart is a model, not a promise. It shows what time does.',
          stitek: 'Investment',
          tip: 'Let the client pick the age.',
        },
        konecne: {
          brana: 'First record the client’s decision: Yes, I want it, Adjust or Not yet.',
          nadpis: 'Final decision',
          otazka: 'Now you know the price and the terms. Do you want this protection?',
          say: 'Yes, changes and not yet are all fine.',
          stitek: 'Confirmation',
          tip: 'If the client picks Adjust, ask what to change.',
          volba: {
            ano: 'Yes, I want it',
            upravit: 'Adjust',
            zatimNe: 'Not yet',
          },
        },
        potvrzeni: {
          celkem: 'Protection in total',
          cena: 'Price',
          cenaUTemat: 'Price so far for {n} of {celkem} topics.',
          kryti: 'Cover',
          nadpis: 'Your protection',
          otazka: 'Does this protection suit you, or would you like to adjust something?',
          riziko: 'Risk',
          rucne: 'In the package split, protection was set manually to {castka}.',
          say: "The insurer's offer will still confirm the cover and the price.",
          stitek: 'Protection',
          tip: 'If it feels expensive, lower the sums insured and say out loud which cover the client gives up.',
        },
        predstaveni: {
          say: 'I introduce myself and explain how I work.',
          tip: 'The client can check the register right away on their phone.',
        },
        rizika: {
          dalsi: 'Next risk',
          nadpis: 'What could happen',
          otazkaSmrtBezUveru: 'If one day you did not come home, what would your family live on?',
          otazkaZavazkyBezCastky: 'Do you have a loan that someone would have to keep paying for you?',
          poradi: 'Risk {n} / {celkem}',
          predchozi: 'Previous risk',
          say: 'Take a guess, then we will look at how it really is.',
          smysl: 'Does that make sense to you?',
          stitek: 'Risks',
          tip: 'After the reveal, ask whether it makes sense.',
          vsePreskoceno: 'No risk to discuss — all of them are skipped.',
        },
        smlouva: {
          nadpis: 'How the contract works',
          otazka: 'What would you like to know about the contract before you decide?',
          say: 'I am telling you up front so nothing surprises you later.',
          stitek: 'Contract',
          tip: 'Read the health questionnaire with the client question by question.',
        },
        souhlas: {
          brana: "First record the client's answer: Yes, Later or No.",
          nadpis: 'The decision is yours',
          otazka: "Would you like to protect your family's income?",
          say: 'Yes, later and no are all fine.',
          stitek: 'Decision',
          tip: 'After the question, stay quiet and let the client answer.',
        },
        svoleni: {
          nadpis: 'What we will cover today',
          otazka: 'May I ask a few questions so I can show you where your family stands?',
          say: 'It takes a few minutes, and the decision is always yours.',
          stitek: 'Intro',
          tip: "Wait for the answer, don't rush.",
        },
        zaver: {
          balicek: 'How much per month',
          dalsiKrok: 'Next step',
          dalsiKrokText: {
            ano: 'We will prepare a tailored proposal and go through it together. The insurer confirms the cover and the price.',
            ne: 'The decision is yours. We can come back to it any time.',
            nezadano: 'We will agree on the next step together.',
            pozdeji: 'We will agree when to come back to it.',
            upravit: 'We will adjust the proposal to suit you and go through it together again. The insurer confirms the cover and the price.',
            zatimNe: 'The decision is yours. We can come back to it any time.',
          },
          nadpis: 'To finish',
          otazka: 'What next step makes sense to you?',
          poznamka: 'Note',
          rozhodnuti: 'Your answer',
          say: 'Here are two numbers. The conclusion is yours.',
          sayBez: 'Thank you for your time. The decision is yours, and it stands.',
          stitek: 'Summary',
          termin: 'Date and time',
          terminKlient: 'Agreed date: {kdy}',
          tip: 'Do not join the numbers into one sentence.',
          tipBez: 'Do not persuade — just agree when you will be in touch.',
        },
      },
      predstaveni: {
        jakText: 'I will show you where your family stands. Whether and how to insure, you decide.',
        odmenaText: 'I will tell you how I am paid for my work, and you will get it in writing before you sign.',
      },
      uvod: {
        nadpis: 'Where your family stands',
        rodina: 'Your family',
        slib: 'We will show you, you ask, and you decide yourself.',
      },
    },
    rizika: {
      nadpis: 'Risks',
    },
    riziko: {
      bezmocnost: {
        coJe: 'A state in which you cannot look after yourself — you cannot eat, wash or get about on your own. Someone has to be with you every day.',
        nazev: 'Full dependence on care',
        pozn: 'Illustrations call this the highest level of dependence. Exactly what triggers a payout is set by the policy.',
      },
      denniOdskodne: {
        coJe: 'A benefit for every day of treatment after an accident. It covers the window before the sickness benefit starts paying.',
        nazev: 'Daily benefit while an injury is treated',
      },
      detiHospitalizace: {
        coJe: 'A benefit for every night the child spends in hospital. The parent stays with the child and does not work.',
        nazev: 'Child in hospital',
      },
      detiOdskodne: {
        coJe: "A benefit for every day the child is treated after an accident — the same loss of the parent's income, only at home.",
        nazev: "Child's daily benefit while treated",
      },
      detiPeceRodice: {
        coJe: 'After an accident or illness the child stays permanently dependent on care. The biggest gap is not the treatment — it is the parent who leaves work for good in order to provide that care.',
        nazev: "A serious event in a child — the parent's lost income",
        pozn: "The sum insured sits on each child's own policy. Part of a child's need is something no insurer will underwrite — that part belongs in the emergency fund and in investments.",
      },
      detiTrvale: {
        coJe: 'A lump sum for rehabilitation, equipment and adapting the home when an accident leaves the child permanently limited.',
        nazev: 'Permanent injury in a child',
      },
      detiZavazne: {
        coJe: 'A lump sum paid on a listed diagnosis in a child — for the treatment, and so that the parent can stay at home.',
        nazev: 'Critical illness in a child',
        pozn: 'How much an insurer will underwrite on a child is limited. The rest of the need belongs in the emergency fund and in investments.',
      },
      hospitalizace: {
        coJe: 'A benefit for every night in hospital. A short-term matter — for an adult the emergency fund usually covers it instead.',
        nazev: 'Hospital stay',
      },
      invalidita1Klesajici: {
        coJe: 'Partly limited ability to work, with a sum insured that falls over time.',
        nazev: 'Disability grade 1 — decreasing sum insured',
      },
      invalidita1Konstantni: {
        coJe: 'Partly limited ability to work. Income falls, the outgoings stay.',
        nazev: 'Disability grade 1 — level sum insured',
      },
      invalidita2Klesajici: {
        coJe: 'Seriously limited ability to work, with a sum insured that falls over time.',
        nazev: 'Disability grade 2 — decreasing sum insured',
      },
      invalidita2Konstantni: {
        coJe: 'Seriously limited ability to work: you can manage some things, but not your own occupation full time.',
        nazev: 'Disability grade 2 — level sum insured',
      },
      invalidita3Klesajici: {
        coJe: 'Total disability, but the sum insured falls year by year.',
        nazev: 'Disability grade 3 — decreasing sum insured',
        pozn: 'The cheaper option. It makes sense only if you really do invest and your assets gradually fill the gap — otherwise the cover falls and the need does not.',
      },
      invalidita3Konstantni: {
        coJe: 'Total disability: you cannot work at all. The sum insured stays the same throughout.',
        nazev: 'Disability grade 3 — level sum insured',
      },
      pece12: {
        coJe: 'A daily benefit for the time when you manage most things yourself but need help with some of them.',
        nazev: 'Long-term care — lower levels of dependence',
      },
      pece34: {
        coJe: 'A monthly income for the whole time you need daily care from another person.',
        nazev: 'Long-term care — higher levels of dependence',
        pozn: 'This app does not work out the income you would need — the adviser fills the amount in from the illustration.',
      },
      pnOd29: {
        coJe: 'A daily benefit that starts after four weeks off work. The first month is covered by the emergency fund.',
        nazev: 'Sickness absence from day 29',
      },
      pnOd61: {
        coJe: 'A daily benefit only after two months. The cheapest option — it makes sense if the emergency fund can carry two months.',
        nazev: 'Sickness absence from day 61',
      },
      pnPlus: {
        coJe: 'A daily benefit on easier terms — it also pays in situations the basic option excludes.',
        nazev: 'Sickness absence with extended cover',
        pozn: 'Exactly what is included and what is excluded is set out in the policy terms. Go through them with your adviser.',
      },
      smrtInvaliditaKombinace: {
        coJe: 'One sum insured, paid according to whichever comes first — death or disability.',
        nazev: 'Death or disability in one sum insured',
        pozn: 'The combination pays out once. Anyone who wants both situations covered in full needs two sums insured, not one.',
      },
      smrtKlesajici: {
        coJe: 'The sum insured falls year by year, because the mortgage balance falls and your assets grow.',
        nazev: 'Death — decreasing sum insured',
        pozn: "The cheaper option. It fits the debt you are paying off — not the family's standard of living, which does not fall.",
      },
      smrtKonstantni: {
        coJe: 'The sum insured stays the same throughout. The family receives the same amount in the first year as in the last.',
        nazev: 'Death — level sum insured',
      },
      smrtKratsiDoba: {
        coJe: 'Cover for a shorter term than the whole policy. Typically until the loan is repaid or the children are grown up.',
        nazev: 'Death — cover for a few years only',
        pozn: 'The app does not work with a separate shorter term — it uses one horizon for the whole analysis. The adviser fills in both the sum insured and the term.',
      },
      smrtUraz: {
        coJe: 'Pays out only if the cause is an accident. That is why it is cheap — and why it must not be the main cover: death from illness is not covered at all.',
        nazev: 'Death caused by an accident',
      },
      trvaleOd1: {
        coJe: 'Pays out even for minor permanent damage. The more expensive option, but with the widest scope of cover.',
        nazev: 'Permanent injury from the lowest percentages',
      },
      trvaleOd10: {
        coJe: 'It leaves out minor damage and pays out only for the kind that really changes your life.',
        nazev: 'Permanent injury from ten per cent',
      },
      trvalePremium: {
        coJe: 'The more serious the consequence, the higher the payout — for severe damage, a multiple of the sum insured.',
        nazev: 'Permanent injury with higher progression',
        pozn: 'How fast the progression rises and where it is capped is set by the policy.',
      },
      zavazkyDluh: {
        coJe: 'A share of the mortgage and the other repayments that will not go away. It is a component of the sum insured for death and for disability, not extra cover.',
        nazev: 'Liabilities — who pays them off',
        pozn: 'Debts are not scaled down in any cover option. A mortgage cannot be repaid to eighty per cent.',
      },
      zavazneKlesajici: {
        coJe: 'The same cover with a sum insured that falls year by year. Cheaper, provided your assets are growing at the same time.',
        nazev: 'Critical illness — decreasing sum insured',
      },
      zavazneOpakovane: {
        coJe: 'It pays out more than once — if a different listed diagnosis comes after recovery, it pays again.',
        nazev: 'Critical illness with repeated payouts',
        pozn: 'The overall cap on repeated payouts is set by the policy.',
      },
      zavazneRozsirene: {
        coJe: 'The same cover, only with a longer list of diagnoses and easier payout conditions. Exactly what is included is set out in the policy.',
        nazev: 'Critical illness — extended scope',
      },
      zavazneZakladni: {
        coJe: 'A lump sum paid on a diagnosis from the list in the policy. That money is not for the bills — it is there so that you can stop working and get treated.',
        nazev: 'Critical illness — basic scope',
      },
      zavazneZeny: {
        coJe: 'An add-on aimed at illnesses that affect women only and at complications in pregnancy.',
        nazev: 'Critical illness cover for women',
      },
    },
    rokFew: '{n} years',
    rokMany: '{n} years',
    rokOne: '{n} year',
    rozdeleni: {
      balicek: 'Monthly package:',
      chybiBalicekTuk: 'No package selected yet',
      investice: 'Investment',
      nadpis: 'How much for protection and how much for investment',
      ochrana: 'Protection',
      podilOchrany: 'Protection takes {pct} of the package',
      popis: 'The package splits into two parts. Use the slider to try it out yourself.',
      posuvnik: 'How much of the package goes to protection',
      prekrocenoText: 'Nothing would be left for investment and the package is {chybi} short. Either the cover goes down, or the amount the client sets aside goes up.',
      prekrocenoTuk: 'Protection costs more than the package',
      skript: 'You have {balicek} a month. How much of that do you want to put towards protecting your family, and how much to leave invested? Try moving the slider yourself.',
      skriptNadpis: 'Wording for the meeting',
      zdrojNeznamy: 'No risk has a protection price entered yet.',
      zdrojPosuvnik: 'You set this amount with the slider.',
      zdrojSoucet: 'From the sum of the risk prices: {soucet} · risks priced: {pocet}',
      zpetNaSoucet: 'Back to the price total',
    },
    rozpad: {
      cile: 'Goals',
      deficitMes: 'Monthly shortfall',
      detiCelkem: 'What the family needs',
      detiNepojistitelne: 'Of which uninsurable',
      detiSoucet: 'Total across policies',
      detiZavazne: 'Critical illness of a child',
      diskont: 'Converted to money of today at a rate of',
      dluhy: 'Debts',
      karence: 'The emergency fund covers (months)',
      naDite: 'Per child',
      nasobekPrijmu: 'Multiple of the annual income',
      prijem: 'Income',
      statniDavka: 'State benefit',
      tnuSablona: 'Permanent injury — template',
      vydaje: 'Capital for expenses to the end of the horizon',
      vydajePoUdalosti: 'Expenses after the event',
    },
    skupina: {
      deti: {
        nazev: 'Children',
        otazka: 'Which of you two would stay at home if your child were ill for a whole year?',
        podtitul: 'A child’s illness means a parent loses income',
      },
      invalidita: {
        nazev: 'Disability',
        otazka: 'How much do you think the state would pay you each month if you could no longer work?',
        podtitul: 'When you can no longer work — and life goes on',
      },
      neschopnost: {
        nazev: 'Long-term sickness absence',
        otazka: 'How much sickness benefit would the state send you per month? Have a guess.',
        podtitul: 'Months at home, the outgoings carry on',
      },
      pece: {
        nazev: 'Long-term care',
        otazka: 'Who would care for you — and what would you pay for that care from?',
        podtitul: 'When you can no longer manage on your own',
      },
      smrt: {
        nazev: 'Death',
        otazka: 'Who would pay off the mortgage if you did not come home?',
        podtitul: 'What is left for the family and what is left for the bank',
      },
      uraz: {
        nazev: 'Accident',
        otazka: 'What would change at home if, after an accident, you could no longer do your work the way you did before?',
        podtitul: 'Permanent consequences and days of treatment',
      },
      zavazky: {
        nazev: 'Liabilities',
        otazka: 'Who would pay off that {castka}?',
        podtitul: 'Repayments that will not go away',
      },
      zavazne: {
        nazev: 'Critical illness',
        otazka: 'If you were given a diagnosis tomorrow — what would you live on during the year when you only want to get treatment?',
        podtitul: 'A diagnosis that means months or years of treatment',
      },
    },
    smlouva: {
      dlouhodoba: {
        nadpis: 'Insurance is for the long term',
        odstoupeni: 'Withdrawing shortly after signing',
        odstoupeniText: 'Shortly after signing, you can withdraw from the contract without giving a reason. The law sets the time limit, and you will find it in the contract.',
        preruseni: 'If you stop paying',
        preruseniText: 'What happens is set by the policy terms.',
        text: 'It makes sense over years, not a few months.',
        ukonceni: 'If you end the contract',
        ukonceniDusledek: 'In the first years, while the entry fee is still being paid off, you may get little or nothing back if you end it.',
        ukonceniText: 'You can. Cover ends on that day. What you get back is set by the policy terms.',
        znovu: 'A new contract later means a new health questionnaire — based on your age and health at that time.',
      },
      dotaznik: {
        nadpis: 'Health questionnaire: truthful and complete',
        podpis: 'Do not sign anything you do not understand.',
        spolu: 'We will go through it together, question by question. Ask about anything you do not understand — language included.',
        text: 'An untrue or incomplete answer can mean the insurer does not pay, or pays less — even after years of payments.',
      },
      investice: {
        dny: 'usually within {dny} days',
        dnyPodleSmlouvy: 'You will find the exact period in the contract.',
        dostupne: 'Money available',
        nadpis: 'The investment part is flexible',
        pozastavit: 'Pause',
        pozastavitText: 'stop investing for a while',
        pridat: 'Add',
        pridatText: 'a higher payment or an extra deposit',
        ubrat: 'Withdraw',
        ubratText: 'take out part of the money',
      },
      nadpis: 'How the contract works',
      oci: 'Contract',
      platba: {
        investice: 'Investment',
        investiceText: 'It has value and you can draw on it. When and how is set by the contract.',
        nadpis: 'Your payment has two parts',
        ochrana: 'Protection',
        ochranaText: 'The price of cover. It is not paid back — like compulsory car insurance.',
      },
      vyluky: {
        nadpis: 'When the insurer does not pay',
        text: 'Every contract has exclusions — cases in which the insurer does not pay. They are in the policy terms and we will go through them together.',
      },
    },
    souhrn: {
      cenaMesic: 'Monthly price',
      cenaNezadana: 'The adviser enters the price from the quote',
      cenaUTemat: 'Price so far for {s} of {z} topics.',
      nadpis: 'Summary',
      osoba: 'Person',
      pozn: 'The adviser will confirm the price and the specific solution against the quote from the insurer.',
      preskoceno: 'Skipped',
      probrano: 'Discussed',
      sCenou: 'With a price',
      vybrano: 'Selected',
      zbyva: 'Remaining',
    },
    spolecne: {
      let: 'years',
      nezadano: 'not entered',
      podtitulek: 'From income through each risk to two numbers: what the family receives if something happens — and what is left if nothing does.',
      rezimKlient: 'Show to client',
      rezimPoradce: 'Back to adviser view',
      sekce: 'Life insurance',
      titulek: 'Analysis for Vietnamese clients',
      ukazka: 'Sample client',
      ukazkaJmeno: 'Sample',
      ukazkaZnacka: 'Sample numbers for practising the meeting — not the data of the client sitting here.',
      vycistit: 'New client',
      zaDen: '/ day',
      zaMesic: '/ month',
      zpet: 'Back to tools',
    },
    stav: {
      doplniPoradce: 'Input missing. The adviser will supply it — we do not estimate it.',
      jeSlozka: 'This is a component of the death and disability sums insured, not extra cover.',
      kombinace: 'A combination pays out once. It consists of: {rizika}',
      neumimeSpocitat: 'The app does not calculate this cover — the adviser will enter the amount from the illustration.',
    },
    stop: {
      bezBalicku: 'Pick a package, or write your own amount.',
      bezCastky: 'Enter the amount.',
      bezCenyOchrany: 'The cost of protection is not known yet — enter it against the risks, or set it with the slider.',
      bezHorizontu: 'Choose how many years the calculation should run to.',
      bezKapitalu: 'Without a modelled investment value the income cannot be calculated.',
      bezKatalogu: 'The risk catalogue could not be loaded.',
      bezPoplatku: 'The investment entry fee has not been entered.',
      bezPrijmu: 'Enter the net monthly income — without it the packages cannot be calculated.',
      bezRizik: 'No risk has been selected yet.',
      bezVeku: 'Enter the client’s age and the target age.',
      bezVydaju: 'Enter the monthly expenditure — otherwise we do not know how much is really left.',
      cilovyVekNizsi: 'The target age {vekCilovy} is lower than the current age {vekDnes} — choose a later one.',
      pctMimoRozsah: 'You can set aside {min} to {max} per cent of income.',
      poplatekMimoRozsah: 'Entry fee out of range — usually {min} to {max} % of the target amount.',
      rokyMimoRozsah: 'The calculation can run for {min} to {max} years.',
      vynosMimoRozsah: 'The expected return must be between 0 and {max} per cent a year.',
    },
    tvar: {
      klesajici: 'decreasing',
      konstantni: 'level',
    },
    varovani: {
      balicekNadVolne: 'The {pct} % package is {chybi} higher than what is left today. It is not a ban — finding the money is the adviser’s job.',
      cenaChybiUNekterych: 'No price entered for {pocet} of the selected risks — they are missing from the total.',
      denniCenaJenPodPrahem: 'The daily cost per person is above {prah} — it is shown for information only, not as a selling line.',
      ochranaNadBalicek: 'Protection costs {chybi} more than the whole package — nothing is left for investing.',
      poplatekNadObvykly: 'The {pct} % fee is outside the usual range of {min}–{max} % of the target amount.',
      poplatekNesplacenyVHorizontu: 'The entry fee will not be fully paid off within the horizon entered.',
      poplatekNezadan: 'No entry fee entered — the figure is gross, before the fee.',
      splatkyNadPolovinu: 'Instalments have grown past half of the income — the figures need finishing by hand.',
      splatkyNadRozpocet: 'Loan instalments take more than what is left after setting money aside — the rule does not fit this household.',
      vlastniNadPrijem: 'The amount entered is higher than the entire monthly income — is that a typo?',
      vynosMimoScenare: 'A return of {vynos} % is not one of the three model scenarios (4 / 7 / 9 %).',
      zadnaCenaZadana: 'No price entered for any of the selected risks — the adviser will fill them in.',
    },
    vstupy: {
      bezJmena: 'Client',
      bezPartnera: 'No partner',
      deti: 'Number of children',
      detiHint: 'Children the household supports.',
      diteJmeno: 'Child’s name',
      diteN: 'Child {n}',
      diteVek: 'Child’s age',
      domacnost: 'Household',
      dvojice: '{a} and {b}',
      forma: 'Type of income',
      formaOsvc: 'Self-employed (OSVČ)',
      formaZamestnanec: 'Employee',
      jistina: 'Outstanding debt principal',
      jistinaHint: 'How much is still left to repay — mortgage and other loans combined.',
      jistinaZbyva: 'Remaining principal on all loans',
      jmenoOsoby: 'Name',
      klient: 'Client',
      klientka: 'Client',
      manzel: 'Husband',
      manzelka: 'Wife',
      muz: 'Male',
      nadpis: 'Who we are modelling',
      oci: 'Inputs',
      partnerHint: 'A partner is defined by a name, not by an income. Without a name, their income is left out of the calculation.',
      podnadpis: 'Eight details and we can get started. The rest we fill in as it comes up.',
      podporaRodine: 'Sent to parents / family monthly',
      pohlavi: 'Sex',
      pohlaviHint: 'Affects the risk rate, not how the client is addressed.',
      prijem: 'Net monthly income',
      prijemHint: 'What actually reaches the account.',
      souhrnNadpis: 'Model for',
      vek: 'Age',
      vekCil: 'Age of financial independence',
      vekCilHint: 'Up to when contributions are made. From that point the portfolio is meant to earn, not the client.',
      vydaje: 'Monthly household expenditure',
      vydajeHint: 'Including loan repayments — everything that leaves the account.',
      vydajeVcSplatek: 'Monthly household expenditure incl. loan repayments',
      zena: 'Female',
    },
    vysledek: {
      bezKrytiStitek: 'No cover entered: {pocet}',
      chybiKryti: 'Some of the risks discussed have no cover (count: {pocet}). Until an amount is entered, the risk will not show up in the payout.',
      hodnotaInvestice: 'Investment part value in the model',
      hodnotaPopis: 'paid into investments {castka}',
      iddKratce: 'The modelled return is not guaranteed and is not a promise that the premiums paid will be returned.',
      iddText: 'On the left is the cover the adviser entered, on the right the modelled development of the investment component. The two figures stand separately: the modelled return is not guaranteed and is not a promise that the premiums paid will be returned. The conclusion is the client’s; the specific solution will be confirmed by the adviser.',
      iddTuk: 'Two separate figures',
      nescitajiSe: 'Risks are not paid out together, so the amounts are not added up.',
      nestaloNadpis: 'What is left at the end',
      nestaloOci: 'If nothing were to happen',
      ochranaZaplatite: 'You pay for protection over {roky}',
      ochranaZaplatiteBezRoku: 'Total you pay for protection',
      poradceNadpis: 'For the adviser',
      poradcePozn: 'Do not combine the figures into a single sentence. Let the client draw the conclusion themselves.',
      renta: 'Modelled monthly income from this amount',
      rentaPozn: 'Income at a safe withdrawal rate of {sazba} per year. A modelled calculation, not a guaranteed payout.',
      rizikoBezNazvu: 'Unnamed risk',
      staloNadpis: 'What the family receives',
      staloOci: 'If something were to happen',
      staloPodnadpis: 'Broken down by the individual risks you selected:',
      staloZdroj: 'The amounts come from the cover you entered for each risk. Risks are not paid out together, so they are not added up.',
      zadnaRizika: 'No risk with a sum of cover entered has been selected yet.',
    },
    zaRokFew: 'over {n} years',
    zaRokMany: 'over {n} years',
    zaRokOne: 'over {n} year',
  },
  /* BLOK:izp END */
  /* BLOK:prodejKit START — generuje scratchpad/slovnik.py, ručně needitovat */
  prodejKit: {
    namitky: {
      analyza: {
        mamPoradce: {
          n: 'I already have an adviser.',
          o: 'That’s good, you don’t need to change anything. The analysis shows where you stand today, and you’re free to take the result to your adviser too.',
        },
        nechciNicKupovat: {
          n: 'I don’t want to buy anything.',
          o: 'Understood. You are not signing anything today — I will show you the numbers, and whether you do anything with them is entirely your decision.',
        },
        nemamCas: {
          n: 'I don’t have time for this.',
          o: 'I understand, time is precious — how much do you have today? We’ll cover only what matters and arrange the rest for another time.',
        },
        partner: {
          n: 'I need to talk it over with my partner.',
          o: 'Of course, it concerns you both. Shall we meet together next time, so your partner hears the same as you?',
        },
        prijmyNereknu: {
          n: 'I’m not telling you my income.',
          o: 'I understand, that’s your call. A rough range is enough — and anything we leave blank stays blank, I won’t guess.',
        },
        procToChcete: {
          n: 'Why do you need to know all this?',
          o: 'Without your numbers I’d be advising you blind. Anything you’d rather not answer, we’ll skip.',
        },
      },
      jenPoradce: 'adviser only',
      kontext: {
        analyza: 'Analysis',
        pojisteni: 'Insurance',
      },
      pojisteni: {
        drahe: {
          n: 'It’s too expensive.',
          o: 'I understand, you know your budget best. We can lower the sums insured where your savings would cover the gap — and we’ll say out loud which cover you’d lose.',
        },
        mamPojisteni: {
          n: 'I already have insurance.',
          o: 'That’s good — we’ll count it in so you don’t pay twice for the same thing. Shall we look at the policy: how much it pays and whether it covers disability too, not just death?',
        },
        manzel: {
          n: 'I need to talk to my husband / wife.',
          o: 'Of course, it’s a decision for both of you. Let’s meet together next time so they see the same numbers you do — when would suit you?',
        },
        nechciSeVazat: {
          n: 'I don’t want to be tied down for years.',
          o: 'Understood — you can end the policy, but in the first years, while the entry fee is still being paid off, you may get little or nothing back. It makes sense long term because price and acceptance depend on your age and health on the day you sign, and health can’t be bought back later.',
        },
        nicSeMiNestane: {
          n: 'Nothing’s going to happen to me.',
          o: 'I hope so, and you’re most likely right. I don’t insure what’s likely, I insure what couldn’t be undone — how many months would your family manage if it did happen?',
        },
        rozmyslim: {
          n: 'I’ll think about it.',
          o: 'Of course, it’s a decision for years and there’s no rush. Just so I know what to send you — do you want to think about whether to cover this risk, or how much to put into it?',
        },
      },
      titul: 'Objections',
    },
    ram: {
      brana: 'This step isn’t finished yet.',
      dalsi: 'Next',
      hotovo: 'Done',
      hotovyKrok: 'done',
      klavesy: '→ or space: next · ←: back · Esc: end',
      klient: 'Client',
      krok: 'Step {n} / {celkem}',
      poradce: 'Adviser',
      prejitNa: 'Step {n}: {nazev}',
      prezentace: 'Presentation',
      rozbalit: 'Expand',
      skryt: 'Hide',
      tahak: 'Cue card',
      tip: 'Tip',
      zavrit: 'Close presentation',
      zpet: 'Back',
    },
    souhlas: {
      ano: 'Yes',
      ne: 'No',
      nezadano: 'Not entered',
      pozdeji: 'Later',
      poznamka: 'Note (optional)',
      vymazat: 'Clear answer',
      zapsano: 'Recorded {kdy}',
    },
  },
  /* BLOK:prodejKit END */
  /* BLOK:planPojistne START — generuje scratchpad/slovnik.py, ručně needitovat */
  planPojistne: {
    budouci: 'in the future {castka} — not counted yet',
    driveNe: 'The client said earlier they do not want income protection — the plan does not deduct the premium.',
    nadPrebytek: 'Insurance {cena} costs more than the monthly surplus {prebytek} — nothing is left for goals.',
    nezadana: 'Insurance cost not entered — the plan leaves it out.',
    nula: 'Insurance cost 0 — nothing is deducted from the surplus.',
    odmitnuto: 'The client does not want income protection for now.',
    prebytekBezPrijmu: 'The monthly surplus is unknown — the analysis is missing income. Add it, or enter the amount you agreed with the client.',
    segment: 'Insurance',
    tokPrebytek: 'Surplus after insurance',
    zToho: 'of which insurance {pojisteni} · for goals {naCile}',
  },
  /* BLOK:planPojistne END */
  /* BLOK:analyzaProdej START — generuje scratchpad/slovnik.py, ručně needitovat */
  analyzaProdej: {
    cas: {
      ano: 'Yes, has time',
      drivejsiZapis: 'Earlier note',
      potvrzeno: 'The client confirmed 45 minutes',
    },
    cesta: {
      dnes: 'TODAY',
      popis: 'Goals appear one by one as time moves on',
      prehrat: 'Play',
      preskocit: 'Skip',
      vek: 'age {n}',
      za: 'in {n} yrs',
      znovu: 'Play again',
    },
    dedictvi: {
      druh: 'Type',
      druhJine: 'Other',
      druhNemovitost: 'Property from parents',
      nadpis: 'Future assets (inheritance)',
      nepocita: 'in the future — not counted yet',
      panel: 'Future assets',
    },
    forma: {
      jiny: 'Other source',
      majitel: 'Company owner',
      osvc: 'Self-employed',
      zamestnanec: 'Employee',
    },
    majetek: {
      nefinPod: 'property, business',
    },
    oceneni: {
      do: 'to',
      ebitda: 'Annual operating profit (EBITDA)',
      ebitdaPopis: 'Profit before interest, taxes, depreciation and amortisation — not profit before tax.',
      horni: 'Upper bound',
      majetkove: 'Asset-based',
      nasobek: 'Multiple',
      nezadano: 'not entered',
      od: 'from',
      otevrit: 'Valuation helper',
      pouzit: 'Use as the value',
      spodni: 'Lower bound',
      stred: 'Midpoint',
      substance: 'Cost to fully equip the business',
      upozorneni: 'A rough estimate, not an expert valuation.',
      vynosove: 'Earnings-based',
      ztrata: 'With zero or negative profit, no earnings-based value is given.',
    },
    podklady: {
      dotaznik: 'Investment questionnaire',
      investicni: 'Investment contracts',
      pojistne: 'Insurance contracts',
      uverove: 'Loan contracts',
      vypisy: 'Bank statements',
    },
    prebytek: {
      nicNezbyva: 'Nothing is left over from income today — free cash flow is {castka}.',
    },
    predstaveni: {
      jakText: 'Today I only get to know your situation and goals. I will bring a proposal next time — the decision is always yours.',
      jakTitul: 'How I work',
      kdoText: 'You can check my registration in the public {dohled} register.',
      kdoTitul: 'Who I am',
      kicker: 'Before we start',
      odmenaText: 'When a contract is arranged, the financial institution pays me a commission. You get the details in writing before you sign.',
      odmenaTitul: 'How I am paid',
    },
    prez: {
      dialog: 'Analysis presentation',
      predstaveni: {
        q: 'Before we start: who I am and how I work',
        tab: 'Introduction',
        tahak: 'What is important for you to know about how I work?',
        tip: 'The client can check the register right away on their phone.',
      },
    },
    reference: {
      gdprPotvrzeno: '✓ Confirmed {datum}',
      gdprText: 'The client confirms that the contacts are shared with the consent of the people recommended, or acknowledges that the adviser will inform them at first contact about the source and processing of their personal data under Art. 14 GDPR.',
      gdprTitul: 'GDPR consent:',
      tahak: '“I have one small favour to ask. If today’s meeting made sense to you, would you send me a tip on two or three people who are dealing with something right now: housing, family, work? No need to persuade them. A name and a phone number are enough, and I will call only once.”',
    },
    rizika: {
      chybi: 'Shortfall',
      chybiHorizont: 'years on the goals',
      chybiPozustalostni: 'survivor benefit for this country',
      chybiPrijem: 'income',
      chybiUdaje: 'Missing for the calculation',
      chybiVydaje: 'essential expenses',
      kicker: 'If you could no longer work',
      krytiInvalidita: 'Disability cover',
      krytiSmrt: 'Death cover',
      mesicne: 'per month',
      potrebujete: 'You need',
      poznamka: 'A model based on your numbers, not a guarantee. State benefits are an estimate.',
      statDa: 'The state pays',
      stavajici: 'Existing policies · disability',
      zustane: 'Income that remains',
    },
    tabulky: {
      budouciPrijmyPopis: 'Income that will be added in two, three or five years. The plan counts it towards the pension.',
      zatimNic: 'Nothing yet.',
    },
    tisk: {
      dalsiSchuzka: 'Next meeting',
      nadpis: 'Meeting summary',
      nezadano: 'not entered',
      podklady: 'Documents to provide',
      prebytek: 'Agreed monthly surplus',
      shrnutiJenJmeni: 'Summary of our analysis: net worth {jmeni}.',
    },
    vydaje: {
      podpora: 'Support for parents / family',
    },
    zastava: {
      popis: 'The property from parents can secure the loan — only with the owner’s consent. Nothing is recalculated.',
      titul: 'Possible loan collateral',
      zvoleno: 'chosen as collateral',
      zvolit: 'choose as collateral',
    },
    zaver: {
      bezDat: 'Once the numbers are in, this will show what to work on.',
      diarPoPrezentaci: 'Add the date to the Calendar after the presentation',
      diarPoPrezentaciAno: '✓ The Calendar opens when the presentation ends',
      model: 'A model based on your numbers, not a guarantee.',
      nadpis: 'What we will work on',
      rizikaNadpis: 'Income protection',
      rizikaText: '{jmeno}: in case of disability, the monthly shortfall is {castka}.',
      terminOtevrit: 'Open the meeting in the Calendar',
      terminRadek: 'Next meeting: {kdy}',
      terminVAnalyze: 'noted in the analysis',
      terminVDiari: 'in the Calendar',
      vseOk: 'Based on the numbers, nothing needs work right now.',
    },
  },
  /* BLOK:analyzaProdej END */
  /* BLOK:nastenkaGrafy START — generuje scratchpad/slovnik.py, ručně needitovat */
  nastenkaGrafy: {
    trychtyr: {
      otevrenychFew: 'open',
      otevrenychMany: 'open',
      otevrenychOne: 'open',
      prumerDniFew: 'avg. {n} days in stage',
      prumerDniMany: 'avg. {n} days in stage',
      prumerDniOne: 'avg. {n} day in stage',
    },
    vyvoj: {
      mesiceFew: '{n} months',
      mesiceMany: '{n} months',
      mesiceOne: '{n} month',
      obchodyFew: '{n} deals',
      obchodyMany: '{n} deals',
      obchodyOne: '{n} deal',
      popisGrafu: 'Deals trend: {obchody} and {bj} over {obdobi}, most in {mesic}',
      slovoObchoduFew: 'deals',
      slovoObchoduMany: 'deals',
      slovoObchoduOne: 'deal',
    },
  },
  /* BLOK:nastenkaGrafy END */
  /* BLOK:analyzaPrezentace START — generuje scratchpad/slovnik.py, ručně needitovat */
  analyzaPrezentace: {
    chip: {
      bydleni: 'Housing',
      deti: 'Children',
      dluhy: 'Debts',
      duchod: 'Retirement',
      investice: 'Investments',
      plan: 'Overall plan',
      pojisteni: 'Insurance',
      rezerva: 'Reserve',
    },
    chybi: {
      a: 'and',
      castka: 'amount',
      castka4: 'the amount',
      horizont: 'horizon',
      horizont4: 'the horizon',
      limity4: 'the cover limits',
      platba4: 'the monthly premium',
      pojistovna4: 'the insurer',
    },
    cislo: {
      mil: '{n}M',
      tis: '{n}k',
    },
    hlaska: {
      cashflowIncomplete: 'Free cash flow cannot be calculated yet.',
      cashflowNic: 'Neither income nor expenses have been entered yet.',
      cashflowPrijmy: 'Add the household income.',
      cashflowVydaje: 'Add the regular expenses so we can calculate free cash flow.',
      cilIncomplete: 'The goal is in progress. Add {chybi}.',
      hypotekaIncomplete: 'The mortgage is recorded. Add the outstanding balance and the monthly repayment.',
      investiceIncomplete: 'The contract is recorded. Add the current value or the regular contribution.',
      investiceIncompleteVice: 'The contracts are recorded. Add the current value or the regular contribution.',
      majetekNeuplny: 'Not entered yet: {chybi}. Net worth is therefore only indicative and incomplete.',
      pojistkaIncomplete: 'The insurance policy is recorded. Add {chybi}.',
      pojistkaIncompleteVice: 'The insurance policies are recorded. Add {chybi}.',
      rezervaIncomplete: 'To calculate the reserve, add: {chybi}.',
      rizikoOrientacni: 'An indicative monthly difference between the family’s expenses and the income that would remain after a loss of income. It is not the insurance need — we will calculate that after taking reserves, social benefits and existing insurance into account.',
      zavazkyEmpty: 'No liabilities are recorded.',
      zavazkyIncomplete: 'The liability is recorded. Add the outstanding balance and the monthly repayment.',
      zavazkyIncompleteVice: 'The liabilities are recorded. Add the outstanding balances and the monthly repayments.',
    },
    horizont: {
      bezTerminu: 'No date set yet',
    },
    krok: {
      cile: {
        q: 'What do you want to achieve? WHAT / WHEN / HOW MUCH',
        tab: 'Goals',
      },
      hodnoty: {
        q: 'Why is money important to you?',
        tab: 'Values',
      },
      ocekavani: {
        q: 'What do you expect from today’s meeting?',
        tab: 'Expectations',
      },
      prijmy: {
        q: 'How much do you earn and how much is left?',
        tab: 'Income and expenses',
      },
      rizika: {
        q: 'What could put the plan at risk?',
        tab: 'Risks',
      },
      rodina: {
        q: 'Who are we planning for today?',
        tab: 'Family',
      },
      zavazky: {
        q: 'What are you repaying today and what contracts do you have?',
        tab: 'Liabilities and contracts',
      },
      zaver: {
        q: 'Let us sum it up.',
        tab: 'Summary',
      },
      zdroje: {
        q: 'What resources do you have for your goals?',
        tab: 'Resources',
      },
    },
    pasmo: {
      dlouhodoby: 'Long-term',
      kratkodoby: 'Short-term',
      strednedoby: 'Medium-term',
    },
    pasmoPopis: {
      dlouhodoby: '10 years or more',
      kratkodoby: 'up to 3 years',
      strednedoby: '4–9 years',
    },
    platno: {
      cesta: {
        nadpis: 'Life path',
        orientacniPozn: 'Financial independence is converted to capital using the 4 % rule — the methodology is not approved, treat the number as indicative.',
        orientacniTitul: 'Converting the annuity to capital (the 4 % rule) is not an approved methodology — the number is indicative.',
      },
      citat: '“{text}”',
      hodnoty: {
        nadpis: 'What matters to you',
        prazdno: 'Write on the left what money means to the client…',
      },
      ocekavani: {
        cil: 'My aim is to check **what you are already doing well**, where you might be **losing money** and what you **could do better**.',
        nadpis: 'What you expect from today',
        prazdno: 'Write the client’s words on the left…',
      },
      prijmy: {
        poznamka503020: '50 / 30 / 20 is a guide, not a binding rule — the real split depends on how the family lives.',
        rozdilNezadano: 'We will show the difference once we have both the calculated surplus and the amount the client agreed to.',
      },
      rizika: {
        kino: 'Play cinema: Risk protection',
      },
      rodina: {
        cilKicker: 'Today’s aim',
        cilText: 'Let us **check together what you are already doing well** — and where your finances **could be improved**. No selling, just a clear picture and a recommendation.',
        nadpis: 'The family we are planning for',
        prazdno: 'Fill in the names of the clients and children on the left…',
      },
      zavazky: {
        dodaPozdeji: 'client will provide later: {n}',
        fixace: 'next fixed-rate end {datum}',
        konec: 'end of repayment {datum}',
        splatka: 'repayment {castka}',
      },
      zdroje: {
        bezKurzu: '{n} items in a foreign currency are not in the summary — there is no usable exchange rate for them. We would rather leave them out than state a number nobody has checked.',
        bezKurzuKat: '{n}× foreign currency without a rate — not counted',
      },
    },
    pole: {
      bonusy: 'Annual bonuses',
      cas: 'Time',
      cilCo: 'WHAT — goal description',
      cilCoPh: 'e.g. a bigger home',
      cilKdy: 'WHEN — in how many years',
      cilKolik: 'HOW MUCH — target amount',
      cilTyp: 'Goal type',
      coDodat: 'What the client should provide',
      dalsiSchuzka: 'Next meeting',
      datum: 'Date',
      doslovne: 'Word for word…',
      formaKlient: 'Income type — client {n}',
      katOpf: 'Investments (funds / ETFs / shares)',
      klientEmail: 'Client {n} — email',
      klientJmeno: 'Client {n} — first name',
      klientN: 'Client {n}',
      klientTelefon: 'Client {n} — phone',
      mamDnes: 'Have today',
      navrh: 'Proposal',
      nezbytne: 'Essential monthly expenses',
      obvykle: 'Usual monthly expenses',
      ocekavani: 'What the client expects (in their own words)',
      pasivni: 'Passive income',
      penize: 'What does money mean to the client? (in their own words)',
      penizePh: 'freedom, security, peace of mind, time with family…',
      poznPrijmy: 'Note on income',
      predvyplnitZCrm: 'Click to prefill the details from the CRM card',
      refTelefon: 'Phone / contact',
      refVztah: 'Relationship / note',
      vlastniPh: 'e.g. pension fund statement',
      vlastniPolozka: 'Custom item',
      vydajePozn: 'Loan repayments are under liabilities — do not count them again. Essential expenses are the minimum for when income stops.',
      zDomacnosti: 'From the household:',
    },
    riziko: {
      evidovano: 'Recorded',
      nezadano: 'Not entered',
      proverit: 'To check',
      vyreseno: 'Resolved',
    },
    role: {
      dite: {
        m: 'Son',
        z: 'Daughter',
      },
      klient: {
        m: 'Client',
        z: 'Client',
      },
      manzel: {
        m: 'Husband',
        z: 'Wife',
      },
      partner: {
        m: 'Partner',
        z: 'Partner',
      },
    },
    sablona: {
      c1: 'Required liquidity reserve',
      c2: 'Housing / renovation',
      c3: 'Education for the children / a start in life',
      c4: 'Financial independence',
      d1: 'Inheritance',
      f1: 'Company / business',
      kz1: 'Endowment life insurance',
      kz2: 'Investment life insurance',
      n1: 'Flat / family house',
      n2: 'Commercial premises',
      n3: 'Land / forests / fields',
      n4: 'Car / vehicles',
      n5: 'Valuables (watches, art, collections…)',
      n6: 'Gold and precious metals',
      o1: 'Equity funds/ETFs',
      o2: 'Bond funds/ETFs',
      o3: 'Money market funds/ETFs',
      o4: 'Real estate and other funds/ETFs',
      o5: 'Individual shares',
      o6: 'Corporate bonds',
      o8: 'Cryptocurrencies',
      pj1: 'Term life insurance',
      pj2: 'Accident insurance',
      pj3: 'Property / household insurance',
      pj4: 'Liability insurance',
      pj5: 'Motor liability / own-damage insurance',
      pj6: 'Legal expenses insurance',
      pz1: 'Legacy supplementary pension insurance',
      pz2: 'Supplementary pension savings',
      pz3: 'Long-term investment product',
      r1: 'Property / building insurance',
      r2: 'Household contents insurance',
      r3: 'Liability insurance',
      r4: 'Motor third-party liability',
      r5: 'Motor own-damage insurance',
      s1: 'Building savings',
      u1: 'Term deposit',
      u2: 'Savings account',
      u3: 'Current account',
      u4: 'Cash at home',
      u5: 'Foreign currencies',
      zb1: 'Mortgage / housing loan',
      zb2: 'Consumer loans',
      zb3: 'Leasing',
      zb4: 'Credit cards',
      zo1: 'Business loan',
      zo2: 'Revolving loan',
    },
    smluvFew: '{n} contracts',
    smluvMany: '{n} contracts',
    smluvOne: '{n} contract',
    tab: {
      bydleni: {
        celkem: 'Total liabilities',
        konec: 'End of repayment',
        mesicne: 'Monthly repayments',
        nadpis: 'Housing',
        nejblizsi: 'Next fixed-rate end',
        pocet: 'Loans',
      },
      investicni: {
        celkem: 'Current value',
        mesicne: 'Regular contributions',
        nadpis: 'Investment contracts',
        nejblizsi: 'Next anniversary',
        pocet: 'Products',
      },
      ostatni: {
        celkem: 'Other loans',
        mesicne: 'Monthly repayments',
        nadpis: 'Other loans',
        nejblizsi: 'Next due date',
        pocet: 'Loans',
      },
      pojistky: {
        mesicne: 'Monthly premiums',
        nadpis: 'Insurance policies',
        nejblizsi: 'Next anniversary',
        pocet: 'Contracts',
      },
    },
    tahak: {
      cile: {
        say1: 'Let us look at your strategic goals in the structure WHAT – WHEN – HOW MUCH.',
        say2: 'What will you need to finance? When do you need the money? How much will the goal cost?',
        say3: 'If the client does not mention them, always check: housing, the children’s future and financial independence.',
        tip: 'For a goal the client underestimates, play the Cinema — it shows the number instead of persuading.',
      },
      hodnoty: {
        say1: 'If the client says, for example, freedom, ask: What does freedom mean to you?',
        say2: 'What else comes to mind? Why is it important to you right now?',
        say3: 'Bridge: If a financial plan gives you {slovaKlienta}, will that be the right solution for you?',
        tip: 'Do not ask about amounts. This is about the reason, not the numbers.',
      },
      ocekavani: {
        say1: 'What do you expect from today’s meeting?',
        say2: 'Repeat the client’s words and continue: My aim is to check what you are already doing well, where you might be losing money and what you could do better.',
        tip: 'Write it down word for word. You will use the client’s own words in the summary and at the next meeting.',
      },
      prijmy: {
        say1: 'Another important resource for reaching your goals is your income.',
        say2: 'Based on the numbers entered, you have roughly {castka} left over. How much are you really willing to put towards your financial plan in the long term?',
        tip: 'The agreed surplus is the client’s number, not yours. Better lower and sustainable.',
      },
      rizika: {
        say1: 'As part of your financial plan, we will also look at your protection — what you have today, what it covers and what it does not.',
        say2: 'We will check whether you can save money or insure more wisely, and show how your protection fits into the whole plan: family, goals, reserve.',
        tip: 'Do not judge and do not scare. Just record the current state and what needs checking.',
      },
      rodina: {
        say1: 'On the phone we agreed on 45 minutes. Nothing has changed on my side. I just want to check that you are also planning for about 45 minutes.',
        say2: 'First I will just check the basic details about you and your family.',
        tip: 'Confirm the time right at the start — then nobody keeps checking the clock.',
      },
      zavazky: {
        say1: 'An important piece of information for reaching your goals is the liabilities and contracts you already have today.',
        say2: 'First we look at mortgages and other loans, then at your existing investment, pension and insurance contracts.',
        tip: 'The end of the fixed-rate period and the contract anniversary are the most valuable details of the whole meeting — without them the proposal cannot be timed.',
      },
      zaver: {
        say1: 'Is there anything important I forgot to ask you about?',
        say2: 'We now have the information needed to prepare your financial strategy and financial plan.',
        say3: 'At the next meeting we will show you: what we recommend, what it will cost, in what order we will take the individual steps and how the plan will lead to your goals.',
        tip: 'Do not go into specific solutions. Today you only agree on the date and the documents.',
      },
      zdroje: {
        say1: 'Now we know your goals. Let us look at the resources you have to reach them.',
        tip: 'Ask category by category, not in general — otherwise the client forgets half of it.',
      },
    },
    typCile: {
      auto: 'Car',
      bydleni: 'Housing',
      deti: 'Children’s future',
      investice: 'Investments',
      nezavislost: 'Financial independence',
      ostatni: 'Other goals',
      podnikani: 'Business',
      podnikatelsky: 'Business loan',
      rekonstrukce: 'Renovation',
      rezerva: 'Reserve',
      spotrebitelsky: 'Consumer loan',
      uver: 'Loan',
    },
    vydajKat: {
      bydleni: 'Housing (rent / owners’ association / repair fund)',
      deti: 'Children, school, activities',
      doprava: 'Transport / car / public transport',
      dovolena: 'Holidays (monthly average)',
      energie: 'Utilities (electricity, gas, water)',
      jidlo: 'Food and household',
      ostatni: 'Other',
      pojisteni: 'Insurance (excluding loan repayments)',
      predplatne: 'Subscriptions and services',
      telekom: 'Phone, internet, TV',
      volnyCas: 'Leisure, hobbies, restaurants',
      zdravi: 'Health, medicines, toiletries',
    },
    zaver: {
      bezTerminu: 'We have not agreed on the date of the next meeting yet. As soon as we do, we will go through the prepared plan together.',
      sTerminem: 'I will prepare the plan and we will go through it together at the next meeting on {kdy}.',
      vHodin: '{datum} at {cas}',
    },
  },
  /* BLOK:analyzaPrezentace END */
  /* BLOK:planKlient START — generuje scratchpad/slovnik.py, ručně needitovat */
  planKlient: {
    letFew: '{n} years',
    letMany: '{n} years',
    letOne: '{n} year',
    metodika: "Meeting the goals: real returns above inflation by asset class (equities {akcie} / bonds {dluhopisy} / cash {cash} % p.a., gradual de-risking towards the goal). Sums insured: capital method @ 4 % real. Social benefits (widow's, orphan's in total for the family, disability pension) are an INDICATIVE ESTIMATE from a template — not a promise by the state; the advisor will verify them. The advisor has the last word.",
    shrnuti: {
      podtitul: 'Three pots at the top, one row per goal. The numbers are the same as in the Proposal.',
      rozdavej: 'Allocate from the resources right in the table until both pots show „Left 0“.',
    },
    tahak: "Advisor's cheat sheet",
    uvod: {
      dobraCile: 'The first is good: [[your goals can be reached.]]',
      dobraPlan: 'Good news: [[you have a plan.]]',
      lepsiCesta: 'The even better one: you get there [[by a safer route]].',
      lepsiDrive: 'The even better one: you can live off your capital [[in just {za}]] — {o} earlier.',
      rentaNa: 'The annuity is at [[{pct} %]] so far — and we can see exactly what to do about it.',
      rentaNezadana: 'The annuity goal has not been set yet.',
    },
  },
  /* BLOK:planKlient END */
  /* BLOK:denniCrm START — generuje scratchpad/slovnik.py, ručně needitovat */
  denniCrm: {
    chybaPopis: 'Your data is safe — the server just couldn’t be reached right now.',
    klientiNenacteno: 'Couldn’t load clients',
    nacitam: 'Loading…',
    obchodyNenacteno: 'Couldn’t load deals',
    offlineKopie: 'offline copy from {cas}',
    offlineKopieBezCasu: 'offline copy',
    zavritZalozku: 'Close tab {nazev}',
    zkusitZnovu: 'Try again',
  },
  /* BLOK:denniCrm END */
  /* BLOK:nastrojeBezSlibu START — generuje scratchpad/slovnik.py, ručně needitovat */
  nastrojeBezSlibu: {
    namitkaRizikoOdpoved: 'I completely understand. Risk can be reduced, but nobody can promise you a return above inflation in advance. I’ll show you conservative options — a savings account, bond funds, a conservative pension fund — and what you can realistically expect from each. You choose what suits you.',
    pojisteniVkladu: 'Deposit insurance',
  },
  /* BLOK:nastrojeBezSlibu END */
  /* BLOK:penzeBezKavy START — generuje scratchpad/slovnik.py, ručně needitovat */
  penzeBezKavy: {
    aRentu: 'and a monthly pension of',
    podleModeluVDuchodu: 'According to the model, at retirement you have saved',
  },
  /* BLOK:penzeBezKavy END */
  /* BLOK:funnelReference START — generuje scratchpad/slovnik.py, ručně needitovat */
  funnelReference: {
    sablona: '[Insert a real testimonial here, with the client’s consent]',
    titul: 'Testimonials (real ones only, with the client’s consent)',
  },
  /* BLOK:funnelReference END */
  /* BLOK:ikony START — generuje scratchpad/slovnik.py, ručně needitovat */
  ikony: {
    aktivita: {
      cesta: 'Route',
      dopis: 'Letter',
      email: 'Email',
      hotovo: 'Done',
      misto: 'Place',
      narozeniny: 'Birthday',
      obchod: 'Deal',
      pripominka: 'Reminder',
      radar: 'Opportunity radar',
      schuzka: 'Meeting',
      servis: 'Service date',
      sms: 'SMS',
      telefonat: 'Phone call',
      udalost: 'Event',
      ukol: 'Task',
      whatsapp: 'WhatsApp',
    },
    cil: {
      auto: 'Car',
      budoucnostDeti: 'Children’s future',
      bydleni: 'Housing',
      investice: 'Investments',
      nezavislost: 'Financial independence',
      obecny: 'Goal',
      ostatni: 'Other goals',
      podnikani: 'Business',
      podnikatelskyUver: 'Business loan',
      rekonstrukce: 'Renovation',
      rezerva: 'Reserve',
      spotrebitelskyUver: 'Consumer loan',
      uver: 'Loan',
    },
    produkt: {
      analyza: 'Analysis',
      hypoteka: 'Mortgage',
      investice: 'Investments',
      jine: 'Other',
      penzijko: 'Pension savings',
      pojisteni_auta: 'Car insurance',
      pojisteni_majetek: 'Property insurance',
      pojisteni_odpovednost: 'Liability insurance',
      pojisteni_ostatni: 'Other insurance',
      pojisteni_zivot: 'Life insurance',
      rezerva: 'Reserve',
      stavebni: 'Building savings',
      uver: 'Loan',
      zdravotni: 'Health insurance',
    },
    profil: {
      dynamicky: 'Dynamic',
      konzervativni: 'Conservative',
      vyvazeny: 'Balanced',
    },
    riziko: {
      dite: 'Child insurance',
      hospitalizace: 'Hospital stay',
      invalidita: 'Disability',
      odskodne: 'Daily accident benefit',
      pn: 'Sick leave',
      rodicovska: 'Parental leave',
      smrt: 'Death',
      stari: 'Old age',
      tnu: 'Permanent consequences of an accident',
      zavazne: 'Critical illness',
    },
    stav: {
      chyba: 'Error',
      info: 'Info',
      ok: 'All good',
      pozor: 'Attention',
    },
  },
  /* BLOK:ikony END */
  /* BLOK:vzorkovna START — generuje scratchpad/slovnik.py, ručně needitovat */
  vzorkovna: {
    ikony: {
      doplnky: 'Extra drawings',
      doplnkyPopis: 'What lucide lacks. Taken over with their licence.',
      mena: 'Currency by tenant country',
      velikosti: 'Size and selected state',
      vybrany: 'Selected',
    },
    motivNahledu: 'Preview in theme',
    motivy: {
      kino: 'Presentation screen',
      popis: 'Goals and reserve at a glance',
      titulek: 'Financial plan',
      tlacitko: 'Save',
    },
    nadpis: 'Style samples',
    obsah: 'Contents',
    pismo: {
      cisla: 'Aligned figures',
      jazyky: 'Five languages, one typeface',
      nadpisUkazka: 'Household financial plan',
      nadpisy: 'Headings',
      stupnice: 'Size scale',
      ukazka: 'The reserve covers six months of household expenses.',
    },
    prazdny: {
      akce: 'Plan a meeting',
      kratky: 'No tasks yet.',
      text: 'You have no meeting planned for today.',
    },
    sekce: {
      ikony: 'Icons in chips',
      motivy: 'Six themes',
      pismo: 'Typography',
      prazdny: 'Empty state',
      stavy: 'States',
      tokeny: 'Colours',
      vystup: 'Output kit',
    },
    skupina: {
      aktivity: 'Activities',
      cile: 'Goals',
      produkty: 'Products',
      profily: 'Investor profile',
      rizika: 'Risks',
      stavy: 'States',
    },
    stavy: {
      bezTextu: 'No text',
      chyba: 'Changes could not be saved',
      ikona: 'Icon',
      info: 'Data from the last meeting',
      ok: 'The reserve covers 6 months of expenses',
      pozor: 'Disability cover is missing',
      stitek: 'Label',
      tecka: 'Dot',
    },
    stitek: 'Design lab · internal preview',
    tokeny: {
      akcent: 'Accent',
      kategorie: 'Categories',
      plochy: 'Surfaces',
      stavy: 'States',
      text: 'Text',
    },
    uvod: 'Type, colours, icons and states in one place. Screens use only what is here.',
    zpet: 'Back',
  },
  /* BLOK:vzorkovna END */
  /* BLOK:novyCrm START — generuje scratchpad/slovnik.py, ručně needitovat */
  novyCrm: {
    akce: {
      otevrit: 'Open: {nazev}',
      otevritVAppce: 'Open in the current CRM',
      vPrototypu: 'Not available in the prototype yet',
      zkusitZnovu: 'Try again',
      zobrazitDalsi: 'Show {n} more',
      zrusitFiltr: 'Clear filter',
    },
    aktivita: {
      dopis: 'Letter',
      email: 'Email',
      schuzka: 'Meeting',
      telefonat: 'Call',
      udalost: 'Event',
      ukol: 'Task',
    },
    analyza: {
      bezAnalyzy: 'There is no analysis yet. Start it in the current app and it will show here in full.',
      chybaBloku: 'This part of the analysis could not be calculated',
      chybi: {
        cil: 'Goal “{nazev}”: add {co}',
        dalsiNaRade: 'next',
        dalsichFew: 'and {n} more in the app',
        dalsichMany: 'and {n} more in the app',
        dalsichOne: 'and {n} more in the app',
        deti: 'A child row without a name and date of birth is not counted',
        faze: 'Parts of the analysis',
        fazeSouhrn: '{n} of {celkem} parts of the analysis done',
        hotovo: 'The analysis is complete, nothing is missing',
        nadpis: 'What is missing',
        nezbytne: 'Essential expenses — without them there is no 50 / 30 / 20 split or protection need',
        partner: 'The partner’s income is filled in, but the partner is not in the analysis (name or date of birth missing)',
        rezerva: 'Accounts and cash — the reserve cannot be calculated without them',
        zadnaPolozka: 'No specific item is missing — finish the remaining parts of the analysis',
        zajisteni: 'Income protection cannot be calculated — missing: {co}',
        zavaznost: {
          nizka: 'Minor',
          stredni: 'Complete',
          vysoka: 'Important',
        },
      },
      chybiUdajuFew: '{n} items missing',
      chybiUdajuMany: '{n} items missing',
      chybiUdajuOne: '{n} item missing',
      cile: {
        chybi: 'missing {co}',
        mesicne: '{mena}/month',
        pocetFew: '{n} goals by date',
        pocetMany: '{n} goals by date',
        pocetOne: '{n} goal by date',
        uverem: 'with a loan',
      },
      doplnitVAppce: 'Complete in the app',
      faze: {
        cile: 'Goals',
        hodnoty: 'Values',
        prijmy: 'Income and expenses',
        rizika: 'Risks',
        uvod: 'Introduction',
        zavazky: 'Liabilities',
        zdroje: 'Resources',
      },
      majetek: {
        budouci: 'Inheritance and future assets',
        budouciStitek: 'in the future · not counted yet',
        cisteJmeni: 'net worth (assets today − debts)',
        dluhy: 'debts (balances)',
        dnes: 'assets today',
        dsti: 'repayments are {pct} % of income',
        fixace: 'next rate fixation ends {datum}',
        nadpis: 'Assets and debts',
        prazdno: 'No assets or debts recorded yet',
        splatky: 'repayments {castka} a month',
        uveruFew: '{n} loans',
        uveruMany: '{n} loans',
        uveruOne: '{n} loan',
        vysokeZadluzeni: 'High debt load (over 40 % of income)',
      },
      menaJina: 'The analysis is kept in {mena}',
      menaStara: 'Older analysis without a currency — amounts are in {mena}',
      nadpis: 'Analysis',
      penize: {
        chybiDo20: '{castka} a month short of the 20 % ideal',
        nadpis: 'Income and expenses',
        odklada: 'Sets aside {pct} % of income · ideal 20 % = {castka}',
        rozpadBezNezbytnych: 'The 50 / 30 / 20 split will show once essential expenses are entered.',
        splneno: 'Saves the ideal 20 % of income or more',
      },
      rezerva: {
        bezVydaju: 'Without essential expenses it is not possible to calculate how many months the reserve lasts',
        castkaPopisek: 'in accounts and cash',
        dnes: 'Reserve today',
        doporuceno: 'Recommended {n} months',
        grafPopis: 'The reserve covers {n} months of the recommended {cil}',
        jednotka: 'mo.',
        mesicuPopisek: 'months of essential expenses and repayments it covers',
        nadpis: 'Reserve',
        nezapsana: 'Accounts and cash are not recorded yet',
        stav: {
          reserve_low: 'Under 3 months',
          reserve_mid: 'Top up to 6 months',
          reserve_ok: 'At least 6 months',
        },
      },
      rodina: {
        bezDeti: 'no children',
        detiFew: '{n} children',
        detiMany: '{n} children',
        detiOne: '{n} child',
        dospelychFew: '{n} adults',
        dospelychMany: '{n} adults',
        dospelychOne: '{n} adult',
        nadpis: 'Family and profile',
        prazdno: 'The family is not filled in the analysis yet',
        prijem: 'income {castka} a month',
        vekNezadany: 'age not entered',
      },
      upraveno: 'Updated {datum}',
      upravitVAppce: 'Edit in the app',
      zacit: 'Start the analysis in the app',
      zajisteni: {
        bezDiry: 'Monthly income is covered',
        dira: '{castka} a month is missing',
        domacnost: 'Household cover',
        mesicne: 'In case of disability: the family needs {potreba} a month · remains {zustane} · the state pays {stat}',
      },
      zpetNaKlienta: 'Back to client',
    },
    cas: {
      dnes: 'today',
      predFew: '{n} days ago',
      predMany: '{n} days ago',
      predOne: '{n} day ago',
      vcera: 'yesterday',
    },
    cesta: {
      hotovo: 'done',
      krokZ: '{n} of {celkem}',
      kroky: {
        analyza: 'Analysis',
        plan: 'Plan',
        predstaveni: 'Introduction',
        realizace: 'Implementation',
        servis: 'Service',
      },
      nadpis: 'Client journey',
      vseHotovo: 'All steps done',
      ziskani: 'Prospecting · before the first meeting',
      ztraceno: 'Lost',
    },
    chyba: {
      aktivity: 'Notes and tasks could not be loaded',
      analyza: 'The analysis could not be loaded',
      analyzaTvar: 'The analysis data has an unexpected format',
      cile: 'The plan could not be loaded',
      fixace: 'Could not load fixations',
      klient: 'The client could not be loaded',
      klienti: 'Clients could not be loaded',
      obchody: 'Deals could not be loaded',
      obecne: 'The data could not be loaded',
      pipeline: 'Could not load the deal summary',
      plan: 'The proposed solution could not be loaded',
      radar: 'Could not load the opportunity radar',
      rizika: 'The cover need could not be calculated',
      ukoly: 'The calendar could not be loaded',
    },
    diar: {
      aDalsichFew: 'and {n} more',
      aDalsichMany: 'and {n} more',
      aDalsichOne: 'and {n} more',
      agenda: 'Day agenda',
      akciFew: '{n} activities',
      akciMany: '{n} activities',
      akciOne: '{n} activity',
      bezCasu: 'No set time',
      celyDen: 'all day',
      dalsiTyden: 'Next week',
      drive: 'Earlier',
      drivePocet: 'Earlier: {n}',
      hodiny: 'Hours of the day',
      hotovo: 'done',
      minut: '{n} min',
      naDnes: 'Today',
      naplanovat: 'Schedule in the diary',
      nejblizsi: 'next up',
      nicPoTerminu: 'Nothing overdue',
      odskrtnout: 'Mark as done',
      otevrit: 'Open in the diary',
      otevritPolozku: 'Open in the diary',
      poTerminu: 'Overdue',
      poTerminuPocetFew: '{n} overdue',
      poTerminuPocetMany: '{n} overdue',
      poTerminuPocetOne: '{n} overdue',
      pozdeji: 'Later',
      pozdejiPocet: 'Later: {n}',
      prazdnoDen: 'Nothing scheduled for this day',
      prazdnoDnes: 'Nothing scheduled for today',
      predchoziTyden: 'Previous week',
      schuzekFew: '{n} meetings',
      schuzekMany: '{n} meetings',
      schuzekOne: '{n} meeting',
      souhrn: 'Day summary',
      souhrnPoTerminu: 'overdue from all days',
      souhrnSchuzky: 'meetings',
      souhrnUkoly: 'tasks, calls and e-mails',
      tyden: 'Week',
      typ: {
        dopis: 'Letter',
        email: 'E-mail',
        poznamka: 'Note',
        schuzka: 'Meeting',
        telefonat: 'Call',
        udalost: 'Event',
        ukol: 'Task',
      },
      ukoluFew: '{n} tasks',
      ukoluMany: '{n} tasks',
      ukoluOne: '{n} task',
    },
    faze: {
      a1: 'Introduction',
      a2: 'Analysis',
      calling: 'Calling',
      done: 'Completed',
      lead: 'Lead',
      lost: 'Lost',
      p1: 'Financial plan',
      p2: 'Presentation',
      servis: 'Service',
      signed: 'Signed',
    },
    fazeObchodu: {
      analyza: 'Analysis',
      cerpani: 'Drawdown',
      podpis: 'Signing',
      proces: 'In progress',
    },
    graf: {
      oblouk: {
        nastavit: 'Set the plan in the app',
        nenastaveno: 'No plan set',
        popisek: 'BJ plan progress',
        zPlanu: '{bj} of {plan} BJ',
      },
      rozpad: {
        cile: 'Goals',
        nezbytne: 'Essentials',
        zivotniStyl: 'Lifestyle',
      },
      trychtyr: {
        popis: 'Open deals by stage',
      },
    },
    hlavicka: {
      hledat: 'Search clients ({zkratka})',
    },
    klient: {
      aktivity: {
        bezDalsiho: 'No next step scheduled',
        dalsiKrok: 'Next step',
        diar: 'Open the diary',
        nadpis: 'Notes and next step',
        naplanovat: 'Schedule in the diary',
        napsat: 'Write a note',
        posledni: 'Recent activity',
        zadne: 'No notes or activity yet',
      },
      analyza: 'Analysis',
      bezAnalyzy: 'No analysis yet. Budget, goals and assets appear once you fill it in.',
      bezUdaju: 'Age and city not entered',
      bilance: 'Monthly budget',
      bilancePrazdna: 'Income and expenses are not filled in yet',
      cile: {
        bezCastkyFew: '{n} goals without an amount',
        bezCastkyMany: '{n} goals without an amount',
        bezCastkyOne: '{n} goal without an amount',
        bezNazvu: 'Untitled goal',
        bezTerminu: 'no deadline',
        chybi: 'Missing',
        cil: 'Goal',
        cilKlienta: 'goal {castka}',
        dalsichFew: 'and {n} more goals in the proposal',
        dalsichMany: 'and {n} more goals in the proposal',
        dalsichOne: 'and {n} more goal in the proposal',
        definice: 'Already has = today’s money at the goal date.',
        dnes: 'now',
        grafPopis: '{nazev}: already has {uzMa} of {cil}',
        jenBezCastkyFew: 'The goals have no amount yet ({n})',
        jenBezCastkyMany: 'The goals have no amount yet ({n})',
        jenBezCastkyOne: 'The goal has no amount yet ({n})',
        nadpis: 'Goals',
        prazdno: 'No goals entered yet',
        regulace: 'An indicative overview based on the plan, not an offer.',
        renta: 'income {castka} per month',
        uverem: 'own funds for a loan',
        uzMa: 'Already has',
        vlastniZdroje: 'Own funds',
        zaFew: 'in {n} years',
        zaMany: 'in {n} years',
        zaOne: 'in {n} year',
      },
      doplnitVAnalyze: 'Complete in the analysis',
      kategorie: 'Category {k}',
      kontaktNezadany: 'No phone or e-mail entered',
      krok: {
        analyza: 'Analysis',
        navrh: 'Proposed solution',
        plan: 'Plan',
        prezentace: 'Presentation',
      },
      majetek: {
        celkem: 'in total',
        dluhy: 'Debts: {castka}',
        grafPopis: 'Total assets {celkem}: {dily}',
        kategorie: {
          firma: 'Business',
          kzp: 'Life insurance with savings',
          nemovitosti: 'Property and cars',
          opf: 'Funds and shares',
          ostatni: 'Other',
          penzijko: 'Pension savings',
          stavebko: 'Building savings',
          ucty: 'Accounts and cash',
        },
        nadpis: 'Assets',
        prazdno: 'No assets recorded yet',
      },
      nadpis: 'Client',
      napsat: 'Send e-mail: {email}',
      nenalezen: 'This client is not in the CRM — it may have been deleted.',
      neuplnaData: 'Part of the analysis data has an unexpected format',
      obchody: {
        bezBj: 'BJ not entered',
        nadpis: 'Client’s deals',
        novy: 'New deal in the app',
        prazdno: 'The client has no open deal',
        vsechny: 'All deals',
      },
      otevritAnalyzu: 'Open the analysis',
      otevritNavrh: 'Open the proposed solution',
      otevritPlan: 'Open the plan',
      pokracovat: 'Continue: {krok}',
      prijmy: 'income per month',
      profil: 'Profile',
      regulace: 'An indicative overview from the analysis, not an offer.',
      rizika: {
        chybi: {
          horizont: 'protection period',
          pozustalostni: 'survivor benefits',
          prijem: 'income',
          vydaje: 'essential expenses',
        },
        chybiCastka: '{castka} short of the recommended cover',
        domacnost: 'household',
        grafPopis: '{riziko}, {kdo}: current policies {kryti} of the recommended cover {potreba}',
        invalidita: 'Disability',
        klient1: 'Client',
        klient2: 'Partner',
        kryti: 'Current policies',
        krytiSpolecne: 'policy without a person — in the analysis, under Risks in contracts, pick whose it is',
        model: 'The recommended cover comes from the analysis calculator (capital method) — a model, not an offer. The Plan shows the sums insured of the option chosen in the Proposal, so they may differ.',
        nadpis: 'Income protection',
        nelzeSpocitat: 'The cover need cannot be calculated yet. Missing: {co}.',
        pokryto: 'covered',
        potreba: 'Recommended cover',
        prazdno: 'Neither the cover need nor existing policies are in the analysis yet',
        radek: 'Recommended cover {potreba} · current policies {kryti}',
        smrt: 'Death',
      },
      splatky: 'loan repayments per month',
      vekFew: '{n} years old',
      vekMany: '{n} years old',
      vekOne: '{n} year old',
      volneCf: 'free cash flow per month',
      vydaje: 'expenses per month',
      zacitAnalyzu: 'Start the analysis',
      zavolat: 'Call: {cislo}',
      zpet: 'Back to clients',
    },
    klienti: {
      bezJmena: 'No name',
      filtr: {
        faze: 'Stage',
        kategorie: 'Category',
        produkt: 'Product',
        vse: 'All',
      },
      hledat: 'Search name, phone, email…',
      hledatPopisek: 'Search clients',
      kpi: {
        bezKontaktu: 'No contact for 90+ days',
        celkem: 'Total',
        podepsano: 'Signed this month',
        skupina: 'Quick filters',
        vBehu: 'In progress',
      },
      nalezenoFew: '{n} clients found',
      nalezenoMany: '{n} clients found',
      nalezenoOne: '{n} client found',
      odebratFiltr: 'Remove filter: {nazev}',
      odhad: 'estimate',
      otevrit: 'Open client: {jmeno}',
      popis: 'Client list',
      prazdno: 'No clients yet',
      pridat: 'Add in the app',
      seznam: 'All clients',
      skupina: {
        klient: 'Client',
        proces: 'In progress',
        ziskani: 'Acquisition',
        ztraceno: 'Lost',
      },
      sloupec: {
        akce: 'Open',
        bj: 'BJ',
        dalsiKrok: 'Next step',
        faze: 'Stage',
        klient: 'Client',
        kontakt: 'Last contact',
        produkty: 'Products',
      },
      vymazat: 'Clear search',
      zrusitVse: 'Clear all',
    },
    legendaObchodu: {
      plna: 'Paying out',
      srafa: 'In progress',
      tecky: 'Interest',
    },
    nastroje: {
      cekani: {
        cenaPopisek: 'that much less at the goal if they start {roky} later',
        dohnat: 'Catching up means saving',
        grafPopis: 'Model: starting now gives {hned} in {roky}; waiting gives {pozdeji}.',
        hned: 'Starts now',
        horizont: 'Goal is in',
        legendaModel: 'Dotted = model calculation',
        letFew: '{n} years',
        letMany: '{n} years',
        letOne: '{n} year',
        mesicne: 'Invests per month',
        mesicnePole: 'Monthly amount',
        model: 'Model at a constant {pct} % a year, before fees and taxes — not a guarantee. At {od}–{do} % the cost is {nizsi} to {vyssi}.',
        nadpis: 'The cost of waiting',
        neplatne: 'The delay must be shorter than the time to the goal.',
        neposlano: 'Contributions not made',
        nominalne: 'Nominal amounts, before inflation',
        odklad: 'Starts later by',
        otazka: 'What does it cost the client to wait before investing regularly?',
        pasmo: 'Range: return {od}–{do} %',
        pozdeji: 'Starts in {roky}',
        ukazka: 'Preview',
        uslyVynos: 'Lost return',
        vynos: 'Expected return',
        vynosText: '{pct} % a year',
        zaLetFew: 'in {n} years',
        zaLetMany: 'in {n} years',
        zaLetOne: 'in {n} year',
        zaMesic: 'per month',
      },
      dlazdice: {
        finMatematika: {
          nazev: 'Financial maths',
          popis: 'Loan, investment and annuity — solves for any value.',
        },
        funnely: {
          nazev: 'Funnel library',
          popis: 'Ready-made funnels and a brief builder.',
        },
        historicka: {
          nazev: 'Historical calculator',
          popis: 'How the client’s money would have grown in real markets since 1926.',
        },
        hypoteky: {
          nazev: 'Mortgages',
          popis: 'Mortgages in progress in one place.',
        },
        investicniStrategie: {
          nazev: 'Investment strategies',
          popis: 'Famous strategies and the power of compounding.',
        },
        investicniStudio: {
          nazev: 'Investment studio',
          popis: 'Portfolio today and after the proposal, crises and costs.',
        },
        kalkulacky: {
          nazev: 'Calculators',
          popis: 'Mortgage, investment and other quick calculations.',
        },
        mapa: {
          nazev: 'Client map',
          popis: 'Clients on a map and the route to a meeting.',
        },
        penze: {
          nazev: 'Pension calculator',
          popis: 'How much the client saves for retirement and what the state adds.',
        },
        provize: {
          nazev: 'Commission',
          popis: 'How many BJ and how much money a deal brings.',
        },
        radar: {
          nazev: 'Opportunity radar',
          popis: 'Clients with a gap in protection or finances.',
        },
      },
      novyStyl: 'Calculator in the new style',
      proMe: 'For me',
      uStolu: 'For the client at the table',
    },
    nav: {
      diar: 'Calendar',
      hlavni: 'New CRM navigation',
      klienti: 'Clients',
      nastroje: 'Tools',
      obchody: 'Deals',
      poradce: 'Signed-in adviser: {jmeno}',
      prehled: 'Overview',
      preskocit: 'Skip to content',
      rezimSvetly: 'Switch to light mode',
      rezimTmavy: 'Switch to dark mode',
      znacka: 'New CRM – overview',
      zpet: 'Back to the current CRM',
      zpetKratce: 'Back to CRM',
    },
    nazev: 'New CRM',
    nenalezeno: {
      akce: 'Back to overview',
      nadpis: 'Page not found',
      text: 'This address does not exist in the new CRM.',
    },
    obchody: {
      bezKlienta: 'No client',
      bezNazvu: 'Untitled deal',
      dnyFew: '{n} days at this stage',
      dnyMany: '{n} days at this stage',
      dnyOne: '{n} day at this stage',
      dnyZkratka: '{n}d',
      fazeVyber: 'Deal stage',
      kpi: {
        bjVBehu: 'BJ in progress',
        cekaPodpis: 'Awaiting signature',
        pocetFew: '{n} deals',
        pocetMany: '{n} deals',
        pocetOne: '{n} deal',
        uzavreno: 'Closed this month',
      },
      nicVeFazi: 'Nothing at this stage',
      novy: 'New deal in the app',
      otevrit: 'Open deal: {nazev}',
      prazdno: 'No deals in progress yet',
      trychtyr: 'Deals by stage',
    },
    plan: {
      bezAnalyzy: 'There is no analysis yet. The plan is built from the analysis.',
      bezNavrhu: 'The proposed solution has not been saved yet. Once you save it in the app, it will appear here.',
      chybaBloku: 'This part of the plan could not be calculated',
      chybaVypoctu: 'The plan could not be calculated',
      cile: {
        bezCastky: 'The goal amount is not set — progress cannot be calculated',
        bezHorizontu: 'The goal date is not set — progress cannot be calculated',
        chybi: '{castka} missing',
        dalsichFew: 'and {n} more goals in the proposal',
        dalsichMany: 'and {n} more goals in the proposal',
        dalsichOne: 'and {n} more goal in the proposal',
        dnes: 'today {pct}',
        grafPopis: '{nazev}: today {dnes}, with the plan {po} of the goal {cil}',
        jednorazove: '{castka} lump sum',
        legendaChybi: 'still missing',
        legendaMa: 'has today',
        legendaPlan: 'added by the plan',
        mesicne: '{castka} a month',
        nadpis: 'Goal progress',
        prazdno: 'The proposal has no goals yet',
        prepocetProfil: 'Goal’s own profile — the Proposal calculates progress with it',
        prepocetRucni: 'Manual monthly amount — the Proposal calculates progress with it',
        sPlanem: 'with the plan {pct}',
        souhrn: 'Met with the plan: {n} of {m}',
        splneno: 'met with the plan',
        vlastniZdroje: 'own funds {castka}',
        zAnalyzy: 'changed in the Proposal · analysis: {castka} · {termin}',
      },
      kroky: {
        chybi: {
          majetkove: 'Property insurance — fill in and save the Property insurance card in the proposal',
          rezerva: 'Reserve — essential expenses are missing in the analysis, so there is no reserve target',
          zivotni: 'Life insurance — sums insured cannot be calculated without income and expenses in the analysis',
        },
        chybiTitulek: 'Steps with missing input:',
        hotovo: 'Done',
        naRade: 'Next up',
        nadpis: 'Next implementation steps',
        prazdno: 'The plan has no implementation steps yet',
      },
      majetek: {
        grafPopis: 'Saved for goals under the plan, in today’s prices: peak {castka} in {rok}. A model, not a guarantee.',
        legenda: 'dots and dashes = model under the plan',
        model: 'Total saved for goals under the plan at a {vynos} return, in today’s prices (returns are after inflation) — a model, not a guarantee; returns are not guaranteed. When a goal is reached, the money is spent and the curve drops.',
        nadpis: 'Wealth over time',
        nula: 'Under the plan nothing is being saved for dated goals yet',
        prazdno: 'The plan has no goals with a date yet',
        rada: 'Saved for goals',
        rokVek: '{rok} · {vek}',
        vrchol: 'Peak {castka} in {rok}',
      },
      nadpis: 'Plan',
      navrh: 'Proposed solution',
      ochrana: {
        bezCastek: 'Sums insured cannot be calculated yet — income or expenses are missing',
        castky: 'disability {invalidita} · death {smrt}',
        cenaDoplni: 'a month for the household — the adviser adds the price',
        cenaNeznama: 'The price of protection is not known yet',
        cenaNula: 'Price from the adviser is 0 — nothing is deducted from the surplus',
        cenaPoradce: 'a month for the household, price from the adviser',
        cenaPoradceCast: 'a month, price from the adviser — only part of the price so far',
        nadpis: 'Family protection',
        odhadOrientacne: '≈ {castka} a month — an indicative estimate only',
        odmitnuto: 'The client does not want income protection yet',
        rozdil: 'Pays {stara} today → {nova} new ({rozdil}). The old policy is cancelled, the plan deducts only the difference.',
        rucne: 'edited by the adviser',
        staraNeznama: 'A cancelled policy has no payment entered — it is not yet subtracted in the difference.',
        varianta: 'Cover option in the proposal',
        zdroj: 'Sums insured of the {varianta} option from the Proposal. The recommended cover in the Analysis comes from the analysis calculator, so it may differ.',
      },
      otevritNavrh: 'Open the proposal in the app',
      prazdnaAnalyza: 'The analysis is empty — the plan has nothing to calculate from.',
      prezentace: 'Presentation',
      profil: 'Profile: {nazev}',
      regulace: 'A model plan from the proposed solution, not an offer. Returns are not guaranteed.',
      rezerva: {
        bezCile: 'The reserve target cannot be calculated — expenses are missing',
        dopocetNezbytneFew: 'reserve target · {n} months of essential expenses and repayments',
        dopocetNezbytneMany: 'reserve target · {n} months of essential expenses and repayments',
        dopocetNezbytneOne: 'reserve target · {n} month of essential expenses and repayments',
        dopocetObvykleFew: 'reserve target · {n} months of usual expenses and repayments',
        dopocetObvykleMany: 'reserve target · {n} months of usual expenses and repayments',
        dopocetObvykleOne: 'reserve target · {n} month of usual expenses and repayments',
        jednorazove: 'topped up as a lump sum',
        mesicne: 'topped up monthly',
        nadpis: 'Reserve',
        plnaDnes: 'Already full today',
        plnaSPlanem: 'Full with the plan',
        zadana: 'reserve target set in the analysis',
      },
      rozpocet: {
        cile: 'Goals',
        jednorazove: 'From savings as a lump sum {prideleno} of {celkem}',
        legendaPlan: 'sent by the plan',
        nadPrebytek: 'The extra premium is higher than the surplus — {castka} a month short',
        nadpis: 'Monthly plan budget',
        ochranaNeznama: 'The adviser has not entered the protection price yet — the plan does not count it',
        ochranaNula: "The adviser's protection price is 0 — nothing is deducted",
        ochranaOdmitnuta: 'The client does not want income protection yet — not deducted',
        pojistneNove: 'Premium {nova} is among fixed payments',
        pojistneZmena: 'Premium among fixed payments: today {stara} → new {nova} ({rozdil})',
        prebytek: 'monthly surplus — where it goes',
        prebytekNejisty: 'Income, expenses and repayments would give {castka} a month — check the agreed surplus in the app.',
        prebytekNezadany: 'The surplus is not entered',
        prebytekNula: 'The surplus is zero',
        prebytekPoPojistnem: 'monthly surplus after premiums — where it goes',
        precerpano: 'The plan allocates more than the surplus',
        renta: 'Investing for retirement income',
        rezerva: 'Reserve',
        vyrovnano: 'All the money has a job',
        zadneZdroje: 'The plan has nothing to allocate — no surplus and no free savings.',
        zbyva: 'Not assigned yet',
      },
      ulozeno: 'Saved {datum}',
      vynos: {
        optimisticky: 'Optimistic return',
        pesimisticky: 'Pessimistic return',
        realisticky: 'Realistic return',
      },
      vynosVeVete: {
        optimisticky: 'optimistic',
        pesimisticky: 'pessimistic',
        realisticky: 'realistic',
      },
    },
    prehled: {
      dnes: {
        bezCasuFew: '{n} tasks without a time',
        bezCasuMany: '{n} tasks without a time',
        bezCasuOne: '{n} task without a time',
        dalsichFew: 'And {n} more today',
        dalsichMany: 'And {n} more today',
        dalsichOne: 'And {n} more today',
        nadpis: 'Today',
        nejblizsiCas: 'Next activity at {cas}',
        nejblizsiNadpis: 'Next in your calendar',
        nicDnes: 'Nothing else in your calendar today',
        otevritDiar: 'Open calendar',
        poTerminuFew: '{n} overdue',
        poTerminuMany: '{n} overdue',
        poTerminuOne: '{n} overdue',
        seznam: 'More activities today',
      },
      klienti: {
        nadpis: 'Recent clients',
      },
      obchody: {
        bjVBehu: 'BJ in progress in total',
        nadpis: 'Deals in progress',
        prazdno: 'No deals in progress',
      },
      pece: {
        bezKontaktu: 'No contact',
        dalsichFew: 'and {n} more',
        dalsichMany: 'and {n} more',
        dalsichOne: 'and {n} more',
        dniFew: '{n} days',
        dniMany: '{n} days',
        dniOne: '{n} day',
        fixace: 'Fixation ends',
        konecSmlouvy: 'Contract ends',
        nadpis: 'Clients to look after',
        prazdno: 'No fixation ending within 120 days and no one without contact for over 90 days',
        vyroci: 'Contract anniversary',
      },
      plan: {
        nadpis: 'Monthly plan',
      },
      provize: {
        bezPozice: 'Position not set',
        koef: '{koef} {mena} per BJ · position {pozice}',
        koefVychozi: '{koef} {mena} per BJ (default)',
        nadpis: 'Estimated commission',
      },
      radar: {
        dalsiMezeryFew: '+{n} more gaps',
        dalsiMezeryMany: '+{n} more gaps',
        dalsiMezeryOne: '+{n} more gap',
        dalsichKlientuFew: 'and {n} more clients with a gap',
        dalsichKlientuMany: 'and {n} more clients with a gap',
        dalsichKlientuOne: 'and {n} more client with a gap',
        kriticka: 'Critical gap',
        krok: 'Suggested step',
        nadpis: 'Opportunity radar',
        otevrit: 'Open the radar in the current CRM',
        prazdno: 'No open opportunities',
        skore: 'score {n}',
      },
    },
    produkt: {
      hypoteka: 'Mortgage',
      investice: 'Investments',
      majetek: 'Property',
      penze: 'Pension',
      uver: 'Loan',
      zp: 'Life insurance',
    },
    produktObchodu: {
      hypoteka: 'Mortgage',
      investice: 'Investments',
      jine: 'Other',
      koupe_nemovitosti: 'Property purchase',
      penzijko: 'Pension savings',
      podnikatelsky_uver: 'Business loan',
      pojisteni_auta: 'Car insurance',
      pojisteni_majetek: 'Property insurance',
      pojisteni_zivot: 'Life insurance',
      prodej_nemovitosti: 'Property sale',
      refinancovani: 'Refinancing',
      spotrebitelsky_uver: 'Consumer loan',
      stavebni: 'Building savings',
      uver: 'Loan',
    },
    prototyp: 'Prototype · read-only',
    pruvodce: {
      nadpis: 'This is a draft of the new CRM',
      rozumim: 'Got it',
      text: 'The data is real and read-only. The look and order of the screens may still change.',
      zapis: 'Keep editing and adding records in the current CRM.',
    },
    stav: {
      fazeNezadana: 'Stage not set',
      nacitam: 'Loading…',
      nezadano: 'not entered',
      nicNeodpovida: 'Nothing matches the filter',
      prazdno: 'Nothing here yet',
      starsiData: 'Older data · {cas}',
    },
    termin: {
      dnes: 'today',
      poFew: '{n} days overdue',
      poMany: '{n} days overdue',
      poOne: '{n} day overdue',
      zaFew: 'in {n} days',
      zaMany: 'in {n} days',
      zaOne: 'in {n} day',
      zitra: 'tomorrow',
    },
    zalozky: {
      analyza: 'Analysis',
      klient: 'Client',
      nadpis: 'Client sections',
      plan: 'Plan',
      prezentace: 'Presentation',
      vAppce: 'opens the current CRM',
    },
    zastupny: {
      nadpis: 'Screen in progress',
      text: 'This part of the new CRM is still being built. For now, use the current CRM.',
    },
  },
  /* BLOK:novyCrm END */
  /* BLOK:vystup START — generuje scratchpad/slovnik.py, ručně needitovat */
  vystup: {
    bullet: {
      aria: {
        chybi: '{popisek}: need {potreba}, covered {kryto}, gap {chybi}.',
        kryto: '{popisek}: need {potreba}, covered {kryto}. Fully covered.',
        nezadano: '{popisek}: need not entered.',
        neznameKryti: '{popisek}: need {potreba}, arranged cover not entered.',
      },
      chybi: 'Gap {castka}',
      krytiNezadane: 'Cover not entered',
      kryto: 'Covered',
      nadRamec: 'Covered, {castka} extra',
      potreba: 'Need {castka}',
      potrebaNezadana: 'Need not entered',
      sjednano: 'Arranged {castka}',
      stat: 'State {castka}',
    },
    cara: {
      aria: 'Projection over {roky}: middle scenario {stred}, range {od} to {do}.',
      ariaSrovnani: 'For comparison, {popisek}: {hodnota}.',
      pasmo: 'Worse to better scenario',
      prazdno: 'Projection not entered',
      stred: 'Middle scenario',
    },
    kobliha: {
      aria: 'Breakdown of {celkem}: {dily}.',
      celkem: 'Total',
      nezadano: 'No amount: {polozky}',
      ostatni: 'Other',
      prazdno: 'Nothing to break down',
    },
    kroky: {
      aktivni: 'current',
      aria: 'Progress: step {n} of {celkem}, {popisek}',
      ceka: 'upcoming',
      hotovo: 'done',
    },
    letFew: '{n} years',
    letMany: '{n} years',
    letOne: '{n} year',
    mesicne: 'per month',
    modelNeniGarance: 'A model, not a guarantee. The actual result may be higher or lower.',
    nezadano: 'not entered',
    rezim: {
      nazev: 'Preview mode',
      obrazovka: 'Screen',
      papir: 'Paper',
      prezentace: 'Presentation',
    },
    splatka: {
      aria: 'Payment {splatka} per month, {roky}. In total {celkem}, of which interest {urok}.',
      ariaUrokNejdriv: 'Early payments are mostly interest, later ones mostly principal.',
      jistina: 'Principal',
      popisek: 'Payment',
      prazdno: 'Loan not entered',
      rok: 'Year {n}',
      souhrn: 'In total you pay {celkem}, of which interest {urok}.',
      urok: 'Interest',
    },
    tok: {
      aria: 'Where the money goes: {toky}.',
      krok: '{z} → {do}: {castka}',
      krokKam: '{z} → {do}: {castka}, {kam}',
      nezadano: 'No amount: {toky}',
      ostatni: 'Other',
      prazdno: 'No money flow',
    },
    ukazka: {
      bullet: 'Need vs. arranged',
      cara: 'Projection with range',
      d: {
        akcie: 'Equities',
        analyza: 'Analysis',
        bezPlanu: 'Without plan',
        deti: 'Investment for children',
        dluhopisy: 'Bonds',
        dps: 'supplementary pension savings',
        fondy: 'mutual funds',
        hotovost: 'Cash',
        hotovostTrida: 'Cash',
        hypoteka: 'Mortgage payment',
        invalidita: 'Disability',
        jednorazove: 'One-off',
        mesicne: 'Monthly',
        nemovitosti: 'Real estate funds',
        nezbytne: 'Essential expenses',
        plan: 'Plan',
        pn: 'Sick leave',
        podminkyUveru: '{castka} · {roky} · interest {sazba}',
        pojisteni: 'Insurance',
        prebytek: 'Monthly surplus',
        predstaveni: 'Introduction',
        prijem: 'Net income',
        realizace: 'Implementation',
        renta: 'Retirement income',
        rezerva: 'Reserve',
        sPlanem: 'With plan',
        servis: 'Service',
        smrt: 'Death',
        sporiciUcet: 'savings account',
        stavebko: 'Building savings loan payment',
        styl: 'Lifestyle',
        volne: 'Free money',
        zlato: 'Gold',
      },
      kdeBullet: 'Risks and reserve in the plan presentation',
      kdeCara: 'With plan vs. without plan',
      kdeKobliha: 'Portfolio in at most five classes',
      kdeKroky: 'Client journey',
      kdeSplatka: 'Mortgage goal — instead of the Historical calculator',
      kdeStavebko: 'Rest of the goal as a building savings loan',
      kdeTok: 'Where the money goes — one-off and monthly separately',
      kdeVelkeCislo: 'Headline number of a calculator or slide',
      kdeVlozeno: 'Investment for children: lump sum and regular, then drawdown',
      kdeVodopad: 'Income → expenses → free money',
      kobliha: 'Donut',
      kroky: 'Step indicator',
      navrh: 'Preview for approval — nothing has been replaced in the plan, presentation or print yet.',
      prehrat: 'Play again',
      splatka: 'Payment and interest',
      tok: 'Money flow',
      ucebniCisla: 'Sample numbers, no client.',
      velkeCislo: 'Big number',
      vlozeno: 'Paid in vs. growth',
      vodopad: 'Waterfall',
    },
    vlozeno: {
      aria: 'In {roky} you save {hodnota}: paid in {vlozeno}, growth {zhodnoceni}.',
      ariaCerpani: 'Then {roky} of drawdown at {castka} per month.',
      cerpani: 'Drawdown',
      cerpaniVeta: 'Then {roky} of drawdown at {castka} per month',
      pasmo: 'Scenario range',
      pasmoVeta: 'Worse to better scenario: {od} – {do}',
      popisek: 'In {roky}',
      prazdno: 'Contribution not entered',
      vlozeno: 'Paid in',
      zhodnoceni: 'Growth',
    },
    vodopad: {
      aria: '{kroky}. Result {vysledek}.',
      ariaNelze: '{kroky}. Result cannot be calculated.',
      nelze: 'Result cannot be calculated, missing: {polozky}',
      vysledek: 'Result',
    },
    zaMesic: '/ mo',
  },
  /* BLOK:vystup END */
  /* BLOK:vnRodina START — generuje scratchpad/slovnik.py, ručně needitovat */
  vnRodina: {
    cile: {
      bydleni: {
        akontace: 'Deposit {pct} %:',
        akontaceHned: 'You need the deposit right away',
        cena: 'A home for',
        cenaPole: 'Price of the home',
        doRoku: 'until {rok}',
        dopocteno: 'repayment estimated',
        letPole: 'Years left to repay',
        na: 'over',
        nadpis: 'Home',
        odkladatNaAkontaci: 'Put aside for the deposit each month',
        otazka: 'Are you paying off a loan, or do you still want to buy a home?',
        pakSplatka: 'then a repayment of about',
        platite: 'You already pay each month',
        rezimDluh: 'Paying off a loan',
        rezimKoupit: 'Want to buy',
        rezimNic: 'Sorted',
        uver: 'Loan',
        vyreseno: 'Your housing is sorted.',
        za: 'in',
        zaPole: 'In how many years you want to buy',
        zbytekPole: 'Remaining loan balance',
        zbyva: 'Still to repay',
      },
      deti: {
        bezDeti: 'No children under 23.',
        naDiteMesicne: 'per child per month',
        nadpis: 'Children up to 23',
        nakladPole: 'Monthly cost of one child',
        radek: 'Child {n} · {mesicu} months',
        samostatne: 'Independent children not counted: {pocet}',
        stoji: 'Up to age 23 this costs',
        zVyplaty: 'Paid from wages today, per month',
      },
      duchod: {
        aria: 'Retirement, what the state pays and the gap: {radky}',
        ariaRadek: '{kdo} state {stat}, gap {chybi}',
        chybi: 'gap',
        chybiRadek: 'gap',
        cilPole: 'How much each of you wants per month in retirement',
        naOsobu: 'a month each',
        nadpis: 'Retirement',
        odchodV: 'Retirement at age',
        odkladat: 'put aside monthly',
        rezimAria: 'How to set the retirement goal',
        rezimCastka: 'Amount',
        rezimStandard: 'Keep our standard',
        standardText: "Keep today's standard: 80 % of each person's current net income.",
        stat: 'state pension (estimate)',
        statRadek: 'state approx.',
        uzVDuchodu: 'already at retirement age',
        vekPole: 'Retirement age',
      },
      nadpis: 'The family goals',
      odkladatCelkem: 'Needed for the goals each month',
      odkladatModelove: '(a model, returns are not certain)',
      prijemRodiny: 'Family income',
      uvod: 'A home, children up to 23 and retirement.',
    },
    hlavicka: {
      navAria: 'Sections of the analysis',
      podtitul: 'A family story: goals and what keeps them safe',
      poradce: 'Adviser',
      priklad: 'Fill in an example',
      promitani: 'Show to the client',
      promitaniKonec: 'Stop showing',
      zpet: 'Back to the Analysis for Vietnamese clients',
    },
    investice: {
      ariaRozdeleni: 'Of the {balicek} package, {ochrana} goes on protection and {investice} into investment.',
      cenaOdPoradce: 'Price of protection from the adviser',
      dnesnimaOcima: "in today's money {castka}",
      doInvestic: 'into investment',
      doVeku: 'Until age',
      dopadPoplatku: 'Together the two fees lower the model value by {castka}.',
      grafAria: 'By age {vek} you pay {zaplaceno} in total, of which {ochrana} goes on protection that is not paid back. The model value of the investment at {vynos} % is {hodnota}, within a range of {od} to {do}. A model, not a promise.',
      hodnotaModel: 'value · model {vynos} %',
      hodnotaPri: 'value at {vynos} %',
      hodnotaVeVeku: 'Value at age {vek} · model {vynos} %',
      investuje: 'invested',
      naOchranu: 'on protection (not paid back)',
      nadpis: 'If nothing happens',
      nakladyNaKonci: 'at age {vek}',
      nakladyNadpis: 'Costs over time',
      nakladyPoLetechFew: 'after {n} years',
      nakladyPoLetechMany: 'after {n} years',
      nakladyPoLetechOne: 'after {n} year',
      nezadano: 'not entered',
      ochranaPopisek: 'of which on protection {castka}, not paid back',
      pasmo: 'range of models',
      pasmoOdDo: 'at {od}–{do} %: {hodnotaOd} to {hodnotaDo}',
      poplatkyDosud: 'fees up to then',
      poplatkyNadpis: 'What the fees cost',
      protiCili: "By your goals, retirement is short by {potreba} in today's money. The investment model comes to {pct} % of that amount.",
      prubezny: 'Ongoing fee',
      prubeznyRadek: '{pct} a year of the investment balance, in total over {roky}',
      uvod: 'Protection is paid from the package; the rest is invested up to the chosen age.',
      vekTooltip: 'age {vek}',
      vstupni: 'Entry fee',
      vynos: 'Model return per year',
      zBalicku: 'Out of the {balicek} monthly package:',
      zTohoOchrana: 'of which on protection',
      zaplaceno: 'Paid in total',
      zaplacenoJak: 'the whole package {balicek} × 12 months × {roky}',
    },
    jednotka: {
      rokFew: 'years',
      rokMany: 'years',
      rokOne: 'year',
      vekFew: 'years',
      vekMany: 'years',
      vekOne: 'year',
    },
    nav: {
      cile: 'Goals',
      investice: 'Investment',
      ochrana: 'Protection',
      odkladat: 'Saving',
      otazky: 'Questions',
      prijmy: 'Income',
      rodina: 'Family',
      srovnani: 'Comparison',
      vypadek: 'If income stops',
      zaver: 'Summary',
    },
    neuplne: {
      cilBydleni: 'housing price or timing',
      nadpis: 'Incomplete, missing:',
      uver: 'loan balance or years',
      vekDitete: 'age of child {n}',
    },
    ochrana: {
      bezMesicne: '{castka} is missing every month. This part has no source of money.',
      bezPn: '{castka} is missing for every day of illness.',
      bezZo: 'Treatment takes months; the bills keep coming and the income is missing.',
      detiCastka: 'Each child: {castka}.',
      dil: {
        bydleni: 'Home',
        deti: 'Children up to 23',
        dluh: 'Share of the loan',
        duchod: 'Retirement',
        duchodPozustaleho: "Partner's retirement",
        renta: 'Income for the family',
        zivot: 'Everyday life until retirement',
      },
      doplniPoradce: 'adviser to add',
      kazdeDite: 'Each child',
      kdoAria: 'Whose calculation to show',
      krokMetodou: 'By calculation (need − state)',
      krokMinimum: 'Minimum = sum insured',
      naDen: '/ day',
      naDnesek: "converted to today's money (4 % a year)",
      naNoc: '/ night',
      nadpis: 'Family protection, risk by risk',
      nepojistujeSe: 'not insured',
      pnBezPrijmu: 'No income. Adviser to add the cover.',
      pnNicNechybi: 'Sickness benefit from the state covers your income.',
      pnPotreba: 'Your net income per day',
      pnStat: 'Sickness benefit from the state',
      podRiziko: {
        dou: 'per day of injury treatment',
        hosp: 'per night in hospital',
        invalidita: 'for full disability',
        pn: 'per day of illness or injury',
        smrt: 'lump sum to the family',
        tnu: 'after an accident, by extent',
        zo: 'lump sum on diagnosis',
      },
      popis: {
        dou: "A payment for each day you are treated after an accident. How many days an injury is paid for is set by the insurer's table.",
        hosp: 'A payment for each night in hospital.',
        invalidita: 'When your health keeps you from working for a long time. The state sets degrees by how much your ability to work has dropped.',
        pn: 'When illness or injury keeps you from working for a while. Sickness benefit from the state replaces only part of your income.',
        smrt: "The family receives a lump sum: it pays the share of the loan and of the children's costs up to 23 that this income carried, and tops up the missing income.",
      },
      riziko: {
        dou: 'Daily injury benefit',
        hosp: 'Hospital stay',
        invalidita: 'Disability',
        pn: 'Unable to work',
        smrt: 'Death',
        tnu: 'Permanent injury',
        zo: 'Critical illness',
      },
      sJednorazove: 'The family receives {castka} and the goals stay in place.',
      sPn: 'A daily benefit of {pn}, plus {dou} after an accident.',
      sPnBezDou: 'A daily benefit of {pn}.',
      sZo: 'A lump sum of {castka} on a diagnosis from the list in the policy.',
      stat: {
        invalidita: 'Disability pension (estimate)',
        smrt: "Survivor's and orphan's pension (estimate)",
      },
      statStupen: 'state approx. {castka} a month',
      stupen: {
        I: 'Degree I · 35–49 %',
        II: 'Degree II · 50–69 %',
        III: 'Degree III · 70 % or more',
        nad40: 'reduction over 40 %',
        nad70: 'reduction over 70 %',
      },
      tabulkaAria: 'Protection by risk and person',
      tnuPasma: 'Paid out in bands:',
      tnuPasmo: '{od}–{do} % ×{k}',
      tnuTabulka: 'What is paid out of {castka} by extent of injury',
      uvod: 'What the family would receive for each event. Risks are not paid out together, so the amounts do not add up.',
      vodopadAria: 'Need {potreba}, state approx. {stat}, gap {chybi}.',
      zoRokyFew: '{n} years of net income',
      zoRokyMany: '{n} years of net income',
      zoRokyOne: '{n} year of net income',
      zoRucne: 'Amount entered by the adviser',
    },
    odkladat: {
      ariaVolne: 'After spending and repayments {volne} is left; the package is {balicek}.',
      celyPlan: "The package is the whole family plan: protection and investment. How much of it the protection costs, your adviser works out from the insurer's offer.",
      doplnPrijmy: 'The packages appear once incomes are entered.',
      doporuceno: 'recommended',
      nadpis: 'How much the family can put aside',
      nevejdeSe: 'does not fit, short by',
      nevejdeSeKratce: 'does not fit',
      odkladate: 'you put aside',
      rozdeleniInvestice: 'and investment gets',
      rozdeleniOchrana: 'protection takes',
      rozdeleniZ: 'Out of',
      uvod: 'For the family goals: 10 to 30 % of net income.',
      uvodDoporuceni: 'Of {prijem} a month, we recommend putting aside {pct} %.',
      vlastni: 'Custom amount:',
      vyberAria: 'What percentage of income to put aside',
      zVolnych: 'from what is left over',
      zbyvaVolne: 'still free',
      zpetNaDoporuceni: 'back to the recommendation',
    },
    osa: {
      ariaDite: 'child {n} independent in {rok}',
      ariaDospely: '{kdo} retires in {rok}',
      ariaUver: 'loan paid off in {rok}',
      diteZkratka: 'C{n}',
      dnes: 'today',
      duchod: 'retires at {vek} · {rok}',
      prazdno: 'The timeline appears once ages are entered.',
      samostatne: 'already independent',
      samostatneRok: 'age 23 · {rok}',
      uver: 'Loan',
      uverDo: 'paid off {rok}',
    },
    otazky: {
      faq: {
        dlouho: {
          odpoved: 'The entry fee is paid off in the first years, so if you end it early you get little or nothing back. Depending on the policy, you can lower the payment, pause investing for a while or take money from the investment part. You can withdraw from the policy within 30 days of taking it out.',
          otazka: 'Why so long? And what if I need to pause, change or take money out?',
        },
        kamInvest: {
          odpoved: "Into funds you choose from the insurer's list: equity, bond or mixed funds. The strategy can be changed during the policy. The value can fall below what you paid in.",
          otazka: 'Where is the money invested?',
        },
        nemocny: {
          odpoved: 'It depends on the illness and the insurer. They may accept you at the normal price, with a loading, with that illness excluded, or turn you down. State the illness truthfully in the questionnaire, otherwise the insurer may not pay.',
          otazka: 'I am ill. Can I get insured?',
        },
        podvod: {
          odpoved: "The insurer and the adviser must be licensed and listed in the central bank's register — you can check this yourself by name. Before signing you get the terms, an overview of the costs and a record of the meeting in writing. Nothing needs to be signed straight away.",
          otazka: "Isn't this a scam?",
        },
        poplatky: {
          odpoved: "The entry fee is a percentage of the target amount, the ongoing fee a percentage of the balance each year. Both are shown in money next to the chart, and all costs are also in the insurer's documents.",
          odpovedCisla: "The entry fee of {pct} of the target amount is {vstupni}. The ongoing fee of {prubeznyPct} a year comes to {prubezne} over the whole period. All costs are also in the insurer's documents.",
          otazka: 'How much are the fees?',
        },
        vratiSe: {
          odpoved: 'Not all of it. The part that pays for protection is the price of the family being covered the whole time — it is not paid back, just like compulsory car insurance. Money for old age comes only from the investment part and its amount is not certain.',
          otazka: 'If nothing happens, do I get back what I paid?',
        },
        vybrat: {
          odpoved: 'From the investment part, usually yes. How much, how fast and with what fee is set by the policy. The protection part is not paid back, so money you may need quickly belongs in a reserve on an account next to the policy.',
          otazka: 'If I run short of money, can I take it out?',
        },
        vynos: {
          odpoved: 'Because the money works regularly over a long time. 5, 7 and 9 % are model rates, not a promise — the real return can be lower or even negative. That is why the chart always shows how much you pay in total.',
          otazka: 'Why does it earn so much?',
        },
      },
      nadpis: 'Your questions',
      vedet: {
        dlouho: 'It is long term. If you end it in the first years, you get little or nothing back.',
        nadpis: 'Three things you need to know',
        poplatky: 'You see the fees above in money, not only as percentages.',
        vynos: 'The return is not certain. The value of the investment can also fall.',
      },
    },
    pomocnik: {
      hledat: 'Search questions',
      nadpis: 'What Vietnamese people in Czechia ask',
      nicNenalezeno: 'Nothing found.',
      otevrit: "Adviser's helper · {pocet} questions",
      pravo: 'Answers under Czech law, checked on 30 Sep 2026.',
      zdroj: 'Source: {zdroj}',
    },
    prijmy: {
      ariaPrijem: 'Family income {celkem}: {dily}',
      ariaVydaje: 'Where the income goes: {dily}',
      chybi: 'short',
      doDuchodu: 'until retirement',
      doplnPrijmy: 'The income bar appears once age and income are entered.',
      mesicne: 'per month',
      nadpis: 'How much passes through your hands',
      rocne: 'per year',
      splatky: 'loan repayments',
      uvod: 'Both incomes together, and where the money goes.',
      volne: 'left over',
      vydaje: 'spending',
      vydajePole: 'Family spending per month (excluding loan repayments, including children)',
      vydajeUpresneni: 'excluding loan repayments, including children',
      vydajeVeta: 'The family spends each month',
    },
    rodina: {
      bezDeti: 'none yet',
      bezPrijmu: 'no income',
      bezPrijmuPrepinac: 'No income right now (parental leave, at home)',
      deti: 'Children',
      diteCislo: 'Child {n}',
      mesicne: 'a month',
      nadpis: 'Your family',
      odebratDite: 'Remove child {n}',
      odebratPartnera: 'Remove the second adult',
      osvc: 'self-employed',
      pridatDite: 'Add a child',
      pridatPartnera: 'Add a partner',
      prijem: 'net income',
      prijemKoho: '{kdo} · net income per month',
      uvod: 'Who is in the family, how old everyone is and what each of you earns.',
      vek: 'age',
      vekDitete: 'Child {n} · age',
      vekKoho: '{kdo} · age',
    },
    role: {
      bo: 'Dad',
      boZkratka: 'D',
      me: 'Mum',
      meZkratka: 'M',
    },
    srovnani: {
      balicek: 'Package',
      cimDriv: "If you started only at {vek}, you would pay {mene} less, but by the model you would have {cena} less (in today's money).",
      legenda: 'Each cell shows the model value and, below it, how much you pay in total. Amounts in {symbol}.',
      mesicne: '{castka} a month',
      nadpis: 'The more and the sooner',
      ochranaStejna: 'protection {castka} a month in every package',
      prazdno: 'The comparison appears once incomes and the price of protection are entered.',
      startDnes: 'Start today',
      startZa: 'In {roky} years',
      tabulkaAria: 'Model value at age {vek} at {vynos} % by package and start',
      uvod: 'Model value at age {vek} at {vynos} %: depending on how much you put aside and when you start.',
    },
    stitek: {
      bezNarokuInv: 'no entitlement to an invalidity pension',
      bezPrijmuDoplniPoradce: 'no income; adviser to add the cover',
      bezPrubeznehoPoplatku: 'without the ongoing fee; the real figure will be lower',
      bezRustuMzdy: "in today's money, without pay rises",
      bezVstupnihoPoplatku: 'without the entry fee; the real figure will be lower',
      bezVynosuKratkyCil: 'short-term goal, calculated without returns',
      dnesniPenize: "in today's money (inflation 2.5 %)",
      duchodBezNaroku: 'no entitlement: under 5 years of insurance in the last 10',
      duchodMinimum: 'statutory minimum',
      duchodOsvcMinimalni: 'self-employed: pension from minimum contributions',
      duchodOveritNarok: 'entitlement unknown, calculated without it: check the ČSSZ statement',
      invaliditaBezPrijmuB: 'parent without income: covers 20% higher expenses minus disability pension',
      invaliditaPoOdchodu: 'disability is not insured after retirement age',
      modelovyVynos: 'model return, not a promise; the value can also fall',
      narokNeovren: 'entitlement not verified',
      ochranaJeNaklad: 'protection is the price of cover; it is not paid back',
      osvcBezNemocenske: 'self-employed without voluntary sickness insurance: the state does not pay',
      osvcNeodecteno: 'self-employed: state pension not deducted, only the social security office knows the amount',
      overitUPojistovny: 'check with the insurer (usually up to {strop})',
      podilNaPrijmu: 'share of the goals by share of family income',
      podlePodminekPojistovny: 'according to the policy terms',
      pozustalostniBezNaroku: "without the required contribution period: survivor's and orphan's pensions not deducted",
      pozustalostniBezPrijmu: "no income: survivor's and orphan's pensions not deducted; adviser to add",
      pozustalostniOsvc: "self-employed: survivor's and orphan's pensions not deducted, only the social security office knows the entitlement",
      sablona: 'template, adviser to verify',
      statOdhad: 'estimate; entitlement only after 5 years of contributions in the last 10',
      statPoradce: 'entered by the adviser',
      statSkDoplniPoradce: 'adviser to add the old-age pension',
      statSkSablona: 'Slovak Social Insurance average, adviser to verify',
      vdovskyJenManzelum: "survivor's pension only for spouses: not deducted",
      vdovskyNevime: "survivor's pension not deducted: marital status not entered",
      zoBezOdectuStatu: 'sickness benefit only covers time off work; it is not deducted from critical illness',
    },
    stop: {
      bezBalicku: 'Choose a package or enter a custom amount.',
      bezCenyZajisteni: "The adviser enters the price of protection from the insurer's quote.",
      bezCileDuchodu: 'Enter how much they want per month in retirement.',
      bezHorizontu: "The target age must be higher than today's age.",
      bezNakladuNaDite: 'Enter how much one child costs per month.',
      bezOsob: 'Enter at least one adult.',
      bezPrijmu: 'Net income is missing. If this person has no income, switch on “no income”.',
      bezVeku: 'Age is missing.',
      bezVydaju: "The family's monthly spending is missing.",
      celyBalicekNaOchranu: 'The whole package goes on protection. Nothing builds up from it for old age.',
      cilBydleniNeuplny: 'The home is missing its price or the number of years.',
      dluhNeuplny: 'The loan is missing its balance or the years left.',
      nejdrivRozpocet: 'Spending is higher than income. Budget first, then the package.',
      nejmensiNevejde: 'Not even {pct} % ({balicek}) fits into the free money of {volne}. Choose your own amount, or sort out the budget first.',
      prubeznyMimoRozsah: 'The ongoing fee must be between 0 and {max} % a year.',
      vekMimoRozsah: 'Age must be between {min} and {max}.',
      vekOdchoduMimoRozsah: 'Retirement age must be between {min} and {max}.',
      vynosMimoRozsah: 'The return after fees falls outside the range we calculate with.',
    },
    suplik: {
      ano: 'Yes',
      balicek: 'Package',
      cenaOchrany: 'Monthly cost of protection',
      cenaOchranyNapoveda: "From the insurer's quote. The app does not estimate the price.",
      davkyNapoveda: 'Empty = estimate by the app under the law.',
      douDospely: 'Adult daily injury benefit, per day',
      invPodilNad40: 'Reduction over 40 %: what % of the sum insured',
      invalidniDuchod: 'Disability pension at full disability from the statement, monthly',
      manzelstvi: 'Marriage',
      nadpis: 'For the adviser',
      narok: 'Entitled to an invalidity pension (5 years of contributions out of the last 10)',
      ne: 'No',
      nevim: 'Not sure',
      ochranaInvestice: 'Protection and investment',
      osvc: 'Self-employed',
      prubeznyPoplatek: 'Ongoing fee (% a year)',
      role: 'Who this is',
      sazba: 'Interest rate',
      sezdani: "Are they married? The survivor's pension is only for spouses.",
      splatka: 'Monthly repayment',
      splatkaNapoveda: 'Empty = the repayment is estimated.',
      statniDuchod: 'Old-age pension from the statement, monthly',
      stavDat: 'Data status',
      tnu: 'Permanent injury: sum insured',
      typ: 'Type of income',
      uver: 'Loan from the contract',
      varianta: 'How the entry fee is paid',
      vekCil: 'Invest until age',
      vlastniBalicek: 'Custom monthly amount (instead of 10–30 %)',
      volbyOchrany: 'Protection options',
      vseZadano: 'Nothing is missing.',
      vstupniPoplatek: 'Entry fee (% of the target amount)',
      vynos: 'Model return per year',
      zamestnanec: 'Employee',
      zavrit: 'Close',
      zoRoky: 'Critical illness: how many years of income',
      zoRokyVolbaFew: '{n} years',
      zoRokyVolbaMany: '{n} years',
      zoRokyVolbaOne: '{n} year',
      zoRucne: 'Critical illness, manual amount · {kdo}',
    },
    trapeni: {
      cesky: {
        odpoved: 'Documents can be in Czech or another agreed language. I will explain everything in Vietnamese, but the wording of the policy is what binds, and you get a record of the meeting. Nothing needs to be signed today — take the documents home, read them with someone you trust, and do not sign anything you do not understand.',
        otazka: "The whole policy is in Czech and I don't understand it. Must I sign it the same day?",
        otazkaVi: 'Hợp đồng toàn tiếng Séc, tôi đọc không hiểu thì ký thế nào? Có cần ký luôn hôm nay không?',
        zdroj: 'Czech Insurance Distribution Act § 79, 90; Czech Civil Code § 2789; KID (PRIIPs Regulation)',
      },
      dane: {
        odpoved: 'Premiums for tax-supported life insurance can be deducted from the tax base, up to CZK 48,000 a year together with pension savings and DIP. The payout must come no earlier than the year you turn 60 (and after 120 months for policies from 2024); an earlier withdrawal means the deductions are taxed back for up to 10 years. You only save the tax on the deducted amount, at the 15 % rate at most CZK 7,200 a year; flat-tax payers and non-residents outside the EU cannot claim it.',
        otazka: 'Can I deduct this from my taxes? How much?',
        otazkaVi: 'Mua cái này có được khấu trừ thuế không? Được bao nhiêu?',
        zdroj: 'Czech Income Tax Act § 15, 15a, 15b; Czech Financial Administration',
      },
      deti: {
        odpoved: "First we protect the parents' income, because the children live on it. Cover for a child is mainly for a serious injury or illness, when a parent stays at home and costs rise; the default is critical illness CZK 2 million, permanent injury CZK 2 million, daily benefit CZK 500 and hospital stay CZK 1,000 a day. The age of 23 is a planning choice — the Czech state treats a studying child as dependent up to 26 at most.",
        otazka: 'The children are small. Should I insure them too? Until when will they need money?',
        otazkaVi: 'Con còn nhỏ, có nên mua cho con không? Con đi học đại học thì cần tiền đến bao giờ?',
        zdroj: "Czech Pension Insurance Act § 20, 52; this analysis's method",
      },
      dotaznik: {
        odpoved: 'Yes — every question truthfully and completely, including the small things the insurer asks about. If a concealment comes to light, the insurer can withdraw from the policy or refuse to pay exactly when the family needs it. A truthful answer can mean a higher premium or an exclusion, but the policy then holds.',
        otazka: 'Do I have to put everything in the questionnaire? What if I leave out something small?',
        otazkaVi: 'Khai sức khỏe có phải khai hết không? Bệnh vặt không khai có sao không?',
        zdroj: 'Czech Civil Code § 2788, 2808, 2809',
      },
      duchodOsvc: {
        odpoved: 'Both the old-age and the disability pension are calculated from the amounts you paid contributions on, so with minimum contributions they will be low. The disability pension also needs enough insured years (over the age of 28, 5 years within the last 10). The exact record of your years and payments is available from the Czech social security office (personal pension record on the ePortal).',
        otazka: 'I pay only the minimum social contributions. What pension will I get? And what will the state pay if I become disabled?',
        otazkaVi: 'Tôi chỉ đóng bảo hiểm xã hội mức thấp nhất, sau này lương hưu được bao nhiêu? Mất sức lao động thì nhà nước trả gì?',
        zdroj: 'Czech Pension Insurance Act § 16, 40; Czech Social Security Administration',
      },
      invalidita: {
        odpoved: 'Disability is a long-term drop in the ability to work because of health; the Czech state has three degrees: 35–49 %, 50–69 % and 70 % or more. The policy pays by its own terms — some follow the social security decision, others their own assessment, usually only once the condition has stabilised. So I always show from which degree it pays and how much.',
        otazka: 'What is disability? When do I get money?',
        otazkaVi: 'Mất sức lao động là thế nào? Bao giờ thì được trả tiền?',
        zdroj: 'Czech Pension Insurance Act § 39; policy terms',
      },
      kamInvest: {
        odpoved: "The investment part buys units in funds you choose from the insurer's list — equity, bond, mixed or money-market funds. The more equities, the higher the possible return and the bigger the swings, and the value can fall below what you paid in. The strategy can usually be changed; conditions and fees are in the price list.",
        otazka: 'What is the money invested in? Can I lose everything?',
        otazkaVi: 'Tiền này đầu tư vào đâu? Có bị mất trắng không?',
        zdroj: 'Czech Insurance Distribution Act § 86; KID (PRIIPs Regulation)',
      },
      kolikStoji: {
        odpoved: "Only the insurer knows the price of protection — it depends on age, health, occupation and the amount of cover, so the analysis shows only the price from the insurer's quote, never an estimate. Before signing, the insurer must show how much of each payment goes on risk cover (which is used up), on costs and on investment. The 10–30 % package is a budget frame, not a price.",
        otazka: 'How much will I pay each month? And how much of it is insurance and how much is invested?',
        otazkaVi: 'Mỗi tháng phải đóng bao nhiêu? Trong đó bao nhiêu là tiền bảo hiểm, bao nhiêu được đầu tư?',
        zdroj: "Czech Insurance Distribution Act § 84, 86; KID (PRIIPs Regulation); this analysis's method",
      },
      komu: {
        odpoved: 'Whoever you name in the policy as beneficiary — it can be a parent in Vietnam (name, date of birth, contact). If nobody is named, the law goes first to the spouse, then children, parents and heirs. The beneficiary can be changed in writing at any time; payment abroad we check in the terms.',
        otazka: 'If I die, who gets the money? Can my parents in Vietnam get it?',
        otazkaVi: 'Nếu tôi mất thì ai nhận tiền? Bố mẹ tôi ở Việt Nam có nhận được không?',
        zdroj: 'Czech Civil Code § 2829, 2831, 2832',
      },
      krach: {
        odpoved: 'Insurers in the Czech Republic are supervised by the Czech National Bank and must hold capital and technical reserves; in a liquidation, the assets covering liabilities go first to insurance claims. Deposit insurance, as with banks, does not cover life insurance. The investment part also moves with the value of the funds, regardless of the insurer.',
        otazka: 'What if the insurer goes bust? What happens to my money?',
        otazkaVi: 'Nếu công ty bảo hiểm phá sản thì tiền của tôi thế nào?',
        zdroj: 'Czech Insurance Act § 123',
      },
      nemocny: {
        odpoved: 'It depends on the diagnosis, the treatment and the insurer: acceptance at the normal price, a loading, an exclusion for that illness only, a postponement or a refusal. The insurer decides after the questionnaire, sometimes after a medical report, and some riders have a waiting period. So state the illness straight away — nothing can be promised in advance.',
        otazka: 'I have high blood pressure, diabetes… Can I get insured at all?',
        otazkaVi: 'Tôi đang bị cao huyết áp, tiểu đường… thì có mua bảo hiểm được không?',
        zdroj: 'Czech Civil Code § 2788; Czech Insurance Distribution Act § 84; policy terms',
      },
      nesezdani: {
        odpoved: "A widow's or widower's pension from the state is only for a husband or wife. In a policy, though, anyone can be the beneficiary, so write your partner into the policy by name. Without a named beneficiary the law gives the money to the spouse, children, parents and heirs — an unmarried partner is not among them.",
        otazka: 'We live together but are not married. If I die, will my partner get anything?',
        otazkaVi: 'Chúng tôi sống với nhau nhưng chưa đăng ký kết hôn. Nếu tôi mất thì người kia có được gì không?',
        zdroj: 'Czech Pension Insurance Act § 49, 50; Czech Civil Code § 2829, 2831',
      },
      osvcPn: {
        odpoved: 'A self-employed person gets sickness benefit only if they have paid voluntary sickness insurance for at least 3 months before falling ill — and even then only from day 15 and from a low base. Without it there is no sickness benefit from the state while the bills keep coming. So for the self-employed we calculate income protection insurance; the terms say from which day it pays.',
        otazka: "I'm self-employed. If I'm ill for months, will the state pay me anything?",
        otazkaVi: 'Tôi tự kinh doanh, nếu ốm phải nghỉ mấy tháng thì nhà nước có trả gì không?',
        zdroj: 'Czech Sickness Insurance Act § 24, 26, 29; Czech Social Security Administration',
      },
      podvod: {
        odpoved: 'The insurer must be licensed by the Czech National Bank and the adviser must be on its register — you can check this yourself by name. Before signing you get the policy terms, the key information document (KID) with the costs and a written record of the meeting, including the risks. Nothing needs to be signed straight away, and in a dispute you can turn to the financial arbiter free of charge.',
        otazka: "Isn't this a scam? In Vietnam people bought insurance through a bank and lost money.",
        otazkaVi: 'Cái này có phải lừa đảo không? Ở Việt Nam người ta mua bảo hiểm qua ngân hàng rồi mất tiền đấy.',
        zdroj: 'Czech National Bank register; Czech Insurance Distribution Act § 79, 88; Czech Financial Arbiter Act § 18',
      },
      poplatky: {
        odpoved: 'All costs are in the documents: the premium structure before signing, costs over time in the KID and each fee in the price list. Part of the costs is paid in the first years, so the investment account grows slowly then; the entry fee on the target amount is shown separately in money in the analysis. Every year you get a statement with the account value, surrender value and costs.',
        otazka: 'What fees are there? Where does my money go in the first years?',
        otazkaVi: 'Phí gì mà nhiều thế? Mấy năm đầu tiền của tôi đi đâu?',
        zdroj: 'Czech Insurance Distribution Act § 84, 86, 89; KID (PRIIPs Regulation)',
      },
      provize: {
        odpoved: 'I receive a commission from the insurer; I must tell you what kind, and you will find it in the information before signing. The law spreads it over 5 years — if the policy ends earlier, I pay part of it back. That is why I care about a policy you can keep paying for a long time.',
        otazka: 'How much do you earn on this?',
        otazkaVi: 'Anh/chị bán cái này được hoa hồng bao nhiêu?',
        zdroj: 'Czech Insurance Distribution Act § 50, 88',
      },
      rodice: {
        odpoved: "We add support for your parents to the family's spending, so the protection calculation counts it too. If illness or injury takes away your income, the insurance benefit helps keep paying this as well. For the case of death you can name your parents as beneficiaries; payment to Vietnam we check in the terms.",
        otazka: 'I send money to my parents every month. Who will send it if I fall ill?',
        otazkaVi: 'Tháng nào tôi cũng gửi tiền về cho bố mẹ. Nếu tôi ốm hay có chuyện gì thì ai gửi?',
        zdroj: "Czech Civil Code § 2829; this analysis's method",
      },
      rozvod: {
        odpoved: 'After a divorce, check the beneficiary: an ex-spouse named in the policy stays the beneficiary until you change it in writing. The policyholder manages the policy, and if the insured person is someone else, their consent is also needed to change the beneficiary or take the surrender value. How the investment part is divided is a matter for the property settlement — a lawyer should assess that.',
        otazka: 'If we divorced, who would the policy and the money in it belong to?',
        otazkaVi: 'Nếu sau này ly hôn thì hợp đồng và tiền trong đó thuộc về ai?',
        zdroj: 'Czech Civil Code § 2826, 2829, 2830, 2832',
      },
      sezona: {
        odpoved: 'Only if the policy explicitly allows it — I will show you in the terms what this product permits (paying less, a payment break, taking the protection cost from the investment account). If you stop paying, you get a reminder with an extra period of at least a month, after which the cover can end. That is why we set the payment by the weak months, not the best ones.',
        otazka: 'Business is up and down. In a slow season, can I pause or lower the payment?',
        otazkaVi: 'Làm ăn lúc được lúc không, mùa ế thì có tạm ngừng hoặc đóng ít đi được không?',
        zdroj: 'Czech Civil Code § 2804, 2838; policy terms',
      },
      skoncit: {
        odpoved: "Set-up costs are usually taken in the first years, so a short policy is expensive and the surrender value is low at first. We plan it around the goal — old age and the children's years. You can still end it: withdraw within 30 days of the confirmation, cancel within 2 months of taking it out, and later end it with a surrender value.",
        otazka: 'Why do I have to pay for so long? What if I want to stop?',
        otazkaVi: 'Sao phải đóng lâu thế? Nếu muốn dừng giữa chừng thì sao?',
        zdroj: 'Czech Civil Code § 2805, 2808, 2842; Czech Insurance Distribution Act § 86',
      },
      staraSmlouva: {
        odpoved: "Do not cancel the old policy for a new one until we compare them in writing: set-up costs are paid again, a new questionnaire looks at today's age and health, and a tax-deducted policy may have to pay the tax back. The Czech National Bank explicitly warns against needless cancellations. Often it is enough to adjust the old one or add only what is missing.",
        otazka: 'I already have a policy from another adviser. Should I cancel it and take out a new one?',
        otazkaVi: 'Tôi có hợp đồng cũ với người khác rồi, có nên hủy để làm cái mới không?',
        zdroj: 'Czech National Bank warning on cancelling policies; Czech Income Tax Act § 15b',
      },
      stari: {
        odpoved: 'Help from children is a beautiful thing, and the aim is for it to be a gift, not a necessity. Money of your own for old age gives you choices: where to live, whether to return to Vietnam, how to help the grandchildren. The amount in the chart is a model with no guarantee.',
        otazka: 'We have children; they will look after us in old age. Why would I need this?',
        otazkaVi: 'Có con rồi, về già con nó lo, cần gì phải mua cái này?',
        zdroj: "this analysis's method; Czech Insurance Distribution Act § 86",
      },
      vietnam: {
        odpoved: 'Whether the policy continues after a move, whether it applies outside the Czech Republic and how payments and payouts work abroad are set by the policy terms — so before signing we ask the insurer in writing and you keep the answer. Taxes change too after moving (a non-resident outside the EU cannot claim the deduction). A Czech pension can be paid out in Vietnam as well; the social security office confirms the conditions.',
        otazka: 'What happens to the policy if the whole family moves back to Vietnam?',
        otazkaVi: 'Sau này cả nhà về Việt Nam thì hợp đồng thế nào? Có đóng tiếp được không, tiền có chuyển về Việt Nam được không?',
        zdroj: 'Czech Civil Code § 2789; Czech Insurance Distribution Act § 84; Czech Income Tax Act § 15; Czech Social Security Administration',
      },
      vratiSe: {
        odpoved: 'Not all of it. The part that pays for protection is the price of the family being covered the whole time, and it is not paid back — just like car insurance. Money for old age comes only from the investment part, after costs and with no promise of returns.',
        otazka: 'If nothing happens, do I get back what I paid?',
        otazkaVi: 'Nếu không có chuyện gì thì tiền đóng bảo hiểm có được trả lại không?',
        zdroj: 'Czech Insurance Distribution Act § 86',
      },
      vybrat: {
        odpoved: 'An extra withdrawal from the investment part is usually possible; the minimum balance, fee and time limit are set by the terms. If the whole policy is ended, you are entitled to a surrender value (after at least two years of premiums, unless the policy excludes it), paid within three months. Money you may need quickly belongs in a reserve on an account next to the policy.',
        otazka: 'If I urgently need money, can I take it out? How soon do I get it?',
        otazkaVi: 'Lúc cần tiền gấp thì có rút ra được không? Bao lâu thì nhận được tiền?',
        zdroj: 'Czech Civil Code § 2842; Czech Insurance Distribution Act § 86; KID (PRIIPs Regulation)',
      },
      vyluky: {
        odpoved: 'Every risk has its own definition and exclusions in the terms — I will show them before signing. Permanent injury and daily benefit cover accidents only; disability, critical illness and inability to work cover illness too, depending on the terms. Losing a job or closing a shop is usually not an insured event.',
        otazka: 'When does the insurer not pay? Does it cover illness too, or only accidents?',
        otazkaVi: 'Trường hợp nào thì bảo hiểm không trả? Ốm có được trả không hay chỉ tai nạn?',
        zdroj: 'Czech Insurance Distribution Act § 84; Czech Civil Code § 2837; policy terms',
      },
      vynos: {
        odpoved: '5, 7 and 9 % are illustrative model rates, not a promise. The investment can also lose value and the client carries the risk — which is why the KID also shows an unfavourable and a stress scenario. A longer period softens the swings but does not remove them, so the chart always shows how much you paid in total.',
        otazka: 'Why does it earn so much? Is that 7 % certain?',
        otazkaVi: 'Sao lãi được nhiều thế? Có chắc được 7 % một năm không?',
        zdroj: 'Czech Insurance Distribution Act § 86; KID (PRIIPs Regulation)',
      },
      zavazneOnem: {
        odpoved: 'It pays a lump sum when a doctor confirms a diagnosis from the list in the terms; the list, definitions and stages differ between insurers. The money can be used for anything — lost income, care, travel for treatment. In our analysis the default amount is one year of net income (two or three years as options).',
        otazka: 'What is critical illness cover? Does it pay if I get cancer?',
        otazkaVi: 'Bảo hiểm bệnh hiểm nghèo là gì? Bị ung thư thì có được trả không?',
        zdroj: "Czech Insurance Distribution Act § 84; policy terms; this analysis's method",
      },
      zdravotniCizinec: {
        odpoved: 'Commercial health insurance pays for treatment, but it does not replace your income when you cannot work and gives the family nothing in case of death or disability. Public health insurance is mainly for people with permanent residence or employees of a Czech employer. The word ‘bảo hiểm’ means both, so I always say which one we mean.',
        otazka: "I have commercial health insurance for foreigners. Isn't that enough?",
        otazkaVi: 'Tôi có bảo hiểm y tế thương mại cho người nước ngoài rồi, thế chưa đủ à?',
        zdroj: 'Czech Public Health Insurance Act § 2',
      },
      zvlast: {
        odpoved: 'That works too: term life insurance just for protection and investing separately. What matters is which comes out better after all costs and which you will actually stick to — I can calculate both side by side from the KID and price lists. The decision is yours and I record it in the meeting record.',
        otazka: 'Why not just buy cheap term insurance and invest separately myself?',
        otazkaVi: 'Sao không mua bảo hiểm rủi ro cho rẻ, còn tiền thì tự đầu tư riêng?',
        zdroj: 'Czech Insurance Distribution Act § 78, 79; KID (PRIIPs Regulation)',
      },
    },
    ui: {
      chybaVypoctu: 'The calculation failed. Please check the entered data.',
      hotovo: 'Done',
      metodika: 'Calculation method as of {verze}.',
      vymazat: 'Clear',
    },
    varovani: {
      balicekNadVolne: 'The {pct} % package does not fit the budget; {chybi} a month short.',
      detiSamostatne: 'Children aged {vek} and over are not counted: {pocet}.',
      duchodNadBalicek: 'Retirement would need {odkladat} a month, more than the whole package of {balicek}.',
      ochranaNadBalicek: 'Protection costs more than the package; nothing is left for investment.',
      poVekuOdchodu: 'Is at or above retirement age.',
      splatkaDopocitana: 'Repayment estimated ({splatka} at {sazbaPct} % a year). Copy the exact one from the contract.',
      vydajeNadPrijmy: 'Spending and repayments exceed income by {chybi}.',
      vynosMimoScenare: 'A {vynos} % return is not one of the 5 / 7 / 9 % scenarios.',
    },
    vypadek: {
      bez: 'Without insurance',
      bezZdroje: 'This part has no source of money.',
      chybiCastka: '{castka} a month missing',
      chybiJednorazove: 'Nothing is missing month to month, but {castka} would be missing for the goals.',
      chybiMesicne: 'Missing every month',
      cip: {
        infarkt: 'Heart attack',
        ledviny: 'Kidney failure',
        mrtvice: 'Stroke',
        ochrnuti: 'Paralysis',
        rakovina: 'Cancer',
        roztrousena: 'Multiple sclerosis',
        srdce: 'Heart surgery',
        uraz: 'Serious accident',
      },
      cipyAria: 'Examples of illnesses and events',
      cipyPoznamka: 'Examples. What exactly the policy covers is set by its terms and conditions.',
      jakSpocitano: 'How we arrived at the amount',
      kdoAria: 'Whose income stops',
      krokChybi: 'The gap = sum insured',
      krokPotreba: 'What the family needs (from your goals)',
      krokStat: 'What the state provides',
      krytoCastka: '{castka} a month covered',
      legendaChybi: 'missing, no source',
      legendaKryto: 'covered by insurance',
      legendaPartner: '{kdo} keeps carrying',
      nadpis: 'If one income stopped',
      nesePartner: '{kdo} still carries {pct} % of the goals with their own income.',
      nicNechybi: "The other partner's income would cover this situation.",
      nicNechybiSam: 'None of the goals you entered would be left without a source of money.',
      pojistnaCastka: 'Sum insured',
      prazdno: 'We will calculate this once the ages, incomes and spending are entered.',
      radek: {
        bydleni: 'Home loan repayment',
        deti: 'Children up to 23',
        duchod: 'Saving for retirement',
        zivot: 'Everyday family life',
      },
      s: 'With insurance',
      sZdrojem: 'The gap is closed; the family goals stay in place.',
      udalost: {
        invalidita: 'Cannot work',
        smrt: 'Death',
      },
      udalostAria: 'What happens',
      uvod: 'Illness or an accident can come unexpectedly. What would happen to the family goals, and what would hold the family up.',
      veta: {
        invalidita: {
          bo: 'If Dad could not work for a long time, his income would stop.',
          me: 'If Mum could not work for a long time, her income would stop.',
        },
        smrt: {
          bo: 'If Dad were no longer here, the family would lose his income for good.',
          me: 'If Mum were no longer here, the family would lose her income for good.',
        },
      },
    },
    zaver: {
      nadpis: 'Two paths',
      nestane: 'If nothing happens — you have money for old age and do not have to rely on your children.',
      nestanePuvod: 'It comes only from the investment part: {investice} a month for {roky}, {zaplaceno} in total. The return is not certain.',
      nestaneVek: 'at age {vek} · model {vynos} %',
      stane: 'If something happened — the whole family is protected.',
      stanePuvod: 'It is paid from the {balicek} package: {ochrana} a month goes on protection. That is the price of cover and it is not paid back.',
      staneRiziko: {
        invalidita: '{kdo} · disability',
        smrt: '{kdo} · death',
      },
    },
  },
  /* BLOK:vnRodina END */
  /* BLOK:kalkLista START — generuje scratchpad/slovnik.py, ručně needitovat */
  kalkLista: {
    cekani: {
      aria: 'Now {hned}, if delayed {pozdeji}, cost of waiting {cena}. One column per 5 years, one layer per block of contributions.',
      blok: 'Contributions, years {od}–{do}',
      budeMit: 'Will have in {roky}',
      hned: 'Now',
      horizont: 'Horizon',
      mesicne: 'Monthly',
      otazkaHned: 'Starting now, in {roky} they will have',
      otazkaPozde: 'Starting {roky} later, they lose',
      pracuji: 'Money at work',
      vetaHned: 'Each 5 years of contributions is one layer — the bottom one works longest.',
      vetaPozde: 'That is what the first {roky} of contributions would grow to — they work longest.',
      vlozi: 'Pays in',
      vynos: 'Annual return',
      zacne: 'Starts in',
      ztrata: 'Lost by waiting',
    },
    dopl: {
      aria: 'The debt of {dluh} falls while the portfolio after tax grows. They cross in {doba}, with {castka} left to repay. Break-even return {hranice}.',
      ariaNikdy: 'The debt of {dluh} falls; the portfolio after tax does not catch up within {roky}.',
      bublinaMim: 'Debt with overpayments',
      chybiDo: 'Short of paying off',
      hranice: 'Break-even return',
      hraniceNad: 'above 30 %',
      hraniceZnacka: 'break-even {pct}',
      investice: 'Investing',
      investiceMes: 'Invested monthly',
      jistina: 'Left to repay',
      konecSplatnosti: 'end of term',
      lzeDoplatit: 'can pay off',
      mimBezDluhu: 'Overpayments: debt-free in',
      mimoradne: 'Overpayments',
      nadInflaci: 'Above inflation',
      nastejno: 'Even',
      nelze: 'These values cannot be calculated — check the rate and the term.',
      nesplati: 'At this payment the mortgage is not repaid even in 80 years.',
      nevyslo: 'After {roky} the portfolio is not enough to pay off — {castka} short after sale and tax.',
      nominalne: 'Nominal',
      nominalnePct: 'nominal {pct}',
      otazka: 'At a {vynos} return, investing {castka} a month would pay off the mortgage in',
      otazkaRealne: 'At a {vynos} return above inflation, investing {castka} a month would pay off the mortgage in',
      poDani: 'after tax and fees',
      podleVynosu: 'As per return',
      poznamka: 'Investment returns are not guaranteed; the mortgage payment is. Sale tax under current law.',
      poznamkaSk: 'Investment returns are not guaranteed; the mortgage payment is. Tax on selling the investment is not included (before tax) — the app does not calculate Slovak rules yet.',
      propad: '35 % drop',
      radaDluh: 'Remaining debt',
      radaMim: 'Overpayments',
      radaPortfolio: 'Portfolio after tax',
      realne: 'real {pct}',
      rezim: 'Return entered',
      riziko: 'Risk',
      sazba: 'Mortgage rate',
      slRozdil: 'Portfolio − debt',
      srovnatZa: 'Compare after',
      tabulkaPopis: 'Amounts in {mena} at year end · portfolio after tax and fees (total {naklady})',
      ter: 'Annual fee (TER)',
      trh: 'Market in the comparison year',
      trhNic: 'Market returns nothing',
      vetaChybi: 'you owe {dluh}, portfolio after tax {portfolio}, {chybi} short of paying off.',
      vetaDnes: 'you owe {dluh}, the investment starts from zero.',
      vetaSplaceno: 'mortgage repaid, portfolio after tax {portfolio}.',
      vetaZbylo: 'you owe {dluh}, portfolio after tax {portfolio} — {zbylo} would be left after paying off.',
      vicNez: 'more than {roky}',
      vstupni: 'Entry fee',
      vyhodnejsi: 'Better over {roky}',
      vyhravaInvestice: 'investing wins',
      vyhravaSplaceni: 'repaying wins',
      vynos: 'Annual return',
      vynosPodUrokem: 'A {vynos} return will not beat the {sazba} mortgage rate — repaying pays off.',
      zbyloBy: 'Left after paying off',
      zbyvaLet: 'Years left',
    },
    historie: {
      aria: 'Actual history from {od} to {do}: paid in {vlozeno}, today {hodnota}.',
      dynamicky: 'Growth',
      hodnota: 'Value',
      jednorazove: 'One-off',
      konzervativni: 'Conservative',
      mesicne: 'Monthly',
      otazka: 'Had they started in {rok}, today they would have',
      otazkaObecna: 'What they would have today',
      portfolio: 'Portfolio',
      roky: 'Years back',
      veta: 'Actual market history {od}–{do}. The past does not guarantee the future.',
      vklad: 'a contribution',
      vlozeno: 'Paid in',
      vlozil: 'Paid in',
      vydelal: 'Earned',
      vyvazeny: 'Balanced',
      zdroj: 'Data source: SBBI/Ibbotson (USA)',
    },
    hypo: {
      aria: 'The principal of {uver} falls to zero over {roky}; total interest paid {urok}.',
      bezJinychUveru: 'no other loans',
      bezPrijmu: 'income not entered',
      bezUveru: 'Own funds cover the full price — no loan needed.',
      bezVeku: 'age not entered',
      bezZavazku: 'debts not entered',
      bublinaJistina: 'Principal at year end',
      bublinaUroky: 'Total interest paid',
      celkem: 'Total paid',
      cena: 'Property price',
      doporuceniNad: 'above the ČNB recommendation of {limit}',
      doporuceniV: 'within the ČNB recommendation of {limit}',
      dstiCo: 'Repayments to net income, ČNB recommendation',
      dstiCoBez: 'Repayments to net income',
      dtiCo: 'Debt to annual income, ČNB recommendation',
      dtiCoBez: 'Debt to annual income',
      dtiCoNbs: 'All loans to annual net income, binding NBS limit',
      jineNevyplneno: 'Not entered',
      jineUvery: 'Client’s other loans',
      jineZadne: 'None',
      ltvCo: 'Loan to property price, binding {regulator} limit',
      ltvNad: 'above the {limit} limit',
      ltvV: 'within the {limit} limit',
      minVlastni: 'min. {castka} (LTV {limit})',
      minVlastniRok: 'min. {castka} (LTV {limit} for a purchase in {rok})',
      nbsLimit: 'NBS limit {limit}',
      nbsLimitNejvys: 'NBS limit at most {limit}',
      nbsMaxUver: 'max. loan {castka}',
      nbsMaxUverNejvys: 'max. loan at most {castka}',
      nbsNad: 'above the NBS limit {limit}',
      nbsV: 'within the NBS limit {limit}',
      otazka: 'Monthly payment',
      poznamkaCz: 'LTV is a binding ČNB limit; DSTI and DTI are only ČNB recommendations.',
      poznamkaSk: 'LTV is a binding NBS limit.',
      poznamkaSkNbs: 'LTV and DTI are binding NBS limits.',
      radaJistina: 'Principal',
      radaUroky: 'Interest paid',
      sazba: 'Interest rate',
      slUmor: 'Principal repaid',
      slUrok: 'Interest paid',
      splatkaNevyplnena: 'loan payment not entered',
      splatkyNadPrijem: 'Repayments exceed net income by {castka} a month.',
      splatnost: 'Term',
      ukazatele: 'Loan indicators',
      ukazateleCnb: 'ČNB indicators',
      vetaDnes: 'you owe {jistina}; repayment {splatka} a month.',
      vetaRoku: 'you owe {jistina}; interest paid so far {uroky}.',
      vlastni: 'Own funds',
      zTohoJistina: 'Of which principal',
      zTohoUrok: 'Of which interest',
      zustatekNevyplnen: 'loan balance not entered',
    },
    jakoVPlanu: 'as in the plan',
    kostra: {
      celkem: 'Total',
      dnes: 'Today',
      grafOvladani: 'Use the arrow keys to pick a year; Home and End jump to the start and the end.',
      grafRole: 'interactive chart',
      rok: 'Year {n}',
      sloupecRok: 'Year',
      tabulka: 'Year-by-year table',
      tabulkaPopis: 'Amounts in {mena}, end-of-year figures',
      zaRoky: 'Over {roky}',
    },
    letFew: '{n} years',
    letMany: '{n} years',
    letOne: '{n} year',
    mesFew: '{n} months',
    mesMany: '{n} months',
    mesOne: '{n} month',
    mesicne: 'a month',
    modelova: 'model value',
    nezadano: 'not entered',
    paticka: 'Indicative calculation, not an offer or a guarantee. Nothing is saved to the analysis.',
    prebytek: 'free cash flow {castka}',
    prumerTrhu: 'market average',
    refi: {
      aria: 'Total paid today {dnes}, after refinancing {nove}.',
      dnes: 'Today',
      jistina: 'Outstanding balance',
      naklady: 'Switching costs',
      nakladyPopisek: '+ {castka} switching costs',
      nakladySerie: 'Switching costs',
      novaSazba: 'New rate',
      nove: 'After switch',
      otazka: 'After refinancing they save',
      otazkaHorsi: 'The new rate is not lower — the payment rises by',
      splatkaDnes: 'Payment today',
      splatkaNova: 'New payment',
      staraSazba: 'Current rate',
      veta: 'Over {roky} they save {castka} in total; costs pay back in {mesice}.',
      vetaBezNakladu: 'Over {roky} they save {castka} in total.',
      vetaHorsi: 'Over {roky} they pay {castka} more.',
      zbyvaLet: 'Remaining term',
    },
    renta: {
      aria: 'Capital {kapital} for an income of {renta} a month. Over {roky}, {vyplaceno} is paid out and {zbude} is left at the end.',
      bublinaKapital: 'Capital at year end',
      bublinaVyplaceno: 'Paid out in total',
      cerpani: 'Draw for',
      cerpaniNavzdy: 'Drawing forever',
      cerpaniRoky: 'Drawing for {roky}',
      navzdy: 'Forever',
      otazka: 'For an income of {castka} a month they need',
      poznamka: 'Return above inflation, income in today’s money. The return is not guaranteed.',
      renta: 'Monthly income',
      slKapital: 'Capital',
      slVyplaceno: 'Paid out in total',
      vetaDnes: 'capital {kapital}, income {renta} a month.',
      vetaNavzdy: 'The income comes only from returns — the capital stays intact.',
      vetaRoku: 'capital {kapital}, paid out in total {vyplaceno}.',
      vetaRoky: 'After {roky} the capital is used up.',
      vynos: 'Return above inflation',
      vyplaceno: 'Paid out over {roky}',
      vyplacenoRada: 'Income paid out',
      zbude: 'Left at the end',
      zustatek: 'Capital',
    },
    splac: {
      aria: 'Remaining debt over time: originally until {puvodni}, with the extra payment until {novy}.',
      driv: 'Debt-free earlier by',
      mimoradna: 'Extra payment',
      nad25: 'Above 25% of the principal a year, the bank may charge a fee.',
      nove: 'With extra payment',
      otazka: 'The extra payment saves in interest',
      puvodne: 'Originally',
      rezim: 'After the extra payment',
      snizit: 'Lower the payment',
      splatkaZustava: 'Payment stays',
      veta: 'The debt is gone in {novy} instead of {puvodni}.',
      vetaDoplaceno: 'The extra payment covers the whole debt.',
      vetaSnizit: 'The payment drops by {castka} a month until the end.',
      zkratit: 'Shorten the term',
    },
    tab: {
      cekani: 'Cost of waiting',
      doplaceni: 'Mortgage vs. investing',
      historie: 'Historical',
      hypoteka: 'Mortgage',
      refinanc: 'Refinancing',
      renta: 'Retirement income',
      splaceni: 'Repay early',
    },
    upravit: '{popisek}: {hodnota}. Edit exact value',
    vratitVychozi: 'Reset to default values',
    zAnalyzy: 'from analysis',
    zmensitKlavesa: 'Shrink (Z key)',
    zvetsit: 'Enlarge calculator',
    zvetsitKlavesa: 'Enlarge (Z key)',
  },
  /* BLOK:kalkLista END */
  /* BLOK:brifink START — generuje scratchpad/slovnik.py, ručně needitovat */
  brifink: {
    poTerminu: 'Overdue ({datum})',
  },
  /* BLOK:brifink END */
  /* BLOK:planVek START — generuje scratchpad/slovnik.py, ručně needitovat */
  planVek: {
    doplnte: 'Add the client’s age',
    proc: 'Without the date of birth the exception for clients under 36 cannot be checked, so the 10 % down payment is not offered.',
  },
  /* BLOK:planVek END */
  /* BLOK:pojisteniPlan START — generuje scratchpad/slovnik.py, ručně needitovat */
  pojisteniPlan: {
    castCeny: 'only part of the price so far',
    cenaCelkemNadpis: 'Total premium',
    cenaCelkemPopis: "The plan uses only the price from the insurer's offer.",
    cenaChybiDeti: "The children's policy price is missing — the plan deducts only the adults.",
    cenaChybiOsoba: 'Price for {jmeno} is missing — the plan deducts only the part entered.',
    cenaDeti: "Children's policy price",
    cenaDoplnte: "Enter the insurer's price",
    cenaOdPojistovny: "Price from the insurer's offer",
    chybiCena: 'price missing',
    detiZavazneNadStropem: 'Above the underwriting limit of {strop} — check with the insurer.',
    jakProgrese: 'How the progression works',
    kalkCenyVarianta: 'Prices for the {varianta} variant — each variant has its own offer.',
    mesicneProCilePoPojistnem: 'Monthly for goals (after premiums)',
    naCile: 'To goals',
    nulaZdrojeKryji: 'An amount of 0 means the family’s own resources (partner’s income, assets) cover this need.',
    orientacne: 'indicative ≈ {castka} — not used in the plan',
    platbaNezadana: 'payment not entered',
    pojistneZmena: 'Premium — change',
    pouzitProVsechny: 'Use for all variants',
    prebytekPoPojistnem: 'Surplus after premiums',
    prezBezCenyPozn: 'The amounts are a proposed cover, not an insurer’s offer. The price and the scope of cover, including exclusions, are set by the insurer in the contract and policy terms.',
    prezCenaPozn: 'Price from the offer entered by the adviser — the insurer confirms the final price in the contract after assessing health. The scope of cover and exclusions are set by the policy terms.',
    prezZavazneProc: 'one-off payment for treatment — lets you stop working and recover',
    rozpocetPojistne: 'Premium: today {stara} → new {nova} ({rozdil})',
    rozpocetPojistneNove: 'New premium {nova} — included in fixed expenses',
    rucne: 'manual',
    rusiSe: 'cancelled',
    skrytProgresi: 'Hide the progression',
    staraZustava: 'old policy kept',
    stareBezCeny: "The difference is calculated once you enter the new policy's price.",
    stareBezKrytiZivota: 'Not deducted — the new contract gives this person no death or disability cover, so the old one stays.',
    stareBezNahrady: 'Price missing — not deducted, the new contract does not cover this person yet.',
    stareIdd: 'Cancel the old policy only after the new one is accepted, at its anniversary, and record the reason in the meeting notes.',
    stareMajetekBezCeny: 'Released once the new policy’s price is entered.',
    stareMajetekBezNahrady: 'No new policy replaces it — the plan keeps paying it.',
    stareNadpis: 'Existing policies',
    stareNespoctenoPartner: 'Not deducted — the plan did not calculate the partner’s cover (date of birth missing), so the policy stays.',
    stareNeznama: 'Enter the payment of the existing policy {nazev} — until then the full new price is deducted.',
    stareNic: 'New premium {nova} — no existing policy is cancelled, the full amount is deducted.',
    stareRozdil: 'Premium: today {stara} → new {nova} · only the difference {rozdil} is deducted',
    tnuAria: 'Permanent injury payout from {castka}: at {pct} % impairment it pays {vyplata}, at 100 % at most {max}.',
    tnuOrientacne: 'Indicative only — bands and multipliers differ between insurers; the insurer has the exact benefit table.',
    tnuPasmo: 'band ×{n}',
    tnuPoskozeni: 'Impairment {pct} %',
    tnuPri: 'at {pct} %',
    tnuVolby: 'Sum insured for permanent injury',
    tnuVyplati: 'pays out',
    tnuVysvetleni: 'In our model each band is multiplied separately: up to 20 % ×1, 20–40 % ×2, 40–60 % ×3, above 60 % ×4. At 100 % the payout is at most {max}× the sum.',
    vetaNad: 'The extra premium {rozdil} exceeds the monthly surplus {prebytek} — nothing is left for goals.',
    vetaNove: 'Premium {nova} · to goals {naCile}',
    vetaZmena: 'Premium: today {stara} → new {nova} ({rozdil}) · to goals {naCile}',
    vydajeNezbytne: 'essential expenses',
    vydajeObvykle: 'usual expenses',
    vydajeSplatkyPojistne: 'Expenses + repayments + premiums',
    vydajeZObvyklych: 'Essential expenses are not entered — the {varianta} variant uses 90 % of usual expenses.',
    zadanaCast: 'part entered',
    zaverOchranaPovinne: 'protection {nova} — part of fixed expenses',
    zaverOchranaZmenaPovinne: 'protection today {stara} → new {nova} — part of fixed expenses',
    zaverZVolnehoCf: 'What it takes from free cash flow',
    zoVolby: 'How many years of net income',
    zustava: 'kept',
  },
  /* BLOK:pojisteniPlan END */
  /* BLOK:minimumSmrti START — generuje scratchpad/slovnik.py, ručně needitovat */
  minimumSmrti: {
    ariaHodnotaNaklad: '{castka} a month',
    ariaNaklad: 'Monthly cost of child {jmeno}',
    ariaPruh: 'Minimum {castka}: {casti}',
    ariaVek: 'Until what age the family supports child {jmeno}',
    bezPrijmu: 'no income',
    bezPrijmuText: 'No income — the death cover pays off at least the family debts.',
    dluhy: 'debts',
    doVekuFew: '{n}',
    doVekuMany: '{n}',
    doVekuOne: '{n}',
    kalkVeta: 'Minimum {castka} = debts {dluhy} + 1 year of family income {prijem} + children {deti}',
    kalkVetaBezDeti: 'Minimum {castka} = debts {dluhy} + 1 year of family income {prijem}',
    kalkVetaSablona: 'Minimum {castka} = debts {dluhy} + 1 year of family income {prijem} + children {deti} — for children an estimate from a template ({naklad} a month per child until age {vek}), not a figure from the analysis',
    klientSrovnani: 'For death the figure is {smrt}, {rozdil} more than for disability. It is the minimum death cover never goes below: debts, a year of family income and children until they are independent.',
    klientSrovnaniBezDeti: 'For death the figure is {smrt}, {rozdil} more than for disability. It is the minimum death cover never goes below: debts and a year of family income.',
    klientSrovnaniSmrtVyssi: 'For death the figure is {smrt}, {rozdil} more than for disability. Both amounts belong on the policy — each covers a different situation.',
    letFew: '{n} years',
    letMany: '{n} years',
    letOne: '{n} year',
    metodou: 'The method gives {castka} — the minimum applies:',
    nakladChybi: 'cost per child is missing — add it to expenses (Children category)',
    nakladDite: 'Cost per child / month',
    nakladHint: 'empty = template {castka}',
    nakladHintBez: 'fill in — no template for this country',
    podMinimem: 'Below the minimum of {castka} (debts + 1 year of family income + children) — entered manually, on purpose.',
    podMinimemBezPrijmu: 'Below the minimum of {castka} (paying off the debts) — entered manually, on purpose.',
    posuvnikNaklad: 'Monthly',
    posuvnikVek: 'Until age',
    pozn: 'Minimum: debts + 1 year of family income + children until independent',
    poznBezPrijmu: 'Minimum: paying off the debts (no income)',
    prezProc: 'At least this much: debts {dluhy} + 1 year of family income {prijem} + children until independent {deti}.',
    prezProcBezDeti: 'At least this much: debts {dluhy} + 1 year of family income {prijem}.',
    prezProcBezPrijmu: 'At least this much: paying off the debts {dluhy}.',
    prezProcSablona: 'At least this much: debts {dluhy} + 1 year of family income {prijem} + children until independent {deti} — for children an estimate from a template ({naklad} a month per child until age {vek}), not a figure from the analysis.',
    prijemRok: '1 year of family income',
    radekDite: '{jmeno}, {vek}: {naklad} × {roky} =',
    radekDiteBezVeku: '{jmeno}, age not entered: {naklad} × {roky} =',
    radekDluhy: 'Pay off the debts',
    radekPrijem: '1 year of family income: {mes} × 12 =',
    sablona: 'template {castka} a month per child',
    stavMetoda: 'The method gives more ({castka}) — the higher amount applies.',
    stavMinimum: 'The method gives {castka} — the minimum applies.',
    stitek: 'minimum',
    titul: 'Minimum death cover',
    vekDeti: "Children's ages (years)",
    vekDitete: 'Child {n}',
    vekFew: 'age {n}',
    vekHint: 'empty = from birth',
    vekMany: 'age {n}',
    vekNeznamy: "child's age not entered — counted from birth",
    vekOne: 'age {n}',
    vetaBezPrijmu: 'Minimum {castka} = paying off the debts — without an income, a year of income and the children are not counted',
    vratit: 'Reset',
    vratitAria: 'Reset {jmeno} to the value from the analysis',
    vystupMetodika: 'For death the minimum applies whenever the capital method comes out lower.',
    zCeho: 'What the minimum is made of',
    zCehoSkryt: 'Hide the breakdown',
    zadano: '{castka} a month per child',
    zdrojAnalyza: 'from the analysis',
    zdrojSablona: 'template',
    zdrojUpraveno: 'adjusted',
  },
  /* BLOK:minimumSmrti END */
  /* BLOK:analyzaCisla START — generuje scratchpad/slovnik.py, ručně needitovat */
  analyzaCisla: {
    auto: {
      chybiCil: 'Replacing the car is missing from your goals. Your car is worth {castka} today — that is the level you will come back to in a few years.',
      maCil: 'You have a car goal. Keep it around {castka} — that is the price level you drive today.',
      nadpis: 'Replacing the car',
    },
    bydleni: {
      bezStropu: 'Your housing goal of {cil} is {nasobek}× your annual income.',
      limitNbs: 'For housing you need a loan of {uver}. The NBS limit for all your loans is {limit} ({max}× annual net income).',
      limitNbsSDluhy: 'For housing you need a loan of {uver}. The NBS limit for all your loans is {limit} ({max}× annual net income); after other loans ({dluhy}), {strop} remains.',
      limitNbsVek: 'Depending on age, the limit may be lower.',
      nadpis: 'Housing price',
      strop: 'Your housing goal of {cil} is {nasobek}× your annual income. The ceiling is {max}×, which is {strop}.',
    },
    jednotky: {
      mil: 'million',
    },
    odkladani: {
      chybi: 'That is {chybi} a month short of the {min} % minimum.',
      dnes: 'Today {pct} % of income goes aside.',
      dohodnuto: 'With the agreed {castka} a month, {pct} % of income will go aside.',
      dohodnutoVklady: 'With the agreed {castka} a month and regular contributions of {vklady}, {pct} % of income will go aside.',
      ideal: 'That is the {ideal} % ideal. At {rychle} % goals fill up very fast.',
      minimum: 'The {min} % minimum is met; the ideal is {ideal} %.',
      nadCilem: 'That is {rychle} % or more — goals fill up very fast.',
      nadpis: 'How much goes aside',
      schodek: 'Spending and repayments are higher than income, so nothing goes aside now.',
    },
    panel: {
      cerpani: 'withdrawal rate',
      kProjednani: '{n} to discuss',
      kapital: 'Capital needed',
      nadpis: 'What the numbers say',
      orientacni: 'indicative',
      orientacniTitle: 'An estimate, not a guaranteed value',
      vseOk: 'all in order',
    },
    renta: {
      bezHypoteky: 'The mortgage is paid off by {rok}, so it is not counted in the pension.',
      bezSplatek: 'Without repayments you will have finished before the pension starts.',
      bezSplatekISporeni: 'Without repayments you will have finished before the pension starts, and without today’s savings.',
      bezSporeni: 'Without today’s savings.',
      chybiCil: 'A pension goal is missing. Today you spend {vydaje} a month — that is what the pension should cover.',
      chybiCilSplatky: 'A pension goal is missing. Today you spend {vydaje} and repay {splatky} a month — the pension should cover {potreba}.',
      doplnUrokHypoteky: 'Add the mortgage interest rate — then we can tell whether it ends before the pension.',
      doplnUrokUveru: 'Add the loan interest rate — then we can tell whether it ends before the pension.',
      doplnZustatekHypoteky: 'Add the mortgage balance and interest rate — then we can tell whether it ends before the pension.',
      doplnZustatekUveru: 'Add the loan balance and interest rate — then we can tell whether it ends before the pension.',
      nadpis: 'Pension goal vs. spending',
      nesedi: 'The pension goal is {zadano}, but today you spend {vydaje} a month. The gap is {rozdil}.',
      nesediSplatky: 'The pension goal is {zadano}, but spending with repayments is {potreba} a month. The gap is {rozdil}.',
      odvozena: 'No income-independence goal set — we use today’s expenses and repayments, without repayments finished before the pension and without today’s savings.',
      sedi: 'The pension goal of {zadano} covers today’s spending of {vydaje}.',
      sediSplatky: 'The pension goal of {zadano} covers today’s spending with repayments of {potreba}.',
    },
    rezerva: {
      doplnit: 'We will fill in your essential spending and work out the reserve from it.',
      nadpis: 'Emergency reserve',
      poRuce: 'You have {likvidni} at hand, enough for {mesicu} months.',
      poRuceBezMesicu: 'You have {likvidni} at hand.',
      pravidlo: 'Your reserve ({m}× essential spending and loan repayments) is {potreba}.',
      vlastniCil: 'Your reserve goal is {cil}.',
      vlastniCilPravidlo: 'By the rule of {m}× essential spending and repayments it would be {potreba}.',
    },
    stav: {
      chybi: 'To work on',
      info: 'For information',
      ok: 'Met',
      pozor: 'Over the limit',
    },
    zivotni: {
      nadpis: 'Life insurance',
      platba: 'You pay {castka} a month for income protection.',
      platbaPodil: 'You pay {castka} a month for income protection, which is {podil} % of income.',
    },
  },
  /* BLOK:analyzaCisla END */
  /* BLOK:analyzaStranka START — generuje scratchpad/slovnik.py, ručně needitovat */
  analyzaStranka: {
    cesta: {
      orientacniKlient: 'An indicative model, not a guarantee.',
    },
    coBudeLabel: 'Points to follow',
    detiFew: '{n} children',
    detiMany: '{n} children',
    detiOne: '{n} child',
    firmaNema: 'The client has no company or business',
    jmenoKlienta: 'First name (Client {n})',
    kompletnostChybi: 'For an accurate plan, still missing: {seznam}.',
    mostek: '“If the financial plan achieves **these goals**, will it be the right solution for you?”',
    napoveda: {
      auto: 'You save for the difference: the price of the next car minus what you get for the current one. When you have more, we will adjust the goal.',
      bydleni: '{prijem} net × 12 × {nasobek} = {castka} (CNB ceiling). Realistically — from today’s home to a similar one, not a palace.',
      bydleniBezRegulatora: 'The housing price should match the household’s net income. Realistically — from today’s home to a similar one, not a palace.',
      bydleniChybi: 'A fair housing price ≈ {nasobek}× annual net income. Income is missing for calculating the ceiling.',
      bydleniNad: 'Above the CNB recommendation ({strop}) — the mortgage may not be approved.',
      bydleniNadNbs: 'The loan of {uver} is above the NBS limit ({strop}) — a bank grants this only as an exception.',
      bydleniNadNbsVycerpano: 'Nothing of the NBS limit remains for the new loan of {uver} — a bank grants this only as an exception.',
      bydleniNadNbsZbyva: 'The loan of {uver} is more than what remains of the NBS limit ({strop}) — a bank grants this only as an exception.',
      bydleniNbs: 'NBS limit: all loans together at most {max}× annual net income = {limit}.',
      bydleniNbsBezDluhu: 'Calculated without other loans.',
      bydleniNbsChybiPrijem: 'The NBS limit counts only the clients’ verifiable and other income — add it.',
      bydleniNbsDluhyChybi: 'The NBS limit covers all loans together — add the balances of other loans.',
      bydleniNbsPravidlo: 'NBS limit: all loans together at most {max}× annual net income.',
      bydleniNbsSDluhy: 'NBS limit: all loans together at most {max}× annual net income = {limit}. After other loans ({dluhy}), {strop} remains for the new loan.',
      bydleniNbsVek: 'From age 41 the limit is lower if the loan ends after age 65 — add the date of birth.',
      bydleniNbsVycerpano: 'Other loans ({dluhy}) already use up the whole NBS limit ({max}× annual income).',
      bydleniOrientacni: 'A fair housing price ≈ {nasobek} × 12 × {prijem} = {castka}.',
      bydleniPravidlo: 'A fair housing price ≈ {nasobek}× annual net income.',
      doporucit: 'Suggest {castka}',
      naHistorii: 'On history',
      naHistoriiTitul: 'Show on real data 1928–2025',
      orientacniPrijem: 'Approximate household net income',
      ostatni: 'What – when – how much, in today’s prices.',
      renta: '{vydaje} expenses + {splatky} instalments = {castka} a month. The annuity must support the same life you live today — not just the essentials.',
      rentaBezHypoteky: '{vydaje} expenses + {splatky} instalments = {castka} a month — the mortgage is paid off by {rok}, so it is not in the annuity. The annuity must support the same life you live today.',
      rentaBezHypotekyBezSplatek: '{vydaje} expenses = {castka} a month — the mortgage is paid off by {rok}, so it is not in the annuity. The annuity must support the same life you live today.',
      rentaBezSplatek: '{vydaje} expenses = {castka} a month. The annuity must support the same life you live today — not just the essentials.',
      rentaChybi: 'Annuity = all of today’s expenses, including instalments and lifestyle. Expenses are missing for the calculation.',
      rentaNizka: 'Expenses with instalments are only {pct} % of income — something is probably missing from the expenses.',
      rentaVysoka: 'Expenses with instalments are {pct} % of income — they exceed income.',
      rezerva: '({nezbytne} essential expenses + {splatky} instalments) × {mesicu} = {castka}. Range {min}–{castka}, depending on how secure your income is.',
      rezervaBezSplatek: '{nezbytne} essential expenses × {mesicu} = {castka}. Range {min}–{castka}, depending on how secure your income is.',
      rezervaChybi: 'Reserve = 3–6× essential expenses + instalments. Essential expenses are missing for the calculation.',
      vzdelani: '{mesicne} a month × {mesicu} months × {let} = {castka}. Studying in Czechia {od}–{do}, abroad roughly two and a half times as much.',
      vzdelaniDeti: '{mesicne} a month × {mesicu} months × {let} × {deti} = {castka}. Studying in Czechia {od}–{do}, abroad roughly two and a half times as much.',
      vzdelaniJednoDite: '{mesicne} a month × {mesicu} months × {let} = {castka} for one child. Studying in Czechia {od}–{do}, abroad roughly two and a half times as much.',
      vzdelaniJinaMena: 'Children’s studies: monthly costs × months a year × years of study. Studying abroad comes out roughly two and a half times as expensive.',
    },
    penzijko: {
      dpsDip: '(DPS {dps} + DIP {dip})',
      jenDip: '(DIP — from the first crown)',
      jenDps: '(contribution above {hranice} a month)',
      nadLimit: 'above the annual cap {limit}: {castka} cannot be claimed',
      odpocet: 'Tax-deductible',
      statni: 'State contribution (DPS)',
      zaMesic: '{castka}/mo',
      zaRok: '{castka}/year',
    },
    prebytekSouhlas: '“Do you agree that we can use {castka} a month for your goals?”',
    skript: {
      cas: 'On the phone we agreed on **45 minutes**. Nothing has changed on my side — I just want to check that you are planning on 45 minutes too.',
      cile: '“Let’s look at your strategic goals in the structure **WHAT – WHEN – HOW MUCH**. What comes to mind first?” If the client does not mention them, check **housing**, **children’s education** and **financial independence**.',
      ocekavani: '“What do you expect from today’s meeting?” → repeat the client’s words and add: “My goal is to check **what you are already doing well**, **where you may be losing money** and **what you can do better**.”',
      penize: '“Let me start with an unusual question: **Why is money important to you?**” → repeat the word (“freedom… what does it mean to you?”) and ask: “What else comes to mind?”',
      pojistky: '“Which **insurance contracts** do you currently have — life, accident, property, car? For each one I need the insurer, contract number, monthly payment and anniversary.” After saving, the contracts appear in the client folder and a cancellation letter can be generated straight from them.',
      prijmy: '“Another very important resource for reaching your goals is **your income**. How much do you earn a month from employment?” (bonuses = average over 2–3 years)',
      rizika: '“As part of your financial plan, we will also look at your **protection**. We will go through what you have today — **what it covers and what it does not**. We will check whether you can **save money** or insure more wisely. And I will show you how your protection fits into the **whole plan**: family, goals, reserve.”',
      vydaje: '“How much do you think you can **save** each month?” — do not dissect the expenses in detail. Check: expenses ≈ the desired annuity; income − expenses = free cash flow.',
      zavazky: '“Your **liabilities** are important information for reaching the goals. First mortgages — housing loans — then the rest.”',
      zaver: '“Is there anything important I forgot to ask you? {veta}”',
      zdroje: '“**Another source** for reaching your goals is **the money you already have**: building savings, pension savings, investments, accounts and property. Let’s go through them together, starting with building savings. Do you use it?”',
    },
    smazatDite: 'Delete the child',
  },
  /* BLOK:analyzaStranka END */
  /* BLOK:kinoMetodika START — generuje scratchpad/slovnik.py, ručně needitovat */
  kinoMetodika: {
    APPROVED: 'From the client’s data',
    CANDIDATE: 'Awaiting methodology approval',
    PROVISIONAL: 'Working claim — no documented source',
  },
  /* BLOK:kinoMetodika END */
  /* BLOK:analyzaPrijmy START — generuje scratchpad/slovnik.py, ručně needitovat */
  analyzaPrijmy: {
    bonusy: 'Bonuses / 13th salary (yearly)',
    chybiJmeno: 'name missing',
    domacnost: 'Shared by the household',
    forma: 'Income type',
    jinaForma: 'entered earlier — belongs to another income type, move or delete it',
    klient: 'Client {n}',
    osobaCelkem: 'Monthly income of this person',
    pasivni: 'Passive income (rent…)',
    pole: {
      davky: 'Pension, parental benefit, other benefits',
      mzdaFirma: 'Net salary from own company',
      ostatniJiny: 'Side jobs, child support and other',
      osvcOstatni: 'Self-employment and other',
      podilyFirma: 'Profit share and other',
      podnikani: 'Net income from self-employment',
      vedlejsiOsvc: 'Side income (salary, pension, parental benefit)',
      vedlejsiZam: 'Side income (side jobs, child support, business)',
      zamestnani: 'Net income from employment',
    },
    poleKlient: '{pole} — client {n}',
    prace: 'Occupation',
    pracePh: 'e.g. driver, accountant, own restaurant',
    pridatDruhou: 'Second person',
    pridatVedlejsi: 'Side income',
  },
  /* BLOK:analyzaPrijmy END */
  /* BLOK:prebytekModel START — generuje scratchpad/slovnik.py, ručně needitovat */
  prebytekModel: {
    mesicneProCile: 'Monthly for goals',
    neodsouhlaseno: 'not yet agreed with the client',
    planNespocita: 'Without income the plan cannot be calculated — add the income or the agreed amount.',
    planPocita: 'For now the plan uses {castka}',
    pravidloNula: 'Loan repayments use up the whole income, so the plan cannot take even 20% of it. Add the expenses in the analysis, or the amount you agreed with the client.',
    zdrojDopocet: 'model: income − expenses − repayments',
    zdrojPravidlo: 'model: 20% of net income',
  },
  /* BLOK:prebytekModel END */
  /* BLOK:vysvetleniInfo START — generuje scratchpad/slovnik.py, ručně needitovat */
  vysvetleniInfo: {
    aria: 'Explanation: {nazev}',
    cipVyberteOsobu: 'pick the person on the policy',
    jakCistPredAPo: 'How to read the comparison',
    jakSeCastkyPocitaji: 'How the amounts are calculated',
    rucniKratce: 'Override prices and sums with the pencil',
  },
  /* BLOK:vysvetleniInfo END */
  /* BLOK:cilDeti START — generuje scratchpad/slovnik.py, ručně needitovat */
  cilDeti: {
    doAnalyzy: 'Add it in the analysis',
    pridat: 'Add a child',
    upozorneni: 'There is a goal for children, but no child is entered — add one (name, date of birth).',
  },
  /* BLOK:cilDeti END */
  /* BLOK:cilHned START — generuje scratchpad/slovnik.py, ručně needitovat */
  cilHned: {
    badgeNavrh: 'proposal',
    bezMesicniInvestice: 'no monthly investment',
    bezMesicniInvesticeVelke: 'No monthly investment',
    brzdaChybi: 'Today’s sources do not cover the remaining {chybi} — choose another source, move the deadline, or top up from the surplus.',
    coSTim: 'What to do:',
    dalsiZdroj: 'add another source in the analysis (accounts, term deposit, building savings)',
    doMesKDispozici: 'Available within ~{mesicu} mo.:',
    dosporeni: 'Top-up from surplus',
    dosporitNabidka: 'top up {castka} monthly for {mesicu} mo.',
    hnedKDispozici: 'Available now:',
    jakBezMesicni: 'Solution: no monthly investment for now.',
    jakDosporit: 'Solution: {jedn} one-off from sources and {prav} monthly for {mesicu} mo.',
    jakDosporitBezZdroju: 'Solution: {prav} monthly for {mesicu} mo.',
    krytoJenZeZdroju: 'a goal due “now” is covered only from money the client already has.',
    mesicu: 'mo.',
    nulaRespektovana: 'No monthly investment — the adviser’s decision, the proposal does not come back.',
    odebratZdroj: 'Do not use this source for this goal',
    poDobu: 'for',
    poMesicich: 'After {mesicu} mo. of top-up:',
    pocetMesicu: 'Number of months',
    posunoutNaRok: 'move the deadline to 1 year',
    povinnaRezerva: 'Required liquidity reserve',
    prebytekNestaci: 'no free surplus for a top-up',
    pridatZdroj: 'Add source:',
    rozdelovnikHned: 'A goal due “now” is covered only from sources — a top-up from the surplus is chosen on the goal card in the Solution proposal.',
    terminSankce: 'early withdrawal may cost a penalty',
    vychaziDoMes: '— from sources within ~{mesicu} mo.',
    vychaziHned: '— right away from sources.',
    vychaziSDosporenim: '— from sources and the top-up.',
    vysledekChybi: 'Available now {konec} — {chybi} missing ({pct} % of the goal).',
    vysledekChybiDoMes: 'Available within ~{doMes} mo. {konec} — {chybi} missing ({pct} % of the goal).',
    vysledekDosporitChybi: 'Now {hned}, after {mesicu} mo. of top-up {konec} — {chybi} missing ({pct} % of the goal).',
    vysledekDosporitChybiDoMes: 'Within ~{doMes} mo. {hned}, after {mesicu} mo. of top-up {konec} — {chybi} missing ({pct} % of the goal).',
    vysledekDosporitOk: 'Now {hned}, after {mesicu} mo. of top-up {konec} — goal covered at {pct} %.',
    vysledekDosporitOkDoMes: 'Within ~{doMes} mo. {hned}, after {mesicu} mo. of top-up {konec} — goal covered at {pct} %.',
    vysledekOk: 'Available now {konec} — goal covered at {pct} %.',
    vysledekOkDoMes: 'Available within ~{doMes} mo. {konec} — goal covered at {pct} %.',
    zVasichPenez: 'from your money',
    zadneZdroje: 'None — the client has no instantly available money.',
    zdrojTermin: 'Term deposit',
  },
  /* BLOK:cilHned END */
  /* BLOK:zdrojNazev START — generuje scratchpad/slovnik.py, ručně needitovat */
  zdrojNazev: {
    bezny: 'current account',
    fondy: 'funds and investment life insurance',
    fondyRezerva: 'topped up from funds',
    fondyUzel: 'Funds and investment life insurance',
    fondyZbytek: 'remainder after topping up the reserve',
    hotovost: 'cash',
    penzijko: 'pension savings (DPS — available at {vek})',
    sporici: 'savings account',
    stavebko: 'building savings',
    stavebkoZruseni: 'cancellation takes ~{mesicu} mo.',
    termin: 'term deposit',
  },
  /* BLOK:zdrojNazev END */
  /* BLOK:navrhC9 START — generuje scratchpad/slovnik.py, ručně needitovat */
  navrhC9: {
    krokyUvodBezPlanu: 'What to do, in this order:',
  },
  /* BLOK:navrhC9 END */
  /* BLOK:metodikaPlanu START — generuje scratchpad/slovnik.py, ručně needitovat */
  metodikaPlanu: {
    bezZmeny: 'The numbers for this client stay the same.',
    coJeJinak: 'What the new methodology does differently:',
    coSeZmeni: 'What the recalculation changes for this client:',
    coSeZmenilo: 'What the recalculation changed for this client:',
    dalsiCile: 'Other goals:',
    dalsiZmeny: 'More changes and what the new methodology does differently',
    mesicne: 'monthly',
    prepocitano: 'Recalculated with the new methodology.',
    prepocitat: 'Recalculate with the new methodology',
    pruhStary: 'This plan is calculated with the methodology used before {datum}.',
    vraceno: 'The plan uses the methodology from before {datum} again.',
    vratit: 'Restore the original calculation',
    vratitTitulek: 'You can restore it until you leave the proposal page.',
    zmenaAkontaceSK: 'Slovakia: down payment under NBS rules — for a purchase by the end of 2026, 80 % LTV is certain; from 2027, 10 % is enough only for a first home: every applicant at most 35 (a second client without a date of birth does not meet the condition), no flat or house to live in or to rent out, and no mortgage among the liabilities.',
    zmenaAkontaceVek: "The 10 % down payment (the exception for young buyers) is assessed by age in the year of purchase (today's age + years to the goal), not by today's age.",
    zmenaCilBezTerminu: 'A goal without a date gets no money from accounts and no monthly amount — the outputs say “add a date” and the money stays with goals that have one.',
    zmenaCilHned: 'A goal due now (0 years) is covered only from money the client already has — the system offers a monthly investment but does not add it on its own.',
    zmenaDosporeniStupne: 'Once the reserve is topped up over the chosen number of months, the other goals get the freed money from the end of the top-up — in steps, not the smallest amount for the whole period. The increase and the year it starts are printed in the Full plan and on the one-page plan.',
    zmenaFondyDoRenty: "Mutual funds, shares and life insurance with a cash value (surrender value) the client already has go to the first passive income goal — only once, even if there are two — and grow until it starts according to that goal's profile. The adviser can send them to another goal in the money flow. Previously the plan did not assign them to any goal.",
    zmenaFondyDoRezervy: "If the client's reserve is short and they hold mutual funds, ETFs or shares, the plan first uses them to top up the missing part of the reserve (only that, never more) and only the rest of the funds goes to the passive income goal. Investment life insurance does not go to the reserve — the surrender value is only paid out after the policy is cancelled. Previously all funds went to the passive income goal and the reserve waited to be saved up from the surplus.",
    zmenaHrubaZCiste: 'Sickness benefit (incapacity for work) is calculated from the gross wage derived from net pay using 2026 taxes and contributions (by bands), not net × 1.39. An earning person under 22 is entitled to a disability pension.',
    zmenaInvaliditaBezPrijmu: 'A parent without income has disability cover only for 20% higher household expenses minus the disability pension, if entitled — the same for the first and second person.',
    zmenaInvaliditaNikdoNevydelava: 'When nobody in the household earns, disability cover is not calculated and the plan says “no income – disability cover is not calculated; add an income”.',
    zmenaInvaliditaNulaTisk: 'A parent without income whose disability pension covers the 20% higher household expenses shows 0 Kč for disability with the reason in the full plan and the one-page plan (previously “—”).',
    zmenaInvalidniDuchod: 'State disability pension: for an earning person an average (CZK 13,000 a month in Czechia) that the adviser can overwrite on the card — not a calculation from wages. No entitlement 0, no income the statutory minimum.',
    zmenaMajetekMzda: 'Employee liability is printed with a limit only from a gross salary the adviser entered or confirmed — the estimate from net salary stays on the adviser’s screen and the plan says ‘limit once the salary is entered’. After a change of the sum insured, the property insurance price is left out of the total and the printout until the adviser confirms it again.',
    zmenaMajetekNahrada: 'Existing property insurance (home contents, property, liability) is released in the plan only once the new property policy has a price from the adviser — the plan then counts the whole swap: it releases the old payment and deducts the new price. Previously cancelling it counted as freed-up money together with the life policy, even without the new policy’s price.',
    zmenaMajetekSmlouvy: 'Property insurance is printed in the plan contract by contract and only with the insurer’s quoted price; the rough estimate stays on the adviser’s screen only.',
    zmenaMiraOdkladani: 'The savings rate in the Proposal, in the plan budget and in the presentation is the same number as in the analysis: the agreed amount (without it, free money from income and expenses) plus regular deposits into savings and investments, divided by net income. Previously only the surplus after insurance divided by income, without deposits.',
    zmenaOchranaNadPrebytek: 'When protection costs more than the surplus, the missing amount shows in the ‘Cash flow over time’ chart, in the shortfall note, in the plan budget, in the Running overview, in the presentation and in the Summary. Previously the premium was capped at the surplus and the missing money disappeared.',
    zmenaPartnerBezNarozeni: 'Partner without a date of birth: the plan does not calculate their cover (death, disability, illness, injury or price) and the outputs say “not calculated — date of birth missing”. The plan does not cancel their existing policies. Previously the partner’s cover was calculated even without a date of birth.',
    zmenaDveCesty: 'The “Without a plan and with a plan” chart compares the same plan money invested and on a savings account, with a band for the worse and better scenario and a line after fees; a plan with a shortfall does not draw the chart. Previously the chart invested all assets without withdrawals for goals.',
    zmenaAlokaceFichtner: 'The split of the money for a goal (equities, bonds, cash) follows a table by risk profile and years to the goal instead of a gradual sale of equities. The last year before the goal holds 97 % in cash and 3 % in bonds (71 % and 29 % for the dynamic profile). Before drawdown, the annuity holds an equity share by profile and years until drawdown starts (balanced profile, 15 years or more: 88 %); previously it moved towards 50 % equities. Monthly amounts therefore shift: with the conservative and balanced profile short goals get slightly more expensive, the annuity with the balanced and dynamic profile gets cheaper.',
    zmenaPenzijkoDoRenty: 'Pension savings are not cancelled: if the income starts before they pay out (60 in Czechia), the income until then comes from other money and from the payout it rises by the pension savings (4 % a year of their value) — without losing state contributions. Previously, pension savings paid out after the income start were not counted at all.',
    zmenaPojistneMajetku: 'The price of new property insurance (household, real estate, liability) from the adviser is a mandatory payment and is deducted from the surplus in full, just like life insurance. A cancelled old property policy is still counted as a saving. Previously, only the difference was deducted when it replaced a cancelled policy.',
    zmenaNizsiVarianty: 'The “Cut back” and “Price first” options now also lower sick leave and critical illness cover: the daily benefit covers only essential expenses and loan repayments (instead of the full income), and critical illness drops by the same ratio as disability. Previously both stayed as in the “Premium cover” option.',
    zmenaPenzijkoJednou: 'The pension savings and a one-off income without an assigned goal go only to the first passive income goal in order — two such goals no longer share the same money twice.',
    zmenaPotrebaRenty: 'Retirement income without a set goal is calculated as in the analysis: today’s expenses without own savings contributions, plus repayments of loans that will still run in retirement. A mortgage paid off before retirement (by its end date, otherwise estimated from balance, interest rate and instalment) is not counted; other loans stay. Previously: all of today’s expenses, without repayments.',
    zmenaProfilCile: "A goal's own risk profile also counts in the calculation — the goal card and every output show the same percentage for the goal.",
    zmenaRenta13: 'The old calculation sends money to the passive income goal only from month 13 — in the first year the whole surplus goes to topping up the reserve.',
    zmenaRentaNavyseni: 'Increases to the passive income goal from money freed up after earlier goals are met are printed in the Full plan and on the one-page plan, with the year they start — like for other goals.',
    zmenaRezervaJednoCislo: 'The reserve has one number across the whole plan: the target exactly as in the analysis formula (no rounding to 10 000), and what the client has, what is missing and how full it is all come from one function — including building savings that arrive within ~4 months.',
    zmenaRucniCastka: 'A monthly amount entered by hand at a goal also counts in the calculation — it is printed in the full plan, the one-page plan, the summary and the presentation, and the other goals get the rest.',
    zmenaRucniNula: 'A monthly amount deleted at a goal also counts in the calculation — the freed money goes to the other goals.',
    zmenaRustMzdySchodek: 'If the family spends more than it earns today, a pay rise first covers this shortfall — goals and the loan instalment only get what is left. Previously the whole pay rise went to the goals.',
    zmenaSkoreZajisteni: 'The financial health score no longer counts empty property-risk rows as entered protection — without an entered amount this part of the score is left out (previously 20 points for the empty template).',
    zmenaSmrtBezMinima: 'Death cover in the full analysis uses only the capital method, without a minimum (the minimum stays only in the Analysis for Vietnamese clients).',
    zmenaSpatneDluhy: 'The step „Clear the bad debt“ counts only loans on the Personal loans tab — consumer loans, credit cards, overdrafts, revolving loans, personal leasing and older rows with no type chosen. A mortgage and loans on the Business loans tab are not bad debt.',
    zmenaSplatkaUveru: 'Once a loan is drawn, its instalment is deducted from the money for the other goals and the passive income goal (for housing, the rent from the expense breakdown that the purchase ends is added back). If the instalment exceeds the budget, the plan says from when and how much is missing.',
    zmenaSrovnaniStejnyZaklad: 'The “without a plan and with a plan” chart in the presentation starts both curves from the same financial assets; unassigned assets grow like assigned ones and inflation is the methodology’s 2.5 % (previously the green curve started only from money assigned to goals and the red one used 2.7 %).',
    zmenaUverSpotrebitelsky: 'A car and other loan-financed goals outside housing use the payment of a consumer loan or a building savings loan (term at most 12 years, indicative rate), not a 30-year mortgage.',
    zmenaZajisteniVzdy: 'The plan always covers income protection — the client’s earlier “No” in the analysis no longer removes the premium from the surplus.',
    zmenaZamestnavatel: 'The employer contribution counts both as savings and as income: savings rate = (agreed amount or free money + own deposits + employer contribution) divided by (net income + employer contribution). Before, it counted only as savings, so the rate came out a bit higher.',
    zmenaZdrojeHned: 'A reserve or goal due now (0 years) draws on the current account, savings account, cash, term deposit and building savings (in that order).',
  },
  /* BLOK:metodikaPlanu END */
  /* BLOK:prahyOdkladani START — generuje scratchpad/slovnik.py, ručně needitovat */
  prahyOdkladani: {
    flagPodMinimem: 'Saving ~{pct} % of income — the minimum is {min} %, ideal {ideal} %',
    hladina: {
      ideal: 'ideal',
      minimum: 'minimum',
      pod: 'below minimum',
      rychle: 'fast to goals',
    },
    novyCrm: {
      chybiDoMinima: '{castka} a month short of the {min} % minimum',
      minimumDoIdealu: '{min} % minimum met · {castka} short of the {ideal} % ideal',
    },
    plan: {
      cileIdeal: 'GOALS — ideal {ideal} %',
      pravidlo503020: 'The 50/30/20 rule: ~50 % essential expenses, 30 % lifestyle, 20 % set aside for goals and passive income. The minimum is {min} %; at {rychle} % goals fill up very fast. We go through a detailed expense breakdown at the service meeting.',
    },
    rozpocet: {
      ideal: '✓ {ideal} % ideal met',
      minimum: '✓ {min} % minimum met · ideal {ideal} %',
      nezname: 'income unknown · minimum {min} %',
      pod: '▲ below the {min} % minimum',
      rychle: '✓ {rychle} % or more — goals fill up fast',
      vcVkladu: 'incl. deposits {castka}',
    },
  },
  /* BLOK:prahyOdkladani END */
  /* BLOK:rozpisPanel START — generuje scratchpad/slovnik.py, ručně needitovat */
  rozpisPanel: {
    hotovo: 'Done',
    kicker: 'Detailed breakdown · item by item',
    prijmy: {
      nadpis: 'Household income',
    },
    vydaje: {
      nadpis: 'Household expenses',
    },
    zavrit: 'Close',
  },
  /* BLOK:rozpisPanel END */
  /* BLOK:planCil START — generuje scratchpad/slovnik.py, ručně needitovat */
  /* BLOK:rustMzdyEfekt START — generuje scratchpad/slovnik.py, ručně needitovat */
  rustMzdyEfekt: {
    klikNedosahne: 'Clicking “{tlacitko}” will not change passive income — another goal takes the money from the steps, or it arrives only after the payouts start.',
    klikUver: 'Clicking “{tlacitko}” will not change passive income — the loan repayment swallows the salary growth: from {rok}, even with it, {chybi} a month is missing for the repayment.',
    konec: '{horizont}: {bez} → {ted}',
    krokRocne: 'Step = +{pct} % of income once every {obdobi} (≈ {rocne} % a year).',
    nepocitaBezMesicni: 'Passive income has no monthly investment — salary-growth steps do not count towards it.',
    nepocitaBezTerminu: 'Passive income has no target date — it is left out of the money split, salary growth included.',
    nepocitaHned: 'Passive income due now does not grow — salary growth will not change it.',
    nepocitaNedosahne: 'The salary growth now in the plan does not reach this passive income — another goal takes the money, or it arrives only after the payouts start.',
    nepocitaRezim: 'Passive income has a chosen solution mode — salary-growth steps do not count towards it. To count them, click „back to the original proposal“ on the pension goal.',
    nepocitaSplneno: 'Passive income is reached even without salary growth ({bez} %).',
    nepocitaUver: 'The salary growth now in the plan never reaches passive income — the loan repayment swallows it: from {rok}, even with salary growth, {chybi} a month is missing for the repayment.',
    poHorizontu: 'Steps from {roky} only begin when the payouts start — they do not count towards it.',
    poKliku: 'After clicking “{tlacitko}”: passive income from {pred} % to {po} %',
    poKlikuBezZmeny: 'Clicking “{tlacitko}” will not change passive income.',
    radekNepocita: 'in the plan ({n} steps), but they do not count towards passive income',
    toastNepocita: 'Prefilled {pocet} salary-growth steps — passive income will not change; the passive-income card says why next to Salary growth.',
    toastPredvyplneno: 'Prefilled {pocet} salary-growth steps — passive income {pred} % → {po} %.',
    toastPredvyplnenoBezRenty: 'Prefilled {pocet} salary-growth steps — adjust them for the client.',
    toastPredvyplnenoVice: 'Prefilled {pocet} salary-growth steps — {zmeny}.',
    toastUzVPlanu: 'The salary-growth steps are already in the plan and match the settings — nothing changes. Passive income counts with them: {ted} % (without them {bez} %).',
    toastUzVPlanuBezCisel: 'The salary-growth steps are already in the plan and match the settings — nothing changes.',
    toastUzVPlanuNepocita: 'The salary-growth steps are already in the plan — nothing changes. They do not count towards passive income, though; the passive-income card says why next to Salary growth.',
    toastUzVPlanuVice: 'The salary-growth steps are already in the plan and match the settings — nothing changes. Without them → with them: {renty}.',
    vPlanu: 'Salary growth in the plan lifts passive income from {bez} % to {ted} %',
  },
  /* BLOK:rustMzdyEfekt END */
  planCil: {
    akontaceDo2026: 'For a purchase in {rok}, 80 % financing is certain in Slovakia (20 % own funds) — neither age nor a first home makes a difference.',
    akontaceK2BezVeku: 'The second client has no date of birth — every applicant must meet the 10 % condition, so we use 20 %. Add the date of birth in the analysis.',
    akontaceNemovitost: 'The analysis shows the client owns a flat or house (to live in or to rent out) or repays a mortgage — from 2027, 10 % is enough in Slovakia only for a first home, so 20 %.',
    doplnenoAutomaticky: 'added automatically',
    jakJednZatim: 'Solution: {jedn} up front, nothing extra per month for now.',
    jakZatimNic: 'Solution: nothing extra per month for now.',
    krokNavyseni: 'From month {mesic} ({rok}) increase by {o} to {celkem} a month.',
    krokRadek: 'from {rok} +{o}',
    krokZacatek: 'From month {mesic} ({rok}) send {celkem} a month.',
    nbsAkontace2027: "NBS: for a purchase by the end of 2026, 80 % is certain (20 % own funds); 90 % only within the bank's quota. From 2027, 10 % is enough only for a first home, for applicants aged up to 35 who own no other residential property (to live in or to rent out). 100% financing is the adviser's decision — 10 % of the price is covered by a building savings loan. The repayment shows in the cash flow only once the loan is drawn",
    profilMimoVypocet: "The calculation and the printout still use the plan's profile — the goal's own profile takes effect after recalculating with the new methodology.",
    rucniMimoVypocet: 'The calculation and the printout still use {castka} — the amount entered by hand takes effect after recalculating with the new methodology.',
    varianta100: '100% financing',
    variantaAkontace: '{pct} % down payment',
    vekVRoceKoupe: 'In the year of purchase ({rok}) the client will be {vek} — the 10 % down payment is assessed at this age.',
    vekVRoceKoupeK2: 'In the year of purchase ({rok}) the client will be {vek} and the second client {vek2} — 10 % is enough only if both are at most 35.',
    vyrazenBezTerminu: 'Without a date the goal is left out of the money split — add a date.',
  },
  /* BLOK:planCil END */
  /* BLOK:kinoOdkladani START — generuje scratchpad/slovnik.py, ručně needitovat */
  kinoOdkladani: {
    a1: {
      aria: 'We do not break down each expense, we only watch the amount set aside',
      kicker: 'Expenses',
      radek1: 'We do not go through expenses in detail.',
      radek2: 'We watch one number: how much goes aside.',
      stranou: 'Set aside',
      stranouPopis: 'the one number we watch',
      tahak: '“We will not count every penny. I only need one number — how much you set aside each month.”',
      titulek: 'It is not about every penny',
      velkePopis: 'Household net income',
    },
    a2: {
      aria: 'Three saving levels',
      dnes: 'Today you set aside {pct} %.',
      dnesDohoda: 'With the agreed amount, {pct} % goes aside.',
      kicker: 'How much aside',
      radek: 'At {rychle} % goals fill up very fast.',
      tahak: '“Ten per cent is the minimum. Twenty is ideal. Thirty — and goals fill up very fast.”',
      titulek: '{min} % minimum, {ideal} % ideal',
      velkePopis: '{pct} % of {prijem}',
    },
    a3: {
      aria: 'At {pct} % ({castka} a month) the model grows to {fv} in 30 years, of which {vlozeno} paid in.',
      kicker: 'Your number',
      nejistota: 'Model based on the plan profile ({profil}), in today’s money, before fees and taxes. Growth is not certain — it can be higher or lower.',
      radekCas: 'Time does the rest — a model, not a promise.',
      radekNula: 'Without saving nothing grows.',
      radekVlozite: 'You put in {castka}.',
      tahak: '“This is a model, not a promise. But it shows what time and regularity do.”',
      titulek: 'How much it can grow',
      velkePopis: 'in 30 years · model',
      vlozeno: 'paid in',
      vynos: 'growth',
    },
    a4: {
      aria: 'At {pct} %: {popis}.',
      cilBezNazvu: 'Goal',
      cilRenta: 'Retirement income',
      cilRezerva: 'Reserve',
      dalsiCile: '+ more goals: {n}, on time {splneno}',
      dnes: 'today',
      hned: 'now',
      kTerminu: 'only {pct} % by the deadline',
      kTerminuSplneno: 'by the deadline',
      kicker: 'Your goals',
      nejistota: 'Same calculation as the solution proposal: growth by the plan profile, goals in the plan order. A model, not a promise.',
      radekHladina: '{pct} % → {n} of {celkem} goals on time',
      radekHladinaVse: '{pct} % → all goals on time ✓',
      rezervaZUspor: 'from savings, now {pct} %',
      tahak: '“Look how the percentage moves when you have your reserve, your home and your retirement income.”',
      titulek: 'What gets done and when',
      velke: '{n} of {celkem}',
      velkePopis: 'goals met on time',
    },
    a5: {
      aria: 'From pay of {prijem}, {stranou} goes aside the day after payday and {zivot} is left for living.',
      denPo: 'the day after payday',
      kicker: 'Get started',
      naZivot: 'For living',
      radek: 'What is left, you spend with peace of mind.',
      stranou: 'Set aside',
      tahak: '“It works best automatically — a standing order the day after payday and you do not think about it again.”',
      titulek: 'Pay yourself first, then the bills',
      velkePopis: 'by standing order the day after payday',
      vyplata: 'Pay',
    },
    doplnPrijmy: 'Fill in income and we will work it out',
    jezdec: {
      aria: 'What percentage of income to set aside',
      dnes: 'today',
      mesicne: 'a month',
      odkladate: 'You set aside',
      valuetext: '{pct} %, {castka} a month',
    },
    nazev: 'Expenses and saving',
    prezTlacitko: 'Play cinema: Expenses and saving',
    prijmy: {
      a2Tahak: '“A proven rule: half for essentials, a third for living and a fifth set aside for the future. The minimum is a tenth.”',
      a3BezVydaju: 'Fill in expenses and we will work out how much you really set aside.',
      a3Ideal: 'Right now you set aside ~{pct} % — that is ideal. ✓',
      a3Minimum: 'Right now you set aside ~{pct} % — the minimum is met, {chybi} a month short of the {ideal} % ideal.',
      a3Pod: 'Right now you set aside ~{pct} % — {chybi} a month short of the {min} % minimum.',
      a3Rychle: 'Right now you set aside ~{pct} % — goals will be met very fast. ✓',
      a3Tahak: '“We will go through expenses in detail at the service meeting. Right now only one thing matters — at least ten per cent going aside, ideally twenty.”',
      a3VelkePopis: 'Ideally this much aside every month',
      a6Radek3: 'The minimum is {min} %, the ideal {ideal} % — what matters is to start.',
    },
    profil: {
      dynamicky: 'dynamic',
      konzervativni: 'conservative',
      vychozi: '{profil}, default',
      vyvazeny: 'balanced',
    },
    rokyFew: '{n} years',
    rokyMany: '{n} years',
    rokyOne: '{n} year',
    tlacitko: 'Saving cinema',
    tlacitkoTitle: 'Play cinema: Expenses and saving',
    utraty: {
      bydleni: 'Housing',
      deti: 'Children',
      doprava: 'Transport',
      dovolena: 'Holidays',
      energie: 'Energy',
      jidlo: 'Food',
      obleceni: 'Clothes',
      restaurace: 'Eating out',
    },
    zaRokyFew: 'in {n} years',
    zaRokyMany: 'in {n} years',
    zaRokyOne: 'in {n} year',
  },
  /* BLOK:kinoOdkladani END */
  /* BLOK:vodopad START — generuje scratchpad/slovnik.py, ručně needitovat */
  vodopad: {
    coKdyby: {
      naBudoucnost: 'To the future',
      presah: '{castka} more than is left — it would have to come out of living costs.',
      prijmu: 'of income',
      startDnes: 'today',
      startDohoda: 'agreed',
      tlacitko: 'What if more went to the future',
      valuetext: '{pct} % of income, {castka} per month',
      zVolnych: 'From free money',
      zbyva: 'Left free',
      zpetDnes: 'Back to today',
      zpetDohoda: 'Back to the agreed amount',
    },
    grafSelhal: 'The chart could not be drawn — the numbers are in the overview.',
    klikRadek: 'Tap a row = items',
    klikSloupec: 'Click a bar = items',
    majetek: {
      celkem: '= Total assets',
      celkemPod: 'both together',
      ciste: '= Net worth',
      cistePod: 'belongs to the family',
      cisteZapPod: 'debt exceeds assets',
      dedictvi: 'Inheritance',
      fin: '+ Financial',
      finPod: 'savings, investments, accounts',
      kat: {
        dedictvi: 'Inheritance',
        firma: 'Business',
        kzp: 'Endowment life insurance',
        nemovitosti: 'Property',
        opf: 'Funds and ETFs',
        penzijko: 'Pension savings',
        stavebko: 'Building savings',
        ucty: 'Account',
        zavazkyB: 'Housing loan',
        zavazkyO: 'Loan',
      },
      nadpis: 'Assets overview',
      nefin: 'Non-financial',
      nepocita: 'not counted yet',
      podily: '{rodina} % of the assets belong to the family, {banka} % to the bank.',
      pointa: 'After subtracting debts, you are left with {castka} of assets.',
      pointaBezJistiny: "The outstanding principal of the debts is missing — we don't know yet how much they reduce the assets.",
      pointaBezZavazku: 'Total assets {castka} — liabilities not entered yet.',
      pointaPrazdne: 'No assets or liabilities entered yet.',
      pointaZaporne: 'Debts exceed assets by {castka}.',
      zavazky: '− Liabilities',
      zavazkyPod: 'outstanding loan principal',
    },
    navic: 'Items exceed the bar by {castka}',
    nerozepsano: 'Not broken down',
    penize: {
      bonusy: 'Bonuses (monthly)',
      chybiPrijmy: 'Add income — free money is not shown without it.',
      chybiVydaje: 'Add expenses — free money is not shown without them.',
      dilNaBudoucnost: 'to the future {castka}',
      dilPrebytek: 'surplus {castka}',
      dilZbyva: 'left {castka}',
      hrdina: 'Free money',
      hrdinaSchodek: 'Shortfall',
      jdeVam: 'yours',
      jenUkazka: 'Preview only — not written to the plan.',
      kazdyMesic: 'every month',
      kicker: 'Income and expenses · monthly',
      klient: 'Client {n}',
      mesicne: 'a month',
      nadVolneCastka: 'over free money {castka}',
      nezadano: 'not entered',
      nezbytne: '− Essential expenses',
      nezbytnePod: 'housing, food, transport',
      nezbytnePrehled: 'Essential expenses',
      odkladDnes: 'Set aside today: {castka} = {pct} % of income (deposits {vklady} + free money {volne}).',
      odkladDohoda: 'Set aside: {castka} = {pct} % of income (deposits {vklady} + agreed amount {dohoda}).',
      ostatni: '− Other expenses',
      ostatniPod: 'leisure, holidays, savings',
      ostatniPrehled: 'Other expenses',
      pasivni: 'Passive income',
      pointa: 'Out of {prijmy} income, {volne} is left after expenses and repayments.',
      pointaSchodek: 'Expenses and repayments exceed income by {castka}.',
      pokryto: 'Deposits already running ({castka}) cover the target — nothing extra from free money.',
      posuvnikNeni: 'There is nothing to set aside now: {castka} is missing every month. Balance the expenses first.',
      prehrat: 'Replay',
      prijmy: 'Income',
      prijmyPod: 'net, household',
      prijmyPrehled: 'Income',
      schodek: '= Shortfall',
      schodekPod: 'missing every month',
      schodekPrehled: 'Shortfall',
      splatky: '− Repayments',
      splatkyPod: 'loans',
      splatkyPrehled: 'Repayments',
      sporeni: 'Savings already running',
      sporeniNesedi: 'savings do not add up',
      sporeniProuzek: 'of which savings {castka}',
      stranouDnes: '{pct} % of income is set aside today',
      stranouDohoda: 'with the agreed amount, {pct} % of income is set aside',
      volne: '= Free money',
      volnePod: 'left for you',
      volnePrehled: 'Free money',
      vydaje: '− Expenses',
      vydajePod: 'essentials not entered yet',
      vydajePrehled: 'Expenses',
      zivotniStyl: 'Lifestyle',
    },
    prehled: 'Overview',
    rozkliknuto: 'Expanded',
    sedi: 'Items add up: {castka}',
    stovka: {
      kopieChyba: 'The sentence could not be copied.',
      kopirovano: 'Copied',
      kopirovat: 'Copy',
      mesicne: '{castka} per month',
      nadpis: 'Out of every 100 {sym} of income',
      nazev: {
        budoucnost: 'Future',
        povinne: 'Essentials',
        vydaje: 'Expenses and repayments',
        zbyva: 'Left over',
        zivot: 'Living',
      },
      nesedi: {
        dohoda: 'The agreed amount {castka} is {nad} higher than free money, which is more than is left for living. Check the agreement.',
        sporeniOstatni: 'Savings of {castka} a month are higher than other expenses of {ostatni}. Check whether savings are included in expenses.',
        sporeniVydaje: 'Savings of {castka} a month are higher than expenses of {ostatni}. Check whether savings are included in expenses.',
        titul: 'The 100 cannot be split yet.',
        ukazka: 'That much cannot go to the future — even all living costs would not cover it.',
      },
      podNadPrijem: '{pct} over income',
      podNadVolne: '{pct} over free money',
      podPrijem: 'income',
      podZbyva: 'left {pct}',
      pravidlo: 'Rule: essentials 50–60 · future at least 20 · the rest for living',
      schodekPozn: '{pct} over income · {castka} short every month',
      slozeni: {
        nadVolne: 'over free money {castka}',
        nezbytne: 'essential {castka}',
        nic: 'nothing yet',
        prebytek: 'surplus {castka}',
        schodek: 'savings are now paid from debt or reserves',
        splatky: 'repayments {castka}',
        sporeni: 'savings {castka}',
        volne: 'free money {castka} (not agreed yet)',
        vydajeBez: 'expenses without savings {castka}',
        zVolnych: 'from free money {castka}',
        zamestnavatel: 'from employer {castka}',
        zivot: 'other expenses without savings',
        zivotSchodek: 'other expenses incl. savings {castka}',
      },
      stav: {
        bezDohodyLatka: '{latka}, if all free money is set aside',
        bezDohodyPod: 'under 10 even with all free money',
        idealSplneno: 'at least 20 met',
        latkaIdeal: 'at least 20',
        latkaMinimum: 'minimum 10',
        minimumSplneno: 'minimum 10 met · {castka} short of 20',
        nadVolneLatka: '{latka} only if {castka} comes out of living',
        nadVolnePod: 'under 10 even with cuts to living',
        neniZCeho: 'nothing to set aside now',
        nezbytneNezadane: 'essentials not entered',
        pod: 'under 10 · {castka} short of 10',
        povinneNad: 'over the recommended 60 by {n}',
        povinnePod: 'under 50',
        povinneV: 'within the recommended 50–60',
        zivotMene: '{castka} less than today',
      },
      ukazka: 'preview',
      veta: {
        bezDohody: '{zac}, and you can set the remaining {b} aside for the future.',
        bud: '{zac}, and you set {b} aside for your future.',
        budZbyvaFew: '{zac}, you set {b} aside for your future and {zb} is still left.',
        budZbyvaMany: '{zac}, you set {b} aside for your future and {zb} is still left.',
        budZbyvaOne: '{zac}, you set {b} aside for your future and {zb} is still left.',
        domluvime: 'Let us agree now how much of the free money you will really set aside.',
        konecDobre: 'you have both, so you are doing well.',
        konecDobreBez: 'you have at least 20 for the future, so you are doing well.',
        konecMinimum: 'you have the minimum 10; {castka} a month is missing to reach the ideal 20.',
        konecMinimumZbytek: 'you have the minimum 10 and {castka} a month is missing to reach the ideal 20, which you can cover from what is left.',
        konecNadVolne: 'that meets {latka}, you will just spend {castka} a month less on living than today.',
        konecNadVolnePod: 'you are still under 10 and will spend {castka} a month less on living than today.',
        konecPod: 'you are under 10 now, so let us find {castka} a month.',
        konecPodZbytek: 'you are under 10 now, {castka} a month is missing, and you can cover that from what is left.',
        konecPovinnePod: 'your essentials are even under 50 and the future over 20, so you are doing well.',
        pravidlo: 'I recommend 50 to 60 for essentials and at least 20 for the future, the rest for living',
        pravidloNad: 'I recommend at most 60 for essentials and at least 20 for the future, the rest for living — essentials take more now, so only {b} is left for the future.',
        schodek: 'Out of every 100 {sym} you earn, you spend {celkem} today — {castka} is missing every month, so first let us sort out expenses together.',
        zac: 'Out of every 100 {sym} you earn, {povinne} goes to what you must pay, {zivot} to living',
        zacBez: 'Out of every 100 {sym} you earn, {vydaje} goes to expenses and repayments',
      },
      vetaTitul: 'Sentence for the client',
      zbyvaPozn: '{castka} per month, not allocated yet',
      znackaBudoucnost: 'future 20+',
      znackaPovinne: 'essentials 50–60',
    },
    zadnePolozky: 'Items are not broken down yet.',
    zpetAria: 'Back to overview',
  },
  /* BLOK:vodopad END */
  /* BLOK:majetekSmlouvy START — generuje scratchpad/slovnik.py, ručně needitovat */
  majetekSmlouvy: {
    bezMzdaPozn: 'The analysis shows no employment income. Enter a salary only if they have an employer.',
    castkaSeZmenila: 'sum insured changed — check the price',
    cenaNecitelna: 'Enter the price as a number, e.g. 420.',
    cenaPlati: 'Price is valid',
    cenaPoNabidce: 'price after the insurer’s quote',
    cenaSmlouvy: 'Contract price',
    cenaZNabidky: 'Price from the quote',
    chybiCenaFew: 'price missing for {n} contracts',
    chybiCenaMany: 'price missing for {n} contracts',
    chybiCenaOne: 'price missing for {n} contract',
    cipLimit: 'limit {limit}',
    cipNenabizet: 'not offered',
    cipPripojisteni: 'add-on',
    coKryje_domacnost: 'Things at home.',
    coKryje_dum: 'The house — the building itself.',
    coKryje_dumDomacnost: 'The house and the things inside.',
    coKryje_dumOdpovednost: 'The house and damage you accidentally cause to others.',
    coKryje_majetek: 'Things at home and damage you accidentally cause to others.',
    coKryje_majetekDum: 'The house, the things inside and damage you accidentally cause to others.',
    coKryje_odpovednost: 'Damage you accidentally cause to others.',
    coKryje_podnik: 'The business, stock, equipment and damage to customers.',
    coKryje_pravni: 'A lawyer and court when it comes to a dispute.',
    coKryje_zam: 'Damage you cause through negligence at work.',
    doplnteCenu: 'Enter the insurer’s price',
    infoMajetek: 'One contract, one price from the insurer’s quote.',
    infoVlastni: 'Separate contract — the item is arranged separately (another insurer or another product), so it has its own price.',
    infoZamJedna: 'One contract or two? Follow the insurer’s quote: one contract number and one price = one contract. Two prices = each their own. Each person has their own limit based on their gross salary.',
    kazdaSvouCenu: 'each has its own price',
    kinoBezCenFew: 'excluding {n} contracts, prices to follow from the quote',
    kinoBezCenMany: 'excluding {n} contracts, prices to follow from the quote',
    kinoBezCenOne: 'excluding {n} contract, price to follow from the quote',
    kinoBezKraceni: 'Full value — no reduction',
    kinoBlok: '1 block = gross salary {mzda}',
    kinoBlokyAria: '{nasobek} times the gross salary of {mzda} is at least {limit}',
    kinoCelkem: 'Total',
    kinoCenuDoplnime: 'price to follow from the quote',
    kinoChybiHodnota: 'We will add the amounts once the value is known — for now as a percentage of the damage.',
    kinoCyklista: 'On a bike you accidentally knock down another cyclist',
    kinoDalsi: 'Next',
    kinoHotovo: 'Done',
    kinoJezdecPct: '{pct} percent of the value',
    kinoJezdecText: '{castka}, {pct} percent of the value',
    kinoKraceni: 'The insurer pays {pct} % of every claim',
    kinoKrok: 'Explanation for the client · {i} of {n}',
    kinoMisto_doma: 'at home',
    kinoMisto_firma: 'in the business',
    kinoMisto_prace: 'at work',
    kinoMisto_spor: 'in a dispute',
    kinoNazev_odpovednost: 'Why liability needs a high limit',
    kinoNazev_plna: 'Why insure for the full value',
    kinoNazev_prace: 'Liability at work',
    kinoNazev_shrnuti: 'What we will arrange',
    kinoNazev_smlouvy: 'What each contract covers',
    kinoOdpPozn: 'Illustration without amounts. A flooded neighbour or goods broken in a shop belong here too. By car? That is covered by motor liability insurance, not this contract.',
    kinoOdpVeta: 'Whoever causes damage to health pays for it. It is not a single bill — some items are paid for years.',
    kinoOsa1: '1 year',
    kinoOsa10: '10 years',
    kinoOsa20: '20 years +',
    kinoOsaAria: 'Illustration without amounts: treatment and pain are paid right away, care even for years, loss of earnings every month even for decades.',
    kinoOsaBolest: 'Pain and loss of amenity',
    kinoOsaLecba: 'Medical costs',
    kinoOsaNehoda: 'accident',
    kinoOsaPece: 'Care for the injured person',
    kinoOsaVydelek: 'Loss of earnings — every month',
    kinoOsobaMzda: '{jmeno} · {mzda}',
    kinoOsobaPodnika: '{jmeno} · self-employed, not applicable',
    kinoPlnaDum: 'Rebuilding the house would cost {castka}',
    kinoPlnaDumBez: 'House · rebuild cost to be added',
    kinoPlnaVeta: 'When the sum insured is lower than the cost of replacing, the insurer cuts every claim in the same proportion — even a small one.',
    kinoPlnaVybaveni: 'Replacing the contents would cost {castka}',
    kinoPlnaVybaveniBez: 'Contents · value to be added',
    kinoPlnaVyska: 'full height = full value',
    kinoPojistenoCastka: '{castka} ({pct} %)',
    kinoPojistenoNa: 'Insured for',
    kinoPojistenoPct: '{pct} % of the value',
    kinoPojistovna: 'Insurer',
    kinoPoznPodpojisteni: 'Illustration based on the general underinsurance rule, without excess. A specific contract may be arranged differently.',
    kinoPoznPodpojisteniCZ: 'Illustration based on the general underinsurance rule (Section 2854 of the Czech Civil Code), without excess. A specific contract may be arranged differently.',
    kinoPraceKde: '{jmeno} · gross salary {mzda}',
    kinoPraceSmlouva: 'This is what a contract with a limit of {nasobek}× salary is for. The insurer sets the scope and exclusions.',
    kinoPraceVeta: 'Through negligence they damage a machine or equipment they work with. The employer may claim compensation. For negligence, the law caps it at {nasobek} times the average monthly earnings.',
    kinoPraceVyjimky: 'The cap does not apply to damage caused intentionally, under the influence of alcohol or drugs, or to shortfalls and loss of entrusted items — the full damage is paid there. Legal basis: {predpis}.',
    kinoProtoLimit: 'That is why the limit is in millions:',
    kinoShrnPozn: 'The amounts are a proposed cover, not a quote. The insurer sets the price, scope of benefits and exclusions in the contract.',
    kinoSkoda: 'Damage',
    kinoStropNejmene: 'Statutory cap for negligence at least',
    kinoStropPozn: '— based on average earnings, with bonuses it comes out higher.',
    kinoTeckaAria: 'Step {i}: {nazev}',
    kinoVetaJedna: '{mista}: one contract with one price takes care of it.',
    kinoVetaKazde: '{mista} — each is handled by a different contract. Each has its own price.',
    kinoVetaVicFew: '{mista} — {n} contracts, each with its own price.',
    kinoVetaVicMany: '{mista} — {n} contracts, each with its own price.',
    kinoVetaVicOne: '{mista} — {n} contract, each with its own price.',
    kinoVetaZadna: 'We have not chosen any contract yet.',
    kinoZavrit: 'Close the explanation',
    kinoZeSveho: 'Out of pocket',
    kinoZpet: 'Back',
    kratceOdpovednost: 'Liability',
    kratcePodnik: 'Business and operations',
    kratceVybaveni: 'Equipment',
    krytiNemovitostChybi: 'property — value to be added',
    krytiPolozka: '{nazev} {castka}',
    krytiZam: 'limit {limit}',
    krytiZamChybi: 'limit once the salary is entered',
    krytiZamChybiOsoba: '{jmeno} — limit once the salary is entered',
    krytiZamOsoba: '{jmeno} — limit {limit}',
    limitDoplnte: 'enter salary',
    limitNetyka: 'not applicable',
    mzdaOdZamestnavatele: 'Salary from employer — {jmeno}',
    mzdaOsoby: 'Gross salary — {jmeno}',
    mzdaPlati: 'Salary is correct',
    mzdaPlatiAria: 'Gross salary of {jmeno} {mzda} is correct',
    nabidnoutV: 'Offer',
    nabizetV: 'Offer',
    nazevDomacnost: 'Household',
    nazevDomacnostOdpovednost: 'Household and liability',
    nazevMajetek: 'Property',
    nazevMajetekDomacnost: 'Property and household',
    nazevNemovitost: 'Property',
    nazevNemovitostOdpovednost: 'Property and liability',
    nazevOdpovednost: 'Personal liability',
    nazevPodnik: 'Business insurance',
    nazevPravni: 'Legal protection',
    nazevVlastni: '{polozky} — separate',
    nazevZam: 'Employee liability — {jmeno}',
    nazevZamDva: 'Employee liability — {jmeno1} and {jmeno2}',
    nenabizetV: 'Don’t offer',
    neresitV: 'Skip',
    netykaSe: 'not applicable',
    nezadanoPlaceholder: 'not entered',
    obsahSeZmenil: 'contents changed — check the price',
    orientacne: 'approx. ≈ {cena}, not a quote',
    osvcMzdaPozn: 'The income in the analysis comes from self-employment. Enter a salary only if they also have an employer.',
    overitCenuFew: 'check the price of {n} contracts',
    overitCenuMany: 'check the price of {n} contracts',
    overitCenuOne: 'check the price of {n} contract',
    podepiseFew: 'The client signs {n} contracts',
    podepiseMany: 'The client signs {n} contracts',
    podepiseOne: 'The client signs {n} contract',
    podnikNeresit: 'Home insurance does not cover the business, stock or equipment.',
    podtitulJedna: 'One contract · one price',
    podtitulNenabizime: 'Not offered',
    podtitulNeresime: 'Skipped',
    podtitulNetyka: '{jmeno} is self-employed — no employer.',
    podtitulNetykaBez: '{jmeno} has no employment income in the analysis.',
    podtitulPrazdna: 'Nothing covered yet — fill in the items',
    podtitulSamostatna: 'Separate contract',
    podtitulZam: 'Limit {nasobek}× gross salary · one price',
    pojistneCelkem: 'Total premium',
    popisekCastka: 'Sum insured',
    popisekLimit: 'Limit',
    popisekVybaveni: 'Value of equipment',
    popisekZasoby: 'Value of stock',
    pravniNabidka: 'Legal protection: offer or not',
    pravniPripojisteni: 'Add-on to the Property contract',
    pravniSamostatna: 'Separate contract',
    pravniUmisteni: 'How legal protection is arranged',
    prepinacAria: '{nazev}: offer or skip',
    presunAria: '{nazev}: belongs to contract',
    presunNova: '+ New separate contract',
    presunPopisek: 'Arranged differently? Belongs to contract',
    prezSmlouvyFew: '{n} contracts',
    prezSmlouvyMany: '{n} contracts',
    prezSmlouvyOne: '{n} contract',
    prezSouhrnBezCen: '{smlouvy} · prices after the quote',
    prezSouhrnCast: '{smlouvy} · {cena} + other prices after the quote',
    prezSouhrnCena: '{smlouvy} · {cena}',
    proc_majetek: 'A single loss on the property or one caused to others would drag the whole plan down.',
    proc_podnik: 'Home insurance does not cover the business.',
    proc_pravni: 'A dispute over money or work costs a lawyer and court fees.',
    proc_vlastni: 'Arranged separately — its own contract and its own price.',
    proc_zam: 'An employer may claim negligent damage at work from the employee; the statutory cap does not always apply.',
    radekSmlouvy: '{nazev} ({kryti}) — {cena}',
    radekSmlouvyBezKryti: '{nazev} — {cena}',
    regul: 'Only quoted prices count towards the total. The amounts are a proposed cover, not a quote — the insurer sets the price, scope of benefits and exclusions in the contract.',
    resitV: 'Cover',
    smlouvaAria: 'Contract {cislo}: {nazev}',
    staraMetodika: 'This plan uses an older methodology: the printout still shows one line — approx. {cena}. Contracts, prices and “Skip” from here reach the printout only after “{prepocitat}”.',
    staraMetodikaBezTisku: 'This plan uses an older methodology: property insurance is not printed. Contracts and prices from here are carried over only after “{prepocitat}”.',
    stavChybiHodnota: 'value missing',
    stavChybiMzda: 'gross salary missing',
    stavNeresit: 'skip',
    stavNetyka: 'not applicable — self-employed',
    stavNetykaBez: 'not applicable — not employed',
    stavNevlastni: 'not owned',
    stavNezadano: 'not entered',
    stavOdhadMzdy: 'estimate from net — please check',
    ukolSmlouvyFew: 'Arrange property insurance — {n} contracts:',
    ukolSmlouvyMany: 'Arrange property insurance — {n} contracts:',
    ukolSmlouvyOne: 'Arrange property insurance — {n} contract:',
    ulozit: 'Save',
    upravitCenu: 'Edit price: {nazev}',
    vetaSjednat: 'Arrange {nazev} ({kryti}) — {cena}',
    vetaSjednatBezKryti: 'Arrange {nazev} — {cena}',
    vsechnyCeny: 'all prices from quotes',
    vysvetlitKlientovi: 'Explain to the client',
    zNabidky: 'from the quote',
    zadatMzdu: 'Also employed? Enter salary',
    zadnaKPodpisu: 'No contract to sign yet',
    zamJakPoznat: 'How to tell one contract from two',
    zamJakText: 'Look at the insurer’s quote: one contract number and one price = one contract for both. Two prices = each their own. Each person has their own limit based on their gross salary.',
    zamKazdy: 'Each their own contract',
    zamSkupina: 'Employee liability',
    zamSpolecna: 'One contract for both',
  },
  /* BLOK:majetekSmlouvy END */
  /* BLOK:duchodInvalidni START — generuje scratchpad/slovnik.py, ručně needitovat */
  duchodInvalidni: {
    ano: 'Yes',
    bezPrijmuB: 'Parent without income: expenses 20% higher ({narust}) minus disability pension ({duchod}).',
    bezPrijmuDomacnosti: 'No income – disability cover is not calculated; add an income.',
    narok: 'Entitled to a disability pension',
    narokPozn: 'Over 28: 5 years of insurance in the last 10. Childcare counts only with public health insurance. “Not sure” = calculated without entitlement.',
    ne: 'No',
    nevim: 'Not sure',
    odStatu: 'State disability pension {castka}',
    odStatuLabel: 'State disability pension',
    stitek: {
      bezNaroku: 'no entitlement: under 5 years of insurance in the last 10',
      bezNarokuPoradce: 'no entitlement',
      chybiNarozeni: 'add date of birth',
      minimum: 'statutory minimum',
      osvcMinimalni: 'self-employed, minimum contributions',
      overitNarok: 'check the ČSSZ statement',
      prumer: 'average',
    },
  },
  /* BLOK:duchodInvalidni END */
  /* BLOK:kinoCile START — generuje scratchpad/slovnik.py, ručně needitovat */
  kinoCile: {
    bydleni: {
      a1: {
        kicker: 'Renting vs. owning',
        l1: 'Renting: lower upfront cost, easier moving, the owner handles repairs — but you build no wealth.',
        l2: 'Mortgage: you need a down payment and a long-term commitment, but part of each payment repays the principal — you gradually own the property.',
        l3: 'What decides is flexibility, monthly cash flow and whether you want to build wealth.',
        nar: "„Rent is not money thrown away — you pay for housing and flexibility. The difference is that with a mortgage part of each payment repays the principal, so you gradually build wealth. Let us look at the numbers and the model's assumptions.“",
        title: 'Renting and a mortgage: how they differ',
      },
      a5: {
        big: 'What we will start setting aside',
        nar: '„Let us start the plan today — so that you hold the keys, not a rental contract.“',
        title: 'Your home has a plan',
        titleVek: 'A home in {roky} years, at {vek}',
      },
      cnb: {
        bigCena: 'Realistic housing price',
        bigNad: '{nasobek}× annual income — above the recommendation',
        bigOk: '{nasobek}× annual income — within the recommended range',
        kicker: 'A healthy price limit',
        lBezCeny1: 'Fill in the REAL price of the property — otherwise the plan will not add up.',
        lBezCeny2: "From today's home to a similar one, not a palace.",
        lBezPrijmu: 'Fill in income and we will check the price-to-income ratio.',
        lCena: 'Property price: {cena} (realistic, so the plan adds up).',
        lCenaHola: 'Property price: {cena}.',
        lNad: 'That is {nasobek}× your annual income — above the healthy limit!',
        lOk: 'That is {nasobek}× your annual income — fine.',
        nar: '„A healthy price is roughly up to nine annual incomes. We must work with a realistic price, otherwise the whole plan does not add up.“',
        title: 'A healthy price ≈ 9× annual income',
      },
      nbs: {
        bigNad: 'Loan above the NBS limit',
        bigOk: 'Loan within the NBS limit',
        bigUver: 'Loan needed',
        kicker: 'NBS limit',
        lLimit: 'Limit for all your loans: {limit}.',
        lLimitNejvys: 'Limit for all your loans: at most {limit}.',
        lUver: 'Loan needed: {uver}.',
        lUverNad: 'Loan needed: {uver} — above the NBS limit!',
        lUverOk: 'Loan needed: {uver} — fine.',
        lVek: 'Depending on age, the limit may be lower.',
        lZbyva: 'Left after your other loans: {strop}.',
        nar: '„In Slovakia the NBS watches all your loans together — at most eight times your annual net income, less from age 41. Let us see where you fit.“',
        title: 'All loans ≤ {max}× annual income',
      },
      paka: {
        bigHotove: 'Total price',
        bigUver: 'Down payment needed ({pct})',
        kicker: 'Mortgage leverage',
        lAkontace: 'Down payment {pct}: {castka}.',
        lHotove: 'Cash = the full amount now.',
        lSHypotekou: 'With a mortgage ~{pct} down payment is enough and you invest the rest.',
        lZbytek: 'A mortgage covers the rest — your money works elsewhere.',
        narHotove: '„Let us weigh cash against a mortgage. Leverage can be your friend.“',
        narUver: '„With a mortgage you do not need the full amount — only the down payment. The rest of your money can keep growing.“',
        titleHotove: 'Cash, or with leverage?',
        titleUver: 'You invest only the {pct} down payment',
      },
    },
    ostatni: {
      a1: {
        big: 'Let us break it down',
        kicker: 'Your goal',
        l1: 'Every big dream needs a plan and a number.',
        l2: 'We will name how much and when.',
        nar: '„Every goal deserves a clear number and a date. Let us get to it.“',
        title: 'Your dream',
      },
      a2: {
        big: 'Target amount',
        kicker: 'How much and when',
        lHorizont: 'Horizon {roky} years.',
        lHorizontVek: 'Horizon {roky} years — at age {vek}.',
        nar: '„Here is the number and the date. From that we can work out the monthly saving.“',
        titleRoky: '{castka} in {roky} years',
      },
      a3: {
        big: 'The goal within reach',
        kicker: 'Three levers',
        l1: 'The sooner you start, the less you need to set aside.',
        l2: 'Regularity beats one-off attempts.',
        nar: '„Three levers work: time, regularity and return. We can switch on all of them.“',
        title: 'Time × regularity × return',
      },
      a4: {
        big: 'Your goal',
        l1: 'We will plan the monthly saving right away.',
        l2: 'A small step today = a big goal tomorrow.',
        nar: '„A dream without a plan is just a wish. Let us turn it into a plan.“',
        title: 'The plan becomes reality',
      },
    },
    renta: {
      a1: {
        big: 'How much is „enough“ by YOUR expenses?',
        kicker: 'The peak of the plan',
        l1: 'The day when work is a choice, not a duty.',
        l2: 'The passive income must carry your whole lifestyle — for life and above inflation.',
        nar: '„The finish line: the day you no longer have to work for money. The passive income must cover your whole life as it is today, without cutting back.“',
        title: 'Financial independence',
      },
      a2: {
        big: "The passive income you need (today's prices)",
        kicker: 'Your lifestyle',
        lBez1: 'The passive income must cover your TOTAL monthly expenses (lifestyle).',
        lBez2: 'Fill in expenses in the analysis so the amount adds up.',
        lRenta: 'Passive income entered in the goal: {renta}.',
        lVydaje: 'Your total monthly expenses per the analysis: {vydaje}.',
        nar: '„These are your expenses today from the analysis and the passive income you entered for the goal. Everything else follows from these two numbers.“',
        title: 'Your monthly expenses today',
      },
      a3: {
        big: "Capital needed (in today's prices)",
        kicker: 'The 4 % rule',
        l2: '4 % is a real return ABOVE inflation — the principal stays, you draw forever.',
        lRocne: '{renta}/mo = {rocne} a year.',
        nar: '„You can safely draw ~4 % of your wealth a year above inflation forever. From your expenses we calculate the capital you need.“',
        title: 'Income × 12 ÷ 4 % = capital',
      },
      a4: {
        big: 'Target capital for freedom',
        l1: 'Regular investing + time = a snowball, income for life.',
        lCil: 'The goal in {roky} years.',
        lCilVek: 'The goal in {roky} years, at {vek}.',
        lKazdy: 'Every month of saving is an extra month of freedom.',
        nar: '„Independence is not bought with money all at once, but with time and regularity. The snowball of compound interest does the rest.“',
        title: 'Freedom is bought with time',
      },
    },
    rezerva: {
      a1: {
        big: 'How many calm months do you have now?',
        kicker: 'What if…',
        l1: 'The car, losing your job, illness, a broken fridge.',
        l2: 'Without a reserve comes debt — credit card, loan, stress.',
        nar: '„Imagine your income stops tomorrow. How long can you keep your everyday life unchanged?“',
        title: 'What if you lose your income tomorrow?',
      },
      a2: {
        big: 'of Czechs lack a reserve for even a month',
        kicker: 'Reality in the Czech Republic',
        l1: '14 % have no reserve at all.',
        l2: "Almost a third do not have even one month's income set aside.",
        l3: 'Source: STEM/MARK for Home Credit, 2024.',
        nar: '„You are not alone — and that is exactly why the reserve is the first step. 14 % of people have nothing at all, a third would not last a month.“',
        title: 'Almost a third of Czechs would not last a month',
      },
      a3: {
        bigCil: 'Target reserve',
        bigMes: '= {mes} calm months',
        kicker: 'The rule',
        lBez1: '3–6 months of expenses set aside = peace of mind.',
        lBez2: 'Fill in essential expenses and we will count the months exactly.',
        lCil: 'Target {cil} = {mes} months of peace of mind.',
        lNez: 'Your essential expenses: {nez}/mo.',
        nar: '„The goal is 3 to 6 months of essential expenses. For you, that comes to this amount.“',
        title: 'Reserve = 3–6× essential expenses',
      },
      a4: {
        big: 'Your shield against bad luck',
        lDnes: 'Deadline: today — the reserve comes first.',
        lTermin: 'Deadline: in {roky} years.',
        nar: '„You do not need it all at once. We will start bit by bit — what matters is to start. The reserve is the foundation the whole plan stands on.“',
        title: 'A cushion is built bit by bit',
      },
    },
    spolecne: {
      cenaZadani: 'Price as entered: {castka}.',
      cilovaCastka: 'Target amount as entered: {castka}.',
      dejstvi: 'Act {n}',
      hotovo: 'Done ✓',
      modelNajmu: 'Model: rent at 0.35 % of the price per month, growing 3 % a year; the mortgage repays the price evenly, without interest or maintenance costs. Reality varies with location, rate and the condition of the property.',
      osaDnes: 'TODAY',
      osaVek: 'at age {vek}',
      osaZa: 'in {n} yrs',
      pauza: 'Pause',
      termin: 'Deadline: in {roky} years.',
      terminNeni: 'No date has been set yet.',
      terminVek: 'Deadline: in {roky} years, at age {vek}.',
      zacniDnes: 'Start today',
    },
    vzdelani: {
      a1: {
        big: 'How much will studies cost?',
        kicker: 'The greatest gift',
        l1: 'A degree, languages, time abroad, a career kick-off.',
        l2: 'The best thing you can give your children — and it costs money.',
        nar: '„The best investment is in your own children. Let us see what lies ahead of them.“',
        title: 'Education = a start in life',
      },
      a2: {
        big: 'Your goal for {deti}',
        kicker: 'The cost of education',
        l1: 'Studying in the Czech Republic ≈ 300–600 thousand (housing, food, materials).',
        l2: 'A university abroad ≈ CZK 1–3 million.',
        nar: '„Studying at home costs hundreds of thousands, abroad easily millions. Good to know in advance.“',
        title: 'Czech Republic: hundreds of thousands; abroad: millions',
      },
      a3: {
        big: 'Target amount',
        bigRoky: 'You can make it in {roky} years',
        kicker: 'Time is running',
        nar: '„Time is on your side. Starting early means setting aside far less.“',
        title: 'Time is your ally',
        titleRoky: 'Needed in {roky} years',
      },
      a4: {
        big: "Your children's future",
        l1: 'Regular investing from today = peace of mind when the time comes.',
        l2: 'We will plan monthly saving for education.',
        nar: '„A few hundred a month today = open doors for your children tomorrow.“',
        title: 'A small amount, a big degree',
      },
      deti: 'children',
      dite: 'child',
    },
    zdroj: {
      akontaceCZ: 'ČNB, general measure No. I/2021 (LTV: under 36, 90 %; otherwise 80 %), verified {datum}',
      akontaceSK: 'NBS, Decree No. 10/2016 § 7 and § 9d (LTV: until the end of 2026, 80 % certain; from 2027, a first home up to age 35, 90 %), verified {datum}',
      cnb: 'ČNB (Czech National Bank) — recommendation on credit ratios',
      ctyriProcenta: 'The 4 % safe withdrawal rule (Trinity study)',
      klient: "Data from the client's analysis",
      najemModel: 'Model comparison of renting and a mortgage (assumptions by the chart)',
      nbs: 'NBS — Decree No. 10/2016 § 8a (DTI limit)',
      rezervaPravidlo: 'Internal methodology — liquid reserve of 3–6× essential expenses',
      stem: 'STEM/MARK for Home Credit',
    },
  },
  /* BLOK:kinoCile END */
  /* BLOK:invaliditaVysvetleni START — generuje scratchpad/slovnik.py, ručně needitovat */
  invaliditaVysvetleni: {
    aria: 'After disability you need {potreba}, you receive {prijde}, {chybi} is missing.',
    ariaPrebyva: 'After disability you need {potreba}, you receive {prijde}, {prebyva} is left over.',
    bezVydaju: 'Disability cover cannot be calculated — the analysis has no expenses.',
    chybiInfo: '{castka} × 12 × {roky} = {soucet} in today’s prices. We assume the paid-out money is invested at a model return of 4 % above inflation (a model, not a guarantee). That is why {kapital} is enough today.',
    chybiVeta: '{castka} missing every month · {roky}',
    cilBezHorizontu: 'goal {nazev} has no horizon, not included',
    duchod: 'state disability pension',
    duchodSablona: 'disability pension (country template)',
    jenUkazka: 'Illustration only — nothing is written to the plan.',
    krok1: 'Expenses after disability',
    krok1B: 'How much household expenses rise',
    krok1BPod: '+20 % of {vydaje}',
    krok1Pod: 'treatment, care, home adjustments',
    krok2: 'What the family receives',
    krok2B: 'What the state pays',
    krok3: 'What is missing — until retirement income ({roky})',
    krok3B: 'What is missing — for {roky}',
    krok4: 'Disability limit',
    krok4BPod: 'debts, goals and retirement are covered by the earner’s disability cover',
    krok4Pod: 'what is missing + debts + goals + retirement − what you already have',
    model: 'An indicative model, not a guarantee: it assumes a return of 4 % above inflation; with a lower return the limit comes out higher. The disability pension is for full (3rd degree) disability; for the 1st and 2nd degree it is lower. Benefits are set by the policy terms.',
    nepotreba: 'The family would keep enough income — disability cover is not needed.',
    nicNechybi: 'Income covers the family’s expenses exactly.',
    odvozenaRenta: 'derived: retirement income = today’s expenses',
    odvozenaRentaPotreba: 'derived: retirement income = today’s expenses and repayments, without savings and repayments finished before retirement',
    odvozeneRoky: 'derived: retirement horizon {roky} by template',
    orezano: 'The family’s income and assets are enough — disability cover is not needed.',
    partner: '{jmeno} keeps earning',
    pasivniAria: 'Passive income {castka}, disability limit {limit}',
    pasivniTitul: 'If you had passive income today',
    pasivniVeta: 'Insurance is the price of not having passive income yet.',
    prahMezera: 'closes the gap',
    prahNula: 'no policy needed',
    prebyvaVeta: 'Income covers the family’s expenses with {castka} left over — the limit is lower by that.',
    rada: {
      chybi: 'missing',
      dnes: 'today',
      duchod: 'disability pension',
      narust: '+20 % after disability',
      partner: 'partner income',
      pasivni: 'passive income',
    },
    radekChybi: 'What is missing until retirement income',
    radekCile: 'Invest for goals (today’s value)',
    radekDluhy: 'Pay off debts',
    radekMajetek: 'What you already have in accounts',
    radekPrebytek: 'What the family has left over from income — until retirement income ({roky})',
    radekRenta: 'Invest for retirement income (today’s value)',
    radekRentaPod: '{castka} in today’s prices in {roky}, 4 % withdrawal',
    rucne: 'The card shows {rucni} entered manually; calculated {spocitano}.',
    skryt: 'Hide calculation',
    titul: 'How the disability amount is built',
    toggle: 'How disability cover is calculated',
    vysledek: 'Disability limit',
    zaokrouhleni: 'Rows are rounded, so their sum may differ slightly.',
  },
  /* BLOK:invaliditaVysvetleni END */
  /* BLOK:staraZtrata START — generuje scratchpad/slovnik.py, ručně needitovat */
  staraZtrata: {
    invalidita: 'The old policy has disability cover of {castka}; the new one has none.',
    jine: 'The old policy has {riziko} of {castka}; the new one has none.',
    smrt: 'The old policy has death cover of {castka}; the new one has none.',
  },
  /* BLOK:staraZtrata END */
  /* BLOK:schodPoSchodu START — generuje scratchpad/slovnik.py, ručně needitovat */
  schodPoSchodu: {
    bezDat: 'Nothing can be calculated from this analysis yet.',
    bezPrijmu: 'Without income and expenses the order cannot be calculated. Fill them in the analysis.',
    e: {
      doporucene: 'Recommended order',
      hlasDoporucene: 'Recommended order restored.',
      hlasPosun: '{nazev} is now in place {n}.',
      nadpis: 'What matters most to you?',
      niz: 'Move {nazev} down',
      podnadpis: 'Put first what you want first.',
      renta: 'Pension · gets what is left',
      rovne: 'Everything is equally important to me',
      seznam: 'Goal order',
      tahnout: 'Drag: {nazev}',
      ulozit: 'Save order',
      vys: 'Move {nazev} up',
      zaklad: 'Foundation: reserve and income protection · always first',
      zakladRezerva: 'Foundation: reserve · always first',
      zakladZajisteni: 'Foundation: income protection · always first',
      zrusit: 'Cancel',
    },
    k: {
      cilCast: '{nazev}: by {rok} {pct} saved, {chybi} missing.',
      cilHotovo: '{nazev}: reached by {rok}, on time.',
      cileFew: '{vcas} of {celkem} goals on time',
      cileMany: '{vcas} of {celkem} goals on time',
      cileOne: '{vcas} of {celkem} goal on time',
      dalsiCast: 'Other goals ({n}): {pct} saved by their dates, {chybi} missing.',
      dalsiHotovo: 'Other goals ({n}): reached by their dates.',
      nezadaneFew: '{n} goals have no amount or date.',
      nezadaneMany: '{n} goals have no amount or date.',
      nezadaneOne: '{n} goal has no amount or date.',
      renta: 'Pension income from {rok}: {pct} ready in the model (pessimistic {pes}), {chybi} missing.',
      rentaHotovo: 'Pension income from {rok}: {pct} ready in the model (pessimistic {pes}).',
      shrnuti: 'At {castka} a month: {cile}, pension {renta}.',
      shrnutiBezRenty: 'At {castka} a month: {cile}.',
      shrnutiJenRenta: 'At {castka} a month: pension {renta}.',
      srovnani: 'At {castka} a month: {cile} (was {vcasDrive}), pension {renta} instead of {rentaDrive}.',
      srovnaniBezRenty: 'At {castka} a month: {cile} (was {vcasDrive}).',
      srovnaniJenRenta: 'At {castka} a month: pension {renta} instead of {rentaDrive}.',
      uvod: 'You set aside {castka} a month. How much will there be by the dates you want?',
      zajisteni: 'Income protection will be arranged after the meeting.',
      zaklad: 'Foundation first.',
      zakladCast: 'Foundation first: by {rok} the reserve is at {pct}, {chybi} missing.',
      zakladHotovo: 'Foundation first: the reserve is topped up by {rok}.',
      zakladMa: 'Foundation first: you already have the reserve today.',
    },
    nadpis: 'Step by step',
    neodsouhlaseno: 'not yet agreed by the client',
    o: {
      dal: 'Next step',
      dalsi: 'Others',
      krok: 'Step {n}: {nazev}',
      kroky: 'Playback steps',
      otazka: 'Order',
      pauza: 'Pause',
      pokracovat: 'Continue',
      prehrat: 'Play',
      preskocit: 'Skip',
      uvod: 'Start',
      zaklad: 'Foundation',
      znovu: 'Replay',
      zpet: 'Step back',
    },
    odkladani: 'Monthly saving',
    p: {
      bezPojistneho: 'No insurance price entered yet, nothing is deducted from the surplus.',
      dnes: '“Today” = what you regularly set aside now (savings, pension savings, funds).',
      model: 'A model, not a guarantee. Same calculation as the Proposed solution: each goal gets money only until its date, showing how much there will be by then. Pessimistic = lower returns.',
      pojistne: 'Surplus after insurance = free surplus minus the adviser insurance price.',
    },
    precerpano: 'Manual amounts at goals: overdrawn by {castka} — we count only with {dostupne} a month.',
    prehravac: 'player',
    q: {
      ano: 'Yes',
      nemeniCisla: 'The figures above follow the Proposed solution by date. The client order is recorded but does not change the calculation yet.',
      otazka: 'Do you agree with this order?',
      popis: 'Foundation → {cile} → pension',
      popisBezCilu: 'Foundation → pension',
      popisBezRenty: 'Foundation → {cile}',
      popisRovne: 'Foundation, then everything equally important: {cile}, the rest to pension',
      popisRovneBezRenty: 'Foundation, then everything equally important: {cile}',
      potvrzeno: 'Order confirmed {datum}',
      upraveno: 'Client order recorded {datum}',
      upravit: 'Adjust',
      zmenit: 'Change',
    },
    s: {
      bezUdaju: 'no data',
      castkaNezadana: 'amount missing',
      chybi: '{castka} missing',
      cil: 'target',
      cileFew: '{n} goals',
      cileMany: '{n} goals',
      cileOne: '{n} goal',
      dalsiFew: '{n} more',
      dalsiMany: '{n} more',
      dalsiOne: '{n} more',
      doplneno: 'topped up',
      doplnit: 'fill in',
      drive: 'was {pct}',
      kRoku: 'by {rok}',
      maDnes: 'already have',
      mesicne: '{castka}/mo.',
      nepocitaSe: 'not counted',
      pesimisticky: 'pessimistic {pct}',
      poSchuzce: 'after meeting',
      pojisteni: 'Insurance',
      potreba: 'needed',
      pripraveno: 'ready',
      renta: 'Pension',
      rezerva: 'Reserve',
      sjednat: 'arrange',
      ted: 'now',
      terminNezadan: 'date missing',
      vcas: 'on time',
    },
    schodyAria: 'Goal steps. {shrnuti}',
    stitek: 'Model',
    tlacitko: 'Play',
    tlacitkoPopis: 'step by step',
    tlacitkoTitul: 'Short animation: how much there will be by each date, goal by goal',
    vekFew: 'age {n}',
    vekMany: 'age {n}',
    vekOne: 'age {n}',
    volbaDnes: 'Today {castka}',
    volbaPlan: 'Surplus {castka}',
    volbaPlanPoPojistnem: 'Surplus after insurance {castka}',
    zavrit: 'Close playback',
  },
  /* BLOK:schodPoSchodu END */
  /* BLOK:smlouvaEditor START — generuje scratchpad/slovnik.py, ručně needitovat */
  smlouvaEditor: {
    celkova: 'Total amount ({mena})',
    chybaPoli: 'The server did not accept the data — please check the filled-in fields.',
    chybaServeru: {
      jenPojistne: 'A cancellation letter can only be generated for insurance contracts',
      klientNenalezen: 'Client not found',
      neplatneId: 'Invalid link — reload the page and try again.',
      smlouvaNenalezena: 'Contract not found',
    },
    cislo: 'Contract number',
    fixace: 'End of fixation',
    hodnota: 'Current value ({mena})',
    instituce: 'Bank / insurer',
    mazaniSelhalo: 'Deleting failed',
    mesicni: 'Monthly amount ({mena})',
    nadpisEditace: 'Edit contract',
    nadpisNova: 'New contract',
    napr: 'e.g. {x}',
    nasporeno: 'Saved ({mena})',
    poznamky: 'Notes',
    poznamkyNapr: 'What matters about this contract…',
    pridano: 'Contract added',
    pridat: 'Add contract',
    sazba: 'Interest rate (%)',
    smazano: 'Contract deleted',
    smazat: 'Delete',
    smazatPotvrzeni: 'Really delete this contract? Linked diary tasks will be deleted too.',
    stav: 'Status',
    stavActive: 'Active',
    stavCancelled: 'Cancelled',
    stavExpired: 'Expired',
    typChybi: 'Choose the contract type',
    typSmlouvy: 'Contract type *',
    typy: {
      hypoteka: 'Mortgage',
      investice: 'Investment',
      jine: 'Other',
      penzijko: 'Pension (DPS/DIP)',
      pojisteni_auta: 'Car insurance',
      pojisteni_majetek: 'Property insurance',
      pojisteni_odpovednost: 'Liability insurance',
      pojisteni_ostatni: 'Other insurance (legal protection, travel…)',
      pojisteni_zivot: 'Life insurance',
      stavebni: 'Building savings',
      uver: 'Loan',
      zdravotni: 'Health',
    },
    ukladaniSelhalo: 'Saving failed',
    ulozeno: 'Contract saved',
    ulozenoJakoJine: 'Saved as “Other” — the server does not know this contract type yet.',
    ulozitZmeny: 'Save changes',
    vyber: '— Choose —',
    vyroci: 'Contract anniversary',
    zacatek: 'Contract start',
    zavrit: 'Close',
    zbyva: 'Remaining balance ({mena})',
    zrusit: 'Cancel',
  },
  /* BLOK:smlouvaEditor END */
  /* BLOK:cilHistorie START — generuje scratchpad/slovnik.py, ručně needitovat */
  cilHistorie: {
    cilCastka: 'goal {castka}',
    hero: 'of {roky}-year periods in history (1946–2026) would have [[reached the goal]]',
    heroPozn: '{ok} of {n} rolling windows. Everything in real terms, after deducting the inflation of the time.',
    jednotka: {
      milion: 'M',
      tisic: 'k',
    },
    legenda: {
      median: 'median',
      nejhorsi: 'worst window',
      nejlepsi: 'best window',
      projekce: 'projection ({varianta})',
    },
    nadpis: 'Historical calculator — had the client invested like this in the past',
    tip: {
      median: 'Median',
      nejhorsi: 'Worst window',
      nejlepsi: 'Best window',
      projekce: 'Projection',
    },
    tipRok: 'Year {rok} · +{n} yrs',
  },
  /* BLOK:cilHistorie END */
  /* BLOK:smlouvaKarta START — generuje scratchpad/slovnik.py, ručně needitovat */
  smlouvaKarta: {
    aktualniHodnota: 'Current value',
    bezCisla: 'number not filled in',
    celkem: 'Total',
    cislo: 'No. {cislo}',
    druh: {
      hypoteka: 'Mortgage',
      investice: 'Investment',
      jine: 'Other',
      penzijko: 'Pension savings (DPS)',
      pojisteni_auta: 'Car insurance',
      pojisteni_majetek: 'Property insurance',
      pojisteni_odpovednost: 'Liability insurance',
      pojisteni_ostatni: 'Other insurance',
      pojisteni_zivot: 'Life insurance',
      stavebni: 'Building savings',
      uver: 'Loan',
      zdravotni: 'Health',
    },
    fixaceDo: 'Fixed until',
    generuji: 'Generating…',
    kratce: {
      hypoteka: 'Mortgage',
      investice: 'Investment',
      jine: 'Other',
      penzijko: 'Pension',
      pojisteni_auta: 'Car ins.',
      pojisteni_majetek: 'Property ins.',
      pojisteni_odpovednost: 'Liability',
      pojisteni_ostatni: 'Other ins.',
      pojisteni_zivot: 'Life ins.',
      stavebni: 'Building sav.',
      uver: 'Loan',
      zdravotni: 'Health',
    },
    mesicne: 'Monthly',
    nasporeno: 'Saved',
    okno: {
      datumMinulo: 'The end date {datum} is already in the past — change it in the letter to the end of the current insurance period.',
      jazyk: {
        cs: 'Czech',
        sk: 'Slovak',
      },
      jazykDopisu: 'The letter is in the insurer’s language ({jazyk}).',
      kopirovat: 'Copy text',
      lhutySK: 'Notice to the end of the insurance period at least 6 weeks ahead (§ 800(1)). Within 2 months of signing only if the policy allows it, with 8 days’ notice (§ 800(2)).',
      sablona: 'Template — before signing, check the details, deadlines and the insurer’s address in the policy and its terms.',
      staryServer: 'The server returned the Czech template. The Slovak version comes with the server update — until then, edit the text before sending.',
      tisk: 'Print / save PDF',
      titulek: 'Cancellation — {pojistovna} / {klient}',
      zaklad: 'Legal basis: {zaklad}',
      zavrit: 'Close',
      zkopirovano: 'Copied to clipboard',
    },
    pocetFew: '{n} contracts',
    pocetMany: '{n} contracts',
    pocetOne: '{n} contract',
    poznamkaZAnalyzy: 'From the analysis — contract held before the analysis',
    prazdnoNadpis: 'No contracts',
    prazdnoText: 'Add the client’s first contract — a mortgage, insurance, an investment…',
    predAnalyzou: 'before analysis',
    predAnalyzouTitle: 'Contract carried over from the financial analysis — the client had it before the analysis',
    prehled: {
      fixaceLet: 'fixed {n} yrs',
      mesicne: '{castka} / mo',
      smlouvy: 'Contracts',
      smlouvyPocet: 'Contracts ({n})',
      zadneSmlouvyZatim: 'No contracts yet — add them in the contracts tab.',
      zobrazitDalsi: '+ Show {n} more',
    },
    pridat: 'Add contract',
    toastChyba: 'Could not generate the letter',
    toastHotovo: 'Letter generated — print it or save it as PDF',
    toastPopup: 'The browser blocked the window — allow pop-ups.',
    toastStaryServer: 'The server only has the Czech template so far — adjust the text to Slovak law before sending.',
    upravit: 'Edit contract',
    vypoved: 'Cancellation letter to insurer',
    vypovedTitle: 'Generates a cancellation letter template under {zakon} — print it or save it as PDF',
    vyroci: 'Anniversary',
    zAnalyzy: 'From analysis: {popis}',
    zacatek: 'Start',
    zakon: {
      CZ: '§ 2807 of the Czech Civil Code',
      SK: '§ 800 of the Slovak Civil Code',
    },
    zbyvaSplatit: 'Remaining balance',
  },
  /* BLOK:smlouvaKarta END */
  /* BLOK:navrhDavky START — generuje scratchpad/slovnik.py, ručně needitovat */
  navrhDavky: {
    invalidniMes: 'Disability pension (monthly)',
    starobniMes: 'Old-age pension (monthly)',
  },
  /* BLOK:navrhDavky END */
  /* BLOK:variantaVynosu START — generuje scratchpad/slovnik.py, ručně needitovat */
  variantaVynosu: {
    optimisticky: 'Optimistic',
    pesimisticky: 'Pessimistic',
    realisticky: 'Realistic',
  },
  /* BLOK:variantaVynosu END */
  /* BLOK:penze2 START — generuje scratchpad/slovnik.py, ručně needitovat */
  penze2: {
    chyby: {
      bezData: 'Date of birth: fill it in or switch on manual years of saving.',
      cele: '{pole}: enter a whole number.',
      cislo: '{pole}: enter a number.',
      datum: 'Date of birth: it cannot be in the future or invalid.',
      nadpis: 'Fix the highlighted fields. The results still reflect the last valid input.',
      prazdne: '{pole}: enter a value.',
      rozsah: '{pole}: enter a value from {min} to {max}.',
      vPenzi: 'The client has already reached retirement age. Switch on manual years of saving.',
    },
    f: {
      bezDat: 'No data for this selection in the period.',
      dataDo: 'data only until {rok}',
      dataOd: 'data from {rok}',
      grafAria: 'Line chart of 100 Kč in funds over {obdobi}. Highest {fond}: {hodnota}',
      grafNadpis: 'Growth of 100 Kč, {obdobi}',
      grafPopis: 'Index 100 = value at the end of {rok}',
      historie: 'History',
      kontext: 'Other selected funds in grey in the background',
      maxZvyr: 'You can highlight at most {max} funds. Untick one first.',
      mimoVyber: 'outside the selection',
      nic: 'Clear selection',
      o10: '10 years',
      o3: '3 years',
      o5: '5 years',
      oVse: 'All',
      obdobi: 'Period',
      pocet: 'Funds: {n} · highlighted {z} of {max}',
      prumery: 'Strategy average (dashed)',
      slAkce: 'Action',
      slCelkem: 'Over the period',
      slFond: 'Fund / average',
      slPa: 'Return p. a.',
      slRust: 'Growth of 1 Kč',
      slStrategie: 'Strategy',
      slVolatilita: 'Volatility',
      spolecnost: 'Pension company',
      strategie: 'Strategy',
      tabulka: 'Funds',
      tabulkaInfo: 'Tick up to 5 funds to highlight them. Asterisk = the fund has no data for the whole period; its return p. a. counts from its launch and its line starts in the launch year.',
      uvod: 'How 100 Kč grew in pension company funds. Annual returns after fees (APS ČR, banky.cz).',
      vse: 'Select all',
      vsechnySpolecnosti: 'all companies',
      vyber: 'Fund selection',
      vyberteAspon: 'Select at least one strategy and one pension company.',
      vysvetlivky: 'How to read the table',
      vysvetlivkyInfo: 'Return p. a. = average annual return over the period (geometric mean). Over the period = by how many percent the value grew. Volatility = standard deviation of annual returns. Transformed funds (old pension scheme) never show a negative result, because by law the pension company covers it.',
      vznik: 'launched {datum}, first year only partly',
      zadnyZvyr: 'No fund is highlighted. Tick one in the table.',
      zrusitZvyr: 'Remove highlight: {fond}',
    },
    h: {
      chybaCastka: '{pole}: enter a number of 0 or more, e.g. 1,000.',
      chybaObdobi: 'The start of saving must be before the end.',
      chybaRok: '{fond}: no returns for {rok}. Data starts in {od}.',
      danVyber: 'Tax on lump-sum withdrawal (indicative)',
      danVyberInfo: 'On a lump-sum withdrawal, 15 % tax is paid on gains and employer contributions. No tax on an annuity of 10 years or more.',
      dipFond: 'What the DIP invests in',
      dipInfo: 'DIP exists since 2024. Earlier years simulate the same contributions into the chosen fund without the state contribution. The tax saving (deduction up to 48,000 Kč a year, 15 %) counts only from 2024.',
      dipPozn: 'The state does not contribute to DIP.',
      dipPoznInfo: 'On withdrawal after age 60 and 10 years of duration, gains are not taxed.',
      doMesice: 'To month',
      doRoku: 'To year',
      drive: 'formerly {nazev}',
      duchod: 'The client receives an old-age pension',
      fond: 'Fund or average',
      grafAria: 'Account value {od}–{do}: highest {fond} {castka}, own contributions {vklady}',
      grafNadpis: 'Account value at year end',
      grafNadpisMesic: 'Account value at year end (last year up to the chosen month)',
      kpiNasporeno: 'Saved',
      kpiNove: 'New scheme',
      kpiRozdil: 'Difference',
      kpiStare: 'Old scheme',
      kpiStat: 'State in total',
      kpiUsporaDip: 'Total tax saving',
      kpiVDip: 'Saved in DIP',
      kpiVklady: 'Own contributions',
      kpiZhod: 'Return on own money',
      mesicuStat: '{mesicu}, state {stat}',
      nove: 'New scheme (fund or average)',
      noveOd2013: 'The new scheme exists since 2013.',
      od: 'from {rok}',
      odMesice: 'From month',
      odRoku: 'From year',
      pohled: {
        cmp: 'Old vs. new pension scheme',
        dip: 'DIP',
        fund: 'Specific fund',
        str: 'Strategy comparison',
      },
      pohledy: 'View',
      pole: {
        emp: 'Employer contribution per month',
        lump: 'One-off deposit at the start',
        own: 'Own contribution per month',
      },
      pravidlaInfo: 'Since 7/2024 no state contribution. State contribution: 2000–2012 max. 150 Kč (indicative scale), 2013–6/2024 max. 230 Kč (from 1,000 Kč), from 7/2024 20 % of the contribution, max. 340 Kč. The tax saving counts from 2013 at 15 %.',
      skupinaNove: 'New scheme – {spolecnost}',
      skupinaPrumery: 'Averages',
      skupinaStare: 'Old scheme',
      slHodnota: '{fond} – value',
      slVynos: '{fond} – return',
      slozeni: 'What it is made of',
      stare: 'Old scheme (transformed fund)',
      statSub: 'contributions {stat} + tax saving {uspora}',
      tfZkratka: 'TF',
      transformovany: 'transformed fund',
      usporaDipSub: 'deduction up to 48,000 Kč a year, from 2024',
      usporaObdobi: 'Tax saving from deductions over the whole period',
      vProspechNoveho: 'in favour of the new scheme',
      vProspechStareho: 'in favour of the old scheme',
      vlastniVklady: 'Own contributions',
      vynosFondu: 'fund return {pct} a year',
      zadani: 'Input',
      zdroje: 'Sources: APS ČR, banky.cz. Returns after fees.',
      zdrojeInfo: 'APS ČR (participant funds 2017–2025, transformed funds 2013–2025, pension funds 1995–2012), banky.cz (participant funds 2013–2016). Contributions at the start of the month, the annual return spread evenly over the months, the state contribution in the same month. Past returns do not guarantee future returns. Not an offer or investment advice.',
      ztrata: 'Loss',
    },
    m: {
      dalsi: 'Existing contract and other assumptions',
      danZVynosu: 'Include tax on pension savings gains',
      danZVynosuInfo: '15 % of the gains (and employer contributions) on a lump-sum withdrawal from pension savings. Not paid on an annuity of 10 years or more. DIP is tax-free once the conditions are met.',
      danZVynosuOdectena: 'Tax on gains (already deducted)',
      danZam: 'Also tax employer contributions to pension savings',
      danZamInfo: 'On a lump-sum withdrawal, 15 % tax applies to the gains and to employer contributions to pension savings (as in the calculator brief). Does not apply to DIP.',
      dip: 'DIP',
      dip2: 'DIP 2',
      dipKratce: 'DIP',
      doMaxima: '{castka} short of the maximum',
      dodaneni: 'Taxing back deductions if conditions are not met',
      duchod: 'The client receives an old-age pension',
      duchodInfo: 'Since 7/2024 a recipient of an old-age pension does not receive the state contribution.',
      duchodceNe: 'pensioner: no contribution',
      grafAria: 'Stacked bar chart of the saved amount by year; in {rok} a total of {castka}',
      grafNadpis: 'Saved at the end of each year',
      jednotkaLet: 'years',
      jednotkaMesicu: 'months',
      jizInfo: 'Counts towards the minimum saving period. Enter the balance of the existing contract as a one-off deposit or transfer.',
      kategorie: {
        dite: 'Child',
        dospely: 'Adult',
        senior: 'Senior',
      },
      klient: 'Client',
      kpiNasporeno: 'Total saved at retirement',
      kpiNavic: 'Extra gained',
      kpiRenta: 'Monthly annuity',
      kpiVynos: 'Return p. a.**',
      letFew: '{n} years',
      letMany: '{n} years',
      letOne: '{n} year',
      maxVyuzito: 'maximum of {castka} used',
      mesicuFew: '{n} months',
      mesicuMany: '{n} months',
      mesicuOne: '{n} month',
      naKonci: 'at the end of saving',
      nadVklady: 'above own contributions of {castka}',
      narozeni: 'Date of birth',
      nelze: 'n/a',
      nesplneno: 'Not met',
      odStatu: 'From the state per year',
      odchod: 'Retirement',
      odebratDip2: 'Remove the second DIP strategy',
      odpocty: 'The client uses tax deductions',
      odpoctyInfo: 'From own contributions to pension savings above 1,700 Kč a month and from DIP, together max. 48,000 Kč a year. Saving = deduction × 15 %; it is not added to the saved amount.',
      odpoctyNe: 'deductions not included',
      penzeVRoce: 'Retirement in',
      penzijko: 'Pension savings (DPS)',
      penzijkoKratce: 'Pension',
      plnaPodpora: 'Full support: {a} a month into pension savings for the state contribution and another {b} a month into pension savings or DIP for the tax deduction.',
      poDani: 'after tax on gains of {castka}',
      pocatek: 'One-off deposit or transfer',
      pocatekInfo: 'The balance of an existing contract or a one-off deposit. Return* treats it as own money paid in at the start.',
      podminky: 'Conditions and taxes',
      podpora: 'Use of state support',
      podporaInfo: 'State contribution: 20 % of own contribution from 500 Kč, max. 340 Kč a month (at 1,700 Kč). Tax saving: 15 % of the deduction, max. 7,200 Kč a year. The state maximum is 11,280 Kč a year.',
      pole: {
        dip2Vlastni: 'DIP 2 – own contributions',
        dip2Vynos: 'DIP 2 – return',
        dip2Zam: 'DIP 2 – employer',
        dipVlastni: 'DIP – own contributions',
        dipVynos: 'DIP – return',
        dipZam: 'DIP – employer',
        dpsPocatek: 'Pension savings – one-off deposit',
        dpsVlastni: 'Pension savings – own contributions',
        dpsVynos: 'Pension savings – return',
        dpsZam: 'Pension savings – employer',
        jizMesicu: 'Already saved on the existing contract',
        narozeni: 'Date of birth',
        rentaLet: 'Years in retirement',
        rentaVynos: 'Return in retirement',
        roky: 'Years of saving',
      },
      pravidlo: 'Rule: age 60 + 120 (60) months',
      pravidloAno: 'Met',
      pravidloAuto: 'Evaluate from age and saving period',
      pravidloDetail: 'age at withdrawal {vek}, saving {mesicu} (minimum {min} months)',
      pravidloInfo: 'Payout without returning support: age 60 and at least 120 months of saving (contracts until 2023: 60 months). If not met, the calculator indicatively returns state contributions, taxes the gains and taxes back deductions for the last 10 years.',
      pravidloNe: 'Not met (early withdrawal)',
      pravidloPredpoklad: 'age not entered, assumed to be met',
      pravidloRucne: 'set manually (minimum {min} months)',
      predpoklady: 'A projection, not a guarantee.',
      predpokladyInfo: 'Assumed return after fees for the whole saving period, monthly compounding (annual return / 12), contributions at the start of the month. The annuity is paid at the start of the month. State support rules valid from 1 July 2024 unchanged for the whole period. The tax saving is not added to the saved amount. Past returns do not guarantee future returns; this is not investment advice.',
      pridatDip2: 'Add a second DIP strategy',
      priklad: 'Example',
      produkty: 'Results by product',
      produktyInfo: 'Return* = annual return on own contributions including the state contribution. Return** = also including the employer contribution. In product rows it is based on the amount before tax, in the Total row after tax.',
      renta: 'Annuity in retirement',
      rentaBezZhod: '{roky}, no further growth',
      rentaInfo: 'The annuity is paid at the start of each month. At 0 % the saved amount is simply split into equal monthly payments.',
      rentaSeZhod: '{roky}, growth {pct} a year',
      rokyDoPenze: 'Years to retirement',
      rokyRucne: 'Enter years of saving manually',
      rokyRucneInfo: 'When you do not know the date of birth or the client wants to save for a different period than until 60 / 65.',
      slozeni: 'What the saved amount is made of',
      smlouva2024: 'Contract signed after 1 Jan 2024',
      smlouva2024Info: 'A contract signed from 1 Jan 2024 needs at least 120 months of saving for a payout without penalty; an older contract needs 60 months.',
      splneno: 'Met',
      statMes: 'State contribution per month',
      strategie: 'Strategy',
      strategieInfo: 'The preset fills in the return from the average of funds with that strategy for {od}–{do} (after fees). Just an input aid, not a forecast.',
      usporaCelkem: 'Tax saving over the whole period (refunded via tax, not in the account)',
      usporaRok: 'Tax saving per year',
      v60: 'at 60',
      v65: 'at 65',
      vRoce: 'in {rok}',
      vek: 'Age',
      vklady: 'Monthly contributions and return',
      vkladyInfo: 'Monthly contributions to pension savings (DPS) and DIP. The return is an assumption after fees, compounded monthly (annual return / 12), contributions at the start of the month.',
      vlastni: 'Own contributions',
      vlastniVynos: 'Custom return',
      vlastniZadani: 'Custom input',
      vynos: 'Annual return',
      vyuzitoAria: '{pct} % of the maximum used',
      vzorPokrocily: 'Example: pension savings + DIP',
      vzorZakladni: 'Example: 1,000 Kč into pension savings',
      zMaxima: 'of max. {castka} · {pct}',
      zamestnavatel: 'Employer',
      zhodVlastnich: 'return on own money',
    },
    prumer: {
      dynamicky: 'Average of dynamic funds',
      jina: 'Average',
      konzervativni: 'Average of conservative funds',
      transformovany: 'Average of transformed funds',
      vyvazeny: 'Average of balanced funds',
    },
    prumerKratce: {
      dynamicky: 'Ø dynamic',
      jina: 'Ø',
      konzervativni: 'Ø conservative',
      transformovany: 'Ø transformed',
      vyvazeny: 'Ø balanced',
    },
    r: {
      coPocitat: 'What to calculate',
      dan: 'Deduct 15 % tax on gains',
      dostavat: 'How much I will receive',
      f: {
        castka: 'Saved at the start of retirement',
        let: 'Years of drawdown',
        letS: 'Years of saving',
        pocatek: 'Already saved',
        renta: 'Desired monthly annuity',
        vynos: 'Return in retirement',
        vynosS: 'Return while saving',
        zam: 'Employer per month',
      },
      grafCerpani: 'Balance during drawdown',
      grafCerpaniAria: 'Area chart of the balance over {roky} of drawing an annuity of {renta} a month',
      grafSporeni: 'Saving and drawing the annuity',
      grafSporeniAria: 'Area chart: saving for {sporeni} up to {castka}, then {roky} of drawing an annuity of {renta}',
      kpiNasporeno: 'Saved with this contribution',
      kpiPotreba: 'Amount needed at retirement',
      kpiRenta: 'Monthly annuity',
      kpiSporit: 'Save per month',
      kpiStatZam: 'State and employer per month',
      kpiVyplaceno: 'Paid out in total',
      kpiZUroku: 'Of which return in retirement',
      kpiZtrata: 'Loss in retirement',
      letRenty: '{roky} of annuity',
      letRentyPo: '{roky} of annuity at {renta}',
      nadCastku: 'above the saved amount of {castka}',
      nelze: {
        nedosazitelne: 'Not achievable at the given return. Try a longer saving period or a higher return.',
        nulovaDoba: 'The saving period is 0 months. Try a longer saving period.',
      },
      nelzeSpocitat: 'cannot be calculated',
      nicKPrevzeti: 'The projection has no valid result yet.',
      odchod: 'Retirement {rok}',
      osaRokPenze: 'Axis: year of retirement (0 = start of retirement)',
      pokryto: 'The entered savings and employer contributions already cover the desired annuity. No own monthly contribution is needed.',
      pozn: 'A projection, not a guarantee.',
      poznDostavatInfo: 'The annuity is paid at the start of the month: monthly rate = annual return / 12; the balance is zero at the end of drawdown. At 0 % the amount is simply split into equal payments. Inflation and taxes on payouts are not considered.',
      poznSporitInfo: 'The monthly contribution is the smallest whole amount in Kč at which the saved sum covers the desired annuity. Saving: monthly compounding (annual return / 12), contributions at the start of the month, state contribution under the rules from 7/2024. The annuity is paid at the start of the month. Inflation is not considered.',
      prevzato: 'Taken from the projection.',
      prevzit: 'Take from the projection',
      rentaMes: 'annuity {renta} a month',
      rokRenty: 'annuity year {n}',
      rokSporeni: 'saving year {n}',
      slCelkem: 'Paid in total',
      slFaze: 'Phase',
      slRokPenze: 'Year of retirement',
      slVklady: 'Contributions per year',
      slVyplaty: 'Payouts per year',
      slZaRok: 'Paid per year',
      slZustatek: 'Balance at year end',
      sporit: 'How much to save',
      staciUspory: 'the entered savings and contributions are enough',
      stat: 'Save in pension savings with the state contribution',
      statInfo: '20 % of own contribution from 500 Kč, max. 340 Kč a month.',
      statZamSub: 'state {stat}, employer {zam}',
      uvod: 'How much the client will receive from the saved amount, or how much to save for the desired annuity.',
      vyplatFew: '{n} monthly payments',
      vyplatMany: '{n} monthly payments',
      vyplatOne: '{n} monthly payment',
      zaokrouhleno: 'own contribution, rounded up',
      zustatek: 'Balance',
    },
    sdileni: {
      doba: 'Saving period',
      mesicne: '{castka} a month',
      uvod: 'Hello, here is the projection of your pension savings and DIP — how much a month and what it could mean in retirement. Have a look and let me know.',
      veta1: 'Retirement is a long-distance run: the earlier you start, the more compound interest works for you.',
      veta2: 'This is a projection with an assumed return, not a guarantee. The actual result will differ.',
    },
    sl: {
      celkem: 'Total',
      danPriVyberu: 'Tax on withdrawal',
      danZVynosu: 'Tax on gains',
      nasporeno: 'Saved',
      predDani: 'Saved before tax',
      produkt: 'Product',
      rok: 'Year',
      vek: 'Age',
      vynos1: 'Return*',
      vynos2: 'Return**',
      vynosFondu: 'Fund return',
    },
    slozky: {
      stat: 'State',
      vlastni: 'Own contributions',
      zamestnavatel: 'Employer',
      zhodnoceni: 'Growth',
      zhodnoceniPoDani: 'Growth after tax',
    },
    stranka: {
      nadpis: 'Pension savings and DIP',
      paticka1: 'A projection, not a guarantee. Past returns do not guarantee future returns. Not investment advice.',
      paticka2: 'Fund returns are after fees (APS ČR, banky.cz). State support rules valid from 1 July 2024, as of October 2026. The calculation is not an offer to sign a contract.',
      podnadpis: 'Projection, fund history, fund comparison and annuity plan.',
      poslat: 'Send to client',
      skVeta: 'The calculator covers Czech pension savings (DPS) and DIP under Czech rules; amounts are in CZK.',
      stitek: 'Pension calculator',
      tisk: 'Print / PDF',
      zalozky: {
        fondy: 'Fund comparison',
        historie: 'Historical',
        modelace: 'DPS + DIP projection',
        renta: 'Annuity plan',
      },
      zalozkyAria: 'Pension calculators',
    },
    strategieNazev: {
      dynamicky: 'Dynamic',
      jina: 'Other',
      konzervativni: 'Conservative',
      transformovany: 'Transformed funds',
      vyvazeny: 'Balanced',
    },
    tabulkaPoLetech: 'Year-by-year table',
    upozorneni: {
      duchodceBezStatu: 'A recipient of an old-age pension does not receive the state contribution (since 7/2024).',
      pravidloNesplneno: 'The 60 years + {min} months rule is not met: state contributions are returned, gains and employer contributions are taxed at 15 %, deductions are taxed back (indicative).',
      zamNadLimit: 'The employer contribution of {rocne} a year is above the tax-free limit of {limit} (DPS + DIP + life insurance combined).',
    },
  },
  /* BLOK:penze2 END */
  /* BLOK:vydajePravidlo START — generuje scratchpad/slovnik.py, ručně needitovat */
  vydajePravidlo: {
    tip: 'The expenses were filled in from the rule ({pct} %) — this is an estimate based on income, not figures from the client. Feel free to overwrite them.',
    tipNazev: 'Expenses from the rule',
  },
  /* BLOK:vydajePravidlo END */
  /* BLOK:rozpisKategorii START — generuje scratchpad/slovnik.py, ručně needitovat */
  rozpisKategorii: {
    planPocita: 'the plan currently uses this figure',
    pouzit: 'Use as usual expenses',
    prepis: 'The category breakdown ({castka}) will be overwritten by the itemised totals — otherwise the plan uses the higher of the two numbers.',
    radek: 'From the category breakdown',
    sedi: 'matches usual expenses',
    smazano: 'Category breakdown deleted',
    smazat: 'Delete breakdown',
    vratit: 'Undo',
  },
  /* BLOK:rozpisKategorii END */
  /* BLOK:smrtVysvetleni START — generuje scratchpad/slovnik.py, ručně needitovat */
  smrtVysvetleni: {
    aria: 'After a death the family needs {potreba}, receives {prijde}, {chybi} is missing.',
    ariaPrebyva: 'After a death the family needs {potreba}, receives {prijde}, {prebyva} is left over.',
    bezVydaju: 'Death cover cannot be calculated — the analysis has no expenses.',
    chybiInfo: '{castka} × 12 × {roky} = {soucet} in today’s prices. We assume the paid-out money is invested at a model return of 4 % above inflation (a model, not a guarantee). That is why {kapital} is enough today.',
    chybiVeta: '{castka} missing every month · {roky}',
    cilBezHorizontu: 'goal {nazev} has no horizon, not included',
    duchod: 'widow’s and orphan’s pension from the state',
    duchodBezDeti: 'widow’s pension from the state',
    duchodSablona: 'survivor’s pension (country template)',
    jenUkazka: 'Illustration only — nothing is written to the plan.',
    krok1: 'Family expenses after death',
    krok1Pod: '{pct} % less than today ({vydaje})',
    krok2: 'What the family receives',
    krok3: 'What is missing — for {roky}',
    krok4: 'Death limit',
    krok4Metoda: 'Capital method',
    krok4Pod: 'what is missing + debts + goals − what you already have',
    krok5Minimum: 'Older method: at least debts + one year of income + children until independent',
    krok5MinimumBezPrijmu: 'Older method: at least paying off debts',
    mezisoucet: 'by the capital method',
    minimumDite: '{jmeno} until age {vek}',
    minimumDiteBezJmena: 'child',
    minimumPrijem: 'Family income for one year',
    minimumVeta: 'This came out higher than the capital method, so it applies.',
    model: 'An indicative model, not a guarantee: it assumes a return of 4 % above inflation; with a lower return the limit comes out higher. The widow’s and orphan’s pensions are an indicative template; the state sets the actual amount. Retirement income (financial independence) is not included in death cover — nobody draws it after death; shared goals remain. Benefits are set by the policy terms.',
    nepotreba: 'The family would keep enough income — death cover is not needed.',
    nicNechybi: 'Income covers the family’s expenses exactly.',
    odvozeneRoky: 'derived: horizon {roky} by template',
    orezano: 'The family’s income and assets are enough — death cover is not needed.',
    partner: '{jmeno} keeps earning',
    pasivniAria: 'Passive income {castka}, death limit {limit}',
    pasivniTitul: 'If you had passive income today',
    pasivniVeta: 'Insurance is the price of not having passive income yet.',
    poPrepoctu: 'After recalculating with the new method, the capital method applies ({castka}).',
    prahMezera: 'closes the gap',
    prahNula: 'no policy needed',
    prebyvaVeta: 'Income covers the family’s expenses with {castka} left over — the limit is lower by that.',
    rada: {
      chybi: 'missing',
      dnes: 'expenses after death',
      duchod: 'state pension',
      partner: 'partner income',
      pasivni: 'passive income',
    },
    radekChybi: 'What is missing for {roky}',
    radekCile: 'Invest for goals (today’s value)',
    radekDluhy: 'Pay off debts',
    radekMajetek: 'What you already have in accounts',
    radekPrebytek: 'What the family has left over from income — over {roky}',
    rucne: 'The card shows {rucni} entered manually; calculated {spocitano}.',
    skryt: 'Hide calculation',
    staraMetodika: 'Older method — the minimum applies.',
    titul: 'How the death amount is built',
    toggle: 'How death cover is calculated',
    vysledek: 'Death limit',
    zaokrouhleni: 'Rows are rounded, so their sum may differ slightly.',
  },
  /* BLOK:smrtVysvetleni END */
  /* BLOK:poradiRizik START — generuje scratchpad/slovnik.py, ručně needitovat */
  poradiRizik: {
    invaliditaSmrt: 'disability / death',
  },
  /* BLOK:poradiRizik END */
  /* BLOK:splatkaUveru START — generuje scratchpad/slovnik.py, ručně needitovat */
  splatkaUveru: {
    infoNazev: 'What the amount is made of',
    rozpad: 'From {rok}: loan instalment {uver}/month + goals entered manually above the budget {rucni}/month.',
    rozpadOchrana: 'From {rok}: loan instalment {uver}/month + protection above the surplus {ochrana}/month.',
    rozpadOchranaRucni: 'From {rok}: loan instalment {uver}/month + protection above the surplus {ochrana}/month + goals entered manually above the budget {rucni}/month.',
    schodek: 'From {rok}, {castka}/month is missing — the instalment is higher than the budget allows.',
    schodekNejvic: 'The most missing is {castka}/month from {rok}.',
  },
  /* BLOK:splatkaUveru END */
  /* BLOK:kartaCile START — generuje scratchpad/slovnik.py, ručně needitovat */
  kartaCile: {
    akontace: 'Down payment',
    bezUveru: 'You pay the full amount from your own money — no loan needed.',
    cashflowBezNajmu: 'From {rok} the payment is {splatka} for {roky}.',
    cashflowDvaUvery: 'From {rok}: repayment {splatka} — of which the building savings loan {stavebko} only for {rokyStavebko}, the mortgage for {roky}.',
    cashflowGraf: 'cash flow over time',
    cashflowKlesne: 'From {rok}: repayment {splatka}, rent {najem} ends — the surplus drops by {zmena}.',
    cashflowSNajmem: 'From {rok} the payment is {splatka}, rent {najem} ends — surplus {zmena}.',
    cashflowStoupne: 'From {rok}: repayment {splatka}, rent {najem} ends — the surplus rises by {zmena}.',
    celkem: 'total',
    celkemZaplatite: 'You pay in total',
    celyText: 'full text',
    cerpani: 'drawdown',
    cilCara: 'goal {castka}',
    cnbKratce: 'under 36, 10% own funds is enough, otherwise 20%',
    detailInvestice: 'Investment detail',
    detailInvesticePod: 'allocation over time, history',
    dofDopadProdej: 'Own funds drop by {snizeni} — {zbyva} left to save.',
    dofDopadZastava: "The bank assesses the loan against both properties: up to {uver} ({ltv}% of {zaklad}) → own funds {vlastni}. Verify the pledger's consent, valuation and creditworthiness with the bank.",
    dofHodnotaZastavy: 'pledge value',
    dofJiny: 'other assets',
    dofNe: 'no',
    dofOdebrat: 'remove',
    dofPouzitZastavu: 'use as collateral',
    dofPouzitoU: 'used for the goal {cil}',
    dofProdej: 'sell a property',
    dofStaraMetodika: 'The plan is calculated with an older methodology — the top-up applies after recalculating with the new methodology.',
    dofStitekOcekavane: 'expected',
    dofStitekOverteDruh: 'check the type',
    dofStitekStehovani: 'only if moving',
    dofStitekZatizeni: 'check encumbrance (mortgage {castka})',
    dofStitekZatizeniBez: 'check mortgage encumbrance',
    dofVynos: 'sale proceeds',
    dofZAnalyzy: 'Chosen as collateral in the analysis: {nazev} · {hodnota}',
    dofZadnaZastava: 'There is no property in the analysis — enter the value manually.',
    dofZadnyJiny: 'There is nothing to sell in the analysis — enter the amount manually.',
    dofZadnyProdej: 'There is no property to sell in the analysis — enter the amount manually.',
    dofZastava: 'pledge a property (own or parental)',
    dofZbyde: '{castka} remains from the sale.',
    dofZrusenoChybi: '“{nazev}” is no longer in the analysis — the saved choice is not counted.',
    dofZrusenoJiny: '“{nazev}” is a property — it belongs to sale or pledge. The saved choice is not counted.',
    dofZrusenoPouzito: '“{nazev}” is already counted for the goal {cil} — each item only once. The saved choice is not counted.',
    dofZrusenoProdej: '“{nazev}” is not a property in the analysis — the saved sale is not counted.',
    dofZrusenoUver: 'A pledge is not possible with a consumer loan — the saved choice is not counted.',
    dofZrusenoZastava: '“{nazev}” cannot be pledged — only a property can. The saved choice is not counted.',
    doporuceno: 'recommended',
    grafAriaModel: 'You put in {vlozeno}; in {roky} the modelled value is {hodnota}, return {vynos} — a model, not a guarantee.',
    hotove: 'in cash',
    hotovePct: 'cash {pct}%',
    hypoVychozi: 'Empty field = the default {sazba}% for {roky} years, not a bank offer.',
    hypotekaVyse: 'Mortgage',
    hypotekaZaRoky: 'Mortgage over {roky}',
    jednorazoveDnes: 'One-off today',
    jenHypotekaAria: 'The chart shows the mortgage only, without the building savings loan.',
    kolikHotove: 'How much you pay in cash',
    kombinace: 'Your free money + the rest monthly',
    kombinacePod: '{jedn} one-off from your money, the rest {mes} monthly',
    kombinacePodNestaci: '{jedn} one-off from your money, the rest {mes} monthly — more than the surplus gives this goal',
    krok1: 'Save',
    krok1Hotove: 'Save what you will pay in cash',
    krok1Rezerva: 'Fill the reserve',
    rezervaBezVydaju: 'The reserve cannot be calculated — expenses are missing in the analysis.',
    krok1Vlastni: 'Save your own funds',
    krok2Hypo: 'Borrow with a mortgage',
    krok2Uver: 'Borrow with a loan',
    krok3: 'Top up from assets',
    krytoZeZdroju: 'Covered by your money — nothing extra is needed.',
    mesNestaci: 'the surplus gives {prideleno} — {chybi} missing',
    mesNestaciKroky: 'the plan gives {prideleno} from now, more later — see step by step',
    mesPakVic: 'today, then more — see step by step',
    modelovaHodnota: 'Modelled value',
    modelove: 'modelled',
    nadPrebytek: 'more than the free surplus',
    nbsKratce: '20% own funds, 10% only exceptionally',
    neboMesicne: 'or monthly',
    neboMesicneRenta: 'or monthly',
    nejistota: "Model ({scenar}) in today's prices, not a guarantee — the actual return will differ.",
    nicSporit: 'Nothing to save.',
    nicSporitUver: 'Nothing to save — the loan and assets cover the whole price (steps 2 and 3).',
    obaUvery: 'Both loans together',
    obojiUlozene: 'One-off and monthly (saved in the plan)',
    odRoku: 'from {rok}',
    odTed: 'from now',
    osaJednorazove: 'one-off — {zdroj}',
    osaJednorazovePoCili: 'one-off — {zdroj} · only after the goal date, not counted',
    osaJednorazovePoRente: 'one-off — {zdroj} · only after the pension starts, not counted',
    osaMzdaNedorazi: '{rust} — does not reach the pension',
    osaMzdaPoCili: '{rust} — only after the goal date, not counted',
    osaMzdaPoRente: '{rust} — only after the pension starts, not counted',
    osaMzdaSplatka: '{rust} — the loan repayment uses all of it, it never reaches the pension',
    osaRustMzdy: 'salary growth',
    osaRustMzdyPozde: '{rust} from {rok} — until now the loan repayment uses it up',
    osaRustMzdyPozdeObecne: '{rust} from {rok}',
    osaRustMzdySablona: 'salary growth (estimate)',
    osaUverSplacen: 'the loan for {cil} is paid off',
    osaUvolneno: 'money freed up from the surplus',
    osaZCile: 'freed up from goal {cil} (saved)',
    osaZaklad: 'regular investment',
    osaZakladMzda: 'incl. +{castka} thanks to the pay rise from {rok}',
    pasmo: 'worse to better scenario',
    pasmoBublina: 'Worse – better scenario',
    pasmoSouhrn: 'worse to better scenario {od} – {do}',
    pctZ: '{pct}% of {cena}',
    plneniZa: 'Goal progress {kdy} ({scenar})',
    plusStavebko: '+ building savings loan {castka} for {roky} years = {splatka}{mes} (own rate)',
    poporade: 'Step by step',
    proVsechnyCile: 'For all goals:',
    pujcite: 'You borrow',
    puvodniNavrh: 'back to the original proposal',
    realne: 'real',
    resiSeUveremHotove: 'Only what you pay in cash is saved; the loan covers the rest — payments start at drawdown.',
    rezimBezSchodu: 'The chosen path uses a flat payment — the increases from the original proposal',
    rokSplaceni: 'repayment year {n}',
    rustBez: 'no growth',
    rustBezRustu: 'The plan does not count on contribution growth — and the settings prescribe none.',
    rustChybi: 'Salary growth is NOT counted yet — there are no steps in the plan. Click Include salary growth.',
    rustLisi: 'The salary growth steps in the plan DIFFER from the settings — the plan uses them. Align them with Include salary growth.',
    rustLisiKratce: 'the plan has different steps',
    rustLisiZahod: 'The plan uses salary growth steps, but the settings produce no growth — discard them so the plan matches the settings.',
    rustMzdy: 'Salary growth',
    rustNepocita: 'not counted yet',
    rustPopis: '{pct} {baze} every {krok} years',
    rustRealne: "real, above inflation — the plan works in today's prices and does not add inflation.",
    rustRucniPolozka: '+{castka} from {rok}',
    rustSablonaNeRucniAno: 'template not yet · the plan has a manual {rucni}',
    rustSedi: 'The plan uses this pace — the salary growth steps in the plan match the settings.',
    rustVPlanu: 'in the plan ({n} steps)',
    rustVPlanuPo: 'in the plan: {n} before the pension, {po} after it starts',
    schodyAria: 'The monthly contribution grows from {od} to {do}.',
    seZastavou: 'with a pledge',
    sjednotit: 'align with the plan',
    skrytGraf: 'hide chart',
    splatkaMesicne: 'Monthly payment',
    splatkaRozpis: 'mortgage {hypo} + building savings loan {stavebko} ({roky})',
    spotrVychozi: 'Empty field = an indicative {sazba}% for {roky} years (at most {max} years) — verify with the bank.',
    srovnatRust: 'Align with settings',
    stavebkoZaRoky: 'Building savings loan {castka} over {roky}',
    upravit: 'edit',
    upravitRucne: 'edit amounts manually',
    uverSpotrebitelsky: 'consumer loan',
    uverStavebko: 'building savings loan',
    uzMate: 'You already have',
    vPlanuNestaci: 'in the plan — not enough',
    vRoce: 'in {rok}',
    vetaRoku: 'paid in {vlozeno} · value {hodnota} · return {vynos}',
    vlastniProfil: 'own profile: {profil}',
    vlastniZdroje: 'own funds',
    vlozeno: 'Paid in',
    vlozite: 'You pay in',
    volitelne: 'optional',
    volnychJen: 'you have {volne} free',
    vybrano: 'selected',
    vynos: 'return',
    zPrebytku: 'from the monthly surplus',
    zTohoHotove: 'of which in cash',
    zVolnych: 'from free money (you have {volne})',
    zahoditKrokyTitul: 'Removes the template salary growth steps from the plan — it then calculates without them, exactly as set.',
    zapocitatRust: 'Include salary growth',
  },
  /* BLOK:kartaCile END */
  /* BLOK:klientEmail START — generuje scratchpad/slovnik.py, ručně needitovat */
  klientEmail: {
    chybaAdresa: 'Check the client e-mail address.',
    chybaPredmet: 'Add a subject.',
    chybaTelo: 'Add the message text.',
    crmBezEmailu: 'The client has no e-mail in the CRM — add it manually.',
    dalsiOdkaz: 'Create another link',
    introFixace: 'Hello, here is the model of your mortgage fixed period. The key figure is the second one — the instalment after the fixed period ends. If anything comes up, get in touch.',
    introHistoricka: 'Hello, here is the promised model of how the investment performed historically. Have a look at the numbers — and get in touch if anything comes up.',
    introModelace: 'Hello, here is the model I promised. Have a look and get in touch if anything comes up.',
    klientNepovinne: 'Client (optional)',
    komu: 'To',
    kopirovaniChyba: 'Copying failed.',
    kopirovat: 'Copy',
    modelaceVPdf: 'Model as PDF',
    nadpis: 'Send to client',
    najdiKlienta: 'Find a client by name…',
    neniEmail: 'This does not look like an e-mail address.',
    nepropojeny: 'E-mail is not connected in the app yet. Your mail program will open with the message pre-filled — you confirm sending there. (You can connect it in Settings.)',
    neznamyTransport: 'Could not check whether e-mail is connected in the app. Your mail program will open with the message pre-filled — you confirm sending there.',
    odejdeGmail: 'It will be sent from your Gmail.',
    odejdeGmailAdresa: 'It will be sent from your Gmail {email}.',
    odejdeSmtp: 'It will be sent from your company e-mail.',
    odejdeSmtpAdresa: 'It will be sent from your company e-mail {email}.',
    odesilam: 'Sending…',
    odeslanToast: 'E-mail sent to the client.',
    odeslanoKlientovi: 'Sent to the client.',
    odeslatChyba: 'The e-mail could not be sent.',
    odeslatNa: 'Send to {adresa}',
    odkazChyba: 'The link could not be created right now. Please try again.',
    otevrete: 'You can open it here:',
    otevrit: 'Open',
    otevritPostu: 'Open mail program',
    ozveteSe: 'If anything does not look right or you have any questions, get in touch — we will go through it together, no rush.',
    pdfChyba: 'The PDF could not be created.',
    pdfStazenoToast: 'PDF downloaded — attach it to the e-mail.',
    pdfVeStazenych: 'The PDF is in your Downloads.',
    popis: 'Choose a client, add an opening message and create a link to this model.',
    popisHotovo: 'The link is ready — send it to the client.',
    poslatEmailem: 'Send by e-mail',
    postaOtevrena: 'The message opened in your mail program. The app has NOT sent it — send it from there.',
    pozdrav: 'Hello,',
    pozdravJmeno: 'Hello {osloveni},',
    predmet: 'Subject',
    predmetVychozi: 'Your financial model',
    priloha: 'The same document is attached as a PDF.',
    prilohyNeumi: 'E-mail from the app cannot carry attachments yet. The PDF downloads to your device — attach it manually, or the link to the model in the text above is enough for the client.',
    sPozdravem: 'Kind regards',
    schuzka: 'Book a meeting',
    spojitSe: 'Get in touch',
    stahnoutPdf: 'Download PDF',
    textPrecti: 'Text — read it before you send',
    titulFixace: 'Mortgage fixed period — what happens after it ends',
    titulHistoricka: 'Historical performance of the investment',
    titulHypoteka: 'Mortgage model',
    titulInvestice: 'Investment model',
    uvodVychozi: 'here is the model we went through together.',
    uvodniPh: 'Hello, here is the model I promised…',
    uvodniZprava: 'Opening message',
    vytvarim: 'Creating…',
    vytvarimOdkaz: 'Creating link…',
    vytvoritOdkaz: 'Create link',
    whatsapp: 'Message on WhatsApp',
    zavolejte: 'Or call me directly: {tel}',
    zjistuji: 'Checking how the e-mail will be sent…',
    zkopirovano: 'Copied',
  },
  /* BLOK:klientEmail END */
  /* BLOK:pdfVystup START — generuje scratchpad/slovnik.py, ručně needitovat */
  pdfVystup: {
    ctaVychozi: 'Book a meeting',
    dalsiKrok: 'Next step',
    disclaimer: 'The model is indicative and based on historical data. Past returns are no guarantee of future returns. Investing in capital markets carries the risk of losing part or all of the amount invested.',
    financniPoradenstvi: 'Financial advice',
    inv: {
      hero: 'Expected value',
      projekce: 'Projection by year',
      scenare: 'Scenarios at the end of the period',
      thOcekavany: 'Expected',
      thOptimisticky: 'Optimistic',
      thPesimisticky: 'Pessimistic',
      thRok: 'Year',
      thVklady: 'Deposits',
      titul: 'Investment model',
    },
    jakTomuRozumet: 'What this means',
    modelace: 'Model',
    modelaceDisclaimer: 'A non-binding, indicative model. We will confirm the exact terms and prices together.',
    platnaDo: 'Valid until',
    pripravenoPro: 'Prepared for',
    qrAlt: 'QR code',
    qrNavod: 'Scan the QR code with your phone camera — it opens a link to contact your advisor.',
    rozpis: 'Detailed breakdown',
    souhrn: 'Summary',
    vstupy: 'Input parameters',
    vypracoval: 'Prepared by',
  },
  /* BLOK:pdfVystup END */
  /* BLOK:zivotkoPdf START — generuje scratchpad/slovnik.py, ručně needitovat */
  zivotkoPdf: {
    cenaChybi: 'The advisor will add the exact price based on the chosen insurer — which is why there is none in this document.',
    cenaDen: 'Per day that comes to {den}.',
    cenaHlava: 'Per family member {hlava} a day.',
    cenaPct: 'That is {pct} % of the family income.',
    cenaStoji: 'All of this protection costs {cena} a month.',
    cilMesicne: '{nazev} {castka}/month',
    cilVychozi: 'goal',
    disclaimer: 'Indicative recommended cover based on the beplan methodology. The exact premium and terms depend on the chosen insurer. The advisor has the last word.',
    heroLabel: 'What the family needs if the breadwinner dies',
    heroLabelInvalidita: 'What the family needs if the breadwinner cannot work',
    inCena: 'Cost of cover / month',
    inNezbytne: 'Essential expenses / month',
    inOsob: 'People in the family',
    inPrijem: 'Family income / month',
    inVarianta: 'Cover option',
    inZajistitNa: 'Cover for',
    metodika: 'Methodology {verze}.',
    naDen: '{castka}/day',
    nar1: 'Today the family has {prijem} a month. Imagine losing part of it.',
    nar2: 'If income drops by 5 % ({p5} a month), it is annoying — but you can cope. A 25 % drop ({p25}) is manageable, you just tighten your belt. A 50 % drop ({p50}) no longer balances the budget. And a 100 % drop ({p100}) is the end of plans, not just a tighter belt.',
    nar3: 'These two hard ends of the ladder are exactly what the proposal covers: {inval} in case of disability, {smrt} in case of death and {pn} for every day of illness or injury. Calculated {roky} ahead, from your own numbers — not from an average table.',
    nar4: 'On top of that, {tnu} for permanent consequences of an injury (the more serious, the higher the payout) and {zav} for a critical illness — cancer, heart attack, stroke. That is money for treatment and for time, not for bills.',
    nar5: 'Protection deals with what happens when something goes wrong. The family goals deal with what happens when everything goes right: {cile}. In total {suma} a month.',
    narrativeTitle: 'Why this amount',
    rokyFew: '{n} years',
    rokyMany: '{n} years',
    rokyOne: '{n} year',
    sumInval: 'If unable to work (disability)',
    sumPn: 'Short illness / injury (sick leave)',
    sumSmrt: 'In case of death',
    summaryTitle: 'What happens if…',
    tableTitle: 'Cover per person',
    thInvalidita: 'Disability',
    thOsoba: 'Person',
    thPn: 'Sick leave/day',
    thSmrt: 'Death',
    thTrvale: 'Permanent injury',
    thVazna: 'Critical illness',
    titul: 'Family protection proposal',
    vic10: 'The table shows the first 5 and the last 5 of {n} people in total — the summary figures above cover the whole family.',
  },
  /* BLOK:zivotkoPdf END */
  /* BLOK:vzhledKontrola START — generuje scratchpad/slovnik.py, ručně needitovat */
  vzhledKontrola: {
    ariaHistVyvoj: 'Investment value {od}–{do}: paid in {vlozeno}, value {hodnota}, savings account {sporeni}',
    ariaRozlozeni: 'Portfolio allocation',
    smazatCil: 'Remove goal',
    smazatOsobu: 'Remove person',
    snizit: 'Decrease',
    zrusitVyber: 'Clear selected period',
    zvysit: 'Increase',
  },
  /* BLOK:vzhledKontrola END */
  /* BLOK:odkladaniZam START — generuje scratchpad/slovnik.py, ručně needitovat */
  odkladaniZam: {
    kino: {
      a5Zam: '+ {castka} paid by the employer straight into the pension plan',
      prijem503020: 'Net monthly income incl. employer contribution',
      tokAria: 'From pay of {prijem} and the employer contribution {zam}, {stranou} goes aside and {zivot} is left for living.',
      vyplataPlus: '+ employer contribution {castka}',
    },
    novyCrmOdklada: 'Sets aside {pct} % of income incl. employer contribution · ideal 20 % = {castka}',
    pochvala: 'You set aside {pct} % of your income incl. employer contribution ({castka})',
    vc: 'incl. employer contribution',
    vodopad: {
      nejvys: 'At most {castka} can be set aside = {pct} % of income incl. employer contribution',
      odkladDnes: 'Set aside today: {castka} = {pct} % of income incl. employer contribution (own deposits {vklady} + employer contribution {zam} + free money {volne}).',
      odkladDohoda: 'Set aside: {castka} = {pct} % of income incl. employer contribution (own deposits {vklady} + employer contribution {zam} + agreed amount {dohoda}).',
      posuvnikPct: '{pct} % of income incl. employer contribution =',
      posuvnikPrazdny: '{pct} % of income incl. employer contribution = —',
      stranouDnes: '{pct} % of income incl. employer contribution is set aside today',
      stranouDohoda: 'with the agreed amount, {pct} % of income incl. employer contribution is set aside',
      uzBezi: 'Already running {castka} (savings deposits {vklady} + employer contribution {zam})',
    },
    zaklad: 'of {zaklad} incl. employer contribution {zam}',
  },
  /* BLOK:odkladaniZam END */
  /* BLOK:fixaceVystup START — generuje scratchpad/slovnik.py, ručně needitovat */
  fixaceVystup: {
    disclaimer: 'The rate history is based on the monthly statistics of the Czech National Bank (new housing loans by length of fixed period, 2006–2026). The rate after the fixed period ends is a MODELLED value, not a forecast — the actual rate will be set by the market and the bank at the time of refixing.',
    dlouha: 'Long fixed period',
    fixaceZa: '{roky} at {sazba}',
    hero: 'Instalment after {po} at a rate of {sazba}',
    kratka: 'Short fixed period',
    nar1: 'The chart shows how your instalment will develop over the whole term — not just in the first years of the fixed period. A short fixed period has a lower instalment today, but once it ends the instalment is recalculated at whatever rate applies then. Nobody knows that rate today.',
    nar2: 'The red line in the chart is your budget. If the instalment after the fixed period crosses it, that means trouble — and that is exactly the risk a lower instalment today hides.',
    nar3: 'The rate history in this tool is the real monthly statistics of the Czech National Bank. It is not a forecast: it shows how often and how strongly rates in the Czech Republic have moved.',
    pdfChyba: 'The PDF could not be generated',
    poLetechFew: '{n} years',
    poLetechMany: '{n} years',
    poLetechOne: '{n} year',
    rokyFew: '{n} years',
    rokyMany: '{n} years',
    rokyOne: '{n} year',
    sazbaPo: 'Rate after the fixed period (modelled)',
    sazbaUnese: 'The highest rate the budget can still handle',
    splatkaDlouha: 'Instalment with a {roky} fixed period',
    splatkaPo: 'Instalment after {po} at {sazba}',
    splatkaTed: 'Instalment now (short fixed period)',
    splatnost: 'Term',
    unese: 'Affordable instalment',
    unesePct: '{castka} ({pct} % of income)',
    vyse: 'Mortgage amount',
  },
  /* BLOK:fixaceVystup END */
  /* BLOK:kinoPrijmy START — generuje scratchpad/slovnik.py, ručně needitovat */
  kinoPrijmy: {
    a1BigDoplnte: 'Add the income and we will split it',
    a1BigPrijem: 'Your net monthly income',
    a1Kicker: 'Where the money goes',
    a1L1: 'Most people have no idea how much they spend and on what.',
    a1L2: 'Without a system, nothing is left at the end of the month.',
    a1Nar: '“Let us look at how to split your money so that something is left for your dreams too.”',
    a1Title: 'Where does the money slip away every month?',
    a2Big: 'A simple system that works',
    a2Kicker: 'The rule',
    a2L1: '50 % essentials — housing, food, energy, loan repayments.',
    a2L2: '30 % lifestyle — treats, hobbies, eating out.',
    a2L3: '20 % set aside for goals — reserve, investments, passive income.',
    a2Title: 'The 50 / 30 / 20 rule',
    a3Kicker: 'How much for YOU',
    a3L2: '20 % = {castka} for long-term goals.',
    a3Title: '20 % is what drives your independence',
    a6Big: 'Your path to freedom',
    a6Kicker: 'Start today',
    a6L1: 'Over time, that 20 % becomes your passive income.',
    a6L2: 'Regularity + time = your money starts working for you.',
    a6Nar: '“That 20 % today is your financial independence tomorrow. Let us get it going.”',
    a6Title: '20 % regularly = financial independence',
    dejstviAria: 'Act {n}',
    nazev: 'Income and expenses',
  },
  /* BLOK:kinoPrijmy END */
  /* BLOK:kinoRizika START — generuje scratchpad/slovnik.py, ručně needitovat */
  kinoRizika: {
    a1: {
      aria: 'The road to your goals: {cile}.',
      ariaBezCilu: 'The road to goals we have yet to add.',
      ariaDalsi: 'The road to your goals: {cile} and {n} more.',
      cile: '{cile}.',
      cileADalsi: '{cile} and more.',
      dalsiCilFew: 'and {n} more goals',
      dalsiCilMany: 'and {n} more goals',
      dalsiCilOne: 'and {n} more goal',
      kicker: 'Your plan',
      radekBezCilu: 'We will add your goals together.',
      radekKrok: 'Step by step, as we agreed.',
      rezie: 'Let the client look for a moment.',
      tahak: '“This is your plan: {cile}. Step by step.”',
      tahakBezCilu: '“Before we start planning, tell me what you want to achieve.”',
      tahakDalsi: '“This is your plan: {cile} and more. Step by step.”',
      tahakHned: '{cil} right away',
      tahakVRoce: '{cil} in {rok}',
      titulek: 'This is your plan',
      titulekBezCilu: 'We build the plan on your goals',
    },
    a1Big: 'What could put the plan at risk?',
    a1Kicker: 'Protect first',
    a1L1: 'A plan has to stand on solid foundations — on protection.',
    a1L2: 'A single loss of income can bring down all the goals at once.',
    a1Nar: '“Before we start building dreams, we need to secure the foundation. Otherwise one accident can sweep away the whole plan.”',
    a1Title: 'First we protect, then we build',
    a2: {
      aria: 'Three clouds above the road to your goals: loss of income (illness, injury, disability, death) — the biggest, loss of property (fire, water, theft) and liability for damage to others.',
      invalidita: 'Disability',
      kicker: 'Risks',
      kradez: 'Theft',
      majetek: 'Loss of property',
      nejvetsi: 'Biggest',
      nemoc: 'Illness',
      pozar: 'Fire',
      radek1: 'There are many risks.',
      radek2: 'The main three are income, property and liability.',
      rezie: 'Do not judge and do not scare.',
      skodaJinemu: 'Damage to others',
      tahak: '“The plan assumes everything goes as expected. But sometimes life brings a cloud. There are many risks — the main three are income, property and liability.”',
      titulek: 'What could threaten the plan?',
      umrti: 'Death',
      uraz: 'Injury',
      voda: 'Water',
    },
    a2BezDeti: 'Your income supports the whole household.',
    a2BezHypo: 'Without income, everything else comes to a halt.',
    a2Big: 'Income = what drives the whole plan',
    a2DetiFew: 'You have {n} children — the family relies on your income.',
    a2DetiMany: 'You have {n} children — the family relies on your income.',
    a2DetiOne: 'You have {n} child — the family relies on your income.',
    a2Hypo: 'The mortgage has to be paid even if income stops.',
    a2Kicker: 'Risk no. 1',
    a2L2: 'Disability, long-term illness, death — income protection.',
    a2Nar: '“The biggest risk is not the market — it is losing the ability to earn. That is what we deal with first.”',
    a3: {
      ariaBezPrijmu: 'The plan rests on income we do not know yet.',
      ariaDopad: 'If {jmeno} cannot work for a long time: {dopad} ({pozn}).',
      ariaMensiDil: '{jmeno} carries the smaller part.',
      ariaNese: '{jmeno} carries it.',
      ariaNevime: 'If {jmeno} cannot work for a long time, what is left for goals we will work out next time, including state benefits.',
      ariaVetsiDil: '{jmeno} carries the larger part.',
      ariaZaklad: 'The plan rests on income of {castka} a month.',
      bezDavek: 'without state benefits',
      jede: 'The plan keeps going',
      kicker: 'The biggest risk',
      klient1: 'Client 1',
      klient2: 'Client 2',
      mene: 'Less left for goals',
      nemuze: '{jmeno} cannot work for a long time',
      nevime: 'We will work out what is left next time',
      nevimePozn: 'including state benefits',
      nezbyde: 'Nothing left for goals',
      obaPracuji: 'Both working',
      pasivni: 'Passive income',
      pracuje: '{jmeno} is working',
      prijemDoplnime: 'We will add income',
      radek: 'The whole plan rests on your income.',
      radekBezPrijmu1: 'The whole plan rests on income.',
      radekBezPrijmu2: 'Income is still missing — we will add it.',
      rezie: 'Tap the buttons under the picture. Do not calculate cover today.',
      skupinaAria: 'What if',
      tahakBezPrijmu: '“The whole plan rests on income. We will add it and next time show what holds it up.”',
      tahakJede: '“The whole plan rests on your income. If {jmeno} cannot work for a long time, the plan keeps going. The state would replace part of it — how much, we will work out next time.”',
      tahakMene: '“The whole plan rests on your income. If {jmeno} cannot work for a long time, less is left for goals. The state would replace part of it — how much, we will work out next time.”',
      tahakNevime: '“The whole plan rests on your income. If {jmeno} cannot work for a long time, income drops. What is left for goals and what the state replaces, we will work out next time.”',
      tahakNezbyde: '“The whole plan rests on your income. If {jmeno} cannot work for a long time, nothing is left for goals. The state would replace part of it — how much, we will work out next time.”',
      vasPlan: 'YOUR PLAN',
      velkePopis: 'a month carries the whole plan',
      vychoziBezPrijmu: 'Without income we do not know what carries the plan',
      vychoziJede: 'Income flows, the plan runs',
      vychoziMene: 'Less is left for goals now — we will cover it in the plan',
      vychoziNezbyva: 'Nothing left for goals now — we will cover it in the plan',
    },
    a3Auto: 'Car → compulsory liability + comprehensive cover.',
    a3Big: 'A complete shield for the family',
    a3Domacnost: 'Household contents and equipment — property insurance.',
    a3Firma: 'Business → business insurance and business interruption.',
    a3Kicker: 'Property & liability',
    a3L2: 'Liability (including towards your employer), legal protection.',
    a3Nar: '“Besides income, we look after property, liability, the car, legal protection and, for business owners, the business too.”',
    a3Nemovitost: 'Property + household contents — property insurance.',
    a3Title: 'What we protect',
    a4: {
      aria: 'Your goals under a dashed shield: we will add protection at the next meeting.',
      coKryje: 'What it covers and what it does not',
      coMate: 'What you have',
      domluveno: '(agreed)',
      jakZapadne: 'How it fits into the plan',
      kicker: 'Next time',
      naDalsiSchuzce: 'At the next meeting',
      pojistneSmlouvy: 'insurance contracts',
      radek: 'Nothing to decide today.',
      rezie: 'Then tick the Insurance contracts document in the Summary.',
      rezieHotovo: 'The Insurance contracts document is already ticked in the Summary.',
      sSebou: 'Bring:',
      tahak: '“As part of the financial plan we will also look at your protection — what you have today, what it covers and what it does not. We will check whether you can save or insure smarter, and show how it fits into the whole plan.”',
      titulek: 'We will go through them at the next meeting',
    },
    a4Big: 'Protection = peace of mind for the whole plan',
    a4Kicker: 'Summary',
    a4L1: 'We will go through every cover — so the family is never left stranded.',
    a4L2: 'Only a well-protected plan is worth building.',
    a4L3: 'It is boring, but it is the very foundation.',
    a4Nar: '“This may be the most important part. Let us go through together what you have covered and where the gaps are.”',
    a4Title: 'Let us go through this together',
    cil: {
      auto: 'Car',
      bydleni: 'Home',
      cil: 'Goal',
      deti: 'Children',
      dnes: 'today',
      investice: 'Investing',
      podnikani: 'Business',
      rekonstrukce: 'Renovation',
      renta: 'Pension',
      rezerva: 'Reserve',
    },
    iAuto: 'Car (liability + comprehensive)',
    iDomacnost: 'Household contents',
    iFirma: 'Business / operations',
    iInvalidita: 'Disability / illness',
    iNemovitost: 'Property',
    iOdpovednost: 'Liability',
    iPravni: 'Legal protection',
    iUmrti: 'Death (family)',
    iVypadek: 'Loss of income',
    iZamestnani: 'Employment',
    nazev: 'Risk protection',
  },
  /* BLOK:kinoRizika END */
  /* BLOK:histKalk START — generuje scratchpad/slovnik.py, ručně needitovat */
  histKalk: {
    alokacePomery: 'Allocation · weights',
    bezPoplatku: 'No fees. Enter them so the client can see how much of their money goes on costs.',
    bezpecnaRenta: 'Safe monthly income',
    brzdaBez: 'No brake',
    brzdaCil: 'For a goal',
    brzdaNadpis: 'Brake (gradual de-risking)',
    brzdaPopisBez: 'The allocation stays the same throughout.',
    brzdaPopisCil: 'Over the last ~10 years it shifts into cash (one-off goal).',
    brzdaPopisRenta: 'Mild de-risking that keeps more equities (passive income).',
    brzdaRenta: 'For passive income',
    cilovaCastka: 'Target amount within the horizon',
    disclaimer: 'The model is based on real historical data from 1926–2026. Past returns are no guarantee of future returns. Investing carries a risk of loss.',
    doba: 'Period',
    dobaInvestice: 'Investment period',
    dobaVyplaty: 'Payout period (years)',
    hodnotaDnes: 'Value today',
    hodnotaRealne: 'Real value',
    jednorazove: 'Lump sum',
    jednorazovyVklad: 'Lump sum',
    koncova: 'Final portfolio value',
    krize: {
      k1929: '1929 crash',
      k1973: 'Oil crisis',
      k1987: 'Black Monday',
      k2000: 'Dot-com',
      k2008: 'Financial crisis',
      k2011: 'Debt crisis',
      k2020: 'Covid',
      k2022: 'War in Ukraine',
    },
    krizeKonec: 'In this data, the market recovered every time.',
    krizeVetaFew: 'Over that period the investment went through {n} crises — and still ended at {castka}.',
    krizeVetaMany: 'Over that period the investment went through {n} crises — and still ended at {castka}.',
    krizeVetaOne: 'Over that period the investment went through {n} crisis — and still ended at {castka}.',
    legInvestice: 'Investment',
    legSporici: 'Savings account',
    legVlozeno: 'Invested',
    letZkratka: 'yrs',
    mesicne: 'Monthly',
    mesicneHodnota: '{castka}/month',
    modCil: 'Goal',
    modRenta: 'Passive income',
    nar1: 'The chart shows how your money would have developed on real historical market data, not on promises. Over the years there were crises and slumps — and yet the value grew over the long run. The most important thing is to start and to stay the course.',
    nar2: 'Past returns are no guarantee of future ones. Markets fluctuate in the short term and the value of an investment can also fall. The model is meant to explain the principle, not to promise a specific return.',
    nar3: 'Time is your greatest ally — thanks to compounding, every additional year works in your favour. That is why it pays to start as early as possible, even with a smaller amount.',
    nastroje: 'Tools',
    navicVeta: 'Compared with a savings account (money market), {castka} more — that is what the “safety” of cash cost.',
    nejhorsim: 'worst',
    nom: 'nominal',
    nominalne: 'nominal',
    obdobi: 'Period',
    obdobiDvojtecka: 'Period:',
    pdfChyba: 'The PDF could not be generated',
    poplatky: 'Fees',
    poplatkyCelkem: 'In total, fees will cost you {castka} — including the returns that money can no longer earn.',
    portfolio: 'Portfolio',
    portfolioMix: 'Portfolio mix',
    potrebujeteMesicne: 'You need per month',
    pouzit: 'Use in the calculation',
    pravidelneMesicne: 'Monthly contribution',
    preset: {
      dynamicky: 'Dynamic',
      konzervativni: 'Conservative',
      moderni: 'Modern',
      vyvazeny: 'Balanced',
      zlaty: 'With gold',
    },
    priJednorazovem: 'With a lump sum of {castka} and an allocation of {alokace}.',
    prubeznyPct: 'Ongoing % (per year)',
    real: 'real',
    realne: 'real',
    realneOd: 'real only from 8/1946 (earlier inflation is missing in the data)',
    rentaMaloHistorie: 'There is not enough history for this allocation to test the whole payout period ({roky}) — shorten it or reduce the young asset classes (BTC, REIT, MSCI).',
    rentaVydrzi: 'From the {castka} saved, it would last {roky} even in the {nejhorsim} historical period (otherwise longer).',
    rokyFew: '{n} years',
    rokyMany: '{n} years',
    rokyOne: '{n} year',
    souhrnReal: 'Modelled on real history (8/1946–2026, {n} periods, after inflation):',
    sporiciByDal: 'A savings account would give',
    staciJednorazovy: '0 {mena} (the lump sum is enough)',
    titul: 'Historical calculator',
    trida: {
      akcie: 'Equities',
      btc: 'Bitcoin',
      dluhopisy: 'Bonds',
      em: 'Emerging markets',
      msci: 'MSCI World',
      ndx: 'NASDAQ-100',
      pt: 'Money market',
      reit: 'Real estate',
      zlato: 'Gold',
    },
    typ: 'Type:',
    vlozenoCelkem: 'Total invested',
    vstupniPct: 'Entry fee %',
    vstupniPoplatek: 'Entry fee: {castka} of the {vlozeno} invested.',
    vynosPa: 'Return p.a.',
    vyvojNadpis: 'Investment value over time',
    zdrojDat1: 'Data: SBBI/Ibbotson US monthly 1926–2026 (Equities = S&P 500 incl. dividends, Bonds = US long-term government, Money market = T-Bills, Inflation = US CPI). Gold = LBMA from 1968 · MSCI World from 1985 (incl. an estimated 2 % p.a. dividend) · Real estate = REIT index from 2004 · Bitcoin from 2010.',
    zdrojDat2: 'Return p.a. = internal rate of return of the cash flows. Past returns do not guarantee future returns.',
    zhodnoceni: 'Gain',
    zkraceno: 'shortened to {roky} (young asset class)',
  },
  /* BLOK:histKalk END */
  /* BLOK:alokaceGraf START — generuje scratchpad/slovnik.py, ručně needitovat */
  alokaceGraf: {
    celkem: 'Overall',
    faze: {
      drzeni: 'Holding. The market fluctuates, the plan does not.',
      hotovost: 'The money is in cash. No market risk.',
      odprodej: 'Selling equities and buying bonds — the goal is getting closer.',
      start: 'Buying — the money goes into equities.',
    },
    mesicuFew: '{n} months',
    mesicuMany: '{n} months',
    mesicuOne: '{n} month',
    nadpis: 'Where the money goes over time',
    pauza: 'Pause',
    prehrat: 'Play',
    rok: 'Year {n}',
    zpetNaCelek: 'Back to the whole period',
  },
  /* BLOK:alokaceGraf END */
  /* BLOK:fondyRenta START — generuje scratchpad/slovnik.py, ručně needitovat */
  fondyRenta: {
    mimo: ' (other accounts and funds no goal received) — total financial assets ',
    prehled: 'Funds → passive income',
    prehledRezerva: 'Funds → reserve',
    prerozdeluje: 'The plan redistributes liquid accounts, building savings, pension savings and funds as a lump sum. Left outside: ',
    rozpocetDoRenty: ' is funds and investment life insurance the client already has — the plan counts them towards the passive income goal.',
    rozpocetKCilum: ' is funds and investment life insurance the client already has — the plan assigned them to goals as set in the money flow.',
    rozpocetRezervaRenta: ' is funds and investment life insurance the client already has — the plan first tops up the reserve from them ({rezerva}) and counts the rest towards the passive income goal.',
  },
  /* BLOK:fondyRenta END */
  /* BLOK:kinoZavazky START — generuje scratchpad/slovnik.py, ručně needitovat */
  kinoZavazky: {
    a0: {
      radek: 'There is no loan in the analysis.',
      tahak: '“You are not repaying any loan. Money that would go to the bank can work for you.”',
      titulek: 'You have no debts',
    },
    a1: {
      ariaChybi: '{nazev}: {stav}.',
      ariaDluzite: 'You owe {castka}.',
      ariaUroky: 'You will still pay {castka} in interest.',
      ariaUrokyCast: 'You will still pay {castka} in interest on loans with a known rate.',
      ariaUver: '{nazev}: debt {dluh}, interest {uroky}, paid off in {rok}.',
      dluh: 'debt',
      dluhNeklesa: 'The debt is not shrinking',
      dluhZnamy: 'debt with known interest',
      doplnteSplatku: 'Add the payment',
      doplnteUrok: 'Add the interest rate',
      doplnteZustatek: 'Add the balance',
      kicker: 'Your debts',
      popisNespocitame: 'we cannot calculate the interest yet',
      popisNikdy: 'the payment does not even cover the interest',
      radekChybi: '{nazev}: {stav}, missing from the total.',
      radekChybiBez: '{nazev}: {stav}.',
      radekDluzite: 'You owe {castka}.',
      radekNaSto: 'For every {sto} of debt you add {kolik} for the bank.',
      subDluh: 'debt {castka}',
      tahak: '“A debt costs more than what you borrowed. This is how much more you will still pay the bank.”',
      tahakDoplnte: '“Let us check the interest rate in the contract. Then you will see right away how much extra you pay the bank.”',
      tip: 'Enter the interest rate from the contract. The film then calculates the interest and the end of repayment.',
      titulek: 'What your debts cost',
      urokyBance: 'interest to the bank',
      velkePopis: 'you will still pay the bank in interest',
    },
    a2: {
      ariaDobry: 'Good housing debt {castka}.',
      ariaDobrySazba: 'Good housing debt {castka} at {sazba}.',
      ariaJenBydleni: 'Only a housing debt of {castka}.',
      ariaPolozka: '{nazev} {sazba} a year',
      ariaPolozkaBez: '{nazev}, interest rate not entered',
      ariaSpatny: 'Bad debt {castka}: {seznam}.',
      ariaZadny: 'You have no bad debts.',
      bydlite: 'You live in it · property {castka}',
      dobry: 'Good debt',
      dobryProc: 'housing',
      firemni: 'Business loan',
      firemniProc: 'business · not part of the step',
      kicker: 'Good and bad debt',
      radekChybiUrok: 'The interest rate is missing for bad debts.',
      radekHypo: 'Mortgage {sazba}.',
      radekJenBydleni: 'You only have a housing debt.',
      radekNetyka: 'The step “Get rid of bad debts” does not apply to you.',
      radekPrvni: 'Bad debts are paid off first.',
      radekSazba: '{druh} costs {sazba} a year.',
      radekZadnaSpotreba: 'No consumer loan.',
      spatny: 'Bad debt',
      spatnyProc: 'consumption',
      spatnyZadnyProc: 'consumer loan, credit card, overdraft',
      tahak: '“We clear expensive loans and credit cards first. You pay the interest for sure, investment returns are not certain.”',
      tahakZadny: '“A mortgage is a debt you live in. You have no consumer loan or credit card, which is good news.”',
      titulek: 'Not every debt is the same',
      titulekZadny: 'You have no bad debts',
      velkePopis: 'bad debt · {druhy}',
      velkePopisZadny: 'bad debt',
      zadny: 'None',
    },
    a3: {
      ariaBez: 'Without extra money: bad debts paid off in {za}, interest {urok}.',
      ariaNavic: 'With {castka} extra a month: free of bad debts in {za} instead of {puvodne}, saving {usetreno} in interest.',
      ariaNesplati: 'Even with {castka} extra a month the bad debts will not be paid off.',
      jezdecAria: 'How much extra to pay on bad debts each month',
      kicker: 'What if',
      mesZkr: '{n} mo.',
      navicMesicne: 'Extra per month',
      navicNejdrivSem: 'extra goes here first',
      nic: 'None',
      nikdy: 'never',
      nikdyPopis: 'payment below interest · debt grows',
      popisPosunte: 'move the slider to send extra',
      popisRoste: 'even with this much extra the debt does not shrink',
      popisSplaceno: 'paid off in {za}',
      popisUsetrite: 'saved on interest',
      pozn: 'Calculated from the payment and interest rate in the contract. The payment of a paid-off loan is freed for you; the extra then goes to the next debt.',
      radekDnes: 'Today free of bad debts in {za}.',
      radekDriv: '{kolik} sooner.',
      radekNejdrazsi: 'Extra goes to the most expensive debt first.',
      radekNikdy: '{nazev}: the payment does not even cover the interest.',
      radekZa: 'Free of bad debts in {za} instead of {puvodne}.',
      rychlaVolba: 'Quick choice',
      tahak: '“Every extra payment goes to the most expensive debt first. What you do not pay the bank stays with you.”',
      titulek: 'Pay off bad debts sooner',
      valuetext: '{castka} a month',
      velkeRoste: 'Still growing',
      velkeZastavi: 'The debt stops growing',
      volne: 'Spare {castka}',
      zCilu: '{castka} of this would come from money for goals until the debts are paid off.',
    },
    a4: {
      aria: 'After the fixed period, at a rate of {sazba}, the payment will be {po} instead of {pred}.',
      dnes: 'Today · {sazba}',
      jakoDnes: 'same as today',
      jezdecAria: 'Mortgage rate after the fixed period ends',
      kicker: 'Mortgage',
      oDvaBody: '2 points higher',
      po: 'After fixed period · {sazba}',
      pozn: 'Nobody knows the rate after the fixed period today. The term stays the same, the payment changes.',
      poznTrh: 'Market average today: Swiss Life Hypoindex {obdobi}.',
      prumerTrhu: 'market average today',
      radekSplatka: 'The payment is recalculated: {pred} → {po}.',
      radekZustatek: 'At the end of the fixed rate {castka} of debt will remain.',
      sazbaPoFixaci: 'Rate after the fixed period',
      tahak: '“The fixed rate will end one day. Now we know what the payment does if the rate goes up.”',
      titulek: 'Fixed rate ends: {kdy}',
      velkePopis: 'monthly payment at a rate of {sazba}',
    },
    a5: {
      ariaDnes: 'For goals today {castka} a month.',
      ariaOd: 'From {rok}: {castka}.',
      ariaRenta: 'Pension from {rok}.',
      dnes: 'today',
      kicker: 'After repayment',
      naCile: 'for goals per month',
      navicNaDluhy: '{castka} extra on debts',
      poRenteFew: 'The mortgage ends {n} years after your pension starts.',
      poRenteMany: 'The mortgage ends {n} years after your pension starts.',
      poRenteOne: 'The mortgage ends {n} year after your pension starts.',
      popisDoplnte: 'without them we do not know when the debts end',
      poznModel: 'Today {castka} a month for goals from spare money, not yet agreed. Freed payments come from the contracts. Other income and spending stay as today.',
      poznOdsouhlaseno: 'Today {castka} a month for goals, as agreed in the analysis. Freed payments come from the contracts. Other income and spending stay as today.',
      predRentouFew: 'It ends {n} years before your pension.',
      predRentouMany: 'It ends {n} years before your pension.',
      predRentouOne: 'It ends {n} year before your pension.',
      radekHypo: 'In {rok} the mortgage ends. Another {castka}.',
      radekUsetreno: 'The {castka} saved on interest stays with you.',
      splaceno: '{nazev}: paid off',
      startRenty: 'pension starts',
      tahak: '“Once the debts end, this money will work for you.”',
      tip: 'Enter the mortgage end date from the contract.',
      titulek: 'Money that gets freed up',
      velkeDoplnte: 'Add the payments',
      velkePopis: 'extra per month for goals · from {rok}',
    },
    mesiceFew: '{n} months',
    mesiceMany: '{n} months',
    mesiceOne: '{n} month',
    nazev: 'Debts',
    prezTlacitko: 'Play film: What your debts cost',
    splacenoVRoce: 'paid off in {rok}',
    stav: {
      bezJistiny: 'balance not entered',
      bezSplatky: 'payment not entered',
      bezUroku: 'interest rate not entered',
      nikdy: 'the payment does not even cover the interest',
    },
    tlacitko: 'Debts film',
    uver: 'Loan',
  },
  /* BLOK:kinoZavazky END */
  /* BLOK:rizikoVysvetleni START — generuje scratchpad/slovnik.py, ručně needitovat */
  rizikoVysvetleni: {
    dite: {
      potreba: 'full need',
      sablonaKrok: 'Template for a child policy',
      sablonaTitul: 'Template: why this amount',
      sablonaToggle: 'Why this amount',
      sablonaVeta: "A template from advisory practice, not a calculation from the client's numbers — overwrite it with the pencil according to the insurer's offer.",
      strop: 'Insurability cap',
      stropPod: 'child policies are underwritten up to roughly {strop}; the remaining {zbytek} belongs in the reserve',
      trvaleTitul: "How the child's sum insured is built",
      trvaleToggle: "How the child's sum insured is calculated",
      vypadekPod: "{kdo}: {prijem} for {roky}, today's value at 4 % above inflation",
      zavazneKrok1: "Caring parent's annual income",
      zavazneKrok1Pod: '{kdo}: {prijem} × 12',
      zavazneStropPod: 'child policies cover up to roughly {strop}; the remaining {zbytek} belongs in the reserve',
    },
    odskodne: {
      krok1: 'Gap nothing else covers',
      krok1PodOdZacatku: 'the reserve does not cover even a month: {prijem} − sick pay {stat}',
      krok1PodRezerva: 'the reserve carries the first months, then sick-leave cover pays — the benefit would cover the same',
      krok1PodVypnuto: 'the benefit is switched off',
      krok2: 'Cap: benefits at most up to net income',
      krok2Pod: '{prijem} − sick pay {stat} − sick leave {pn}',
      model: 'The benefit covers the days when sick-leave cover does not pay yet and the reserve is not enough. All benefits together must not exceed net income — no insurer would underwrite that.',
      titul: 'How the daily accident benefit is built',
      toggle: 'How the daily accident benefit is calculated',
      vysledek: 'Daily accident benefit limit',
      vysledekPod: 'the smaller of the two, rounded to tens',
    },
    pn: {
      krok1: 'Net income',
      krok1Vydaje: 'Share of essential expenses',
      krok1VydajeSplatky: 'Share of essential expenses and loan repayments',
      krok2: 'What the state pays',
      krok3: 'Income gap',
      krok3Pod: '{prijem} − {stat}',
      krok4: 'Daily benefit',
      krok4Pod: '{vypadek} ÷ {dni} days',
      krok5: 'When the policy starts paying',
      krok5Hodnota: 'from month {mesic}',
      krok5Info: 'Waiting period = how many whole months the reserve lasts, at most 3. A longer waiting period = a cheaper policy.',
      krok5Pod: 'reserve {rezerva} = {nasobek}× essential expenses ({vydaje}) — it carries you until then',
      krok5PodNula: 'reserve {rezerva} does not cover even one month of essential expenses ({vydaje})',
      model: 'Indicative model, not a guarantee: sick pay under the 2026 rules, the state sets the actual amount. The waiting period and payout are set by the policy terms.',
      odDneOsvc: 'paid from day {den}',
      odDneZam: 'paid from day {den}; until then the employer pays wage compensation',
      omezeno: 'at most up to net income',
      predpoklad: 'we assume mandatory sickness insurance',
      sazbaInfo: 'We use 60 % — the rate for the first 30 days. From day 31 the state pays 66 %, from day 61 72 %, so the model is cautious.',
      statBez: 'Without sickness insurance — no sick pay is paid.',
      statOsvc: 'Self-employed without sickness insurance — no sick pay is paid.',
      statRozpad: 'gross pay ≈ {hruba} → daily base {dvz} → after reduction {rdvz} → {sazba} % = {den} × 30 days',
      statRozpadSK: 'gross pay ≈ {hruba} → daily assessment base {dvz} → {sazba} % = {den} × 30 days',
      strop: 'cap: at most {strop} — nothing counts from a daily base above {hranice}',
      stropSK: 'cap: daily assessment base at most {hranice}',
      titul: 'How the daily benefit is built',
      toggle: 'How sick leave is calculated',
      varianty: 'Same in all cover variants — a short gap is not scaled down.',
      vysledek: 'Sick leave limit',
    },
    rucne: 'The card shows {rucni} entered manually; calculated {spocitano}.',
    skryt: 'Hide calculation',
    zaokrouhleni: 'Rows are rounded, so their sum may differ slightly.',
    zavazne: {
      krok1: 'Annual net income',
      krok1Pod: '{prijem} × 12',
      krok2: 'For how many years',
      krok2Hodnota: '× {roky}',
      krok2Pod: 'choose 1 / 2 / 3 years below the row',
      titul: 'How the critical illness amount is built',
      toggle: 'How critical illness cover is calculated',
      vysledek: 'Critical illness limit',
    },
  },
  /* BLOK:rizikoVysvetleni END */
  /* BLOK:fondKategorie START — generuje scratchpad/slovnik.py, ručně needitovat */
  fondKategorie: {
    'akcie-em': 'Equities – emerging markets',
    'akcie-eu': 'Equities – Europe',
    'akcie-svet': 'Equities – world',
    'akcie-tech': 'Equities – technology',
    'akcie-usa': 'Equities – USA',
    dluhopisy: 'Bonds',
    fond: 'Fund',
    fondA: 'Fund A',
    fondB: 'Fund B',
    krypto: 'Crypto (ETP)',
    nemovitosti: 'Real estate funds',
    penizni: 'Money market / conservative',
    smisene: 'Mixed',
    zlato: 'Gold / commodities',
  },
  /* BLOK:fondKategorie END */
  /* BLOK:kino503020 START — generuje scratchpad/slovnik.py, ručně needitovat */
  kino503020: {
    a1: {
      aria: '50/30/20 rule: of the income {prijem}, {stranou} is set aside, {styl} goes to living and {nezbytne} to essentials including loan payments.',
      bezPrijmu: 'Without income we cannot split it by the rule.',
      kat: {
        bonusy: 'bonuses',
        pasivni: 'passive income',
      },
      kicker: 'The rule',
      osoba: 'Person {n}',
      prijem: 'net income',
      prijemDomacnosti: 'net household income',
      radek1: 'Half for essentials.',
      radek2: 'Just under a third for living.',
      radek3: 'A fifth set aside.',
      splatkyNadRozpocet: 'Loan payments today take more than the rule leaves for expenses.',
      tahak: '“A proven rule: of {prijem}, half goes to essentials, just under a third to living and a fifth is set aside for the future. The minimum is a tenth.”',
      titulek: '50 / 30 / 20',
      zamestnavatel: 'employer {castka}',
    },
    a2: {
      aria: 'Today {pct}% is set aside ({stranou}). {radek} {dily}.',
      ariaPravidlo: 'The rule: 20% set aside, 30% for living, 50% for essentials and loan payments.',
      ariaSchodek: 'Today {chybi} is missing every month: expenses and loan payments exceed income. Nothing is set aside, savings deposits are in the expenses.',
      bezVydaju: 'Add the expenses and we will work out how much you really set aside.',
      bezVydajuVizual: 'Without expenses we do not state a percentage.',
      dohodaNad: 'The agreed amount is {castka} higher than the free money.',
      kicker: 'You today',
      nesoulad: 'Deposits are higher than expenses, please check the expense breakdown.',
      poznVklady: 'incl. savings deposits',
      poznZam: 'incl. {castka} from the employer',
      pravidlo: 'The rule',
      prepinacAria: 'What to show',
      radekIdeal: 'That is the ideal. ✓',
      radekMinimum: 'You have the minimum. {chybi} is missing to the ideal.',
      radekPod: '{chybi} a month is missing to reach the minimum.',
      radekRychle: 'Goals are being met very fast. ✓',
      radekSchodek: 'Before saving, this gap needs to be closed.',
      tahakBezVydaju: '“Before we name a percentage, let us add the expenses together.”',
      tahakCastVolne: '{zbyva} of it you have in free money, we would look for the rest in expenses.',
      tahakIdeal: '“You set aside {pct}% of your income. That is the ideal. Now it is about where we send that money.”',
      tahakMinimum: 'You set aside {pct}% of your income. You have the minimum, {chybi} is missing to the ideal.',
      tahakPod: 'You set aside {pct}% of your income. {chybi} is missing to the minimum.',
      tahakRychle: '“You set aside {pct}% of your income, so goals are met very fast. Let us make sure enough is left for living.”',
      tahakSchodek: '“Today {chybi} is missing every month. Before we start saving, we need to close this gap.”',
      tahakVolne: 'You have that in free money, no need to cut.',
      tahakVydaje: 'There is no free money for it today, we will look for it in expenses.',
      titulek: 'Where you are today',
      velkeBezVydaju: 'expenses are not entered',
      velkePopis: 'of income set aside · {castka}',
      velkeSchodek: 'missing every month',
      vyDnes: 'You today',
      zbyvaPred: 'Left free:',
    },
    a3: {
      aria: 'At {pct}%, {stranou} is set aside and {zbyva} is left free. Essentials and loan payments do not change.',
      ariaStyl: 'At {pct}%, {stranou} is set aside, of which {styl} comes from lifestyle. Essentials and loan payments do not change.',
      kicker: 'What if',
      pct: {
        necelych: 'just under {pct}%',
        pres: 'over {pct}%',
        presne: '{pct}%',
      },
      pokryto: 'Deposits already running cover it ({vklady}).',
      radekSchodek: 'With a deficit, expenses first, then percentages.',
      staci: 'Free money is enough.',
      tahak: '“Try it yourself. Deposits and free money give at most {max} a month, that is {pct}. Above that we would be taking from your living.”',
      tahakSchodek: '“Saving from debt makes no sense. First we find those {chybi}, then we come back to percentages.”',
      titulek: 'Where to find it',
      velkePopis: 'set aside a month',
      velkeSchodek: 'nothing to save from',
      zbyva: '{castka} is left.',
      zeStylu: 'Cut {castka} a month from lifestyle.',
    },
    a4: {
      ariaBezCile: 'There is no pension in your goals yet.',
      ariaChybi: '{chybi} a month is missing to a pension that supports the family.',
      ariaPotreba: 'The family needs {potreba} a month.',
      ariaSedi: 'The pension in your goals, {zadano}, supports the family.',
      ariaSplatky: 'Of which {nazev} {splatky} ({proc}).',
      bezSporeni: 'Without today’s savings of {castka}, you no longer save in retirement.',
      bezUveru: 'Without loans repaid before retirement.',
      bezUveruRok: 'Without loans repaid by {rok}.',
      chybiMesicne: '{chybi} a month missing',
      kapital: 'A pension of {potreba} in today’s prices needs capital of roughly',
      kicker: 'Living off capital',
      potrebuje: 'The family needs',
      pravni: 'Model based on a withdrawal rate of roughly {sazba} a year ({profil} profile). It is not a return or a guarantee, reality may differ.',
      radekPotreba: 'The family needs {potreba} a month.',
      radekSoucet: 'Expenses {vydaje} + {nazev} {splatky} = {potreba} a month.',
      splatky: 'loan payments',
      splatkyBezi: 'still running in retirement',
      splatkyNeznamyKonec: 'the end cannot be calculated, add the interest rate',
      tahak: '“Living off capital does not mean earning a lot. It means your assets pay the bills for you.”',
      tahakUrok: '(Add the loan’s interest rate or balance, the app will then work out whether it ends before retirement.)',
      titulek: 'How much must the pension cover?',
      vCilech: 'Pension in goals',
      vCilechJe: 'Your goals have {zadano}.',
      vCilechNeni: 'There is no pension in your goals yet.',
      velkeBezCile: 'a month the pension should be',
      velkeChybi: 'a month missing to a pension that supports the family',
      velkeSedi: 'the pension in your goals supports the family ✓',
      zTohoSplatky: 'of which {nazev}',
    },
    ctverecek: '1 square = 1% of income ({castka} a month)',
    dil: {
      nad: 'Of which above income',
      nezbytne: 'Essentials',
      nezbytneVse: 'Essentials incl. loan payments',
      splatky: 'Loan payments',
      stranou: 'Set aside',
      styl: 'Lifestyle',
      volne: 'Left free',
      vydaje: 'Expenses (no breakdown)',
      zVkladu: 'From deposits and free money',
      zestylu: 'From lifestyle',
    },
    doplnPrijmy: 'Add the income',
    nazev: 'Income · 50/30/20',
    prah: {
      ideal: '{pct}% ideal',
      minimum: '{pct}% minimum',
      rychle: '{pct}% fast',
    },
    prahPrijem: 'income',
    profil: {
      dynamicky: 'dynamic',
      konzervativni: 'conservative',
      vyvazeny: 'balanced',
    },
    uvozovky: '“{text}”',
  },
  /* BLOK:kino503020 END */
  /* BLOK:portfolioKarta START — generuje scratchpad/slovnik.py, ručně needitovat */
  portfolioKarta: {
    investice: 'Investments',
    odhadBj: '* estimate from signed units (BJ)',
    penze: 'Pension',
    pojisteni: 'Insurance',
    proviceYtd: 'Commission YTD',
    rezerva: 'Reserve',
    rocniVynos: 'Annual return',
    titul: 'Client portfolio',
    zadnyProdukt: 'No investment product',
  },
  /* BLOK:portfolioKarta END */
  /* BLOK:kinoZdroje START — generuje scratchpad/slovnik.py, ručně needitovat */
  kinoZdroje: {
    a1: {
      ariaFin: 'Financial assets {castka}.',
      ariaKapsa: '{nazev} {castka}, {kdy}.',
      ariaNefin: '{nazev} {castka}: not counted towards goals.',
      ariaPrazdna: '{nazev}: nothing entered.',
      doplnte: 'Add the assets',
      kicker: 'Your money',
      nefinPopis: 'not counted towards goals',
      nemovitost: 'Property',
      nevime: 'We do not know yet where the money is.',
      podil: '{pct}% of it is {misto}.',
      polovina: 'Half of it is {misto}.',
      radek2: 'Not everything is available equally fast.',
      tahak: '“Before we start saving new money, let us look at what you already have. It is often more than people think.”',
      titulek: 'Money you already have',
      velkePopis: 'financial assets',
      vse: 'All of it is {misto}.',
    },
    a2: {
      ariaZisk: 'In 10 years {castka} on the account will buy as much as {za} today; interest is above inflation of {inflace}.',
      ariaZtrata: 'In 10 years {castka} on the account will buy only as much as {za} today, at inflation of {inflace} a year.',
      bezUroku: 'The account pays no interest.',
      dnes: 'today {castka}',
      kicker: 'Inflation',
      pilulkyAria: 'Which inflation',
      radekZisk: 'In 10 years {castka} will buy what {za} buys today.',
      radekZtrata: 'In 10 years {castka} will buy only what {za} buys today.',
      tahak: '“Inflation is a quiet thief. The number on the statement stays, but it buys less and less.”',
      titulek: 'Money on the account quietly loses value',
      titulekStaci: 'Interest keeps up with inflation for now',
      urok: 'Account interest {urok}.',
      urokNezadan: 'The account interest rate is not entered, we use 0%.',
      velkePopis: 'purchasing power in 10 years · inflation {inflace}',
      volba: {
        cil: {
          cnb: 'CNB target',
          ecb: 'ECB target',
        },
        historie: 'like {od}–{do}',
        plan: 'plan assumption',
      },
      zdrojCZK: 'The plan assumes {plan}. Czech Statistical Office: {rok} {posledni}, 2016–2025 average {prumer}. CNB target 2%.',
      zdrojEUR: 'The plan assumes {plan}. ECB target 2%.',
      zdrojJiny: 'The plan assumes inflation of {plan}.',
    },
    a3: {
      ariaNic: 'Nothing is working.',
      ariaPodRezervou: '{rezerva}: {ucet} on the account, {chybi} missing.',
      ariaSrovnani: 'Outlook {roky}: if {x} stays on the account, it buys like {ucet} today. If it works by the plan’s profile, the model gives {model}, {horsi} in a worse scenario, {lepsi} in a better one. Return not guaranteed.',
      chybi: '{castka} missing',
      dlouhyCil: 'long-term goal (retirement)',
      jenNad: 'Only above the reserve',
      jezdecAria: 'How much money from the account could work',
      kicker: 'What if',
      model: 'Model: {roky} like the goal {cil}, {profil} profile, in today’s money, without fees and taxes. Return not guaranteed, the bracket above the bar = the plan’s worse and better scenario. Account: interest {urok}, inflation {inflace}.',
      naUctu: 'on the account {castka}',
      nadRezervu: 'above the reserve {castka}',
      nic: 'Nothing',
      pasmo: 'worse scenario {horsi} · better {lepsi}',
      pracuje: 'Working:',
      pracujeModel: 'Working · model',
      radekJenNad: 'Only {castka} is above it.',
      radekKlesla: 'The reserve would drop to {castka}.',
      radekNaUctu: 'The account holds {castka}.',
      radekNad: 'Above it there is {castka}.',
      radekRezerva: 'The reserve is {castka}.',
      radekRezervaNa: 'The reserve for {n} mo. is {castka}.',
      radekRezervaZustava: 'The reserve of {castka} stays on the account.',
      rezerva: 'reserve · {castka}',
      rezervaNa: 'reserve for {n} mo. · {castka}',
      sniInflace: 'eaten by inflation',
      tahak: '“We leave the reserve on the account and do not touch it. The money above it can work.”',
      titulek: 'The reserve stays, the rest can work',
      titulekPodRezervou: 'The full reserve first',
      titulekRezerva: 'Part of the reserve would be working',
      urokNad: 'from interest above inflation',
      valuetextRezerva: '{x}, of which {rezerva} from the reserve',
      varovani: '{castka} would come from the reserve. It would then not be complete.',
      velkeChybiRezerva: 'missing to the reserve',
      velkeNic: 'nothing is working',
      velkePasmo: 'worse scenario {horsi} · better {lepsi}',
      velkePopis: '{roky} extra · model, return not guaranteed',
      velkeZRezervy: 'would be missing from the reserve',
      vlozenoVynos: 'put in {x} + modelled return {vynos}',
      zUctu: 'from the account',
      zustaneNaUctu: 'Stays on the account',
    },
    a4: {
      ariaBez: 'Without the money you have: {popis}.',
      ariaS: 'With the money you have: {popis}.',
      bezNich: 'Without it',
      cil: 'Goal',
      dnesPct: 'today {pct}%',
      hotovaDoMes: 'complete within {n} mo.',
      hotovaHned: 'complete right away',
      hotovaZaMes: 'complete in {n} mo.',
      kTerminu: 'by the deadline',
      kTerminuPct: 'by the deadline {pct}%',
      kicker: 'Your goals',
      mesicne: '{castka}/mo.',
      nepriradeno: {
        investice: 'Investments',
        stavebko: 'The rest of building savings',
        ucty: 'The rest in accounts',
      },
      nepriradenoPopis: 'the plan does not assign it to any goal yet',
      plusOdkladani: '+ saving',
      plusVynos: '+ return (model)',
      poMesicne: '{castka} a month',
      pozn: 'The same calculation as the Solution proposal, in today’s money. The return is a model, not a promise.',
      radekBez: '{cil} would have {bez}% instead of {s}% by the deadline.',
      radekS: '{cil} by the deadline {s}% instead of {bez}%.',
      radekStejne: 'Without it the plan would come out the same.',
      renta: 'Retirement',
      rezerva: 'Reserve',
      sPenezi: 'With the money you have',
      segmentAria: 'Comparison',
      tahak: '“Another resource for reaching your goals is the money you already have.”',
      titulek: 'Another resource for your goals',
      vVeku: 'at age {vek}',
      vVekuPoStartu: 'at age {vek} · after retirement starts',
      velkeNic: 'Nothing yet',
      velkeNicPopis: 'nothing from the assets arrives by the goals’ deadlines',
      velkePopis: 'the plan assigns to goals by their deadline',
      vetaRezervaBez: 'Without it the reserve would take {n} mo. to save.',
      vetaRezervaDoMes: 'The reserve is complete within {n} mo.',
      vetaRezervaHned: 'The reserve is complete right away.',
      vetaRezervaPct: 'The reserve is at {pct}% today.',
      vetaRezervaZa: 'The reserve will be complete in {n} mo.',
      vlastniZdroje: 'own funds {castka}',
      zaMes: 'in {n} mo.',
      zatimNic: 'nothing yet',
      zdrojPenzijko: 'pension savings',
    },
    kapsa: {
      investice: 'Investments',
      nezapsano: 'nothing entered',
      penzijko: 'Pension savings',
      stavebko: 'Building savings',
      ucty: {
        bezny: 'Current account',
        hotovost: 'Cash',
        sporici: 'Savings account',
        ucty: 'Accounts',
      },
    },
    kdy: {
      castHned: 'partly right away',
      hned: 'right away',
      investice: 'in a few days',
      penzijko: 'at age {vek}',
      stavebko: 'within {n} mo.',
    },
    misto: {
      investice: 'in investments',
      penzijko: 'in pension savings',
      stavebko: 'in building savings',
      ucty: {
        bezny: 'in the current account',
        hotovost: 'in cash',
        sporici: 'in the savings account',
        ucty: 'in accounts',
      },
    },
    nazev: 'Resources',
    osa: {
      dnes: 'today',
      zaRokyFew: 'in {n} years',
      zaRokyMany: 'in {n} years',
      zaRokyOne: 'in {n} year',
    },
    prezTlacitko: 'Start the film: Money you already have',
    rokyFew: '{n} years',
    rokyMany: '{n} years',
    rokyOne: '{n} year',
    tlacitko: 'Resources film',
    tlacitkoTitle: 'Play the film: Money you already have',
    zaRokyFew: 'in {n} years',
    zaRokyMany: 'in {n} years',
    zaRokyOne: 'in {n} year',
  },
  /* BLOK:kinoZdroje END */
  /* BLOK:predAPo START — generuje scratchpad/slovnik.py, ručně needitovat */
  predAPo: {
    cena: 'Price',
    hlavicka: {
      dnes: 'Today',
      kryti: 'Cover ×',
      nove: 'New',
    },
    infoDalsiRizika: 'Sums insured for all risks (disability, death, sick leave, critical illness, permanent injury, daily benefit) are entered per person in the analysis: Insurance contracts → Risks in contracts.',
    infoNema: '“none” = no recorded policy covers this risk. “not entered” = there is a policy, but its sum insured is missing.',
    infoRozsah: 'For a household without the insured person selected we do not show the cover multiple — it would compare one person’s policy with the new cover of both.',
    mene: 'less',
    nema: 'none',
    spolecna: 'incl. joint contract',
    spolecnaU: 'joint contract · paid under {kdo}',
    stitekNove: 'new',
    ztrata: 'lost',
  },
  /* BLOK:predAPo END */
  /* BLOK:podkladyKlienta START — generuje scratchpad/slovnik.py, ručně needitovat */
  podkladyKlienta: {
    dny: {
      '0': 'on Sunday',
      '1': 'on Monday',
      '2': 'on Tuesday',
      '3': 'on Wednesday',
      '4': 'on Thursday',
      '5': 'on Friday',
      '6': 'on Saturday',
    },
    dok: {
      leasing: 'leasing agreement',
      naSchuzce: 'we will fill it in together at the meeting',
      pojistna: 'insurance policy',
      portfolio: 'portfolio statement',
      smlouvaVypis: 'contract and latest statement',
      triMesice: 'for the last 3 months',
      uverova: 'loan agreement and balance statement',
      vypis: 'latest statement',
      vypisUctu: 'account statement',
      zustatek: 'current balance',
    },
    nazev: {
      akcie: 'Shares',
      cennosti: 'Valuables insurance',
      cizimena: 'Foreign currency account',
      danove: 'Tax return for {rok}',
      dip: 'Long-term investment product (DIP)',
      dluhopisy: 'Bonds',
      dps: 'Pension savings (DPS)',
      fondy: 'Funds / ETFs',
      investice: 'Investments',
      krypto: 'Cryptocurrencies',
      kzp: 'Endowment life insurance',
      pojistka: 'Insurance policy',
      pripojisteni: 'Supplementary pension insurance',
      sporici: 'Savings account',
      stavebko: 'Building savings',
      terminovany: 'Term deposit',
      uver: 'Loan',
      vypisy: 'Current account statements',
    },
    platno: {
      emailem: 'I will also send you the list by e-mail',
      idealne: 'Ideally before the meeting',
      kicker: 'Wrap-up',
      papiry: 'You can also bring the papers to the meeting',
      pod: 'A scan or a phone photo is enough.',
      posleteNa: 'Send to',
      prazdne: 'Nothing yet — we will add it at the next meeting.',
      titul: 'What I will need from you',
      zpravou: 'I will also send you the list in a message',
    },
    pocetSmluvFew: '{n} contracts',
    pocetSmluvMany: '{n} contracts',
    pocetSmluvOne: '{n} contract',
    ui: {
      bezEmailu: '{kdo} has no e-mail.',
      bezKontaktu: 'no contact',
      bezTelefonu: '{kdo} has no phone number.',
      chybaRada: 'Try again, or open the message in your mail app.',
      chybaTitul: 'Sending failed — nothing was sent',
      chybiMujEmail: 'Your e-mail is missing from the message, so the client would not know where to send the scans.',
      cisloVarovani: 'this looks like a contract number — better leave it out of the message',
      detailEmail: 'Sent {kdy} by e-mail · {komu}',
      detailMailto: 'Opened in your mail app {kdy} · {komu} · send it from there',
      detailWa: 'Opened in WhatsApp {kdy} · {komu} · send it from there',
      dokumentFew: 'documents',
      dokumentMany: 'documents',
      dokumentOne: 'document',
      doplnitEmail: 'Add the e-mail in Introduction',
      doplnitNastaveni: 'Add a public e-mail in Settings',
      doplnitTelefon: 'Add the phone in Introduction',
      emailUctu: 'The message uses the e-mail of your connected account',
      instituceChybi: 'institution not filled in',
      jazyk: 'Message language',
      jen: '{kanal} only',
      kanalEmail: 'e-mail',
      kanalEmailSpatny: 'e-mail in the wrong format',
      kanalTelefon: 'phone',
      kdyCas: '{den} at {cas}',
      klient: 'The client',
      komu: 'Send to',
      kopirovaniChyba: 'Copying failed — select the text and copy it manually.',
      kopirovat: 'Copy',
      neodeslano: 'Not sent yet',
      nicVybrano: 'Nothing selected — the message will not be sent',
      odebrat: 'Remove: {nazev}',
      odesilam: 'Sending…',
      odeslanoEmail: 'Sent {den} by e-mail',
      odeslanoToast: 'The e-mail was sent to the client.',
      odeslatChyba: 'Sending failed.',
      opravitEmail: 'Fix the e-mail in Introduction',
      otevritPostu: 'Open in mail app',
      plusDotaznik: '+ questionnaire at the meeting',
      pocetPred: 'The message will include',
      pod: 'Built from Resources, Liabilities and assets in the analysis',
      podleMajetku: 'based on assets: {nazev}',
      polozkaMajetku: 'asset item',
      poslatEmail: 'Send by e-mail',
      poslatWa: 'Send via WhatsApp',
      pozdeji: 'will provide later',
      poznGmail: 'Will be sent from your Gmail {email}',
      poznGmailBez: 'Will be sent from your Gmail',
      poznMailto: 'Opens your mail app — send it from there',
      poznSmtp: 'Will be sent from your company e-mail {email}',
      poznSmtpBez: 'Will be sent from your company e-mail',
      poznWa: 'Opens WhatsApp with the text ready — send it from there',
      poznZjistuji: 'Checking how the e-mail will be sent…',
      predanoWa: 'Passed to WhatsApp {den}',
      predmet: 'Subject',
      pridat: 'Add',
      pridatLabel: 'Custom item',
      pridatPh: 'e.g. purchase contract for the flat',
      pripravenoEmail: 'Prepared in e-mail {den}',
      rozbalit: 'Show the whole message',
      sbalit: 'Collapse the message',
      skupina: {
        dalsi: 'Other',
        pojisteni: 'Insurance',
        sporeni: 'Savings and investments',
        uvery: 'Loans',
      },
      spatnyEmail: '{kdo} has an e-mail in the wrong format ({email}).',
      terminAnalyza: 'Date recorded in the analysis: {kdy}',
      terminDiar: 'Date from the diary: {kdy}',
      terminProbehl: 'The date in the analysis ({kdy}) has passed — it is not in the message',
      terminZadny: 'No next meeting in the diary — no date in the message',
      titul: 'What the client should provide',
      vlastni: 'custom item',
      waBezEmailu: 'Without your e-mail the client would send the scans via WhatsApp.',
      zkopirovano: 'Message text copied.',
      zkusitZnovu: 'Try again',
      zmena: 'The message has changed since it was sent — send it again.',
      znovuEmail: 'Send again by e-mail',
      znovuWa: 'Send again via WhatsApp',
      zpravaPod: 'The client sends the scans to your e-mail',
      zpravaTitul: 'Message for the client',
    },
    viceFew: '{n} contracts: {dok} for each',
    viceMany: '{n} contracts: {dok} for each',
    viceOne: '{n} contract: {dok}',
    zprava: {
      dotaznik: 'We will fill in the investment questionnaire together at the meeting.',
      fotka: 'A photo from your phone is enough, as long as it is readable.',
      kamEmail: 'Please send them to my e-mail {email} whenever you have a moment.',
      kamEmailTermin: 'Please send them to my e-mail {email}, ideally before our next meeting {den}',
      kamOdpoved: 'Please send them as a reply to this e-mail whenever you have a moment.',
      kamOdpovedTermin: 'Please send them as a reply to this e-mail, ideally before our next meeting {den}',
      nevadi: 'If you cannot find something, no problem — we will go through it together. You can also bring the papers to the meeting.',
      pozdrav: 'Hello,',
      pozdravJmeno: 'Hello {osloveni},',
      predmet: 'Documents for preparing your proposal',
      predmetTermin: 'Documents for our next meeting',
      uvod: 'thank you for our meeting. To prepare the proposal, please send me scans or photos of these documents:',
    },
  },
  /* BLOK:podkladyKlienta END */
  /* BLOK:vykonTymu START — generuje scratchpad/slovnik.py, ručně needitovat */
  vykonTymu: {
    aktivita: {
      aria: '{metrika} over the last {tydnu} weeks: {soucet} ticked off in total, weekly goal {cil}, below goal in {pod} of {ukoncenych} finished weeks.',
      ariaBezCile: '{metrika} over the last {tydnu} weeks: {soucet} ticked off in total, no weekly goal set.',
      ariaCast: '{metrika} over the last {tydnu} weeks: {soucet} ticked off in total. Only {s} of {celkem} people have a weekly goal, so the team is not rated.',
      ariaNovyCil: '{metrika} over the last {tydnu} weeks: {soucet} ticked off in total, weekly goal {cil}, no finished week with a goal yet.',
      cil: 'goal {n}',
      cilCast: 'only {s} of {celkem} people have a goal, so no team goal line',
      cilDrive: 'earlier goal {n}',
      hovory: 'Calls',
      nadpis: 'Activity by week',
      neodskrtnuto: 'Not ticked off in the diary, not counted in the bars or the goal: {n}',
      prazdno: 'No calls or meetings with clients have been ticked off as done in the last {tydnu} weeks.',
      probiha: 'in progress',
      radekZalohy: '{datum}: {n}',
      schuzky: 'Meetings',
      typNeznamy: 'No type, not counted: {n}',
    },
    bezJmena: 'No name',
    cil: {
      chyba: 'The goal could not be saved.',
      hodnoty: 'Calls per week: {hovory} · meetings per week: {schuzky}',
      hovory: 'Calls per week',
      jenPrimy: 'The goal is set by the direct manager.',
      nadpis: 'Weekly activity goal',
      nastavil: 'Set by {jmeno}, {datum}',
      neplatny: 'Enter a whole number from 0 to 200.',
      prazdne: 'An empty field means no goal.',
      schuzky: 'Meetings per week',
      ukladam: 'Saving…',
      ulozeno: 'Weekly goal saved.',
      ulozit: 'Save goal',
      zpet: 'Back',
      zrusit: 'Remove goal',
      zrusitPotvrdit: 'Really remove the weekly goal?',
    },
    detail: {
      chyba: 'Advisor performance could not be loaded.',
      hlubsi: "Clients and deals are opened by this person's direct manager.",
      koucink: 'Coaching',
      nacitam: 'Loading advisor performance…',
      nadpis: 'Performance: {jmeno}',
      pipelineObchody: 'Clients and deals',
      zavrit: 'Close',
    },
    drobecky: {
      aria: 'Team levels',
      ja: 'Me',
      zpet: 'Back to my team',
    },
    faze: {
      a1: 'Introduction',
      a2: 'Analysis',
      p1: 'Financial plan',
      p2: 'Presentation',
      volani: 'Calling',
    },
    informace: {
      odpojeni: 'Only your manager can disconnect you — they remove you in My team. You cannot disconnect yourself.',
      potvrzeno: 'Your manager and the managers above them see your clients, pipeline, goals and performance (calls and meetings with clients by week). Never the private items in your diary; the whole diary only with your consent. Your manager can set you a weekly goal for calls and meetings.',
      pozvat: 'Enter their email. An invitation is created that they must accept themselves in Settings — only then will you see their clients, deals, goals and performance (calls and meetings with clients by week). The whole diary only with their consent, never private items. We do not send an email; send them the link yourself.',
      prijeti: 'Once you accept, your manager and the managers above them will see your clients, pipeline, goals and performance: how many calls and meetings with clients you have each week and when you were last in touch with a client. Never the private items in your diary; the whole diary only with your consent.',
      rozumim: 'Got it',
      vzdy: 'Regardless of this choice, your manager sees your performance: how many calls and meetings with clients you have each week and when you were last in touch with a client. Without titles, times or places. Never private items.',
      zvonecek: 'Your manager and the managers above them see your clients, pipeline, goals and performance: how many calls and meetings with clients you have each week and when you were last in touch with a client. Never the private items in your diary; the whole diary only with your consent.',
      zvonecekNadpis: 'What your manager sees',
    },
    kontrola: {
      dniBezFew: '{n} days without logged activity',
      dniBezMany: '{n} days without logged activity',
      dniBezOne: '{n} day without logged activity',
      krokAno: 'Scheduled',
      krokNe: 'Missing',
      krokPoTerminu: 'Overdue',
      mene: 'Show less',
      nadpis: 'To check',
      nicZaOkno: 'Nothing in the last {dni} days',
      nicZapsano: 'Nothing logged',
      oriznuto: 'Showing {zobrazeno} of {celkem}.',
      popis: 'Active clients with no activity logged for {prah} or more days.',
      prazdno: 'Nobody has been waiting longer than {prah} days.',
      sloupecFaze: 'Stage',
      sloupecKlient: 'Client',
      sloupecKrok: 'Next step',
      sloupecPoradce: 'Advisor',
      sloupecPosledni: 'Last logged activity',
      sloupecVeFazi: 'In stage',
      veFaziFew: '{n} days',
      veFaziMany: '{n} days',
      veFaziNevime: 'tracked since {datum}',
      veFaziOne: '{n} day',
      vice: 'Show all {n}',
    },
    kpi: {
      bezKroku: 'No next step',
      bezKrokuPod: 'active clients with nothing scheduled',
      pipelineBj: 'Pipeline BJ',
      pipelineBjPod: 'Introduction to Presentation',
      schuzkyTyden: 'Meetings this week',
      schuzkyTydenPod: 'with clients, ticked off in the diary',
      vAktivite: 'Active clients',
      vAktivitePod: 'Calling to Presentation',
    },
    nadpis: 'Team performance',
    pipeline: {
      aria: 'Pipeline by advisor: {jmeno} has the most active clients ({pocet}).',
      detail: 'Details',
      klientuFew: '{n} clients',
      klientuMany: '{n} clients',
      klientuOne: '{n} client',
      nadpis: 'Pipeline by advisor',
      prazdny: 'No active clients',
      radekAria: '{jmeno}: {pocet} active clients, pipeline {bj} BJ. {rozpad}',
      segment: '{faze} {pocet}',
      tym: 'Team · {pocet}',
    },
    poznamka: {
      kratce: 'Logged work activities only.',
      cyklus: 'There is a loop in the team relationships; everyone is shown only once.',
      faze: 'Since {datum} we have been tracking moves between stages.',
      hloubka: 'The team is deeper than 5 levels; deeper levels are not shown.',
      oriznuto: 'There is more data than we can count at once; the numbers are a lower estimate.',
      patra: 'The numbers at the top cover the whole team including the levels below it; advisor rows show only their own clients.',
      zdroj: 'We count only work activities logged with a client in the diary and in the client timeline. Calls, meetings and goal progress only when ticked off as done. Never private items. What an advisor has not logged we cannot see, and that does not mean they are not working.',
    },
    stav: {
      bezCile: 'No goal set',
      chyba: 'Far below goal',
      minulyChyba: 'Last week: far below goal',
      minulyOk: 'Last week: goal met',
      minulyPozor: 'Last week: below goal',
      ok: 'Meeting the weekly goal',
      pozor: 'Below goal',
    },
    stavy: {
      bezPristupu: 'You no longer have access to this team.',
      chyba: 'Team performance could not be loaded.',
      nacitam: 'Loading team performance…',
      nedostupne: 'Team performance will be switched on after the server update.',
      prazdnyTym: 'Nobody reports directly to you yet — the ranking below shows the whole network.',
      vrcholy: 'Teams in the system',
      vrcholyPopis: 'Choose the team you want to see.',
      znovu: 'Try again',
    },
    zebricek: {
      jenObsazenost: 'The diary shares only busy times — meetings with clients can’t be told from it.',
    },
  },
  /* BLOK:vykonTymu END */
  /* BLOK:pruvodce START — generuje scratchpad/slovnik.py, ručně needitovat */
  pruvodce: {
    akce: {
      domluvitTermin: 'Book the next meeting',
      jeToSpravne: 'It is correct',
      kinoRizik: 'Play Risk cinema',
      nemaMajetek: 'No assets',
      nemaZavazky: 'No loans or policies',
      opraveno: 'Fixed to {hodnota}',
      opravit: 'Fix to {hodnota}',
      oznaceno: 'Marked as correct',
      prejit: 'Go to field',
      prejitNezbytne: 'Go to essential expenses',
      prejitObvykle: 'Go to usual expenses',
      prejitPrijmy: 'Go to income',
      prejitVydaje: 'Go to expenses',
      prohodit: 'Swap',
      prohozeno: 'Swapped',
      vratit: 'Undo',
    },
    brana: {
      dalsi: 'and {n} more',
      duvod: {
        dalsiSchuzka: 'We will add it at the next meeting',
        jiny: 'Other reason',
        nechce: 'Left blank at client request',
        podklady: 'Client will provide documents',
      },
      min: {
        cil: 'Goal with amount and deadline',
        osoby: 'People and dates of birth',
        prijmy: 'Income',
        vydaje: 'Expenses',
      },
      minimum: 'Required minimum',
      minimumSplneno: 'Required minimum met',
      nadpis: 'Ready for the plan?',
      planOrientacni: 'The plan is indicative — missing:',
      podezrele: 'Suspicious numbers',
      pokracovat: 'Continue to the plan',
      poradiNezapsano: 'Goal order agreed: not recorded',
      poradiZapsano: 'Goal order agreed: recorded {datum}',
      pozdeji: 'Missing, but you can continue',
      poznamka: 'Note (optional)',
      proc: 'Why are you continuing? (optional)',
      slozka: 'For the client folder: {n}',
      zaznamy: 'Meeting records',
      zbyvaFew: '{n} items missing — the plan will be calculated, but the numbers are only indicative. Fill them in when you can.',
      zbyvaMany: '{n} items missing — the plan will be calculated, but the numbers are only indicative. Fill them in when you can.',
      zbyvaOne: '{n} item missing — the plan will be calculated, but the numbers are only indicative. Fill it in when you can.',
      zbyvaSeznamFew: '{n} items left: {seznam}',
      zbyvaSeznamMany: '{n} items left: {seznam}',
      zbyvaSeznamOne: '{n} item left: {seznam}',
      zpet: 'Back to the analysis',
    },
    chybi: {
      castka: 'amount',
      cil: '{nazev}: {co}',
      cilBezNazvu: 'Untitled goal',
      diteKCili: 'Goal for children, but no child',
      dodaPozdeji: '{smlouva}: client will provide',
      doplnRizika: 'Add the risks: {smlouva}',
      jmenoK1: 'Client name and surname',
      komuPatri: 'Whose risks: {smlouva}',
      narozeniDite: 'Child date of birth {jmeno}',
      narozeniK1: 'Client date of birth',
      narozeniPartner: 'Partner date of birth — without it the partner’s cover is not calculated',
      nezbytne: 'Essential expenses',
      prazdneDite: 'Empty child row',
      prijemBezOsoby: '2nd person income, no person',
      smlouva: 'Contract',
      termin: 'deadline',
      titul: 'Missing:',
    },
    jednotka: {
      letFew: '{n} years',
      letMany: '{n} years',
      letOne: '{n} year',
    },
    kontrola: {
      V1: {
        hlaska: 'Expenses {V} are more than 5× income {P}.',
        hlaskaBezOpravy: 'Expenses {V} are more than 5× income {P}. Are both numbers right?',
        kratce: 'Expenses far above income',
        otazka: 'What does a normal month cost you, without loan payments?',
      },
      V10: {
        hlaska: 'Date of birth {datum} is in the future.',
        kratce: 'Birth in the future',
        otazka: 'Could you repeat the date of birth?',
      },
      V11: {
        hlaska: 'The age comes out as {n}. Is the year of birth right?',
        kratce: 'Age does not fit',
        otazka: 'Could you repeat the date of birth?',
      },
      V12: {
        hlaska: 'The child date of birth {datum} does not fit the parents.',
        kratce: 'Child older than a parent',
        otazka: 'What is the child date of birth?',
      },
      V13: {
        hlaska: '{Z} of income is left, you set aside {X}. Are the expenses right?',
        kratce: 'Unexplained remainder',
        otazka: 'Where does the money that is left go?',
      },
      V14: {
        hlaska: 'Expenses {V} are more than 2.5× income {P}. Are both numbers right?',
        kratce: 'Expenses above income',
        otazka: 'What does a normal month cost you, without loan payments?',
      },
      V15: {
        hlaska: 'Expenses {V} are only {x} % of income {P}. Are the expenses right?',
        kratce: 'Expenses far below income',
        otazka: 'What does a normal month cost you, without loan payments?',
      },
      V2: {
        hlaska: 'Essential expenses {N} are higher than usual {V}.',
        hlaskaBezOpravy: 'Essential expenses {N} are higher than usual {V}. Are both numbers right?',
        hlaskaObvykle: 'Usual expenses {V} are lower than essential {N}.',
        kratce: 'Essential above usual expenses',
        otazka: 'How much would you need each month if you had to save?',
      },
      V3: {
        hlaska: 'Income {X} is more than 10× expenses {V}.',
        hlaskaBezOpravy: 'Income {X} is more than 10× expenses {V}. Is it per year? Monthly {mesicne}.',
        hlaskaNejiste: 'Income {X} is more than 10× expenses {V}. Are both numbers right?',
        kratce: 'Income likely per year',
        otazka: 'Is this net income per month or per year?',
      },
      V4: {
        hlaska: 'Agreed surplus {X} is higher than income {P}.',
        hlaskaBezOpravy: 'Agreed surplus {X} is higher than income {P}. Is the surplus right?',
        kratce: 'Surplus above income',
        otazka: 'How much can you set aside each month without feeling the pinch?',
      },
      V5: {
        hlaska: 'A deadline of {roky} years looks like a calendar year.',
        hlaskaBezOpravy: 'A deadline of {roky} years looks like a calendar year. In how many years is it?',
        kratce: 'Deadline entered as a year',
        otazka: 'In how many years do you want it?',
      },
      V6: {
        hlaska: 'A monthly annuity of {X} is more than 20× income. Is it the total amount?',
        kratce: 'Annuity looks like capital',
        otazka: 'How much would you like to receive each month?',
      },
      V7: {
        hlaska: 'Interest {u} % looks like a decimal number.',
        hlaskaBezOpravy: 'Interest {u} % is unusually low. Is it right?',
        kratce: 'Interest as a decimal',
        otazka: 'What interest rate is in your contract?',
      },
      V8: {
        hlaska: 'Interest {u} % on a housing loan is unusually high.',
        hlaskaBezOpravy: 'Interest {u} % on a housing loan is unusually high. Is it right?',
        kratce: 'High housing loan interest',
        otazka: 'What interest rate is in your contract?',
      },
      V9: {
        hlaska: 'Payment {s} is more than 20× the balance {j}.',
        hlaskaBezOpravy: 'Payment {s} is more than 20× the balance {j}. Are they swapped?',
        kratce: 'Payment and balance swapped',
        otazka: 'How much is left to repay and how much do you pay monthly?',
      },
    },
    kratce: {
      bezNazvu: 'Untitled',
      cislo: 'contract number',
      instituce: 'institution',
      investiceUdaje: '{nazev}: {co}',
      menaDatum: '{nazev}: {mena} rate date',
      menaKurz: '{nazev}: {mena} rate',
      menaStary: '{nazev}: old {mena} rate',
      nemovitostPojisteni: '{nazev}: property insurance',
      obe: 'institution and contract number',
      obecne: 'Add details',
      vozidloPojistka: '{nazev}: motor liability',
      vozidloVyroci: '{nazev}: policy anniversary',
      zavazekCisla: '{nazev}: balance and payment',
    },
    krok: {
      cile: 'Goals',
      hodnoty: 'Expectations and values',
      majetek: 'Assets',
      predstaveni: 'Time',
      prijmy: 'Income and expenses',
      rizika: 'Risks',
      rodina: 'Family',
      zavazky: 'Liabilities',
      zaver: 'Wrap-up',
    },
    nav: 'Analysis steps',
    otazka: {
      prepinac: 'Questions for the client',
      skryt: 'Hide questions',
      titul: 'Question for the client',
      zobrazit: 'Show questions',
    },
    otevrit: 'Show analysis steps',
    souhrn: '{hotovo} of {celkem} done',
    stav: {
      chybiFew: '{n} missing',
      chybiMany: '{n} missing',
      chybiOne: '{n} missing',
      hotovo: 'done',
      keKontroleFew: '{n} to check',
      keKontroleMany: '{n} to check',
      keKontroleOne: '{n} to check',
      nezacato: 'not started',
    },
    zde: 'you are here',
  },
  /* BLOK:pruvodce END */
  /* CLIENT PLAN OUTPUT (25 Oct 2026, N1) — see cs.js */
  planVystup: {
    financniPlan: 'Financial plan',
    obsah: 'Contents',
    upozorneniNadpis: 'Important notices',
    upozorneni1: 'This financial plan analyses your savings and investments, clarifies your financial goals and proposes a path to reach them with regard to your risk tolerance.',
    upozorneni2: 'All recommendations are based on the information you provided. Investment performance calculations are for illustration only — past performance does not guarantee future results.',
    upozorneni3: 'The plan is built from the data known at the date of creation and needs regular updates, especially when the circumstances it was based on change.',
    upozorneni4: 'The final decision on implementing the recommendations is always yours alone. Transactions may have tax consequences — we recommend discussing them with a tax adviser.',
    bezZmenNadpis: 'Fulfilment of your goals if you change nothing',
    bezZmenPopis: 'How much of each goal the money you already have would cover today — without new deposits. The target is 100 %.',
    bezZmenCoUkazuje: 'The chart shows: 1. how full your liquid reserve for unexpected situations is, 2. what share of your strategic goals that cost money you can finance, 3. what share of the living standard you want from the moment of financial independence you can reach.',
    vychazimeNadpis: 'The plan is based on the following information',
    vychazimePopis: 'As in other areas of life, in personal finance it matters to know why. That is why we start with your values and your big strategic goals — only with them does every step of the plan make sense.',
    cileNadpis: 'Your strategic goals that cost money',
    popisCile: 'Goal',
    majetek: 'Assets',
    hodnota: 'Value',
    cisteJmeni: 'Net worth (assets − debts)',
    rozpisNadpis: 'Detailed breakdown of income and expenses',
    prijmy: 'Income',
    vydaje: 'Expenses',
    rocniCastka: 'Annual amount',
    mesicniPrumer: 'Monthly average',
    procentoZCelku: 'Share of total',
    procentoZPrijmu: 'Share of income',
    cistyPrijem: 'Net income — {jmeno}',
    ostatniPrijem: 'Other income — {jmeno}',
    pasivniPrijem: 'Passive income (rent, yields)',
    bonusy: 'Bonuses and rewards (yearly ÷ 12)',
    vydajeCelkem: 'Expenses and repayments total',
    prebytekDeficit: 'Surplus / deficit',
    mesicne: 'monthly',
    zajisteniNadpis: 'Insurance — securing needs in case of an unexpected event',
    investiceNadpis: 'Investments — linked to securing personal goals',
    alokaceSouhrn: 'Portfolio allocation — summary',
    tridaAktiv: 'Asset class',
    aktualne: 'Current',
    zmena: 'Change',
    doporuceno: 'Recommended',
    celkem: 'Total',
    nezarazeno: 'Unclassified (pension, insurance and alternative products)',
    nezarazenoPozn: 'The percentages of the three classes are calculated from money market, bonds and equities only. Unclassified products are handled by the plan at each goal according to when the money becomes available.',
    alokaceDleCilu: 'Allocation by goal',
    alokaceDleCiluPopis: 'Strategic split of the funds assigned to each goal according to its horizon. The sum of the rows is the allocation of the whole plan; it does not reflect product liquidity or current market valuation.',
    penezniTrh: 'Money market',
    penezniTrhKratce: 'Money',
    dluhopisy: 'Bonds',
    akcie: 'Equities',
    zdrojeCilu: 'What pays for the goals',
    zdrojeCiluPopis: 'Which accounts and products the plan assigns to which goal and how much is set aside monthly. One-off deposit = money that still has to be put towards the goal.',
    dumNadpis: 'Your plan in one picture',
    dumPopis: 'The foundations (reserve and protection) carry the floors with your goals ordered by date; financial independence is on top. Green = how much of the goal the plan covers once implemented.',
    dumAria: 'Plan house: {pointa}.',
    dumZaklady: 'Foundations',
    dumRezerva: 'Reserve {castka}',
    dumRezervaRadek: 'Reserve',
    dumRenta: 'income {castka}',
    dumVlastniZdroje: 'of which own funds {castka}',
    dumZajisteniVse: 'protection as proposed: covered',
    dumZajisteniChybi: 'protection missing: {seznam}',
    dumZajisteniChybiVeta: 'The proposed protection does not yet cover: {seznam}.',
    dumZdrojMajetek: 'Assets · one-off',
    dumZdrojPrebytek: 'Surplus · monthly',
    dumZbyva: '{castka} left',
    dumPrecerpano: 'overdrawn by {castka}',
    dumLegMate: 'you have / met',
    dumLegChybi: 'missing',
    dumLegNezname: 'cannot be calculated',
    dumLegTok: 'money flow from assets and surplus',
    dumLegVyska: 'floor height by amount, higher = later',
    dumHotoveNadpis: 'What is done',
    dumHotove: 'Once implemented, the plan fully covers: {seznam}.',
    dumHotoveNic: 'The plan does not yet fully cover any goal.',
    dumVolne: '{castka} remains free.',
    dumChybiNadpis: 'What is missing',
    dumChybi: 'The plan does not yet fully cover: {seznam}.',
    dumChybiNic: 'Nothing, once implemented the plan covers all goals.',
    dumNezname: 'Cannot be calculated: {seznam}.',
    dumKrokNadpis: 'Next step',
    dumKrokRealizace: 'Implement the plan: {jednorazove} one-off from today’s assets and {mesicne} from the surplus towards the goals.',
    dumKrokCil: 'Then adjust the amount, date or monthly deposit of {nazev} ({pct}) so the plan covers it fully.',
    dumKrokPrecerpano: 'The plan uses more money than is available (overdrawn by {castka}). Reduce a goal or move its date.',
    dumCil: 'Goal',
    dumKdy: 'When',
    dumCastka: 'Amount',
    dumJednorazove: 'One-off',
    dumMesicne: 'Monthly',
    dumSplneno: 'Met',
    tokyJednorazove: 'Money flow: one-off from assets',
    tokyMesicne: 'Money flow: monthly from surplus',
    tokyAria: '{druh}: {seznam}.',
    pravidelneMesicne: 'regular investment',
    pritok: 'future inflow',
    diverzifikace: 'Diversification',
    diverzifikacePopis: 'The more angles the portfolio is spread across (currencies, managers, issuers), the better it is protected from a single failure. Methodology: at most 5 % of assets with one corporate issuer.',
    menyChip: 'Currencies: {pocet} ({meny}) · home currency {pct} %',
    spravciChip: 'Institutions and managers: {pocet} · largest {nazev} {pct} %',
    emitentChip: 'Above {limit} % with one issuer: {polozky}',
    zrealizujeteNadpis: 'Fulfilment of your goals if you implement our recommendations',
    zrealizujetePopis: 'Left: today. Right: after implementing the plan. The target is 100 %.',
    vyvojNadpis: 'Asset and cash-flow analysis year by year',
    vyvojPopis: 'The financial-independence portfolio according to the plan: how much will have been deposited in total and what value it will have (in today’s prices, at the expected return of the chosen allocation).',
    rok: 'Year',
    vlozenoCelkem: 'Deposited in total',
    hodnotaPortfolia: 'Portfolio value',
    podilCile: 'Share of goal',
    vyvojPozn: 'The results are indicative and cannot be taken as a promise of the future.',
    vypisNadpis: 'Statement of assets',
    vypisPopis: 'structure of assets at the plan date — by asset class, currency and institution',
    majetekCelkem: 'Total assets',
    financniAktiva: 'Financial assets',
    nefinancniMajetek: 'Non-financial assets',
    dluhy: 'Debts',
    podleTrid: 'By asset class',
    podleMen: 'By currency',
    podleInstituci: 'By institution and manager (financial assets)',
    pokracovani: 'continued',
    ostatni: 'other',
    krytoZdroji: 'covered by resources',
    neuvedeno: 'institution not stated',
    nezapocteno: 'Not included — no valid exchange rate: {polozky}',
    polozky: 'Items',
    polozka: 'Item',
    instituce: 'Institution',
    cilovaAlokace: 'Target allocation × current (financial assets)',
    rozdil: 'Difference',
    tridaPenezni: 'Money market (accounts, savings)',
    tridaDluhopisy: 'Bonds',
    tridaAkcie: 'Equities',
    tridaAlternativni: 'Alternative and other investments',
    tridaPenzijni: 'Pension products',
    tridaPojisteni: 'Life insurance with cash value',
    tridaNemovitosti: 'Real estate, car, valuables',
    tridaFirma: 'Business',
    vytvoreno: 'Created',
    strana: 'Page',
  },
  /* BLOK:navrhV2 START — Návrh řešení v 9 krocích (15. 10. 2026). Zdroj: lib/navrh/texty/*.js,
     shodu hlídá lib/navrh/__tests__/slovnikNavrhV2.test.js — needitovat ručně, upravit text v lib/navrh/texty. */
  navrhV2: {
    dilna: {
      titul: 'Workshop',
      podtitul: 'the advisor’s desk · the client never sees it',
      sekce: {
        pripraveno: 'Ready for the client?',
        penize: 'Splitting the money',
        penizePod: 'formerly Table / Summary',
        texty: 'Texts for the client',
        textyPod: 'system proposal until you write your own',
        produkty: 'Allocation, fees and products',
        nastaveni: 'Calculation settings and methodology',
        poznamka: 'Note and benefits',
      },
      znacka: {
        chyba: 'error',
        pozor: 'warning',
        info: 'input missing',
      },
      pripraveno: {
        vecOne: '{n} item',
        vecFew: '{n} items',
        vecMany: '{n} items',
        nicNeblokujeKratce: 'nothing blocks',
        blokujeKratce: 'blocks the presentation',
        vsePripraveno: 'all ready',
        blokujeNadpis: 'Blocks the presentation',
        chybiNadpis: 'Missing, but you can continue',
        tiskNadpis: 'For the printed plan',
        nicNeblokuje: 'Nothing blocks — income and the plan are calculated with the current methodology',
        nicNeblokujePostaru: 'Nothing blocks — income is filled in, the plan is still calculated the old way',
        nicNechybi: 'Nothing is missing.',
        prejit: 'Go',
        doplnitVAnalyze: 'Fill in the analysis',
        otevrit: 'Open',
      },
      polozka: {
        prijemPrijmy: 'Income is missing — the plan cannot be calculated without it',
        prijemNula: 'The surplus is zero — the plan has nothing to split',
        cenaOchrany: 'The price of cover for the {varianta} option is missing — step 8 and Before and after have no price yet',
        cenaOchranyCast: 'The price of cover for the {varianta} option is entered for some people only',
        majetekOne: 'Property and liability: {n} contract is waiting for the insurer’s price',
        majetekFew: 'Property and liability: {n} contracts are waiting for the insurer’s price',
        majetekMany: 'Property and liability: {n} contracts are waiting for the insurer’s price',
        majetekOverit: 'Property and liability: the contract changed after the price was entered — check the price (contracts: {n})',
        uverDnes: 'Current loan ({nazev}): missing {co}',
        coUrok: 'interest rate',
        coKonec: 'end of repayment',
        coOba: 'interest rate and end of repayment',
        bydleni: '{nazev}: the {pct} % financing is only a system proposal so far — choose it with the client',
        bydleniBezPct: '{nazev}: the financing is only a system proposal so far — choose it with the client',
        schodek: 'Shortfall after the loans are drawn: {kroky} per month',
        schodekKrok: 'from {rok} {castka}',
        partner: '{jmeno}: date of birth is missing — cover cannot be calculated',
        staryPlan: 'The plan is calculated the old way (methodology {datum}) — recalculate in Calculation settings',
        nadPrebytek: 'The plan asks for {plan} of the surplus, but the surplus is {prebytek} — {chybi} per month is missing. Adjust the amounts in Splitting the money',
        rezervaDosporit: 'With the plan the reserve reaches only {pct} % — it can be topped up from the surplus with {castkaMes} per month for {mesicu} months (step 4)',
        rezerva: 'With the plan the reserve reaches only {pct} % — there is no free surplus to top it up',
        cilBezCastky: 'Goal “{nazev}” has no amount — the plan does not include it',
        cilBezTerminu: 'Goal “{nazev}” has no date — the plan does not save for it',
        cilBezObojiho: 'Goal “{nazev}” has no amount and no date — the plan does not include it',
        zivotPod20: 'Only {pct} % of income ({castka} per month) is left for discretionary spending — we recommend 20 to 30 %. The client will see this in step 8',
      },
      tisk: {
        produkty: 'Products',
        coKdyProc: 'What / When / Why',
        poznamka: 'Note on the proposal',
        starobni: 'Old-age pension',
        navrhSystemu: 'system proposal',
        upraveno: 'edited by the advisor',
        zadnyRadek: 'no row',
        prazdna: 'empty',
        vyplnena: 'filled in',
        nezadano: 'not entered — not printed',
        rucne: 'entered manually',
        radkuOne: '{n} row',
        radkuFew: '{n} rows',
        radkuMany: '{n} rows',
      },
      penize: {
        prebytek: 'Surplus',
        naPlan: 'To the plan today',
        zbyva: 'Left for good',
        presuny: 'Moved from savings',
        drziSplatka: 'today {castka}, then a loan repayment takes it',
        odkud: 'Where the money comes from',
        kam: 'Where to',
        podlePlanu: 'as planned',
        rozdelenoRucne: 'split manually by amounts',
        zatimNikam: 'nowhere yet',
        vLetech: 'at age {vek}',
        zadneZdroje: 'The client has no savings that could be assigned.',
        rust: 'Salary growth and inflows',
        pritokyCile: 'One-off inflows to goals',
        tabulka: 'A4 landscape table',
        tabulkaNeulozeno: 'The proposal could not be saved — the table would show an old version.',
        prehled: 'Split by goal',
        sloupec: {
          cil: 'Goal',
          kdy: 'When',
          kolik: 'Amount',
          jednorazove: 'One-off',
          mesicne: 'Monthly',
          dosazeno: 'Reached',
        },
        plusKroky: '+ increases over time',
        rucne: 'Adjust the split manually',
        rucnePod: 'one-off and monthly by goal, where the money comes from',
      },
      texty: {
        cile: 'Texts for the goals',
        coKdyProc: 'What / When / Why for the printed plan',
        co: 'What',
        kdy: 'When',
        proc: 'Why',
        coPlaceholder: 'What we recommend',
        pridatRadek: 'Add a row',
        smazatRadek: 'Delete the row',
        pojistky: 'Solution for each policy',
      },
      produkty: {
        alokace: 'Allocation',
        alokaceZProfilu: 'Allocation from the {profil} profile',
        alokaceRucne: 'Allocation edited manually',
        akcie: 'Shares',
        dluhopisy: 'Bonds',
        hotovost: 'Cash',
        upravitAlokaci: 'Edit the allocation',
        hotovo: 'Done',
        soucet: 'Total {pct} %',
        soucetSpatne: 'Total {pct} % — it should be 100 %',
        zpetNaProfil: 'Back to the profile',
        vstupni: 'Entry fee % ({min}–{max})',
        sprava: 'Management fee % per year ({min}–{max})',
        nezadano: 'not entered',
        spravaVychozi: 'Empty field = charts use the default management fee of {pct} %.',
        titul: 'Products',
        nazev: 'Product name',
        castka: 'Amount',
        akce: 'Action',
        koupit: 'Buy',
        prodat: 'Sell',
        ponechat: 'Keep',
        navysit: 'Increase',
        pridat: 'Add a product',
        smazat: 'Delete the product',
        zadnyRadek: 'No row yet.',
        sjednat: 'Close → Contract',
        sjednatPopis: 'The client agrees? The products prefill into the contract.',
      },
      nastaveni: {
        profil: 'Profile',
        scenar: 'Scenario',
        metodikaAktualni: 'Methodology {datum} — current, nothing to recalculate.',
        metodikaBezZmen: 'Methodology {datum} — the new methodology changes nothing for this client.',
      },
      poznamka: {
        placeholder: 'Note on the solution — it is printed in the full plan',
        davky: 'Social benefits for the printed plan',
        odhad: 'estimate from income',
        rucne: 'entered manually',
        zpetNaOdhad: 'Back to the estimate',
        starobniNezadano: 'Old-age pension: not entered — the printed plan will not show it.',
      },
    },
    kroky14: {
      krok1: {
        nadpis: 'Why we are doing this',
        citace: '“{text}”',
        analyza: '{jmena}, analysis {datum}',
        spojka: 'and',
        cileAria: 'Your goals',
        mesicneOd: '{castka} a month · from {rok}',
        vDnesnichCenach: 'in today’s prices',
        renta: 'Financial independence',
        uverem: 'with a loan',
        castkaNezadana: 'amount not entered',
        bezTerminu: 'no date',
      },
      krok2: {
        nadpis: 'Where you are today',
        majetek: 'Assets',
        naUctech: 'In accounts',
        sporeni: 'Savings and investments',
        nemovitosti: 'Property',
        celkem: 'Total',
        dluhy: 'debts {castka}',
        bezDluhu: 'no debts',
        ze100: 'Out of every 100 {sym} of income',
        dnes: 'Today',
        sPrebytkem: 'With the surplus',
        prebytek: 'Surplus {castka} a month',
        odsouhlaseny: 'agreed',
        nadVolne: '{castka} of it comes out of living costs (Living {a} → {b})',
        dobre: 'What you are doing well',
        odklad: 'You put aside {pct} % of income ({castka}) · with the surplus {pctPo} %',
        odkladJen: 'You put aside {pct} % of income ({castka})',
        rezerva: 'Your reserve is {pct} % complete',
        rezervaHotova: 'Your reserve is complete',
        most: 'If {jmeno} cannot work, the family is short {castka} a month',
        mostJeden: 'In case of disability you are short {castka} a month',
        mostAkce: 'Protection',
        detail: 'Assets and loans in detail',
        budouci: 'Future assets: {nazev}',
        uvery: 'Loans today',
        zbyva: '{castka} left',
        splatka: 'instalment {castka}',
        hypoChybi: 'The mortgage is missing the interest rate and end date — the model appears once they are filled in.',
      },
      krok3: {
        nadpis: 'Protecting your income',
        rucniOne: '{n} manual change',
        rucniFew: '{n} manual changes',
        rucniMany: '{n} manual changes',
        vratitVse: 'Undo all',
        invalidita: 'The worst risk is disability',
        dnes: 'Today',
        nemuze: '{jmeno} cannot work',
        nemuzeJeden: 'If you cannot work',
        duchod: 'disability pension',
        potreba: 'needed {castka}',
        chybi: 'Short {castka} a month',
        nicNechybi: 'Income covers the need, nothing is missing',
        prumer: 'disability pension {castka} is an average',
        aria: 'Today {dnes} comes in. If {jmeno} cannot work, {prijde} comes in and {potreba} a month is needed.',
        ariaJeden: 'Today {dnes} comes in. If you cannot work, {prijde} comes in and {potreba} a month is needed.',
        pojistka: 'Do you already have insurance?',
        platba: '{castka} a month',
        platbaNezadana: 'payment not entered',
        predApo: 'Before and after',
        veta: 'If {jmeno} loses their health, the family receives {nove} instead of {dnes}.',
        vetaJeden: 'If you lose your health, you receive {nove} instead of {dnes}.',
        vetaNema: 'If {jmeno} loses their health, the family receives {nove}. Today nothing.',
        vetaNemaJeden: 'If you lose your health, you receive {nove}. Today nothing.',
        vetaBez: 'If {jmeno} loses their health, the family receives {nove}.',
        vetaBezJeden: 'If you lose your health, you receive {nove}.',
        dovetek: 'New = at the start, decreasing over the years.',
        vetaCena: 'You pay {dnes} a month, newly {nove}.',
        vetaCenaJen: 'Newly you will pay {nove} a month.',
        dalsiRizika: 'Other risks · {n}',
        pojistne: 'premium {dnes} → {nove}',
        pojistneNove: 'premium {nove}',
        rizikOne: '{n} risk',
        rizikFew: '{n} risks',
        rizikMany: '{n} risks',
        dnesNezadano: 'not entered today',
        jakSePocita: 'How it is calculated',
        nespocteno: '{jmeno}: not calculated — date of birth missing',
        doplnit: 'Complete in the analysis',
        varianty: 'How much cover do you want?',
        invaliditaKoho: 'Disability · {jmeno}',
        invaliditaSloupec: 'Disability',
        variantaSloupec: 'Option',
        cena: 'Price',
        cenaNezadana: 'price not entered yet',
        mesicne: '{castka} a month',
        zvoleno: 'selected',
        ulozeno: 'Saved: {nazev}',
        vratit: 'Undo',
        coZnamenaji: 'What the options mean',
        majetek: 'Property and liability',
        bezSmluvMajetku: 'No property contract',
        vysvetlitMajetek: 'Explain property cover',
        upravitKryti: 'Edit amounts and cover options',
      },
      krok4: {
        nadpis: 'Reserve',
        cil: 'Goal {castka}',
        zakladOne: '{n} month of essential spending and instalments ({castka})',
        zakladFew: '{n} months of essential spending and instalments ({castka})',
        zakladMany: '{n} months of essential spending and instalments ({castka})',
        mate: 'You have',
        chybi: 'Missing',
        zFondu: 'We top up from funds',
        zaOne: 'in {n} month',
        zaFew: 'in {n} months',
        zaMany: 'in {n} months',
        kde: 'In a savings account or a money market fund, not in shares.',
        hotova: 'The reserve is complete',
        aria: 'Reserve today {dnes} %, with the plan {po} %',
        dnesPct: 'today {pct} %',
        poPct: 'with the plan {pct} %',
        dosporitNabidka: 'Top up {castka} a month for {mesicu} months',
        dosporeni: 'We top it up from the surplus with {castka} a month for {mesicu} months.',
        dosporitZrusit: 'Cancel top-up',
      },
      nezadano: 'not entered',
    },
    kroky56: {
      k5: {
        nadpis: 'Your goals',
        cipyAria: 'Your goals by year',
        uverem: 'with a loan',
        renta: 'Retirement income',
        profilRadek: 'Profile: {profil} · {scenar} · de-risking before the goal',
        zmenitVDilne: 'Change in Workshop',
        zadneCile: 'Apart from the reserve and retirement income, the plan has no other goals.',
      },
      profil: {
        dynamicky: 'Dynamic',
        vyvazeny: 'Balanced',
        konzervativni: 'Conservative',
      },
      karta: {
        castkaRok: '{castka} · {rok}',
        vek: '{jmeno} at {vek}',
        plneni: 'today {dnes} % → with the plan {po} %',
        sPlanem: 'with the plan {po} %',
        mesicne: 'Monthly',
        jednorazove: 'One-off',
        splatkaOd: 'Repayment from {rok}',
        bezPenez: 'No money yet',
        chybi: 'missing {castka}',
        modelove: 'Modelled in {rok}',
        cil: 'Goal',
        splneno: 'reached',
        chybiNadpis: 'Missing',
        upravitCil: 'Edit goal amount and year',
        castkaPole: 'Goal amount',
        rokPole: 'Goal year',
        pouzit: 'Apply',
        zrusit: 'Cancel',
        vratit: 'Restore values from the analysis',
        upraveno: 'edited',
        detail: 'Detail',
        glideNadpis: 'How the mix changes',
        prvni: 'First year',
        polovina: 'Halfway',
        posledni: 'Last year',
        slozeni: 'equities {akcie} % · bonds {dluhopisy} % · cash {cash} %',
        jakInvestovat: 'How to invest',
        jakInvestovatText: 'According to the plan, {profil} profile: equities are sold gradually before the goal, the last year is all in cash.',
      },
      duvod: {
        splatka: 'From {rok} the repayment of the loan “{popis}” takes the whole surplus — nothing is left for this goal each month.',
        drivejsi: 'Today the surplus goes to earlier goals.',
        bezTerminu: 'The goal has no date yet — the plan does not save for it.',
        jine: 'The plan does not put any money here yet.',
      },
      fin: {
        krok1: 'How you will finance the purchase',
        jakZaplatit: 'How you will pay',
        zaplatitSporenim: 'Save it all',
        zaplatitUverem: 'With a loan',
        krok2: 'Save your own funds',
        uver: 'Loan',
        hypoteka: 'Mortgage',
        uverem100: '100 % with a loan',
        hotove: 'In cash',
        hotovePct: '{pct} %',
        produkt: 'Loan type',
        spotrebitelsky: 'Consumer loan',
        stavebko: 'Building savings loan',
        splatnost: 'Term',
        urokRocne: 'Interest p.a.',
        volba: 'Option',
        vlastniZdroje: 'Own funds',
        mesicneDoKoupe: 'Monthly until purchase',
        splatka: 'Repayment',
        a10: '10 % own funds',
        a20: '20 % own funds',
        a30: '30 % own funds',
        a100: '100 % with building savings',
        zastava: '100 % secured by another property',
        duvodVek: 'only up to age 36 · {jmeno} will be {vek} in {rok}',
        duvodVekNbs: 'only first home up to age 35 · {jmeno} will be {vek} in {rok}',
        duvodDo2026: 'for purchases until the end of 2026 only 20 % own funds',
        duvodNemovitost: 'only a first home without other property',
        duvodK2: 'the second applicant\'s date of birth is missing',
        duvodVekNeznamy: 'date of birth is missing',
        duvodNelze: 'the plan cannot calculate this option',
        a100Rozpis: 'mortgage {hypo} + building savings {stavebko}',
        zastavaRadek: 'collateral: {nazev} {castka}',
        zatizeni: 'check encumbrance — the property has a mortgage',
        hypoInfo: 'Mortgage {sazba} % for {roky}',
        dalsiMoznosti: 'More financing options',
        klientVolba: '{volba} · {uver} for {roky}',
        sporitVysledek: 'Modelled in {roky}: {hodnota} of {cil}',
        bezVlastnich: 'No own funds needed — the loan covers the whole price.',
        schodek: 'From {rok} the budget is short by {castka} a month.',
      },
      k6: {
        nadpis: 'Retirement income',
        nazev: 'Financial independence',
        podnadpis: '{castka} a month in today\'s prices · from {rok}',
        kapital: 'Capital needed',
        kapitalPozn: '4 % withdrawal a year, perpetual income',
        planDava: 'The plan gives (modelled)',
        pasmo: '{od} – {do}',
        pasmoPozn: 'worse to better scenario',
        poPoplatcichCastka: 'after fees {castka}',
        poPoplatcichPct: 'after fees {pct} %',
        dnes: 'today',
        zdrojRadek: '{popis} · {kdy}',
        zdrojVek: '{rok}, at {vek}',
        mesicneOdDneska: 'Monthly from today',
        mesicnePopo: 'Monthly {kroky}',
        mesicneOd: 'Monthly from {rok}',
        az: 'up to {castka}',
        zdrojeDoRenty: 'Building savings and pension savings into retirement income',
        ano: 'yes',
        ne: 'no',
        doCeho: 'What we invest in',
        rentier: 'Income portfolio: equities {akcie} % · bonds {dluhopisy} % · cash {cash} %. It is kept during withdrawals too.',
        bezRenty: 'Retirement income is not set in the analysis yet.',
      },
      graf: {
        vlozeno: 'Paid in',
        modelove: 'Modelled',
        poPoplatcich: 'After fees',
        pasmo: 'worse to better scenario',
        pasmoBublina: 'Worse – better scenario',
        cil: 'Goal {castka}',
        kapital: 'Capital {castka}',
        aria: '{nazev}: modelled {hodnota} in {rok} of {cil}, worse scenario {od}, better {do}, after fees {po}. A model, not a guarantee.',
        vetaRoku: 'Paid in {vlozeno} · modelled {hodnota} · after fees {po}',
        dnes: 'today',
      },
      letOne: '{n} year',
      letFew: '{n} years',
      letMany: '{n} years',
    },
    kroky79: {
      k7: {
        sPlanem: 'With the plan',
        naUctu: 'In a savings account',
        poPoplatcich: 'after fees',
        pasmo: 'worse to better scenario',
        pasmoBublina: 'Worse – better scenario',
        veta: 'Same money, same goals: in {roky} the plan models {sPlanem} (worse scenario {horsi}), a savings account {naUctu}.',
        vetaSPoplatky: 'Same money, same goals: in {roky} the plan models {sPlanem} before fees ({poPoplatcich} after fees, worse scenario {horsi}), a savings account {naUctu}.',
        vetaUcet: 'Savings account = the same money on the same day, at the savings rate of {sazba} % a year above inflation (in today’s prices).',
        chybiNaUctu: 'In a savings account, {castka} would be missing for “{cil}” in {rok}.',
        vetaRoku: 'With the plan {sPlanem} · savings account {naUctu}',
        aria: 'In {roky} the plan models {sPlanem} before fees, {poPoplatcich} after fees, worse scenario {horsi}, savings account {naUctu}. A model, not a guarantee.',
        dnes: 'today',
        schodek: 'After the loans are drawn, the plan is short by {seznam} a month — we solve that first (step 8).',
        schodekPrez: 'After the loans are drawn, the plan is short by {seznam} a month — we solve that first.',
        postaru: 'Calculated the old way — the comparison appears after recalculation.',
        prepocitat: 'Recalculate',
        bezCilu: 'The plan does not send money to any goal yet — nothing to compare.',
        odklad: 'What waiting costs',
        odkladUvod: 'Monthly amount needed for an income of {renta}:',
        odkladDnes: 'if you start today',
        odkladZa: 'if you start in {roky}',
        mesicneCastka: '{castka} a month',
      },
      k8: {
        mesicne: 'Monthly',
        mesicneRozpad: 'protection {ochrana} (today {dnes}) · investments {investice}',
        mesicneBezCeny: 'investments {investice} · protection not priced yet',
        mesicneBezNove: 'investments {investice} · no new cover',
        bezNoveOchrany: 'no new cover',
        vicNezDnes: '{castka} more than today',
        orientacne: 'approx. {castka} · app estimate, not deducted',
        jednorazove: 'New money one-off',
        presunyUvod: 'We move it from your savings:',
        presun: '{odkud} → {kam}',
        vRoce: 'in {rok}',
        zaMesicu: 'in {n} mo.',
        odkud: {
          ucty: 'accounts and building savings',
          fondy: 'funds',
          penzijko: 'pension savings',
          pritok: 'future income',
          dopocet: 'extra deposit',
        },
        kam: {
          rezerva: 'reserve',
          renta: 'income for life',
        },
        vetaPrebytek: 'Of the surplus {prebytek}, {plan} goes to the plan, {zbyva} is left.',
        vetaPrebytekDrzi: 'Of the surplus {prebytek}, {plan} goes to the plan.',
        vetaNadPrebytek: 'The plan asks for {plan} of the surplus, but the surplus is {prebytek} — {chybi} a month is missing.',
        vetaDrzi: 'The plan does not use the remaining {castka} for goals: from {rok} the loan payment for “{uver}” takes it.',
        schodek: 'After the loans are drawn, {seznam} a month is missing.',
        schodekPolozka: 'from {rok} {castka}',
        stovka: 'You would have {pct} % of income ({castka} a month) left for discretionary spending (beyond essentials) — we recommend 20 to 30 %.',
        ochranaOsob: 'Personal protection',
        cenaOsoby: '{jmeno} · monthly',
        cenaDeti: 'Children · monthly',
        cenaPh: 'price from the insurer',
        pojistne: 'Premium: today {dnes} → {nove}',
        pojistneRozdil: '({rozdil})',
        cenaNezadana: 'price not entered yet',
        majetek: 'Property and liability',
        smlouvyOne: '{n} contract',
        smlouvyFew: '{n} contracts',
        smlouvyMany: '{n} contracts',
        investice: 'Investments',
        poplatky: 'entry fee {vstupni} % · management {sprava} % a year',
        poplatkyNezadane: 'entry fee and management: not entered',
        mesicneCastka: '{castka} a month',
        rozdeleni: 'How the surplus is split',
        zUspor: 'One-off from savings',
        zPrebytku: 'Monthly from the surplus {prebytek}',
        ochranaRozdil: 'protection (difference to today)',
        zbyvaDnes: 'left today',
        udalostSplatka: 'from {rok} · loan payment “{popis}”',
        udalostDoplaceno: 'in {rok} · paid off “{popis}”',
        udalostRenta: 'from {rok} · more for the income',
        uvolniSe: 'freed up',
        cashflow: 'Cash flow over time',
        cashflowAria: 'Plan cash flow chart: {dnes} a month left today, {nejhorsi} in the worst year.',
        zmenitVDilne: 'Edit in the Workshop',
      },
      k9: {
        tri: {
          zajistit: 'Protect income and property',
          rezervaDluhy: 'Reserve and costly debts',
          investovat: 'Invest',
        },
        ochrana: '{varianta} · {cena} a month',
        ochranaBezCeny: '{varianta} · price not entered yet',
        ochranaBezNove: '{varianta} · no new cover',
        majetek: 'property {smlouvy}',
        majetekCena: 'property {smlouvy} · {cena} a month',
        rezerva: 'Reserve {castka}',
        rezervaHotovo: 'Reserve {castka} · done',
        dluhy: 'repay loan {castka}',
        investice: '{castka} a month for goals',
        investiceSchodek: 'For now {castka} a month · from {rok} {chybi} is missing',
        chybiPodklad: 'data missing',
        smysl: 'Does this make sense to you?',
        citace: 'At the start you said: “{hodnoty}”',
        domluveno: 'Agreed',
        ja: 'Me (adviser)',
        vy: 'You',
        vyJmena: 'You ({jmena})',
        a: 'and',
      },
      doma: {
        tlacitko: 'We will think it over at home',
        ukladam: 'Saving…',
        neulozeno: 'The plan could not be saved. Please try again.',
        titul: 'Your financial plan',
        intro: 'Hello, here is the plan we went through together. Take your time at home and let me know.',
      },
      snimek: {
        hero: 'Plan monthly',
        heroBezCeny: 'Investments per month (cover not priced yet)',
        poPoplatcich: 'After fees in {roky}',
        pro: 'For',
        prebytek: 'Surplus',
        naPlan: 'From the surplus to the plan',
        presuny: 'Moved from savings',
        ochrana: 'Protection · {varianta}',
        investice: 'Investments monthly',
        sPlanem: 'With the plan in {roky}',
        naUctu: 'In a savings account',
        garance: 'A model from your numbers, not a guarantee.',
      },
    },
    ramec: {
      analyza: 'Analysis',
      zpetNaAnalyzu: 'Back to analysis',
      navrhDatum: 'Proposed solution · {datum}',
      klient: 'Client',
      spojka: 'and',
      pasek: {
        popis: 'Monthly',
        prebytek: 'Surplus',
        plan: 'plan',
        splatky: 'loan payments',
        zbyva: 'left',
        chybi: 'missing',
      },
      pohled: {
        skupina: 'View',
        dilna: 'Workshop',
        plan: 'Plan',
        klient: 'For the client',
      },
      kDoplneni: 'To complete: {n}',
      ulozeni: {
        neulozeno: 'Not saved',
        uklada: 'Saving…',
        ulozeno: 'Saved {cas}',
        chyba: 'Not saved',
        offline: 'Offline',
        zkusitZnovu: 'Try again',
        chybaText: 'Changes could not be saved.',
      },
      prezentovat: 'Present',
      prezentovatBlokuje: 'Cannot present yet: {duvod}',
      zpetDoUprav: 'Back to editing',
      dalsiKrok: 'Next step',
      krokZ: 'Step {n} of {z}',
      krokyPlanu: 'Plan steps',
      znacka: {
        chyba: 'error',
        pozor: 'warning',
        info: 'missing input',
      },
      nacitani: 'Loading the proposal…',
      chybaNacteni: 'The proposal could not be loaded.',
      bezPrijmu: {
        kroky: 'Steps 3–9',
        veta: 'Without income the plan cannot be calculated — add income in the analysis.',
        vetaNula: 'The surplus is zero or negative — the plan has nothing to pay from. Adjust expenses or the surplus in the analysis.',
        akce: 'Go to income',
      },
      dialogChybi: {
        nadpis: 'The client will see what is still missing',
        dalsi: 'More in the Workshop: {n}',
        doplnit: 'Fill in',
        prezentovat: 'Present anyway',
        zrusit: 'Back',
      },
      staryPlan: {
        veta: 'Calculated the old way ({datum})',
        vetaBezData: 'Calculated the old way',
        prepocitat: 'Recalculate',
        coSeZmeni: 'What will change',
      },
      offline: 'Offline · changes will be saved once you reconnect.',
      prezentace: {
        oblast: 'Plan presentation',
        krokZ: 'step {n} of {z}',
        cilZ: 'goal {n} of {z}',
        dalsi: 'Next',
        predchozi: 'Previous',
        konec: 'End presentation',
        dokoncit: 'Finish',
      },
      uvod: {
        nadpis: 'Your financial plan',
        veta: 'Let us go through it together, step by step.',
      },
      dveZpravy: {
        nadpis: 'I have two pieces of news for you',
        dobraCile: 'The first is good: [[your goals can be achieved.]]',
        dobraPlan: 'Good news: [[you have a plan.]]',
        lepsiCesta: 'The even better one: you get there [[by a safer path]].',
        lepsiDrive: 'The even better one: you can live off your capital [[in just {za}]] — {o} sooner.',
        rentaNa: 'Your retirement income is at [[{pct} %]] for now — and we can see exactly what to do about it.',
        rentaNezadana: 'The retirement income goal is not set yet.',
      },
      dialogStary: {
        nadpis: 'The plan was calculated the old way ({datum})',
        nadpisBezData: 'The plan was calculated the old way',
        text: 'The old calculation stays until you recalculate it. Step 7 appears in the presentation only after recalculation.',
        postaru: 'Present the old way',
        prepocitat: 'Recalculate and present',
        zrusit: 'Back',
      },
    },
    kroky: {
      proc: 'Why',
      dnes: 'Where you are today',
      zajisteni: 'Protection',
      rezerva: 'Reserve',
      cile: 'Goals',
      renta: 'Retirement income',
      dveCesty: 'Two paths',
      kolik: 'What it costs',
      triKroky: 'Three steps',
    },
    zaklad: {
      krokCislo: 'Step {n}',
      stitek: {
        nezadano: 'not entered',
        navrh: 'suggestion',
        postaru: 'calculated the old way',
        odhad: 'estimate',
        poplatky: 'fees not entered',
      },
      model: {
        veta: 'Modelled · {scenar} · in today’s prices · before fees',
        cara: 'dotted line',
        scenar: {
          realisticky: 'realistic scenario',
          pesimisticky: 'pessimistic scenario',
          optimisticky: 'optimistic scenario',
        },
        garance: 'A model based on your numbers, not a guarantee.',
      },
      poplatky: {
        vychozi: 'after the default management fee of {sprava} %',
        zadane: 'after fees: entry {vstupni} %, management {sprava} %',
        legenda: '{cara} = {popis}',
        legendaCastka: '{cara} = {popis}: {castka}',
      },
      nacitani: 'Loading the plan numbers…',
    },
  },
  /* BLOK:navrhV2 END */
  trychtyrBuilder: {
    title: "Funnel from A to Z",
    info: "Seven steps based on the Konverzky method: magnet → page → thank-you → call → mini-webinar → e-mails → ads and measurement. You fill the templates yourself, nothing is generated by AI; saved on the server for you.",
    krokN: "Step {n}", hotovo: "Done", rozpracovano: "In progress", nezacato: "Not started", postup: "Progress", hotovychKroku: "{h} of {n} done",
    ulozit: "Save", ukladam: "Saving…", ulozeno: "Saved {cas}", ulozenoBezCasu: "Saved", neulozeno: "Unsaved", ulozeniSelhalo: "Save failed", zkusitZnovu: "Try again",
    mistniKopie: "Server unavailable — you are working with a local copy from this browser. I will retry saving.",
    nacitam: "Loading…", povinne: "required", vyber: "— choose —",
    vlozitSablonu: "Insert template", pouzitNavrh: "Use suggestion for empty fields", dosaditTitulek: "Put into headline", pravidlaTitulku: "Headline rules",
    mojeOdkazy: "My links to share", nahledBezSlugu: "Preview only for now — for a live link set your card slug in", nastaveni: "Settings",
    otevrit: "Open", kopirovat: "Copy", zkopirovano: "Copied", kopieSelhala: "Copy failed", tisk: "Print / PDF", tiskSelhal: "Could not open print",
    zasady: "6 rules of the sales system", krokyHovoru: "9 steps of the call", beaty: "Script beat by beat (order is binding)",
    emailyOblouk: "Warm-up arc — 6 days + delivery", emailyNoBooking: "When they do not book after the inquiry", emailySekvence: "E-mail sequence",
    den: "Day", cil: "Goal", predmet: "Subject", nahledRadek: "Preview line", telo: "Body", ctaTlacitko: "Link text (CTA)", testPraveRuky: "Right-hand test", kopirovatSekvenci: "Copy whole sequence",
    uhly: "Ad angles — the ad sells the click", kanaly: "Channels and setup", navodMereni: "Measurement step by step", otevritNastaveni: "Web settings → Measurement", idNastaveno: "ID set", idChybi: "ID missing", format: "format",
    checklist: "Check before launch", predchozi: "Previous", dalsi: "Next step",
  },
};

export default en;
